// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23dee2e6%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%2386c9d4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23198754%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23dc3545%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%2833, 37, 41, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23212529%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23053b44%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%236dbecb%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://italia.github.io/design-web-toolkit/components/raw/spid/index.css);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Titillium+Web:wght@300;400;600;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.react-app-uniforms {
  /* The following block can be included in a custom.scss */
  /*!
   * Bootstrap  v5.3.2 (https://getbootstrap.com/)
   * Copyright 2011-2023 The Bootstrap Authors
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   */
  /* rtl:raw:
  [type="tel"],
  [type="url"],
  [type="email"],
  [type="number"] {
    direction: ltr;
  }
  */
  /* rtl:begin:ignore */
  /* rtl:end:ignore */
  /* rtl:begin:ignore */
  /* rtl:end:ignore */
  /* rtl:begin:ignore */
  /* rtl:end:ignore */
  /* rtl:begin:ignore */
  /* rtl:end:ignore */
  /* rtl:options: {
    "autoRename": true,
    "stringMap":[ {
      "name"    : "prev-next",
      "search"  : "prev",
      "replace" : "next"
    } ]
  } */
  /* rtl:begin:remove */
  /* rtl:end:remove */
  /* Stile per disabilitare le celle precedenti alla data iniziale */
  /*
  .css-b62m3t-container {
    z-index: 200;
  }
  */
  /* Accordion */
}
.react-app-uniforms .btn-primary {
  color: #fff;
}
.react-app-uniforms .btn-secondary {
  color: #0C93A9;
}
.react-app-uniforms :root,
.react-app-uniforms [data-bs-theme=light] {
  --bs-blue: #0d6efd;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #d63384;
  --bs-red: #dc3545;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffc107;
  --bs-green: #198754;
  --bs-teal: #20c997;
  --bs-cyan: #0dcaf0;
  --bs-black: #000;
  --bs-white: #fff;
  --bs-gray: #6c757d;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f8f9fa;
  --bs-gray-200: #e9ecef;
  --bs-gray-300: #dee2e6;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #6c757d;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #0C93A9;
  --bs-secondary: #EEF4F5;
  --bs-success: #198754;
  --bs-info: #FFF;
  --bs-warning: #ffc107;
  --bs-danger: #dc3545;
  --bs-light: #f8f9fa;
  --bs-dark: #212529;
  --bs-primary-rgb: 12, 147, 169;
  --bs-secondary-rgb: 238, 244, 245;
  --bs-success-rgb: 25, 135, 84;
  --bs-info-rgb: 255, 255, 255;
  --bs-warning-rgb: 255, 193, 7;
  --bs-danger-rgb: 220, 53, 69;
  --bs-light-rgb: 248, 249, 250;
  --bs-dark-rgb: 33, 37, 41;
  --bs-primary-text-emphasis: #053b44;
  --bs-secondary-text-emphasis: #5f6262;
  --bs-success-text-emphasis: #0a3622;
  --bs-info-text-emphasis: #666666;
  --bs-warning-text-emphasis: #664d03;
  --bs-danger-text-emphasis: #58151c;
  --bs-light-text-emphasis: #495057;
  --bs-dark-text-emphasis: #495057;
  --bs-primary-bg-subtle: #cee9ee;
  --bs-secondary-bg-subtle: #fcfdfd;
  --bs-success-bg-subtle: #d1e7dd;
  --bs-info-bg-subtle: white;
  --bs-warning-bg-subtle: #fff3cd;
  --bs-danger-bg-subtle: #f8d7da;
  --bs-light-bg-subtle: #fcfcfd;
  --bs-dark-bg-subtle: #ced4da;
  --bs-primary-border-subtle: #9ed4dd;
  --bs-secondary-border-subtle: #f8fbfb;
  --bs-success-border-subtle: #a3cfbb;
  --bs-info-border-subtle: white;
  --bs-warning-border-subtle: #ffe69c;
  --bs-danger-border-subtle: #f1aeb5;
  --bs-light-border-subtle: #e9ecef;
  --bs-dark-border-subtle: #adb5bd;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-font-sans-serif: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 1rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #212529;
  --bs-body-color-rgb: 33, 37, 41;
  --bs-body-bg: #fff;
  --bs-body-bg-rgb: 255, 255, 255;
  --bs-emphasis-color: #000;
  --bs-emphasis-color-rgb: 0, 0, 0;
  --bs-secondary-color: rgba(33, 37, 41, 0.75);
  --bs-secondary-color-rgb: 33, 37, 41;
  --bs-secondary-bg: #e9ecef;
  --bs-secondary-bg-rgb: 233, 236, 239;
  --bs-tertiary-color: rgba(33, 37, 41, 0.5);
  --bs-tertiary-color-rgb: 33, 37, 41;
  --bs-tertiary-bg: #f8f9fa;
  --bs-tertiary-bg-rgb: 248, 249, 250;
  --bs-heading-color: inherit;
  --bs-link-color: #0C93A9;
  --bs-link-color-rgb: 12, 147, 169;
  --bs-link-decoration: underline;
  --bs-link-hover-color: #0a7687;
  --bs-link-hover-color-rgb: 10, 118, 135;
  --bs-code-color: #d63384;
  --bs-highlight-color: #212529;
  --bs-highlight-bg: #fff3cd;
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #dee2e6;
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.375rem;
  --bs-border-radius-sm: 0.25rem;
  --bs-border-radius-lg: 0.5rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-xxl: 2rem;
  --bs-border-radius-2xl: var(--bs-border-radius-xxl);
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-focus-ring-width: 0.25rem;
  --bs-focus-ring-opacity: 0.25;
  --bs-focus-ring-color: rgba(12, 147, 169, 0.25);
  --bs-form-valid-color: #198754;
  --bs-form-valid-border-color: #198754;
  --bs-form-invalid-color: #dc3545;
  --bs-form-invalid-border-color: #dc3545;
}
.react-app-uniforms [data-bs-theme=dark] {
  color-scheme: dark;
  --bs-body-color: #dee2e6;
  --bs-body-color-rgb: 222, 226, 230;
  --bs-body-bg: #212529;
  --bs-body-bg-rgb: 33, 37, 41;
  --bs-emphasis-color: #fff;
  --bs-emphasis-color-rgb: 255, 255, 255;
  --bs-secondary-color: rgba(222, 226, 230, 0.75);
  --bs-secondary-color-rgb: 222, 226, 230;
  --bs-secondary-bg: #343a40;
  --bs-secondary-bg-rgb: 52, 58, 64;
  --bs-tertiary-color: rgba(222, 226, 230, 0.5);
  --bs-tertiary-color-rgb: 222, 226, 230;
  --bs-tertiary-bg: #2b3035;
  --bs-tertiary-bg-rgb: 43, 48, 53;
  --bs-primary-text-emphasis: #6dbecb;
  --bs-secondary-text-emphasis: #f5f8f9;
  --bs-success-text-emphasis: #75b798;
  --bs-info-text-emphasis: white;
  --bs-warning-text-emphasis: #ffda6a;
  --bs-danger-text-emphasis: #ea868f;
  --bs-light-text-emphasis: #f8f9fa;
  --bs-dark-text-emphasis: #dee2e6;
  --bs-primary-bg-subtle: #021d22;
  --bs-secondary-bg-subtle: #303131;
  --bs-success-bg-subtle: #051b11;
  --bs-info-bg-subtle: #333333;
  --bs-warning-bg-subtle: #332701;
  --bs-danger-bg-subtle: #2c0b0e;
  --bs-light-bg-subtle: #343a40;
  --bs-dark-bg-subtle: #1a1d20;
  --bs-primary-border-subtle: #075865;
  --bs-secondary-border-subtle: #8f9293;
  --bs-success-border-subtle: #0f5132;
  --bs-info-border-subtle: #999999;
  --bs-warning-border-subtle: #997404;
  --bs-danger-border-subtle: #842029;
  --bs-light-border-subtle: #495057;
  --bs-dark-border-subtle: #343a40;
  --bs-heading-color: inherit;
  --bs-link-color: #6dbecb;
  --bs-link-hover-color: #8acbd5;
  --bs-link-color-rgb: 109, 190, 203;
  --bs-link-hover-color-rgb: 138, 203, 213;
  --bs-code-color: #e685b5;
  --bs-highlight-color: #dee2e6;
  --bs-highlight-bg: #664d03;
  --bs-border-color: #495057;
  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);
  --bs-form-valid-color: #75b798;
  --bs-form-valid-border-color: #75b798;
  --bs-form-invalid-color: #ea868f;
  --bs-form-invalid-border-color: #ea868f;
}
.react-app-uniforms *,
.react-app-uniforms *::before,
.react-app-uniforms *::after {
  box-sizing: border-box;
}
@media (prefers-reduced-motion: no-preference) {
  .react-app-uniforms :root {
    scroll-behavior: smooth;
  }
}
.react-app-uniforms body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.react-app-uniforms hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: var(--bs-border-width) solid;
  opacity: 0.25;
}
.react-app-uniforms h6, .react-app-uniforms .h6, .react-app-uniforms h5, .react-app-uniforms .h5, .react-app-uniforms h4, .react-app-uniforms .h4, .react-app-uniforms h3, .react-app-uniforms .h3, .react-app-uniforms h2, .react-app-uniforms .h2, .react-app-uniforms h1, .react-app-uniforms .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  color: var(--bs-heading-color);
}
.react-app-uniforms h1, .react-app-uniforms .h1 {
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  .react-app-uniforms h1, .react-app-uniforms .h1 {
    font-size: 2.5rem;
  }
}
.react-app-uniforms h2, .react-app-uniforms .h2 {
  font-size: calc(1.325rem + 0.9vw);
}
@media (min-width: 1200px) {
  .react-app-uniforms h2, .react-app-uniforms .h2 {
    font-size: 2rem;
  }
}
.react-app-uniforms h3, .react-app-uniforms .h3 {
  font-size: calc(1.3rem + 0.6vw);
}
@media (min-width: 1200px) {
  .react-app-uniforms h3, .react-app-uniforms .h3 {
    font-size: 1.75rem;
  }
}
.react-app-uniforms h4, .react-app-uniforms .h4 {
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  .react-app-uniforms h4, .react-app-uniforms .h4 {
    font-size: 1.5rem;
  }
}
.react-app-uniforms h5, .react-app-uniforms .h5 {
  font-size: 1.25rem;
}
.react-app-uniforms h6, .react-app-uniforms .h6 {
  font-size: 1rem;
}
.react-app-uniforms p {
  margin-top: 0;
  margin-bottom: 1rem;
}
.react-app-uniforms abbr[title] {
  text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}
.react-app-uniforms address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}
.react-app-uniforms ol,
.react-app-uniforms ul {
  padding-left: 2rem;
}
.react-app-uniforms ol,
.react-app-uniforms ul,
.react-app-uniforms dl {
  margin-top: 0;
  margin-bottom: 1rem;
}
.react-app-uniforms ol ol,
.react-app-uniforms ul ul,
.react-app-uniforms ol ul,
.react-app-uniforms ul ol {
  margin-bottom: 0;
}
.react-app-uniforms dt {
  font-weight: 700;
}
.react-app-uniforms dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}
.react-app-uniforms blockquote {
  margin: 0 0 1rem;
}
.react-app-uniforms b,
.react-app-uniforms strong {
  font-weight: bolder;
}
.react-app-uniforms small, .react-app-uniforms .small {
  font-size: 0.875em;
}
.react-app-uniforms mark, .react-app-uniforms .mark {
  padding: 0.1875em;
  color: var(--bs-highlight-color);
  background-color: var(--bs-highlight-bg);
}
.react-app-uniforms sub,
.react-app-uniforms sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}
.react-app-uniforms sub {
  bottom: -0.25em;
}
.react-app-uniforms sup {
  top: -0.5em;
}
.react-app-uniforms a {
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  text-decoration: underline;
}
.react-app-uniforms a:hover {
  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);
}
.react-app-uniforms a:not([href]):not([class]), .react-app-uniforms a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}
.react-app-uniforms pre,
.react-app-uniforms code,
.react-app-uniforms kbd,
.react-app-uniforms samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
}
.react-app-uniforms pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}
.react-app-uniforms pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}
.react-app-uniforms code {
  font-size: 0.875em;
  color: var(--bs-code-color);
  word-wrap: break-word;
}
a > .react-app-uniforms code {
  color: inherit;
}
.react-app-uniforms kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.875em;
  color: var(--bs-body-bg);
  background-color: var(--bs-body-color);
  border-radius: 0.25rem;
}
.react-app-uniforms kbd kbd {
  padding: 0;
  font-size: 1em;
}
.react-app-uniforms figure {
  margin: 0 0 1rem;
}
.react-app-uniforms img,
.react-app-uniforms svg {
  vertical-align: middle;
}
.react-app-uniforms table {
  caption-side: bottom;
  border-collapse: collapse;
}
.react-app-uniforms caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-secondary-color);
  text-align: left;
}
.react-app-uniforms th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}
.react-app-uniforms thead,
.react-app-uniforms tbody,
.react-app-uniforms tfoot,
.react-app-uniforms tr,
.react-app-uniforms td,
.react-app-uniforms th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}
.react-app-uniforms label {
  display: inline-block;
}
.react-app-uniforms button {
  border-radius: 0;
}
.react-app-uniforms button:focus:not(:focus-visible) {
  outline: 0;
}
.react-app-uniforms input,
.react-app-uniforms button,
.react-app-uniforms select,
.react-app-uniforms optgroup,
.react-app-uniforms textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}
.react-app-uniforms button,
.react-app-uniforms select {
  text-transform: none;
}
.react-app-uniforms [role=button] {
  cursor: pointer;
}
.react-app-uniforms select {
  word-wrap: normal;
}
.react-app-uniforms select:disabled {
  opacity: 1;
}
.react-app-uniforms [list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}
.react-app-uniforms button,
.react-app-uniforms [type=button],
.react-app-uniforms [type=reset],
.react-app-uniforms [type=submit] {
  -webkit-appearance: button;
}
.react-app-uniforms button:not(:disabled),
.react-app-uniforms [type=button]:not(:disabled),
.react-app-uniforms [type=reset]:not(:disabled),
.react-app-uniforms [type=submit]:not(:disabled) {
  cursor: pointer;
}
.react-app-uniforms ::-moz-focus-inner {
  padding: 0;
  border-style: none;
}
.react-app-uniforms textarea {
  resize: vertical;
}
.react-app-uniforms fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}
.react-app-uniforms legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit;
}
@media (min-width: 1200px) {
  .react-app-uniforms legend {
    font-size: 1.5rem;
  }
}
.react-app-uniforms legend + * {
  clear: left;
}
.react-app-uniforms ::-webkit-datetime-edit-fields-wrapper,
.react-app-uniforms ::-webkit-datetime-edit-text,
.react-app-uniforms ::-webkit-datetime-edit-minute,
.react-app-uniforms ::-webkit-datetime-edit-hour-field,
.react-app-uniforms ::-webkit-datetime-edit-day-field,
.react-app-uniforms ::-webkit-datetime-edit-month-field,
.react-app-uniforms ::-webkit-datetime-edit-year-field {
  padding: 0;
}
.react-app-uniforms ::-webkit-inner-spin-button {
  height: auto;
}
.react-app-uniforms [type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}
.react-app-uniforms ::-webkit-search-decoration {
  -webkit-appearance: none;
}
.react-app-uniforms ::-webkit-color-swatch-wrapper {
  padding: 0;
}
.react-app-uniforms ::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}
.react-app-uniforms output {
  display: inline-block;
}
.react-app-uniforms iframe {
  border: 0;
}
.react-app-uniforms summary {
  display: list-item;
  cursor: pointer;
}
.react-app-uniforms progress {
  vertical-align: baseline;
}
.react-app-uniforms [hidden] {
  display: none !important;
}
.react-app-uniforms .lead {
  font-size: 1.25rem;
  font-weight: 300;
}
.react-app-uniforms .display-1 {
  font-size: calc(1.625rem + 4.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .react-app-uniforms .display-1 {
    font-size: 5rem;
  }
}
.react-app-uniforms .display-2 {
  font-size: calc(1.575rem + 3.9vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .react-app-uniforms .display-2 {
    font-size: 4.5rem;
  }
}
.react-app-uniforms .display-3 {
  font-size: calc(1.525rem + 3.3vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .react-app-uniforms .display-3 {
    font-size: 4rem;
  }
}
.react-app-uniforms .display-4 {
  font-size: calc(1.475rem + 2.7vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .react-app-uniforms .display-4 {
    font-size: 3.5rem;
  }
}
.react-app-uniforms .display-5 {
  font-size: calc(1.425rem + 2.1vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .react-app-uniforms .display-5 {
    font-size: 3rem;
  }
}
.react-app-uniforms .display-6 {
  font-size: calc(1.375rem + 1.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .react-app-uniforms .display-6 {
    font-size: 2.5rem;
  }
}
.react-app-uniforms .list-unstyled {
  padding-left: 0;
  list-style: none;
}
.react-app-uniforms .list-inline {
  padding-left: 0;
  list-style: none;
}
.react-app-uniforms .list-inline-item {
  display: inline-block;
}
.react-app-uniforms .list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}
.react-app-uniforms .initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}
.react-app-uniforms .blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}
.react-app-uniforms .blockquote > :last-child {
  margin-bottom: 0;
}
.react-app-uniforms .blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #6c757d;
}
.react-app-uniforms .blockquote-footer::before {
  content: "— ";
}
.react-app-uniforms .img-fluid {
  max-width: 100%;
  height: auto;
}
.react-app-uniforms .img-thumbnail {
  padding: 0.25rem;
  background-color: var(--bs-body-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  max-width: 100%;
  height: auto;
}
.react-app-uniforms .figure {
  display: inline-block;
}
.react-app-uniforms .figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}
.react-app-uniforms .figure-caption {
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}
.react-app-uniforms .container,
.react-app-uniforms .container-fluid,
.react-app-uniforms .container-xxl,
.react-app-uniforms .container-xl,
.react-app-uniforms .container-lg,
.react-app-uniforms .container-md,
.react-app-uniforms .container-sm {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}
@media (min-width: 576px) {
  .react-app-uniforms .container-sm, .react-app-uniforms .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .react-app-uniforms .container-md, .react-app-uniforms .container-sm, .react-app-uniforms .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .react-app-uniforms .container-lg, .react-app-uniforms .container-md, .react-app-uniforms .container-sm, .react-app-uniforms .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .react-app-uniforms .container-xl, .react-app-uniforms .container-lg, .react-app-uniforms .container-md, .react-app-uniforms .container-sm, .react-app-uniforms .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .react-app-uniforms .container-xxl, .react-app-uniforms .container-xl, .react-app-uniforms .container-lg, .react-app-uniforms .container-md, .react-app-uniforms .container-sm, .react-app-uniforms .container {
    max-width: 1320px;
  }
}
.react-app-uniforms :root {
  --bs-breakpoint-xs: 0;
  --bs-breakpoint-sm: 576px;
  --bs-breakpoint-md: 768px;
  --bs-breakpoint-lg: 992px;
  --bs-breakpoint-xl: 1200px;
  --bs-breakpoint-xxl: 1400px;
}
.react-app-uniforms .row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}
.react-app-uniforms .row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}
.react-app-uniforms .col {
  flex: 1 0 0%;
}
.react-app-uniforms .row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}
.react-app-uniforms .row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}
.react-app-uniforms .row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}
.react-app-uniforms .row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333333%;
}
.react-app-uniforms .row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}
.react-app-uniforms .row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}
.react-app-uniforms .row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66666667%;
}
.react-app-uniforms .col-auto {
  flex: 0 0 auto;
  width: auto;
}
.react-app-uniforms .col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}
.react-app-uniforms .col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}
.react-app-uniforms .col-3 {
  flex: 0 0 auto;
  width: 25%;
}
.react-app-uniforms .col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}
.react-app-uniforms .col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}
.react-app-uniforms .col-6 {
  flex: 0 0 auto;
  width: 50%;
}
.react-app-uniforms .col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}
.react-app-uniforms .col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}
.react-app-uniforms .col-9 {
  flex: 0 0 auto;
  width: 75%;
}
.react-app-uniforms .col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}
.react-app-uniforms .col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}
.react-app-uniforms .col-12 {
  flex: 0 0 auto;
  width: 100%;
}
.react-app-uniforms .offset-1 {
  margin-left: 8.33333333%;
}
.react-app-uniforms .offset-2 {
  margin-left: 16.66666667%;
}
.react-app-uniforms .offset-3 {
  margin-left: 25%;
}
.react-app-uniforms .offset-4 {
  margin-left: 33.33333333%;
}
.react-app-uniforms .offset-5 {
  margin-left: 41.66666667%;
}
.react-app-uniforms .offset-6 {
  margin-left: 50%;
}
.react-app-uniforms .offset-7 {
  margin-left: 58.33333333%;
}
.react-app-uniforms .offset-8 {
  margin-left: 66.66666667%;
}
.react-app-uniforms .offset-9 {
  margin-left: 75%;
}
.react-app-uniforms .offset-10 {
  margin-left: 83.33333333%;
}
.react-app-uniforms .offset-11 {
  margin-left: 91.66666667%;
}
.react-app-uniforms .g-0,
.react-app-uniforms .gx-0 {
  --bs-gutter-x: 0;
}
.react-app-uniforms .g-0,
.react-app-uniforms .gy-0 {
  --bs-gutter-y: 0;
}
.react-app-uniforms .g-1,
.react-app-uniforms .gx-1 {
  --bs-gutter-x: 0.25rem;
}
.react-app-uniforms .g-1,
.react-app-uniforms .gy-1 {
  --bs-gutter-y: 0.25rem;
}
.react-app-uniforms .g-2,
.react-app-uniforms .gx-2 {
  --bs-gutter-x: 0.5rem;
}
.react-app-uniforms .g-2,
.react-app-uniforms .gy-2 {
  --bs-gutter-y: 0.5rem;
}
.react-app-uniforms .g-3,
.react-app-uniforms .gx-3 {
  --bs-gutter-x: 1rem;
}
.react-app-uniforms .g-3,
.react-app-uniforms .gy-3 {
  --bs-gutter-y: 1rem;
}
.react-app-uniforms .g-4,
.react-app-uniforms .gx-4 {
  --bs-gutter-x: 1.5rem;
}
.react-app-uniforms .g-4,
.react-app-uniforms .gy-4 {
  --bs-gutter-y: 1.5rem;
}
.react-app-uniforms .g-5,
.react-app-uniforms .gx-5 {
  --bs-gutter-x: 3rem;
}
.react-app-uniforms .g-5,
.react-app-uniforms .gy-5 {
  --bs-gutter-y: 3rem;
}
@media (min-width: 576px) {
  .react-app-uniforms .col-sm {
    flex: 1 0 0%;
  }
  .react-app-uniforms .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .react-app-uniforms .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .react-app-uniforms .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .react-app-uniforms .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .react-app-uniforms .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .react-app-uniforms .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .react-app-uniforms .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .react-app-uniforms .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .react-app-uniforms .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .react-app-uniforms .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .react-app-uniforms .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .react-app-uniforms .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .react-app-uniforms .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .react-app-uniforms .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .react-app-uniforms .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .react-app-uniforms .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .react-app-uniforms .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .react-app-uniforms .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .react-app-uniforms .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .react-app-uniforms .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .react-app-uniforms .offset-sm-0 {
    margin-left: 0;
  }
  .react-app-uniforms .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .react-app-uniforms .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .react-app-uniforms .offset-sm-3 {
    margin-left: 25%;
  }
  .react-app-uniforms .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .react-app-uniforms .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .react-app-uniforms .offset-sm-6 {
    margin-left: 50%;
  }
  .react-app-uniforms .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .react-app-uniforms .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .react-app-uniforms .offset-sm-9 {
    margin-left: 75%;
  }
  .react-app-uniforms .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .react-app-uniforms .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .react-app-uniforms .g-sm-0,
  .react-app-uniforms .gx-sm-0 {
    --bs-gutter-x: 0;
  }
  .react-app-uniforms .g-sm-0,
  .react-app-uniforms .gy-sm-0 {
    --bs-gutter-y: 0;
  }
  .react-app-uniforms .g-sm-1,
  .react-app-uniforms .gx-sm-1 {
    --bs-gutter-x: 0.25rem;
  }
  .react-app-uniforms .g-sm-1,
  .react-app-uniforms .gy-sm-1 {
    --bs-gutter-y: 0.25rem;
  }
  .react-app-uniforms .g-sm-2,
  .react-app-uniforms .gx-sm-2 {
    --bs-gutter-x: 0.5rem;
  }
  .react-app-uniforms .g-sm-2,
  .react-app-uniforms .gy-sm-2 {
    --bs-gutter-y: 0.5rem;
  }
  .react-app-uniforms .g-sm-3,
  .react-app-uniforms .gx-sm-3 {
    --bs-gutter-x: 1rem;
  }
  .react-app-uniforms .g-sm-3,
  .react-app-uniforms .gy-sm-3 {
    --bs-gutter-y: 1rem;
  }
  .react-app-uniforms .g-sm-4,
  .react-app-uniforms .gx-sm-4 {
    --bs-gutter-x: 1.5rem;
  }
  .react-app-uniforms .g-sm-4,
  .react-app-uniforms .gy-sm-4 {
    --bs-gutter-y: 1.5rem;
  }
  .react-app-uniforms .g-sm-5,
  .react-app-uniforms .gx-sm-5 {
    --bs-gutter-x: 3rem;
  }
  .react-app-uniforms .g-sm-5,
  .react-app-uniforms .gy-sm-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 768px) {
  .react-app-uniforms .col-md {
    flex: 1 0 0%;
  }
  .react-app-uniforms .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .react-app-uniforms .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .react-app-uniforms .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .react-app-uniforms .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .react-app-uniforms .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .react-app-uniforms .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .react-app-uniforms .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .react-app-uniforms .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .react-app-uniforms .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .react-app-uniforms .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .react-app-uniforms .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .react-app-uniforms .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .react-app-uniforms .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .react-app-uniforms .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .react-app-uniforms .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .react-app-uniforms .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .react-app-uniforms .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .react-app-uniforms .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .react-app-uniforms .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .react-app-uniforms .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .react-app-uniforms .offset-md-0 {
    margin-left: 0;
  }
  .react-app-uniforms .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .react-app-uniforms .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .react-app-uniforms .offset-md-3 {
    margin-left: 25%;
  }
  .react-app-uniforms .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .react-app-uniforms .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .react-app-uniforms .offset-md-6 {
    margin-left: 50%;
  }
  .react-app-uniforms .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .react-app-uniforms .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .react-app-uniforms .offset-md-9 {
    margin-left: 75%;
  }
  .react-app-uniforms .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .react-app-uniforms .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .react-app-uniforms .g-md-0,
  .react-app-uniforms .gx-md-0 {
    --bs-gutter-x: 0;
  }
  .react-app-uniforms .g-md-0,
  .react-app-uniforms .gy-md-0 {
    --bs-gutter-y: 0;
  }
  .react-app-uniforms .g-md-1,
  .react-app-uniforms .gx-md-1 {
    --bs-gutter-x: 0.25rem;
  }
  .react-app-uniforms .g-md-1,
  .react-app-uniforms .gy-md-1 {
    --bs-gutter-y: 0.25rem;
  }
  .react-app-uniforms .g-md-2,
  .react-app-uniforms .gx-md-2 {
    --bs-gutter-x: 0.5rem;
  }
  .react-app-uniforms .g-md-2,
  .react-app-uniforms .gy-md-2 {
    --bs-gutter-y: 0.5rem;
  }
  .react-app-uniforms .g-md-3,
  .react-app-uniforms .gx-md-3 {
    --bs-gutter-x: 1rem;
  }
  .react-app-uniforms .g-md-3,
  .react-app-uniforms .gy-md-3 {
    --bs-gutter-y: 1rem;
  }
  .react-app-uniforms .g-md-4,
  .react-app-uniforms .gx-md-4 {
    --bs-gutter-x: 1.5rem;
  }
  .react-app-uniforms .g-md-4,
  .react-app-uniforms .gy-md-4 {
    --bs-gutter-y: 1.5rem;
  }
  .react-app-uniforms .g-md-5,
  .react-app-uniforms .gx-md-5 {
    --bs-gutter-x: 3rem;
  }
  .react-app-uniforms .g-md-5,
  .react-app-uniforms .gy-md-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 992px) {
  .react-app-uniforms .col-lg {
    flex: 1 0 0%;
  }
  .react-app-uniforms .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .react-app-uniforms .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .react-app-uniforms .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .react-app-uniforms .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .react-app-uniforms .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .react-app-uniforms .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .react-app-uniforms .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .react-app-uniforms .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .react-app-uniforms .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .react-app-uniforms .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .react-app-uniforms .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .react-app-uniforms .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .react-app-uniforms .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .react-app-uniforms .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .react-app-uniforms .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .react-app-uniforms .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .react-app-uniforms .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .react-app-uniforms .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .react-app-uniforms .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .react-app-uniforms .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .react-app-uniforms .offset-lg-0 {
    margin-left: 0;
  }
  .react-app-uniforms .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .react-app-uniforms .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .react-app-uniforms .offset-lg-3 {
    margin-left: 25%;
  }
  .react-app-uniforms .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .react-app-uniforms .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .react-app-uniforms .offset-lg-6 {
    margin-left: 50%;
  }
  .react-app-uniforms .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .react-app-uniforms .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .react-app-uniforms .offset-lg-9 {
    margin-left: 75%;
  }
  .react-app-uniforms .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .react-app-uniforms .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .react-app-uniforms .g-lg-0,
  .react-app-uniforms .gx-lg-0 {
    --bs-gutter-x: 0;
  }
  .react-app-uniforms .g-lg-0,
  .react-app-uniforms .gy-lg-0 {
    --bs-gutter-y: 0;
  }
  .react-app-uniforms .g-lg-1,
  .react-app-uniforms .gx-lg-1 {
    --bs-gutter-x: 0.25rem;
  }
  .react-app-uniforms .g-lg-1,
  .react-app-uniforms .gy-lg-1 {
    --bs-gutter-y: 0.25rem;
  }
  .react-app-uniforms .g-lg-2,
  .react-app-uniforms .gx-lg-2 {
    --bs-gutter-x: 0.5rem;
  }
  .react-app-uniforms .g-lg-2,
  .react-app-uniforms .gy-lg-2 {
    --bs-gutter-y: 0.5rem;
  }
  .react-app-uniforms .g-lg-3,
  .react-app-uniforms .gx-lg-3 {
    --bs-gutter-x: 1rem;
  }
  .react-app-uniforms .g-lg-3,
  .react-app-uniforms .gy-lg-3 {
    --bs-gutter-y: 1rem;
  }
  .react-app-uniforms .g-lg-4,
  .react-app-uniforms .gx-lg-4 {
    --bs-gutter-x: 1.5rem;
  }
  .react-app-uniforms .g-lg-4,
  .react-app-uniforms .gy-lg-4 {
    --bs-gutter-y: 1.5rem;
  }
  .react-app-uniforms .g-lg-5,
  .react-app-uniforms .gx-lg-5 {
    --bs-gutter-x: 3rem;
  }
  .react-app-uniforms .g-lg-5,
  .react-app-uniforms .gy-lg-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1200px) {
  .react-app-uniforms .col-xl {
    flex: 1 0 0%;
  }
  .react-app-uniforms .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .react-app-uniforms .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .react-app-uniforms .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .react-app-uniforms .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .react-app-uniforms .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .react-app-uniforms .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .react-app-uniforms .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .react-app-uniforms .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .react-app-uniforms .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .react-app-uniforms .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .react-app-uniforms .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .react-app-uniforms .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .react-app-uniforms .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .react-app-uniforms .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .react-app-uniforms .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .react-app-uniforms .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .react-app-uniforms .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .react-app-uniforms .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .react-app-uniforms .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .react-app-uniforms .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .react-app-uniforms .offset-xl-0 {
    margin-left: 0;
  }
  .react-app-uniforms .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .react-app-uniforms .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .react-app-uniforms .offset-xl-3 {
    margin-left: 25%;
  }
  .react-app-uniforms .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .react-app-uniforms .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .react-app-uniforms .offset-xl-6 {
    margin-left: 50%;
  }
  .react-app-uniforms .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .react-app-uniforms .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .react-app-uniforms .offset-xl-9 {
    margin-left: 75%;
  }
  .react-app-uniforms .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .react-app-uniforms .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .react-app-uniforms .g-xl-0,
  .react-app-uniforms .gx-xl-0 {
    --bs-gutter-x: 0;
  }
  .react-app-uniforms .g-xl-0,
  .react-app-uniforms .gy-xl-0 {
    --bs-gutter-y: 0;
  }
  .react-app-uniforms .g-xl-1,
  .react-app-uniforms .gx-xl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .react-app-uniforms .g-xl-1,
  .react-app-uniforms .gy-xl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .react-app-uniforms .g-xl-2,
  .react-app-uniforms .gx-xl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .react-app-uniforms .g-xl-2,
  .react-app-uniforms .gy-xl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .react-app-uniforms .g-xl-3,
  .react-app-uniforms .gx-xl-3 {
    --bs-gutter-x: 1rem;
  }
  .react-app-uniforms .g-xl-3,
  .react-app-uniforms .gy-xl-3 {
    --bs-gutter-y: 1rem;
  }
  .react-app-uniforms .g-xl-4,
  .react-app-uniforms .gx-xl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .react-app-uniforms .g-xl-4,
  .react-app-uniforms .gy-xl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .react-app-uniforms .g-xl-5,
  .react-app-uniforms .gx-xl-5 {
    --bs-gutter-x: 3rem;
  }
  .react-app-uniforms .g-xl-5,
  .react-app-uniforms .gy-xl-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1400px) {
  .react-app-uniforms .col-xxl {
    flex: 1 0 0%;
  }
  .react-app-uniforms .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .react-app-uniforms .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .react-app-uniforms .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .react-app-uniforms .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .react-app-uniforms .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .react-app-uniforms .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .react-app-uniforms .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .react-app-uniforms .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .react-app-uniforms .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .react-app-uniforms .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .react-app-uniforms .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .react-app-uniforms .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .react-app-uniforms .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .react-app-uniforms .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .react-app-uniforms .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .react-app-uniforms .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .react-app-uniforms .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .react-app-uniforms .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .react-app-uniforms .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .react-app-uniforms .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .react-app-uniforms .offset-xxl-0 {
    margin-left: 0;
  }
  .react-app-uniforms .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .react-app-uniforms .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .react-app-uniforms .offset-xxl-3 {
    margin-left: 25%;
  }
  .react-app-uniforms .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .react-app-uniforms .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .react-app-uniforms .offset-xxl-6 {
    margin-left: 50%;
  }
  .react-app-uniforms .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .react-app-uniforms .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .react-app-uniforms .offset-xxl-9 {
    margin-left: 75%;
  }
  .react-app-uniforms .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .react-app-uniforms .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .react-app-uniforms .g-xxl-0,
  .react-app-uniforms .gx-xxl-0 {
    --bs-gutter-x: 0;
  }
  .react-app-uniforms .g-xxl-0,
  .react-app-uniforms .gy-xxl-0 {
    --bs-gutter-y: 0;
  }
  .react-app-uniforms .g-xxl-1,
  .react-app-uniforms .gx-xxl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .react-app-uniforms .g-xxl-1,
  .react-app-uniforms .gy-xxl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .react-app-uniforms .g-xxl-2,
  .react-app-uniforms .gx-xxl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .react-app-uniforms .g-xxl-2,
  .react-app-uniforms .gy-xxl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .react-app-uniforms .g-xxl-3,
  .react-app-uniforms .gx-xxl-3 {
    --bs-gutter-x: 1rem;
  }
  .react-app-uniforms .g-xxl-3,
  .react-app-uniforms .gy-xxl-3 {
    --bs-gutter-y: 1rem;
  }
  .react-app-uniforms .g-xxl-4,
  .react-app-uniforms .gx-xxl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .react-app-uniforms .g-xxl-4,
  .react-app-uniforms .gy-xxl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .react-app-uniforms .g-xxl-5,
  .react-app-uniforms .gx-xxl-5 {
    --bs-gutter-x: 3rem;
  }
  .react-app-uniforms .g-xxl-5,
  .react-app-uniforms .gy-xxl-5 {
    --bs-gutter-y: 3rem;
  }
}
.react-app-uniforms .table {
  --bs-table-color-type: initial;
  --bs-table-bg-type: initial;
  --bs-table-color-state: initial;
  --bs-table-bg-state: initial;
  --bs-table-color: var(--bs-emphasis-color);
  --bs-table-bg: var(--bs-body-bg);
  --bs-table-border-color: var(--bs-border-color);
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: var(--bs-emphasis-color);
  --bs-table-striped-bg: rgba(var(--bs-emphasis-color-rgb), 0.05);
  --bs-table-active-color: var(--bs-emphasis-color);
  --bs-table-active-bg: rgba(var(--bs-emphasis-color-rgb), 0.1);
  --bs-table-hover-color: var(--bs-emphasis-color);
  --bs-table-hover-bg: rgba(var(--bs-emphasis-color-rgb), 0.075);
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--bs-table-border-color);
}
.react-app-uniforms .table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
  background-color: var(--bs-table-bg);
  border-bottom-width: var(--bs-border-width);
  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
}
.react-app-uniforms .table > tbody {
  vertical-align: inherit;
}
.react-app-uniforms .table > thead {
  vertical-align: bottom;
}
.react-app-uniforms .table-group-divider {
  border-top: calc(var(--bs-border-width) * 2) solid currentcolor;
}
.react-app-uniforms .caption-top {
  caption-side: top;
}
.react-app-uniforms .table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}
.react-app-uniforms .table-bordered > :not(caption) > * {
  border-width: var(--bs-border-width) 0;
}
.react-app-uniforms .table-bordered > :not(caption) > * > * {
  border-width: 0 var(--bs-border-width);
}
.react-app-uniforms .table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.react-app-uniforms .table-borderless > :not(:first-child) {
  border-top-width: 0;
}
.react-app-uniforms .table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}
.react-app-uniforms .table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}
.react-app-uniforms .table-active {
  --bs-table-color-state: var(--bs-table-active-color);
  --bs-table-bg-state: var(--bs-table-active-bg);
}
.react-app-uniforms .table-hover > tbody > tr:hover > * {
  --bs-table-color-state: var(--bs-table-hover-color);
  --bs-table-bg-state: var(--bs-table-hover-bg);
}
.react-app-uniforms .table-primary {
  --bs-table-color: #000;
  --bs-table-bg: #cee9ee;
  --bs-table-border-color: #a5babe;
  --bs-table-striped-bg: #c4dde2;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #b9d2d6;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #bfd8dc;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.react-app-uniforms .table-secondary {
  --bs-table-color: #000;
  --bs-table-bg: #fcfdfd;
  --bs-table-border-color: #cacaca;
  --bs-table-striped-bg: #eff0f0;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #e3e4e4;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #e9eaea;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.react-app-uniforms .table-success {
  --bs-table-color: #000;
  --bs-table-bg: #d1e7dd;
  --bs-table-border-color: #a7b9b1;
  --bs-table-striped-bg: #c7dbd2;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #bcd0c7;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #c1d6cc;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.react-app-uniforms .table-info {
  --bs-table-color: #000;
  --bs-table-bg: white;
  --bs-table-border-color: #cccccc;
  --bs-table-striped-bg: #f2f2f2;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #e6e6e6;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #ececec;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.react-app-uniforms .table-warning {
  --bs-table-color: #000;
  --bs-table-bg: #fff3cd;
  --bs-table-border-color: #ccc2a4;
  --bs-table-striped-bg: #f2e7c3;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #e6dbb9;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #ece1be;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.react-app-uniforms .table-danger {
  --bs-table-color: #000;
  --bs-table-bg: #f8d7da;
  --bs-table-border-color: #c6acae;
  --bs-table-striped-bg: #eccccf;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #dfc2c4;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #e5c7ca;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.react-app-uniforms .table-light {
  --bs-table-color: #000;
  --bs-table-bg: #f8f9fa;
  --bs-table-border-color: #c6c7c8;
  --bs-table-striped-bg: #ecedee;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #dfe0e1;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #e5e6e7;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.react-app-uniforms .table-dark {
  --bs-table-color: #fff;
  --bs-table-bg: #212529;
  --bs-table-border-color: #4d5154;
  --bs-table-striped-bg: #2c3034;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: #373b3e;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #323539;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.react-app-uniforms .table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
@media (max-width: 575.98px) {
  .react-app-uniforms .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .react-app-uniforms .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .react-app-uniforms .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .react-app-uniforms .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .react-app-uniforms .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.react-app-uniforms .form-label {
  margin-bottom: 0.5rem;
}
.react-app-uniforms .col-form-label {
  padding-top: calc(0.375rem + var(--bs-border-width));
  padding-bottom: calc(0.375rem + var(--bs-border-width));
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}
.react-app-uniforms .col-form-label-lg {
  padding-top: calc(0.5rem + var(--bs-border-width));
  padding-bottom: calc(0.5rem + var(--bs-border-width));
  font-size: 1.25rem;
}
.react-app-uniforms .col-form-label-sm {
  padding-top: calc(0.25rem + var(--bs-border-width));
  padding-bottom: calc(0.25rem + var(--bs-border-width));
  font-size: 0.875rem;
}
.react-app-uniforms .form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}
.react-app-uniforms .form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-clip: padding-box;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .react-app-uniforms .form-control {
    transition: none;
  }
}
.react-app-uniforms .form-control[type=file] {
  overflow: hidden;
}
.react-app-uniforms .form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.react-app-uniforms .form-control:focus {
  color: var(--bs-body-color);
  background-color: var(--bs-body-bg);
  border-color: #86c9d4;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(12, 147, 169, 0.25);
}
.react-app-uniforms .form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.5em;
  margin: 0;
}
.react-app-uniforms .form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.react-app-uniforms .form-control::placeholder {
  color: var(--bs-secondary-color);
  opacity: 1;
}
.react-app-uniforms .form-control:disabled {
  background-color: var(--bs-secondary-bg);
  opacity: 1;
}
.react-app-uniforms .form-control::file-selector-button {
  padding: 0.375rem 0.75rem;
  margin: -0.375rem -0.75rem;
  margin-inline-end: 0.75rem;
  color: var(--bs-body-color);
  background-color: var(--bs-tertiary-bg);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: var(--bs-border-width);
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .react-app-uniforms .form-control::file-selector-button {
    transition: none;
  }
}
.react-app-uniforms .form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: var(--bs-secondary-bg);
}
.react-app-uniforms .form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--bs-body-color);
  background-color: transparent;
  border: solid transparent;
  border-width: var(--bs-border-width) 0;
}
.react-app-uniforms .form-control-plaintext:focus {
  outline: 0;
}
.react-app-uniforms .form-control-plaintext.form-control-sm, .react-app-uniforms .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}
.react-app-uniforms .form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}
.react-app-uniforms .form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  margin-inline-end: 0.5rem;
}
.react-app-uniforms .form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}
.react-app-uniforms .form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
}
.react-app-uniforms textarea.form-control {
  min-height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
}
.react-app-uniforms textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}
.react-app-uniforms textarea.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
}
.react-app-uniforms .form-control-color {
  width: 3rem;
  height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
  padding: 0.375rem;
}
.react-app-uniforms .form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.react-app-uniforms .form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: var(--bs-border-radius);
}
.react-app-uniforms .form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: var(--bs-border-radius);
}
.react-app-uniforms .form-control-color.form-control-sm {
  height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}
.react-app-uniforms .form-control-color.form-control-lg {
  height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
}
.react-app-uniforms .form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .react-app-uniforms .form-select {
    transition: none;
  }
}
.react-app-uniforms .form-select:focus {
  border-color: #86c9d4;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(12, 147, 169, 0.25);
}
.react-app-uniforms .form-select[multiple], .react-app-uniforms .form-select[size]:not([size="1"]) {
  padding-right: 0.75rem;
  background-image: none;
}
.react-app-uniforms .form-select:disabled {
  background-color: var(--bs-secondary-bg);
}
.react-app-uniforms .form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 var(--bs-body-color);
}
.react-app-uniforms .form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}
.react-app-uniforms .form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}
.react-app-uniforms [data-bs-theme=dark] .form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.react-app-uniforms .form-check {
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem;
}
.react-app-uniforms .form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}
.react-app-uniforms .form-check-reverse {
  padding-right: 1.5em;
  padding-left: 0;
  text-align: right;
}
.react-app-uniforms .form-check-reverse .form-check-input {
  float: right;
  margin-right: -1.5em;
  margin-left: 0;
}
.react-app-uniforms .form-check-input {
  --bs-form-check-bg: var(--bs-body-bg);
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  appearance: none;
  background-color: var(--bs-form-check-bg);
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: var(--bs-border-width) solid var(--bs-border-color);
  print-color-adjust: exact;
}
.react-app-uniforms .form-check-input[type=checkbox] {
  border-radius: 0.25em;
}
.react-app-uniforms .form-check-input[type=radio] {
  border-radius: 50%;
}
.react-app-uniforms .form-check-input:active {
  filter: brightness(90%);
}
.react-app-uniforms .form-check-input:focus {
  border-color: #86c9d4;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(12, 147, 169, 0.25);
}
.react-app-uniforms .form-check-input:checked {
  background-color: #0C93A9;
  border-color: #0C93A9;
}
.react-app-uniforms .form-check-input:checked[type=checkbox] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.react-app-uniforms .form-check-input:checked[type=radio] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.react-app-uniforms .form-check-input[type=checkbox]:indeterminate {
  background-color: #0C93A9;
  border-color: #0C93A9;
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.react-app-uniforms .form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.react-app-uniforms .form-check-input[disabled] ~ .form-check-label, .react-app-uniforms .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}
.react-app-uniforms .form-switch {
  padding-left: 2.5em;
}
.react-app-uniforms .form-switch .form-check-input {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  width: 2em;
  margin-left: -2.5em;
  background-image: var(--bs-form-switch-bg);
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .react-app-uniforms .form-switch .form-check-input {
    transition: none;
  }
}
.react-app-uniforms .form-switch .form-check-input:focus {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.react-app-uniforms .form-switch .form-check-input:checked {
  background-position: right center;
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.react-app-uniforms .form-switch.form-check-reverse {
  padding-right: 2.5em;
  padding-left: 0;
}
.react-app-uniforms .form-switch.form-check-reverse .form-check-input {
  margin-right: -2.5em;
  margin-left: 0;
}
.react-app-uniforms .form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}
.react-app-uniforms .btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.react-app-uniforms .btn-check[disabled] + .btn, .react-app-uniforms .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}
.react-app-uniforms [data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
.react-app-uniforms .form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  appearance: none;
  background-color: transparent;
}
.react-app-uniforms .form-range:focus {
  outline: 0;
}
.react-app-uniforms .form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(12, 147, 169, 0.25);
}
.react-app-uniforms .form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(12, 147, 169, 0.25);
}
.react-app-uniforms .form-range::-moz-focus-outer {
  border: 0;
}
.react-app-uniforms .form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  appearance: none;
  background-color: #0C93A9;
  border: 0;
  border-radius: 1rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .react-app-uniforms .form-range::-webkit-slider-thumb {
    transition: none;
  }
}
.react-app-uniforms .form-range::-webkit-slider-thumb:active {
  background-color: #b6dfe5;
}
.react-app-uniforms .form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.react-app-uniforms .form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: #0C93A9;
  border: 0;
  border-radius: 1rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .react-app-uniforms .form-range::-moz-range-thumb {
    transition: none;
  }
}
.react-app-uniforms .form-range::-moz-range-thumb:active {
  background-color: #b6dfe5;
}
.react-app-uniforms .form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.react-app-uniforms .form-range:disabled {
  pointer-events: none;
}
.react-app-uniforms .form-range:disabled::-webkit-slider-thumb {
  background-color: var(--bs-secondary-color);
}
.react-app-uniforms .form-range:disabled::-moz-range-thumb {
  background-color: var(--bs-secondary-color);
}
.react-app-uniforms .form-floating {
  position: relative;
}
.react-app-uniforms .form-floating > .form-control,
.react-app-uniforms .form-floating > .form-control-plaintext,
.react-app-uniforms .form-floating > .form-select {
  height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  min-height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  line-height: 1.25;
}
.react-app-uniforms .form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  height: 100%;
  padding: 1rem 0.75rem;
  overflow: hidden;
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: var(--bs-border-width) solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .react-app-uniforms .form-floating > label {
    transition: none;
  }
}
.react-app-uniforms .form-floating > .form-control,
.react-app-uniforms .form-floating > .form-control-plaintext {
  padding: 1rem 0.75rem;
}
.react-app-uniforms .form-floating > .form-control::placeholder,
.react-app-uniforms .form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.react-app-uniforms .form-floating > .form-control:focus, .react-app-uniforms .form-floating > .form-control:not(:placeholder-shown),
.react-app-uniforms .form-floating > .form-control-plaintext:focus,
.react-app-uniforms .form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.react-app-uniforms .form-floating > .form-control:-webkit-autofill,
.react-app-uniforms .form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.react-app-uniforms .form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.react-app-uniforms .form-floating > .form-control:focus ~ label,
.react-app-uniforms .form-floating > .form-control:not(:placeholder-shown) ~ label,
.react-app-uniforms .form-floating > .form-control-plaintext ~ label,
.react-app-uniforms .form-floating > .form-select ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.react-app-uniforms .form-floating > .form-control:focus ~ label::after,
.react-app-uniforms .form-floating > .form-control:not(:placeholder-shown) ~ label::after,
.react-app-uniforms .form-floating > .form-control-plaintext ~ label::after,
.react-app-uniforms .form-floating > .form-select ~ label::after {
  position: absolute;
  inset: 1rem 0.375rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: var(--bs-body-bg);
  border-radius: var(--bs-border-radius);
}
.react-app-uniforms .form-floating > .form-control:-webkit-autofill ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.react-app-uniforms .form-floating > .form-control-plaintext ~ label {
  border-width: var(--bs-border-width) 0;
}
.react-app-uniforms .form-floating > :disabled ~ label,
.react-app-uniforms .form-floating > .form-control:disabled ~ label {
  color: #6c757d;
}
.react-app-uniforms .form-floating > :disabled ~ label::after,
.react-app-uniforms .form-floating > .form-control:disabled ~ label::after {
  background-color: var(--bs-secondary-bg);
}
.react-app-uniforms .input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.react-app-uniforms .input-group > .form-control,
.react-app-uniforms .input-group > .form-select,
.react-app-uniforms .input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.react-app-uniforms .input-group > .form-control:focus,
.react-app-uniforms .input-group > .form-select:focus,
.react-app-uniforms .input-group > .form-floating:focus-within {
  z-index: 5;
}
.react-app-uniforms .input-group .btn {
  position: relative;
  z-index: 2;
}
.react-app-uniforms .input-group .btn:focus {
  z-index: 5;
}
.react-app-uniforms .input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-tertiary-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
}
.react-app-uniforms .input-group-lg > .form-control,
.react-app-uniforms .input-group-lg > .form-select,
.react-app-uniforms .input-group-lg > .input-group-text,
.react-app-uniforms .input-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}
.react-app-uniforms .input-group-sm > .form-control,
.react-app-uniforms .input-group-sm > .form-select,
.react-app-uniforms .input-group-sm > .input-group-text,
.react-app-uniforms .input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}
.react-app-uniforms .input-group-lg > .form-select,
.react-app-uniforms .input-group-sm > .form-select {
  padding-right: 3rem;
}
.react-app-uniforms .input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.react-app-uniforms .input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.react-app-uniforms .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.react-app-uniforms .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.react-app-uniforms .input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.react-app-uniforms .input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.react-app-uniforms .input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.react-app-uniforms .input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.react-app-uniforms .input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(var(--bs-border-width) * -1);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.react-app-uniforms .input-group > .form-floating:not(:first-child) > .form-control,
.react-app-uniforms .input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.react-app-uniforms .valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-valid-color);
}
.react-app-uniforms .valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--bs-success);
  border-radius: var(--bs-border-radius);
}
.was-validated .react-app-uniforms:valid ~ .valid-feedback,
.was-validated .react-app-uniforms:valid ~ .valid-tooltip, .react-app-uniforms.is-valid ~ .valid-feedback,
.react-app-uniforms.is-valid ~ .valid-tooltip {
  display: block;
}
.was-validated .react-app-uniforms .form-control:valid, .react-app-uniforms .form-control.is-valid {
  border-color: var(--bs-form-valid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .react-app-uniforms .form-control:valid:focus, .react-app-uniforms .form-control.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}
.was-validated .react-app-uniforms textarea.form-control:valid, .react-app-uniforms textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}
.was-validated .react-app-uniforms .form-select:valid, .react-app-uniforms .form-select.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .react-app-uniforms .form-select:valid:not([multiple]):not([size]), .was-validated .react-app-uniforms .form-select:valid:not([multiple])[size="1"], .react-app-uniforms .form-select.is-valid:not([multiple]):not([size]), .react-app-uniforms .form-select.is-valid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .react-app-uniforms .form-select:valid:focus, .react-app-uniforms .form-select.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}
.was-validated .react-app-uniforms .form-control-color:valid, .react-app-uniforms .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}
.was-validated .react-app-uniforms .form-check-input:valid, .react-app-uniforms .form-check-input.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .react-app-uniforms .form-check-input:valid:checked, .react-app-uniforms .form-check-input.is-valid:checked {
  background-color: var(--bs-form-valid-color);
}
.was-validated .react-app-uniforms .form-check-input:valid:focus, .react-app-uniforms .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}
.was-validated .react-app-uniforms .form-check-input:valid ~ .form-check-label, .react-app-uniforms .form-check-input.is-valid ~ .form-check-label {
  color: var(--bs-form-valid-color);
}
.react-app-uniforms .form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}
.was-validated .react-app-uniforms .input-group > .form-control:not(:focus):valid, .react-app-uniforms .input-group > .form-control:not(:focus).is-valid,
.was-validated .react-app-uniforms .input-group > .form-select:not(:focus):valid,
.react-app-uniforms .input-group > .form-select:not(:focus).is-valid,
.was-validated .react-app-uniforms .input-group > .form-floating:not(:focus-within):valid,
.react-app-uniforms .input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}
.react-app-uniforms .invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-invalid-color);
}
.react-app-uniforms .invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--bs-danger);
  border-radius: var(--bs-border-radius);
}
.was-validated .react-app-uniforms:invalid ~ .invalid-feedback,
.was-validated .react-app-uniforms:invalid ~ .invalid-tooltip, .react-app-uniforms.is-invalid ~ .invalid-feedback,
.react-app-uniforms.is-invalid ~ .invalid-tooltip {
  display: block;
}
.was-validated .react-app-uniforms .form-control:invalid, .react-app-uniforms .form-control.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .react-app-uniforms .form-control:invalid:focus, .react-app-uniforms .form-control.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}
.was-validated .react-app-uniforms textarea.form-control:invalid, .react-app-uniforms textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}
.was-validated .react-app-uniforms .form-select:invalid, .react-app-uniforms .form-select.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .react-app-uniforms .form-select:invalid:not([multiple]):not([size]), .was-validated .react-app-uniforms .form-select:invalid:not([multiple])[size="1"], .react-app-uniforms .form-select.is-invalid:not([multiple]):not([size]), .react-app-uniforms .form-select.is-invalid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .react-app-uniforms .form-select:invalid:focus, .react-app-uniforms .form-select.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}
.was-validated .react-app-uniforms .form-control-color:invalid, .react-app-uniforms .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}
.was-validated .react-app-uniforms .form-check-input:invalid, .react-app-uniforms .form-check-input.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .react-app-uniforms .form-check-input:invalid:checked, .react-app-uniforms .form-check-input.is-invalid:checked {
  background-color: var(--bs-form-invalid-color);
}
.was-validated .react-app-uniforms .form-check-input:invalid:focus, .react-app-uniforms .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}
.was-validated .react-app-uniforms .form-check-input:invalid ~ .form-check-label, .react-app-uniforms .form-check-input.is-invalid ~ .form-check-label {
  color: var(--bs-form-invalid-color);
}
.react-app-uniforms .form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}
.was-validated .react-app-uniforms .input-group > .form-control:not(:focus):invalid, .react-app-uniforms .input-group > .form-control:not(:focus).is-invalid,
.was-validated .react-app-uniforms .input-group > .form-select:not(:focus):invalid,
.react-app-uniforms .input-group > .form-select:not(:focus).is-invalid,
.was-validated .react-app-uniforms .input-group > .form-floating:not(:focus-within):invalid,
.react-app-uniforms .input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}
.react-app-uniforms .btn {
  --bs-btn-padding-x: 0.75rem;
  --bs-btn-padding-y: 0.375rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 1rem;
  --bs-btn-font-weight: 400;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: var(--bs-body-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-width: var(--bs-border-width);
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: var(--bs-border-radius);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .react-app-uniforms .btn {
    transition: none;
  }
}
.react-app-uniforms .btn:hover {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
}
.btn-check + .react-app-uniforms .btn:hover {
  color: var(--bs-btn-color);
  background-color: var(--bs-btn-bg);
  border-color: var(--bs-btn-border-color);
}
.react-app-uniforms .btn:focus-visible {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:focus-visible + .react-app-uniforms .btn {
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked + .react-app-uniforms .btn, :not(.btn-check) + .react-app-uniforms .btn:active, .react-app-uniforms .btn:first-child:active, .react-app-uniforms .btn.active, .react-app-uniforms .btn.show {
  color: var(--bs-btn-active-color);
  background-color: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
}
.btn-check:checked + .react-app-uniforms .btn:focus-visible, :not(.btn-check) + .react-app-uniforms .btn:active:focus-visible, .react-app-uniforms .btn:first-child:active:focus-visible, .react-app-uniforms .btn.active:focus-visible, .react-app-uniforms .btn.show:focus-visible {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.react-app-uniforms .btn:disabled, .react-app-uniforms .btn.disabled, fieldset:disabled .react-app-uniforms .btn {
  color: var(--bs-btn-disabled-color);
  pointer-events: none;
  background-color: var(--bs-btn-disabled-bg);
  border-color: var(--bs-btn-disabled-border-color);
  opacity: var(--bs-btn-disabled-opacity);
}
.react-app-uniforms .btn-primary {
  --bs-btn-color: #000;
  --bs-btn-bg: #0C93A9;
  --bs-btn-border-color: #0C93A9;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #30a3b6;
  --bs-btn-hover-border-color: #249eb2;
  --bs-btn-focus-shadow-rgb: 10, 125, 144;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #3da9ba;
  --bs-btn-active-border-color: #249eb2;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #0C93A9;
  --bs-btn-disabled-border-color: #0C93A9;
}
.react-app-uniforms .btn-secondary {
  --bs-btn-color: #000;
  --bs-btn-bg: #EEF4F5;
  --bs-btn-border-color: #EEF4F5;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #f1f6f7;
  --bs-btn-hover-border-color: #f0f5f6;
  --bs-btn-focus-shadow-rgb: 202, 207, 208;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #f1f6f7;
  --bs-btn-active-border-color: #f0f5f6;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #EEF4F5;
  --bs-btn-disabled-border-color: #EEF4F5;
}
.react-app-uniforms .btn-success {
  --bs-btn-color: #fff;
  --bs-btn-bg: #198754;
  --bs-btn-border-color: #198754;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #157347;
  --bs-btn-hover-border-color: #146c43;
  --bs-btn-focus-shadow-rgb: 60, 153, 110;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #146c43;
  --bs-btn-active-border-color: #13653f;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #198754;
  --bs-btn-disabled-border-color: #198754;
}
.react-app-uniforms .btn-info {
  --bs-btn-color: #000;
  --bs-btn-bg: #FFF;
  --bs-btn-border-color: #FFF;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: white;
  --bs-btn-hover-border-color: white;
  --bs-btn-focus-shadow-rgb: 217, 217, 217;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: white;
  --bs-btn-active-border-color: white;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #FFF;
  --bs-btn-disabled-border-color: #FFF;
}
.react-app-uniforms .btn-warning {
  --bs-btn-color: #000;
  --bs-btn-bg: #ffc107;
  --bs-btn-border-color: #ffc107;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #ffca2c;
  --bs-btn-hover-border-color: #ffc720;
  --bs-btn-focus-shadow-rgb: 217, 164, 6;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ffcd39;
  --bs-btn-active-border-color: #ffc720;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #ffc107;
  --bs-btn-disabled-border-color: #ffc107;
}
.react-app-uniforms .btn-danger {
  --bs-btn-color: #fff;
  --bs-btn-bg: #dc3545;
  --bs-btn-border-color: #dc3545;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #bb2d3b;
  --bs-btn-hover-border-color: #b02a37;
  --bs-btn-focus-shadow-rgb: 225, 83, 97;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #b02a37;
  --bs-btn-active-border-color: #a52834;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #dc3545;
  --bs-btn-disabled-border-color: #dc3545;
}
.react-app-uniforms .btn-light {
  --bs-btn-color: #000;
  --bs-btn-bg: #f8f9fa;
  --bs-btn-border-color: #f8f9fa;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #d3d4d5;
  --bs-btn-hover-border-color: #c6c7c8;
  --bs-btn-focus-shadow-rgb: 211, 212, 213;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #c6c7c8;
  --bs-btn-active-border-color: #babbbc;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #f8f9fa;
  --bs-btn-disabled-border-color: #f8f9fa;
}
.react-app-uniforms .btn-dark {
  --bs-btn-color: #fff;
  --bs-btn-bg: #212529;
  --bs-btn-border-color: #212529;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #424649;
  --bs-btn-hover-border-color: #373b3e;
  --bs-btn-focus-shadow-rgb: 66, 70, 73;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #4d5154;
  --bs-btn-active-border-color: #373b3e;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #212529;
  --bs-btn-disabled-border-color: #212529;
}
.react-app-uniforms .btn-outline-primary {
  --bs-btn-color: #0C93A9;
  --bs-btn-border-color: #0C93A9;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #0C93A9;
  --bs-btn-hover-border-color: #0C93A9;
  --bs-btn-focus-shadow-rgb: 12, 147, 169;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #0C93A9;
  --bs-btn-active-border-color: #0C93A9;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0C93A9;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0C93A9;
  --bs-gradient: none;
}
.react-app-uniforms .btn-outline-secondary {
  --bs-btn-color: #EEF4F5;
  --bs-btn-border-color: #EEF4F5;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #EEF4F5;
  --bs-btn-hover-border-color: #EEF4F5;
  --bs-btn-focus-shadow-rgb: 238, 244, 245;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #EEF4F5;
  --bs-btn-active-border-color: #EEF4F5;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #EEF4F5;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #EEF4F5;
  --bs-gradient: none;
}
.react-app-uniforms .btn-outline-success {
  --bs-btn-color: #198754;
  --bs-btn-border-color: #198754;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #198754;
  --bs-btn-hover-border-color: #198754;
  --bs-btn-focus-shadow-rgb: 25, 135, 84;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #198754;
  --bs-btn-active-border-color: #198754;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #198754;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #198754;
  --bs-gradient: none;
}
.react-app-uniforms .btn-outline-info {
  --bs-btn-color: #FFF;
  --bs-btn-border-color: #FFF;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #FFF;
  --bs-btn-hover-border-color: #FFF;
  --bs-btn-focus-shadow-rgb: 255, 255, 255;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #FFF;
  --bs-btn-active-border-color: #FFF;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #FFF;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #FFF;
  --bs-gradient: none;
}
.react-app-uniforms .btn-outline-warning {
  --bs-btn-color: #ffc107;
  --bs-btn-border-color: #ffc107;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #ffc107;
  --bs-btn-hover-border-color: #ffc107;
  --bs-btn-focus-shadow-rgb: 255, 193, 7;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ffc107;
  --bs-btn-active-border-color: #ffc107;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffc107;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ffc107;
  --bs-gradient: none;
}
.react-app-uniforms .btn-outline-danger {
  --bs-btn-color: #dc3545;
  --bs-btn-border-color: #dc3545;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #dc3545;
  --bs-btn-hover-border-color: #dc3545;
  --bs-btn-focus-shadow-rgb: 220, 53, 69;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #dc3545;
  --bs-btn-active-border-color: #dc3545;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #dc3545;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #dc3545;
  --bs-gradient: none;
}
.react-app-uniforms .btn-outline-light {
  --bs-btn-color: #f8f9fa;
  --bs-btn-border-color: #f8f9fa;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #f8f9fa;
  --bs-btn-hover-border-color: #f8f9fa;
  --bs-btn-focus-shadow-rgb: 248, 249, 250;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #f8f9fa;
  --bs-btn-active-border-color: #f8f9fa;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f8f9fa;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f8f9fa;
  --bs-gradient: none;
}
.react-app-uniforms .btn-outline-dark {
  --bs-btn-color: #212529;
  --bs-btn-border-color: #212529;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #212529;
  --bs-btn-hover-border-color: #212529;
  --bs-btn-focus-shadow-rgb: 33, 37, 41;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #212529;
  --bs-btn-active-border-color: #212529;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #212529;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #212529;
  --bs-gradient: none;
}
.react-app-uniforms .btn-link {
  --bs-btn-font-weight: 400;
  --bs-btn-color: var(--bs-link-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: var(--bs-link-hover-color);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: var(--bs-link-hover-color);
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: 0 0 0 #000;
  --bs-btn-focus-shadow-rgb: 10, 125, 144;
  text-decoration: underline;
}
.react-app-uniforms .btn-link:focus-visible {
  color: var(--bs-btn-color);
}
.react-app-uniforms .btn-link:hover {
  color: var(--bs-btn-hover-color);
}
.react-app-uniforms .btn-lg, .react-app-uniforms .btn-group-lg > .btn {
  --bs-btn-padding-y: 0.5rem;
  --bs-btn-padding-x: 1rem;
  --bs-btn-font-size: 1.25rem;
  --bs-btn-border-radius: var(--bs-border-radius-lg);
}
.react-app-uniforms .btn-sm, .react-app-uniforms .btn-group-sm > .btn {
  --bs-btn-padding-y: 0.25rem;
  --bs-btn-padding-x: 0.5rem;
  --bs-btn-font-size: 0.875rem;
  --bs-btn-border-radius: var(--bs-border-radius-sm);
}
.react-app-uniforms .fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .react-app-uniforms .fade {
    transition: none;
  }
}
.react-app-uniforms .fade:not(.show) {
  opacity: 0;
}
.react-app-uniforms .collapse:not(.show) {
  display: none;
}
.react-app-uniforms .collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .react-app-uniforms .collapsing {
    transition: none;
  }
}
.react-app-uniforms .collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .react-app-uniforms .collapsing.collapse-horizontal {
    transition: none;
  }
}
.react-app-uniforms .dropup,
.react-app-uniforms .dropend,
.react-app-uniforms .dropdown,
.react-app-uniforms .dropstart,
.react-app-uniforms .dropup-center,
.react-app-uniforms .dropdown-center {
  position: relative;
}
.react-app-uniforms .dropdown-toggle {
  white-space: nowrap;
}
.react-app-uniforms .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.react-app-uniforms .dropdown-toggle:empty::after {
  margin-left: 0;
}
.react-app-uniforms .dropdown-menu {
  --bs-dropdown-zindex: 1000;
  --bs-dropdown-min-width: 10rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0.5rem;
  --bs-dropdown-spacer: 0.125rem;
  --bs-dropdown-font-size: 1rem;
  --bs-dropdown-color: var(--bs-body-color);
  --bs-dropdown-bg: var(--bs-body-bg);
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-border-radius: var(--bs-border-radius);
  --bs-dropdown-border-width: var(--bs-border-width);
  --bs-dropdown-inner-border-radius: calc(var(--bs-border-radius) - var(--bs-border-width));
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-divider-margin-y: 0.5rem;
  --bs-dropdown-box-shadow: var(--bs-box-shadow);
  --bs-dropdown-link-color: var(--bs-body-color);
  --bs-dropdown-link-hover-color: var(--bs-body-color);
  --bs-dropdown-link-hover-bg: var(--bs-tertiary-bg);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0C93A9;
  --bs-dropdown-link-disabled-color: var(--bs-tertiary-color);
  --bs-dropdown-item-padding-x: 1rem;
  --bs-dropdown-item-padding-y: 0.25rem;
  --bs-dropdown-header-color: #6c757d;
  --bs-dropdown-header-padding-x: 1rem;
  --bs-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius);
}
.react-app-uniforms .dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--bs-dropdown-spacer);
}
.react-app-uniforms .dropdown-menu-start {
  --bs-position: start;
}
.react-app-uniforms .dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}
.react-app-uniforms .dropdown-menu-end {
  --bs-position: end;
}
.react-app-uniforms .dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}
@media (min-width: 576px) {
  .react-app-uniforms .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .react-app-uniforms .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .react-app-uniforms .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .react-app-uniforms .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .react-app-uniforms .dropdown-menu-md-start {
    --bs-position: start;
  }
  .react-app-uniforms .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .react-app-uniforms .dropdown-menu-md-end {
    --bs-position: end;
  }
  .react-app-uniforms .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .react-app-uniforms .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .react-app-uniforms .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .react-app-uniforms .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .react-app-uniforms .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .react-app-uniforms .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .react-app-uniforms .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .react-app-uniforms .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .react-app-uniforms .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .react-app-uniforms .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  .react-app-uniforms .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .react-app-uniforms .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  .react-app-uniforms .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.react-app-uniforms .dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer);
}
.react-app-uniforms .dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.react-app-uniforms .dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}
.react-app-uniforms .dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer);
}
.react-app-uniforms .dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.react-app-uniforms .dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}
.react-app-uniforms .dropend .dropdown-toggle::after {
  vertical-align: 0;
}
.react-app-uniforms .dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer);
}
.react-app-uniforms .dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.react-app-uniforms .dropstart .dropdown-toggle::after {
  display: none;
}
.react-app-uniforms .dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.react-app-uniforms .dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}
.react-app-uniforms .dropstart .dropdown-toggle::before {
  vertical-align: 0;
}
.react-app-uniforms .dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1;
}
.react-app-uniforms .dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--bs-dropdown-item-border-radius, 0);
}
.react-app-uniforms .dropdown-item:hover, .react-app-uniforms .dropdown-item:focus {
  color: var(--bs-dropdown-link-hover-color);
  background-color: var(--bs-dropdown-link-hover-bg);
}
.react-app-uniforms .dropdown-item.active, .react-app-uniforms .dropdown-item:active {
  color: var(--bs-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-active-bg);
}
.react-app-uniforms .dropdown-item.disabled, .react-app-uniforms .dropdown-item:disabled {
  color: var(--bs-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}
.react-app-uniforms .dropdown-menu.show {
  display: block;
}
.react-app-uniforms .dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.875rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap;
}
.react-app-uniforms .dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color);
}
.react-app-uniforms .dropdown-menu-dark {
  --bs-dropdown-color: #dee2e6;
  --bs-dropdown-bg: #343a40;
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: #dee2e6;
  --bs-dropdown-link-hover-color: #fff;
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0C93A9;
  --bs-dropdown-link-disabled-color: #adb5bd;
  --bs-dropdown-header-color: #adb5bd;
}
.react-app-uniforms .btn-group,
.react-app-uniforms .btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.react-app-uniforms .btn-group > .btn,
.react-app-uniforms .btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.react-app-uniforms .btn-group > .btn-check:checked + .btn,
.react-app-uniforms .btn-group > .btn-check:focus + .btn,
.react-app-uniforms .btn-group > .btn:hover,
.react-app-uniforms .btn-group > .btn:focus,
.react-app-uniforms .btn-group > .btn:active,
.react-app-uniforms .btn-group > .btn.active,
.react-app-uniforms .btn-group-vertical > .btn-check:checked + .btn,
.react-app-uniforms .btn-group-vertical > .btn-check:focus + .btn,
.react-app-uniforms .btn-group-vertical > .btn:hover,
.react-app-uniforms .btn-group-vertical > .btn:focus,
.react-app-uniforms .btn-group-vertical > .btn:active,
.react-app-uniforms .btn-group-vertical > .btn.active {
  z-index: 1;
}
.react-app-uniforms .btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.react-app-uniforms .btn-toolbar .input-group {
  width: auto;
}
.react-app-uniforms .btn-group {
  border-radius: var(--bs-border-radius);
}
.react-app-uniforms .btn-group > :not(.btn-check:first-child) + .btn,
.react-app-uniforms .btn-group > .btn-group:not(:first-child) {
  margin-left: calc(var(--bs-border-width) * -1);
}
.react-app-uniforms .btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.react-app-uniforms .btn-group > .btn.dropdown-toggle-split:first-child,
.react-app-uniforms .btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.react-app-uniforms .btn-group > .btn:nth-child(n+3),
.react-app-uniforms .btn-group > :not(.btn-check) + .btn,
.react-app-uniforms .btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.react-app-uniforms .dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
.react-app-uniforms .dropdown-toggle-split::after, .dropup .react-app-uniforms .dropdown-toggle-split::after, .dropend .react-app-uniforms .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .react-app-uniforms .dropdown-toggle-split::before {
  margin-right: 0;
}
.react-app-uniforms .btn-sm + .dropdown-toggle-split, .react-app-uniforms .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}
.react-app-uniforms .btn-lg + .dropdown-toggle-split, .react-app-uniforms .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}
.react-app-uniforms .btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.react-app-uniforms .btn-group-vertical > .btn,
.react-app-uniforms .btn-group-vertical > .btn-group {
  width: 100%;
}
.react-app-uniforms .btn-group-vertical > .btn:not(:first-child),
.react-app-uniforms .btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(var(--bs-border-width) * -1);
}
.react-app-uniforms .btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.react-app-uniforms .btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.react-app-uniforms .btn-group-vertical > .btn ~ .btn,
.react-app-uniforms .btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.react-app-uniforms .nav {
  --bs-nav-link-padding-x: 1rem;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-link-color);
  --bs-nav-link-hover-color: var(--bs-link-hover-color);
  --bs-nav-link-disabled-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.react-app-uniforms .nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  text-decoration: none;
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .react-app-uniforms .nav-link {
    transition: none;
  }
}
.react-app-uniforms .nav-link:hover, .react-app-uniforms .nav-link:focus {
  color: var(--bs-nav-link-hover-color);
}
.react-app-uniforms .nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(12, 147, 169, 0.25);
}
.react-app-uniforms .nav-link.disabled, .react-app-uniforms .nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}
.react-app-uniforms .nav-tabs {
  --bs-nav-tabs-border-width: var(--bs-border-width);
  --bs-nav-tabs-border-color: var(--bs-border-color);
  --bs-nav-tabs-border-radius: var(--bs-border-radius);
  --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);
  --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);
  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);
  --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}
.react-app-uniforms .nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
  border: var(--bs-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--bs-nav-tabs-border-radius);
  border-top-right-radius: var(--bs-nav-tabs-border-radius);
}
.react-app-uniforms .nav-tabs .nav-link:hover, .react-app-uniforms .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--bs-nav-tabs-link-hover-border-color);
}
.react-app-uniforms .nav-tabs .nav-link.active,
.react-app-uniforms .nav-tabs .nav-item.show .nav-link {
  color: var(--bs-nav-tabs-link-active-color);
  background-color: var(--bs-nav-tabs-link-active-bg);
  border-color: var(--bs-nav-tabs-link-active-border-color);
}
.react-app-uniforms .nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.react-app-uniforms .nav-pills {
  --bs-nav-pills-border-radius: var(--bs-border-radius);
  --bs-nav-pills-link-active-color: #fff;
  --bs-nav-pills-link-active-bg: #0C93A9;
}
.react-app-uniforms .nav-pills .nav-link {
  border-radius: var(--bs-nav-pills-border-radius);
}
.react-app-uniforms .nav-pills .nav-link.active,
.react-app-uniforms .nav-pills .show > .nav-link {
  color: var(--bs-nav-pills-link-active-color);
  background-color: var(--bs-nav-pills-link-active-bg);
}
.react-app-uniforms .nav-underline {
  --bs-nav-underline-gap: 1rem;
  --bs-nav-underline-border-width: 0.125rem;
  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);
  gap: var(--bs-nav-underline-gap);
}
.react-app-uniforms .nav-underline .nav-link {
  padding-right: 0;
  padding-left: 0;
  border-bottom: var(--bs-nav-underline-border-width) solid transparent;
}
.react-app-uniforms .nav-underline .nav-link:hover, .react-app-uniforms .nav-underline .nav-link:focus {
  border-bottom-color: currentcolor;
}
.react-app-uniforms .nav-underline .nav-link.active,
.react-app-uniforms .nav-underline .show > .nav-link {
  font-weight: 700;
  color: var(--bs-nav-underline-link-active-color);
  border-bottom-color: currentcolor;
}
.react-app-uniforms .nav-fill > .nav-link,
.react-app-uniforms .nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}
.react-app-uniforms .nav-justified > .nav-link,
.react-app-uniforms .nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}
.react-app-uniforms .nav-fill .nav-item .nav-link,
.react-app-uniforms .nav-justified .nav-item .nav-link {
  width: 100%;
}
.react-app-uniforms .tab-content > .tab-pane {
  display: none;
}
.react-app-uniforms .tab-content > .active {
  display: block;
}
.react-app-uniforms .navbar {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 0.5rem;
  --bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);
  --bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);
  --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);
  --bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-padding-y: 0.3125rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 1.25rem;
  --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-nav-link-padding-x: 0.5rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0.75rem;
  --bs-navbar-toggler-font-size: 1.25rem;
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  --bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);
  --bs-navbar-toggler-border-radius: var(--bs-border-radius);
  --bs-navbar-toggler-focus-width: 0.25rem;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
}
.react-app-uniforms .navbar > .container,
.react-app-uniforms .navbar > .container-fluid,
.react-app-uniforms .navbar > .container-sm,
.react-app-uniforms .navbar > .container-md,
.react-app-uniforms .navbar > .container-lg,
.react-app-uniforms .navbar > .container-xl,
.react-app-uniforms .navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.react-app-uniforms .navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  text-decoration: none;
  white-space: nowrap;
}
.react-app-uniforms .navbar-brand:hover, .react-app-uniforms .navbar-brand:focus {
  color: var(--bs-navbar-brand-hover-color);
}
.react-app-uniforms .navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.react-app-uniforms .navbar-nav .nav-link.active, .react-app-uniforms .navbar-nav .nav-link.show {
  color: var(--bs-navbar-active-color);
}
.react-app-uniforms .navbar-nav .dropdown-menu {
  position: static;
}
.react-app-uniforms .navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-navbar-color);
}
.react-app-uniforms .navbar-text a,
.react-app-uniforms .navbar-text a:hover,
.react-app-uniforms .navbar-text a:focus {
  color: var(--bs-navbar-active-color);
}
.react-app-uniforms .navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}
.react-app-uniforms .navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  .react-app-uniforms .navbar-toggler {
    transition: none;
  }
}
.react-app-uniforms .navbar-toggler:hover {
  text-decoration: none;
}
.react-app-uniforms .navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);
}
.react-app-uniforms .navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}
.react-app-uniforms .navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}
@media (min-width: 576px) {
  .react-app-uniforms .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .react-app-uniforms .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .react-app-uniforms .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .react-app-uniforms .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .react-app-uniforms .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .react-app-uniforms .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .react-app-uniforms .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .react-app-uniforms .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .react-app-uniforms .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .react-app-uniforms .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .react-app-uniforms .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .react-app-uniforms .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .react-app-uniforms .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .react-app-uniforms .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .react-app-uniforms .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .react-app-uniforms .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .react-app-uniforms .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .react-app-uniforms .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .react-app-uniforms .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .react-app-uniforms .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .react-app-uniforms .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .react-app-uniforms .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .react-app-uniforms .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .react-app-uniforms .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .react-app-uniforms .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .react-app-uniforms .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .react-app-uniforms .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .react-app-uniforms .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .react-app-uniforms .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .react-app-uniforms .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .react-app-uniforms .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .react-app-uniforms .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .react-app-uniforms .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .react-app-uniforms .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .react-app-uniforms .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .react-app-uniforms .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .react-app-uniforms .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .react-app-uniforms .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .react-app-uniforms .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .react-app-uniforms .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .react-app-uniforms .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .react-app-uniforms .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .react-app-uniforms .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .react-app-uniforms .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .react-app-uniforms .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .react-app-uniforms .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .react-app-uniforms .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .react-app-uniforms .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .react-app-uniforms .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .react-app-uniforms .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.react-app-uniforms .navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.react-app-uniforms .navbar-expand .navbar-nav {
  flex-direction: row;
}
.react-app-uniforms .navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.react-app-uniforms .navbar-expand .navbar-nav .nav-link {
  padding-right: var(--bs-navbar-nav-link-padding-x);
  padding-left: var(--bs-navbar-nav-link-padding-x);
}
.react-app-uniforms .navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.react-app-uniforms .navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.react-app-uniforms .navbar-expand .navbar-toggler {
  display: none;
}
.react-app-uniforms .navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}
.react-app-uniforms .navbar-expand .offcanvas .offcanvas-header {
  display: none;
}
.react-app-uniforms .navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}
.react-app-uniforms .navbar-dark,
.react-app-uniforms .navbar[data-bs-theme=dark] {
  --bs-navbar-color: rgba(255, 255, 255, 0.55);
  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #fff;
  --bs-navbar-brand-color: #fff;
  --bs-navbar-brand-hover-color: #fff;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}
.react-app-uniforms [data-bs-theme=dark] .navbar-toggler-icon {
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}
.react-app-uniforms .card {
  --bs-card-spacer-y: 1rem;
  --bs-card-spacer-x: 1rem;
  --bs-card-title-spacer-y: 0.5rem;
  --bs-card-title-color: ;
  --bs-card-subtitle-color: ;
  --bs-card-border-width: var(--bs-border-width);
  --bs-card-border-color: var(--bs-border-color-translucent);
  --bs-card-border-radius: var(--bs-border-radius);
  --bs-card-box-shadow: ;
  --bs-card-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-card-cap-padding-y: 0.5rem;
  --bs-card-cap-padding-x: 1rem;
  --bs-card-cap-bg: rgba(var(--bs-body-color-rgb), 0.03);
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: var(--bs-body-bg);
  --bs-card-img-overlay-padding: 1rem;
  --bs-card-group-margin: 0.75rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  color: var(--bs-body-color);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius);
}
.react-app-uniforms .card > hr {
  margin-right: 0;
  margin-left: 0;
}
.react-app-uniforms .card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.react-app-uniforms .card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}
.react-app-uniforms .card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}
.react-app-uniforms .card > .card-header + .list-group,
.react-app-uniforms .card > .list-group + .card-footer {
  border-top: 0;
}
.react-app-uniforms .card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color);
}
.react-app-uniforms .card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
  color: var(--bs-card-title-color);
}
.react-app-uniforms .card-subtitle {
  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--bs-card-subtitle-color);
}
.react-app-uniforms .card-text:last-child {
  margin-bottom: 0;
}
.react-app-uniforms .card-link + .card-link {
  margin-left: var(--bs-card-spacer-x);
}
.react-app-uniforms .card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.react-app-uniforms .card-header:first-child {
  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;
}
.react-app-uniforms .card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.react-app-uniforms .card-footer:last-child {
  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);
}
.react-app-uniforms .card-header-tabs {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0;
}
.react-app-uniforms .card-header-tabs .nav-link.active {
  background-color: var(--bs-card-bg);
  border-bottom-color: var(--bs-card-bg);
}
.react-app-uniforms .card-header-pills {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
}
.react-app-uniforms .card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius);
}
.react-app-uniforms .card-img,
.react-app-uniforms .card-img-top,
.react-app-uniforms .card-img-bottom {
  width: 100%;
}
.react-app-uniforms .card-img,
.react-app-uniforms .card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}
.react-app-uniforms .card-img,
.react-app-uniforms .card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}
.react-app-uniforms .card-group > .card {
  margin-bottom: var(--bs-card-group-margin);
}
@media (min-width: 576px) {
  .react-app-uniforms .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .react-app-uniforms .card-group > .card {
    flex: 1 0 0%;
    margin-bottom: 0;
  }
  .react-app-uniforms .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .react-app-uniforms .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .react-app-uniforms .card-group > .card:not(:last-child) .card-img-top,
  .react-app-uniforms .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .react-app-uniforms .card-group > .card:not(:last-child) .card-img-bottom,
  .react-app-uniforms .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .react-app-uniforms .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .react-app-uniforms .card-group > .card:not(:first-child) .card-img-top,
  .react-app-uniforms .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .react-app-uniforms .card-group > .card:not(:first-child) .card-img-bottom,
  .react-app-uniforms .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}
.react-app-uniforms .accordion {
  --bs-accordion-color: var(--bs-body-color);
  --bs-accordion-bg: var(--bs-body-bg);
  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --bs-accordion-border-color: var(--bs-border-color);
  --bs-accordion-border-width: var(--bs-border-width);
  --bs-accordion-border-radius: var(--bs-border-radius);
  --bs-accordion-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-accordion-btn-padding-x: 1.25rem;
  --bs-accordion-btn-padding-y: 1rem;
  --bs-accordion-btn-color: var(--bs-body-color);
  --bs-accordion-btn-bg: var(--bs-accordion-bg);
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  --bs-accordion-btn-icon-width: 1.25rem;
  --bs-accordion-btn-icon-transform: rotate(-180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  --bs-accordion-btn-focus-border-color: #86c9d4;
  --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(12, 147, 169, 0.25);
  --bs-accordion-body-padding-x: 1.25rem;
  --bs-accordion-body-padding-y: 1rem;
  --bs-accordion-active-color: var(--bs-primary-text-emphasis);
  --bs-accordion-active-bg: var(--bs-primary-bg-subtle);
}
.react-app-uniforms .accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 1rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  .react-app-uniforms .accordion-button {
    transition: none;
  }
}
.react-app-uniforms .accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: var(--bs-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);
}
.react-app-uniforms .accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-active-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}
.react-app-uniforms .accordion-button::after {
  flex-shrink: 0;
  width: var(--bs-accordion-btn-icon-width);
  height: var(--bs-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--bs-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--bs-accordion-btn-icon-width);
  transition: var(--bs-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  .react-app-uniforms .accordion-button::after {
    transition: none;
  }
}
.react-app-uniforms .accordion-button:hover {
  z-index: 2;
}
.react-app-uniforms .accordion-button:focus {
  z-index: 3;
  border-color: var(--bs-accordion-btn-focus-border-color);
  outline: 0;
  box-shadow: var(--bs-accordion-btn-focus-box-shadow);
}
.react-app-uniforms .accordion-header {
  margin-bottom: 0;
}
.react-app-uniforms .accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}
.react-app-uniforms .accordion-item:first-of-type {
  border-top-left-radius: var(--bs-accordion-border-radius);
  border-top-right-radius: var(--bs-accordion-border-radius);
}
.react-app-uniforms .accordion-item:first-of-type .accordion-button {
  border-top-left-radius: var(--bs-accordion-inner-border-radius);
  border-top-right-radius: var(--bs-accordion-inner-border-radius);
}
.react-app-uniforms .accordion-item:not(:first-of-type) {
  border-top: 0;
}
.react-app-uniforms .accordion-item:last-of-type {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}
.react-app-uniforms .accordion-item:last-of-type .accordion-button.collapsed {
  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);
}
.react-app-uniforms .accordion-item:last-of-type .accordion-collapse {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}
.react-app-uniforms .accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
}
.react-app-uniforms .accordion-flush .accordion-collapse {
  border-width: 0;
}
.react-app-uniforms .accordion-flush .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.react-app-uniforms .accordion-flush .accordion-item:first-child {
  border-top: 0;
}
.react-app-uniforms .accordion-flush .accordion-item:last-child {
  border-bottom: 0;
}
.react-app-uniforms .accordion-flush .accordion-item .accordion-button, .react-app-uniforms .accordion-flush .accordion-item .accordion-button.collapsed {
  border-radius: 0;
}
.react-app-uniforms [data-bs-theme=dark] .accordion-button::after {
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}
.react-app-uniforms .breadcrumb {
  --bs-breadcrumb-padding-x: 0;
  --bs-breadcrumb-padding-y: 0;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-bg: ;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color: var(--bs-secondary-color);
  --bs-breadcrumb-item-padding-x: 0.5rem;
  --bs-breadcrumb-item-active-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius);
}
.react-app-uniforms .breadcrumb-item + .breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x);
}
.react-app-uniforms .breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--bs-breadcrumb-item-padding-x);
  color: var(--bs-breadcrumb-divider-color);
  content: var(--bs-breadcrumb-divider, "/") /* rtl: var(--bs-breadcrumb-divider, "/") */;
}
.react-app-uniforms .breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color);
}
.react-app-uniforms .pagination {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.375rem;
  --bs-pagination-font-size: 1rem;
  --bs-pagination-color: var(--bs-link-color);
  --bs-pagination-bg: var(--bs-body-bg);
  --bs-pagination-border-width: var(--bs-border-width);
  --bs-pagination-border-color: var(--bs-border-color);
  --bs-pagination-border-radius: var(--bs-border-radius);
  --bs-pagination-hover-color: var(--bs-link-hover-color);
  --bs-pagination-hover-bg: var(--bs-tertiary-bg);
  --bs-pagination-hover-border-color: var(--bs-border-color);
  --bs-pagination-focus-color: var(--bs-link-hover-color);
  --bs-pagination-focus-bg: var(--bs-secondary-bg);
  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(12, 147, 169, 0.25);
  --bs-pagination-active-color: #fff;
  --bs-pagination-active-bg: #0C93A9;
  --bs-pagination-active-border-color: #0C93A9;
  --bs-pagination-disabled-color: var(--bs-secondary-color);
  --bs-pagination-disabled-bg: var(--bs-secondary-bg);
  --bs-pagination-disabled-border-color: var(--bs-border-color);
  display: flex;
  padding-left: 0;
  list-style: none;
}
.react-app-uniforms .page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  text-decoration: none;
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .react-app-uniforms .page-link {
    transition: none;
  }
}
.react-app-uniforms .page-link:hover {
  z-index: 2;
  color: var(--bs-pagination-hover-color);
  background-color: var(--bs-pagination-hover-bg);
  border-color: var(--bs-pagination-hover-border-color);
}
.react-app-uniforms .page-link:focus {
  z-index: 3;
  color: var(--bs-pagination-focus-color);
  background-color: var(--bs-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--bs-pagination-focus-box-shadow);
}
.react-app-uniforms .page-link.active, .active > .react-app-uniforms .page-link {
  z-index: 3;
  color: var(--bs-pagination-active-color);
  background-color: var(--bs-pagination-active-bg);
  border-color: var(--bs-pagination-active-border-color);
}
.react-app-uniforms .page-link.disabled, .disabled > .react-app-uniforms .page-link {
  color: var(--bs-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--bs-pagination-disabled-bg);
  border-color: var(--bs-pagination-disabled-border-color);
}
.react-app-uniforms .page-item:not(:first-child) .page-link {
  margin-left: calc(var(--bs-border-width) * -1);
}
.react-app-uniforms .page-item:first-child .page-link {
  border-top-left-radius: var(--bs-pagination-border-radius);
  border-bottom-left-radius: var(--bs-pagination-border-radius);
}
.react-app-uniforms .page-item:last-child .page-link {
  border-top-right-radius: var(--bs-pagination-border-radius);
  border-bottom-right-radius: var(--bs-pagination-border-radius);
}
.react-app-uniforms .pagination-lg {
  --bs-pagination-padding-x: 1.5rem;
  --bs-pagination-padding-y: 0.75rem;
  --bs-pagination-font-size: 1.25rem;
  --bs-pagination-border-radius: var(--bs-border-radius-lg);
}
.react-app-uniforms .pagination-sm {
  --bs-pagination-padding-x: 0.5rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-font-size: 0.875rem;
  --bs-pagination-border-radius: var(--bs-border-radius-sm);
}
.react-app-uniforms .badge {
  --bs-badge-padding-x: 0.65em;
  --bs-badge-padding-y: 0.35em;
  --bs-badge-font-size: 0.75em;
  --bs-badge-font-weight: 700;
  --bs-badge-color: #fff;
  --bs-badge-border-radius: var(--bs-border-radius);
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius);
}
.react-app-uniforms .badge:empty {
  display: none;
}
.react-app-uniforms .btn .badge {
  position: relative;
  top: -1px;
}
.react-app-uniforms .alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1rem;
  --bs-alert-padding-y: 1rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);
  --bs-alert-border-radius: var(--bs-border-radius);
  --bs-alert-link-color: inherit;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius);
}
.react-app-uniforms .alert-heading {
  color: inherit;
}
.react-app-uniforms .alert-link {
  font-weight: 700;
  color: var(--bs-alert-link-color);
}
.react-app-uniforms .alert-dismissible {
  padding-right: 3rem;
}
.react-app-uniforms .alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1.25rem 1rem;
}
.react-app-uniforms .alert-primary {
  --bs-alert-color: var(--bs-primary-text-emphasis);
  --bs-alert-bg: var(--bs-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-border-subtle);
  --bs-alert-link-color: var(--bs-primary-text-emphasis);
}
.react-app-uniforms .alert-secondary {
  --bs-alert-color: var(--bs-secondary-text-emphasis);
  --bs-alert-bg: var(--bs-secondary-bg-subtle);
  --bs-alert-border-color: var(--bs-secondary-border-subtle);
  --bs-alert-link-color: var(--bs-secondary-text-emphasis);
}
.react-app-uniforms .alert-success {
  --bs-alert-color: var(--bs-success-text-emphasis);
  --bs-alert-bg: var(--bs-success-bg-subtle);
  --bs-alert-border-color: var(--bs-success-border-subtle);
  --bs-alert-link-color: var(--bs-success-text-emphasis);
}
.react-app-uniforms .alert-info {
  --bs-alert-color: var(--bs-info-text-emphasis);
  --bs-alert-bg: var(--bs-info-bg-subtle);
  --bs-alert-border-color: var(--bs-info-border-subtle);
  --bs-alert-link-color: var(--bs-info-text-emphasis);
}
.react-app-uniforms .alert-warning {
  --bs-alert-color: var(--bs-warning-text-emphasis);
  --bs-alert-bg: var(--bs-warning-bg-subtle);
  --bs-alert-border-color: var(--bs-warning-border-subtle);
  --bs-alert-link-color: var(--bs-warning-text-emphasis);
}
.react-app-uniforms .alert-danger {
  --bs-alert-color: var(--bs-danger-text-emphasis);
  --bs-alert-bg: var(--bs-danger-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-border-subtle);
  --bs-alert-link-color: var(--bs-danger-text-emphasis);
}
.react-app-uniforms .alert-light {
  --bs-alert-color: var(--bs-light-text-emphasis);
  --bs-alert-bg: var(--bs-light-bg-subtle);
  --bs-alert-border-color: var(--bs-light-border-subtle);
  --bs-alert-link-color: var(--bs-light-text-emphasis);
}
.react-app-uniforms .alert-dark {
  --bs-alert-color: var(--bs-dark-text-emphasis);
  --bs-alert-bg: var(--bs-dark-bg-subtle);
  --bs-alert-border-color: var(--bs-dark-border-subtle);
  --bs-alert-link-color: var(--bs-dark-text-emphasis);
}
@keyframes progress-bar-stripes {
  0% {
    background-position-x: 1rem;
  }
}
.react-app-uniforms .progress,
.react-app-uniforms .progress-stacked {
  --bs-progress-height: 1rem;
  --bs-progress-font-size: 0.75rem;
  --bs-progress-bg: var(--bs-secondary-bg);
  --bs-progress-border-radius: var(--bs-border-radius);
  --bs-progress-box-shadow: var(--bs-box-shadow-inset);
  --bs-progress-bar-color: #fff;
  --bs-progress-bar-bg: #0C93A9;
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius);
}
.react-app-uniforms .progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .react-app-uniforms .progress-bar {
    transition: none;
  }
}
.react-app-uniforms .progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height);
}
.react-app-uniforms .progress-stacked > .progress {
  overflow: visible;
}
.react-app-uniforms .progress-stacked > .progress > .progress-bar {
  width: 100%;
}
.react-app-uniforms .progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .react-app-uniforms .progress-bar-animated {
    animation: none;
  }
}
.react-app-uniforms .list-group {
  --bs-list-group-color: var(--bs-body-color);
  --bs-list-group-bg: var(--bs-body-bg);
  --bs-list-group-border-color: var(--bs-border-color);
  --bs-list-group-border-width: var(--bs-border-width);
  --bs-list-group-border-radius: var(--bs-border-radius);
  --bs-list-group-item-padding-x: 1rem;
  --bs-list-group-item-padding-y: 0.5rem;
  --bs-list-group-action-color: var(--bs-secondary-color);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-tertiary-bg);
  --bs-list-group-action-active-color: var(--bs-body-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-bg);
  --bs-list-group-disabled-color: var(--bs-secondary-color);
  --bs-list-group-disabled-bg: var(--bs-body-bg);
  --bs-list-group-active-color: #fff;
  --bs-list-group-active-bg: #0C93A9;
  --bs-list-group-active-border-color: #0C93A9;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius);
}
.react-app-uniforms .list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.react-app-uniforms .list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}
.react-app-uniforms .list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit;
}
.react-app-uniforms .list-group-item-action:hover, .react-app-uniforms .list-group-item-action:focus {
  z-index: 1;
  color: var(--bs-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--bs-list-group-action-hover-bg);
}
.react-app-uniforms .list-group-item-action:active {
  color: var(--bs-list-group-action-active-color);
  background-color: var(--bs-list-group-action-active-bg);
}
.react-app-uniforms .list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  text-decoration: none;
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}
.react-app-uniforms .list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.react-app-uniforms .list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.react-app-uniforms .list-group-item.disabled, .react-app-uniforms .list-group-item:disabled {
  color: var(--bs-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--bs-list-group-disabled-bg);
}
.react-app-uniforms .list-group-item.active {
  z-index: 2;
  color: var(--bs-list-group-active-color);
  background-color: var(--bs-list-group-active-bg);
  border-color: var(--bs-list-group-active-border-color);
}
.react-app-uniforms .list-group-item + .list-group-item {
  border-top-width: 0;
}
.react-app-uniforms .list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--bs-list-group-border-width));
  border-top-width: var(--bs-list-group-border-width);
}
.react-app-uniforms .list-group-horizontal {
  flex-direction: row;
}
.react-app-uniforms .list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--bs-list-group-border-radius);
  border-top-right-radius: 0;
}
.react-app-uniforms .list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--bs-list-group-border-radius);
  border-bottom-left-radius: 0;
}
.react-app-uniforms .list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.react-app-uniforms .list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--bs-list-group-border-width);
  border-left-width: 0;
}
.react-app-uniforms .list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--bs-list-group-border-width));
  border-left-width: var(--bs-list-group-border-width);
}
@media (min-width: 576px) {
  .react-app-uniforms .list-group-horizontal-sm {
    flex-direction: row;
  }
  .react-app-uniforms .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .react-app-uniforms .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .react-app-uniforms .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .react-app-uniforms .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .react-app-uniforms .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .react-app-uniforms .list-group-horizontal-md {
    flex-direction: row;
  }
  .react-app-uniforms .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .react-app-uniforms .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .react-app-uniforms .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .react-app-uniforms .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .react-app-uniforms .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .react-app-uniforms .list-group-horizontal-lg {
    flex-direction: row;
  }
  .react-app-uniforms .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .react-app-uniforms .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .react-app-uniforms .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .react-app-uniforms .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .react-app-uniforms .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .react-app-uniforms .list-group-horizontal-xl {
    flex-direction: row;
  }
  .react-app-uniforms .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .react-app-uniforms .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .react-app-uniforms .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .react-app-uniforms .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .react-app-uniforms .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .react-app-uniforms .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .react-app-uniforms .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .react-app-uniforms .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .react-app-uniforms .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .react-app-uniforms .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .react-app-uniforms .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
.react-app-uniforms .list-group-flush {
  border-radius: 0;
}
.react-app-uniforms .list-group-flush > .list-group-item {
  border-width: 0 0 var(--bs-list-group-border-width);
}
.react-app-uniforms .list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}
.react-app-uniforms .list-group-item-primary {
  --bs-list-group-color: var(--bs-primary-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);
}
.react-app-uniforms .list-group-item-secondary {
  --bs-list-group-color: var(--bs-secondary-text-emphasis);
  --bs-list-group-bg: var(--bs-secondary-bg-subtle);
  --bs-list-group-border-color: var(--bs-secondary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);
}
.react-app-uniforms .list-group-item-success {
  --bs-list-group-color: var(--bs-success-text-emphasis);
  --bs-list-group-bg: var(--bs-success-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);
  --bs-list-group-active-color: var(--bs-success-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);
}
.react-app-uniforms .list-group-item-info {
  --bs-list-group-color: var(--bs-info-text-emphasis);
  --bs-list-group-bg: var(--bs-info-bg-subtle);
  --bs-list-group-border-color: var(--bs-info-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);
  --bs-list-group-active-color: var(--bs-info-bg-subtle);
  --bs-list-group-active-bg: var(--bs-info-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);
}
.react-app-uniforms .list-group-item-warning {
  --bs-list-group-color: var(--bs-warning-text-emphasis);
  --bs-list-group-bg: var(--bs-warning-bg-subtle);
  --bs-list-group-border-color: var(--bs-warning-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);
  --bs-list-group-active-color: var(--bs-warning-bg-subtle);
  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);
}
.react-app-uniforms .list-group-item-danger {
  --bs-list-group-color: var(--bs-danger-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);
}
.react-app-uniforms .list-group-item-light {
  --bs-list-group-color: var(--bs-light-text-emphasis);
  --bs-list-group-bg: var(--bs-light-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);
  --bs-list-group-active-color: var(--bs-light-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);
}
.react-app-uniforms .list-group-item-dark {
  --bs-list-group-color: var(--bs-dark-text-emphasis);
  --bs-list-group-bg: var(--bs-dark-bg-subtle);
  --bs-list-group-border-color: var(--bs-dark-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);
  --bs-list-group-active-color: var(--bs-dark-bg-subtle);
  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);
}
.react-app-uniforms .btn-close {
  --bs-btn-close-color: #000;
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  --bs-btn-close-opacity: 0.5;
  --bs-btn-close-hover-opacity: 0.75;
  --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(12, 147, 169, 0.25);
  --bs-btn-close-focus-opacity: 1;
  --bs-btn-close-disabled-opacity: 0.25;
  --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--bs-btn-close-color);
  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;
  border: 0;
  border-radius: 0.375rem;
  opacity: var(--bs-btn-close-opacity);
}
.react-app-uniforms .btn-close:hover {
  color: var(--bs-btn-close-color);
  text-decoration: none;
  opacity: var(--bs-btn-close-hover-opacity);
}
.react-app-uniforms .btn-close:focus {
  outline: 0;
  box-shadow: var(--bs-btn-close-focus-shadow);
  opacity: var(--bs-btn-close-focus-opacity);
}
.react-app-uniforms .btn-close:disabled, .react-app-uniforms .btn-close.disabled {
  pointer-events: none;
  user-select: none;
  opacity: var(--bs-btn-close-disabled-opacity);
}
.react-app-uniforms .btn-close-white {
  filter: var(--bs-btn-close-white-filter);
}
.react-app-uniforms [data-bs-theme=dark] .btn-close {
  filter: var(--bs-btn-close-white-filter);
}
.react-app-uniforms .toast {
  --bs-toast-zindex: 1090;
  --bs-toast-padding-x: 0.75rem;
  --bs-toast-padding-y: 0.5rem;
  --bs-toast-spacing: 1.5rem;
  --bs-toast-max-width: 350px;
  --bs-toast-font-size: 0.875rem;
  --bs-toast-color: ;
  --bs-toast-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-border-width: var(--bs-border-width);
  --bs-toast-border-color: var(--bs-border-color-translucent);
  --bs-toast-border-radius: var(--bs-border-radius);
  --bs-toast-box-shadow: var(--bs-box-shadow);
  --bs-toast-header-color: var(--bs-secondary-color);
  --bs-toast-header-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-header-border-color: var(--bs-border-color-translucent);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius);
}
.react-app-uniforms .toast.showing {
  opacity: 0;
}
.react-app-uniforms .toast:not(.show) {
  display: none;
}
.react-app-uniforms .toast-container {
  --bs-toast-zindex: 1090;
  position: absolute;
  z-index: var(--bs-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.react-app-uniforms .toast-container > :not(:last-child) {
  margin-bottom: var(--bs-toast-spacing);
}
.react-app-uniforms .toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}
.react-app-uniforms .toast-header .btn-close {
  margin-right: calc(-0.5 * var(--bs-toast-padding-x));
  margin-left: var(--bs-toast-padding-x);
}
.react-app-uniforms .toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word;
}
.react-app-uniforms .modal {
  --bs-modal-zindex: 1055;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: ;
  --bs-modal-bg: var(--bs-body-bg);
  --bs-modal-border-color: var(--bs-border-color-translucent);
  --bs-modal-border-width: var(--bs-border-width);
  --bs-modal-border-radius: var(--bs-border-radius-lg);
  --bs-modal-box-shadow: var(--bs-box-shadow-sm);
  --bs-modal-inner-border-radius: calc(var(--bs-border-radius-lg) - (var(--bs-border-width)));
  --bs-modal-header-padding-x: 1rem;
  --bs-modal-header-padding-y: 1rem;
  --bs-modal-header-padding: 1rem 1rem;
  --bs-modal-header-border-color: var(--bs-border-color);
  --bs-modal-header-border-width: var(--bs-border-width);
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: var(--bs-border-color);
  --bs-modal-footer-border-width: var(--bs-border-width);
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}
.react-app-uniforms .modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none;
}
.modal.fade .react-app-uniforms .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .react-app-uniforms .modal-dialog {
    transition: none;
  }
}
.modal.show .react-app-uniforms .modal-dialog {
  transform: none;
}
.modal.modal-static .react-app-uniforms .modal-dialog {
  transform: scale(1.02);
}
.react-app-uniforms .modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2);
}
.react-app-uniforms .modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.react-app-uniforms .modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}
.react-app-uniforms .modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2);
}
.react-app-uniforms .modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  outline: 0;
}
.react-app-uniforms .modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: #000;
  --bs-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}
.react-app-uniforms .modal-backdrop.fade {
  opacity: 0;
}
.react-app-uniforms .modal-backdrop.show {
  opacity: var(--bs-backdrop-opacity);
}
.react-app-uniforms .modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}
.react-app-uniforms .modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
  margin: calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x)) calc(-0.5 * var(--bs-modal-header-padding-y)) auto;
}
.react-app-uniforms .modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height);
}
.react-app-uniforms .modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}
.react-app-uniforms .modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}
.react-app-uniforms .modal-footer > * {
  margin: calc(var(--bs-modal-footer-gap) * 0.5);
}
@media (min-width: 576px) {
  .react-app-uniforms .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: var(--bs-box-shadow);
  }
  .react-app-uniforms .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .react-app-uniforms .modal-sm {
    --bs-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .react-app-uniforms .modal-lg,
  .react-app-uniforms .modal-xl {
    --bs-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .react-app-uniforms .modal-xl {
    --bs-modal-width: 1140px;
  }
}
.react-app-uniforms .modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.react-app-uniforms .modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.react-app-uniforms .modal-fullscreen .modal-header,
.react-app-uniforms .modal-fullscreen .modal-footer {
  border-radius: 0;
}
.react-app-uniforms .modal-fullscreen .modal-body {
  overflow-y: auto;
}
@media (max-width: 575.98px) {
  .react-app-uniforms .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .react-app-uniforms .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .react-app-uniforms .modal-fullscreen-sm-down .modal-header,
  .react-app-uniforms .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .react-app-uniforms .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .react-app-uniforms .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .react-app-uniforms .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .react-app-uniforms .modal-fullscreen-md-down .modal-header,
  .react-app-uniforms .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .react-app-uniforms .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .react-app-uniforms .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .react-app-uniforms .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .react-app-uniforms .modal-fullscreen-lg-down .modal-header,
  .react-app-uniforms .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .react-app-uniforms .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .react-app-uniforms .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .react-app-uniforms .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .react-app-uniforms .modal-fullscreen-xl-down .modal-header,
  .react-app-uniforms .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .react-app-uniforms .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .react-app-uniforms .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .react-app-uniforms .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .react-app-uniforms .modal-fullscreen-xxl-down .modal-header,
  .react-app-uniforms .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .react-app-uniforms .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.react-app-uniforms .tooltip {
  --bs-tooltip-zindex: 1080;
  --bs-tooltip-max-width: 200px;
  --bs-tooltip-padding-x: 0.5rem;
  --bs-tooltip-padding-y: 0.25rem;
  --bs-tooltip-margin: ;
  --bs-tooltip-font-size: 0.875rem;
  --bs-tooltip-color: var(--bs-body-bg);
  --bs-tooltip-bg: var(--bs-emphasis-color);
  --bs-tooltip-border-radius: var(--bs-border-radius);
  --bs-tooltip-opacity: 0.9;
  --bs-tooltip-arrow-width: 0.8rem;
  --bs-tooltip-arrow-height: 0.4rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  margin: var(--bs-tooltip-margin);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
.react-app-uniforms .tooltip.show {
  opacity: var(--bs-tooltip-opacity);
}
.react-app-uniforms .tooltip .tooltip-arrow {
  display: block;
  width: var(--bs-tooltip-arrow-width);
  height: var(--bs-tooltip-arrow-height);
}
.react-app-uniforms .tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}
.react-app-uniforms .bs-tooltip-top .tooltip-arrow, .react-app-uniforms .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--bs-tooltip-arrow-height));
}
.react-app-uniforms .bs-tooltip-top .tooltip-arrow::before, .react-app-uniforms .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--bs-tooltip-bg);
}
.react-app-uniforms .bs-tooltip-end .tooltip-arrow, .react-app-uniforms .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.react-app-uniforms .bs-tooltip-end .tooltip-arrow::before, .react-app-uniforms .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--bs-tooltip-bg);
}
.react-app-uniforms .bs-tooltip-bottom .tooltip-arrow, .react-app-uniforms .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--bs-tooltip-arrow-height));
}
.react-app-uniforms .bs-tooltip-bottom .tooltip-arrow::before, .react-app-uniforms .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-bottom-color: var(--bs-tooltip-bg);
}
.react-app-uniforms .bs-tooltip-start .tooltip-arrow, .react-app-uniforms .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.react-app-uniforms .bs-tooltip-start .tooltip-arrow::before, .react-app-uniforms .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-left-color: var(--bs-tooltip-bg);
}
.react-app-uniforms .tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius);
}
.react-app-uniforms .popover {
  --bs-popover-zindex: 1070;
  --bs-popover-max-width: 276px;
  --bs-popover-font-size: 0.875rem;
  --bs-popover-bg: var(--bs-body-bg);
  --bs-popover-border-width: var(--bs-border-width);
  --bs-popover-border-color: var(--bs-border-color-translucent);
  --bs-popover-border-radius: var(--bs-border-radius-lg);
  --bs-popover-inner-border-radius: calc(var(--bs-border-radius-lg) - var(--bs-border-width));
  --bs-popover-box-shadow: var(--bs-box-shadow);
  --bs-popover-header-padding-x: 1rem;
  --bs-popover-header-padding-y: 0.5rem;
  --bs-popover-header-font-size: 1rem;
  --bs-popover-header-color: inherit;
  --bs-popover-header-bg: var(--bs-secondary-bg);
  --bs-popover-body-padding-x: 1rem;
  --bs-popover-body-padding-y: 1rem;
  --bs-popover-body-color: var(--bs-body-color);
  --bs-popover-arrow-width: 1rem;
  --bs-popover-arrow-height: 0.5rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius);
}
.react-app-uniforms .popover .popover-arrow {
  display: block;
  width: var(--bs-popover-arrow-width);
  height: var(--bs-popover-arrow-height);
}
.react-app-uniforms .popover .popover-arrow::before, .react-app-uniforms .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}
.react-app-uniforms .bs-popover-top > .popover-arrow, .react-app-uniforms .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.react-app-uniforms .bs-popover-top > .popover-arrow::before, .react-app-uniforms .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .react-app-uniforms .bs-popover-top > .popover-arrow::after, .react-app-uniforms .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.react-app-uniforms .bs-popover-top > .popover-arrow::before, .react-app-uniforms .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--bs-popover-arrow-border);
}
.react-app-uniforms .bs-popover-top > .popover-arrow::after, .react-app-uniforms .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--bs-popover-border-width);
  border-top-color: var(--bs-popover-bg);
}
.react-app-uniforms .bs-popover-end > .popover-arrow, .react-app-uniforms .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.react-app-uniforms .bs-popover-end > .popover-arrow::before, .react-app-uniforms .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .react-app-uniforms .bs-popover-end > .popover-arrow::after, .react-app-uniforms .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.react-app-uniforms .bs-popover-end > .popover-arrow::before, .react-app-uniforms .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--bs-popover-arrow-border);
}
.react-app-uniforms .bs-popover-end > .popover-arrow::after, .react-app-uniforms .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--bs-popover-border-width);
  border-right-color: var(--bs-popover-bg);
}
.react-app-uniforms .bs-popover-bottom > .popover-arrow, .react-app-uniforms .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.react-app-uniforms .bs-popover-bottom > .popover-arrow::before, .react-app-uniforms .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .react-app-uniforms .bs-popover-bottom > .popover-arrow::after, .react-app-uniforms .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.react-app-uniforms .bs-popover-bottom > .popover-arrow::before, .react-app-uniforms .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--bs-popover-arrow-border);
}
.react-app-uniforms .bs-popover-bottom > .popover-arrow::after, .react-app-uniforms .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--bs-popover-border-width);
  border-bottom-color: var(--bs-popover-bg);
}
.react-app-uniforms .bs-popover-bottom .popover-header::before, .react-app-uniforms .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);
}
.react-app-uniforms .bs-popover-start > .popover-arrow, .react-app-uniforms .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.react-app-uniforms .bs-popover-start > .popover-arrow::before, .react-app-uniforms .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .react-app-uniforms .bs-popover-start > .popover-arrow::after, .react-app-uniforms .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.react-app-uniforms .bs-popover-start > .popover-arrow::before, .react-app-uniforms .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--bs-popover-arrow-border);
}
.react-app-uniforms .bs-popover-start > .popover-arrow::after, .react-app-uniforms .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--bs-popover-border-width);
  border-left-color: var(--bs-popover-bg);
}
.react-app-uniforms .popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius);
}
.react-app-uniforms .popover-header:empty {
  display: none;
}
.react-app-uniforms .popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color);
}
.react-app-uniforms .carousel {
  position: relative;
}
.react-app-uniforms .carousel.pointer-event {
  touch-action: pan-y;
}
.react-app-uniforms .carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.react-app-uniforms .carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}
.react-app-uniforms .carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .react-app-uniforms .carousel-item {
    transition: none;
  }
}
.react-app-uniforms .carousel-item.active,
.react-app-uniforms .carousel-item-next,
.react-app-uniforms .carousel-item-prev {
  display: block;
}
.react-app-uniforms .carousel-item-next:not(.carousel-item-start),
.react-app-uniforms .active.carousel-item-end {
  transform: translateX(100%);
}
.react-app-uniforms .carousel-item-prev:not(.carousel-item-end),
.react-app-uniforms .active.carousel-item-start {
  transform: translateX(-100%);
}
.react-app-uniforms .carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.react-app-uniforms .carousel-fade .carousel-item.active,
.react-app-uniforms .carousel-fade .carousel-item-next.carousel-item-start,
.react-app-uniforms .carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.react-app-uniforms .carousel-fade .active.carousel-item-start,
.react-app-uniforms .carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .react-app-uniforms .carousel-fade .active.carousel-item-start,
  .react-app-uniforms .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}
.react-app-uniforms .carousel-control-prev,
.react-app-uniforms .carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .react-app-uniforms .carousel-control-prev,
  .react-app-uniforms .carousel-control-next {
    transition: none;
  }
}
.react-app-uniforms .carousel-control-prev:hover, .react-app-uniforms .carousel-control-prev:focus,
.react-app-uniforms .carousel-control-next:hover,
.react-app-uniforms .carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}
.react-app-uniforms .carousel-control-prev {
  left: 0;
}
.react-app-uniforms .carousel-control-next {
  right: 0;
}
.react-app-uniforms .carousel-control-prev-icon,
.react-app-uniforms .carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}
.react-app-uniforms .carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
}
.react-app-uniforms .carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}
.react-app-uniforms .carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
}
.react-app-uniforms .carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .react-app-uniforms .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.react-app-uniforms .carousel-indicators .active {
  opacity: 1;
}
.react-app-uniforms .carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #fff;
  text-align: center;
}
.react-app-uniforms .carousel-dark .carousel-control-prev-icon,
.react-app-uniforms .carousel-dark .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
.react-app-uniforms .carousel-dark .carousel-indicators [data-bs-target] {
  background-color: #000;
}
.react-app-uniforms .carousel-dark .carousel-caption {
  color: #000;
}
.react-app-uniforms [data-bs-theme=dark] .carousel .carousel-control-prev-icon,
.react-app-uniforms [data-bs-theme=dark] .carousel .carousel-control-next-icon, .react-app-uniforms [data-bs-theme=dark].carousel .carousel-control-prev-icon,
.react-app-uniforms [data-bs-theme=dark].carousel .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
.react-app-uniforms [data-bs-theme=dark] .carousel .carousel-indicators [data-bs-target], .react-app-uniforms [data-bs-theme=dark].carousel .carousel-indicators [data-bs-target] {
  background-color: #000;
}
.react-app-uniforms [data-bs-theme=dark] .carousel .carousel-caption, .react-app-uniforms [data-bs-theme=dark].carousel .carousel-caption {
  color: #000;
}
.react-app-uniforms .spinner-grow,
.react-app-uniforms .spinner-border {
  display: inline-block;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);
}
@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.react-app-uniforms .spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.25em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}
.react-app-uniforms .spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.2em;
}
@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.react-app-uniforms .spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}
.react-app-uniforms .spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
}
@media (prefers-reduced-motion: reduce) {
  .react-app-uniforms .spinner-border,
  .react-app-uniforms .spinner-grow {
    --bs-spinner-animation-speed: 1.5s;
  }
}
.react-app-uniforms .offcanvas, .react-app-uniforms .offcanvas-xxl, .react-app-uniforms .offcanvas-xl, .react-app-uniforms .offcanvas-lg, .react-app-uniforms .offcanvas-md, .react-app-uniforms .offcanvas-sm {
  --bs-offcanvas-zindex: 1045;
  --bs-offcanvas-width: 400px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 1rem;
  --bs-offcanvas-padding-y: 1rem;
  --bs-offcanvas-color: var(--bs-body-color);
  --bs-offcanvas-bg: var(--bs-body-bg);
  --bs-offcanvas-border-width: var(--bs-border-width);
  --bs-offcanvas-border-color: var(--bs-border-color-translucent);
  --bs-offcanvas-box-shadow: var(--bs-box-shadow-sm);
  --bs-offcanvas-transition: transform 0.3s ease-in-out;
  --bs-offcanvas-title-line-height: 1.5;
}
@media (max-width: 575.98px) {
  .react-app-uniforms .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .react-app-uniforms .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .react-app-uniforms .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .react-app-uniforms .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .react-app-uniforms .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .react-app-uniforms .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .react-app-uniforms .offcanvas-sm.showing, .react-app-uniforms .offcanvas-sm.show:not(.hiding) {
    transform: none;
  }
  .react-app-uniforms .offcanvas-sm.showing, .react-app-uniforms .offcanvas-sm.hiding, .react-app-uniforms .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .react-app-uniforms .offcanvas-sm {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .react-app-uniforms .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .react-app-uniforms .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
@media (max-width: 767.98px) {
  .react-app-uniforms .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .react-app-uniforms .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .react-app-uniforms .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .react-app-uniforms .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .react-app-uniforms .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .react-app-uniforms .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .react-app-uniforms .offcanvas-md.showing, .react-app-uniforms .offcanvas-md.show:not(.hiding) {
    transform: none;
  }
  .react-app-uniforms .offcanvas-md.showing, .react-app-uniforms .offcanvas-md.hiding, .react-app-uniforms .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .react-app-uniforms .offcanvas-md {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .react-app-uniforms .offcanvas-md .offcanvas-header {
    display: none;
  }
  .react-app-uniforms .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
@media (max-width: 991.98px) {
  .react-app-uniforms .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .react-app-uniforms .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .react-app-uniforms .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .react-app-uniforms .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .react-app-uniforms .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .react-app-uniforms .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .react-app-uniforms .offcanvas-lg.showing, .react-app-uniforms .offcanvas-lg.show:not(.hiding) {
    transform: none;
  }
  .react-app-uniforms .offcanvas-lg.showing, .react-app-uniforms .offcanvas-lg.hiding, .react-app-uniforms .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .react-app-uniforms .offcanvas-lg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .react-app-uniforms .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .react-app-uniforms .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
@media (max-width: 1199.98px) {
  .react-app-uniforms .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .react-app-uniforms .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .react-app-uniforms .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .react-app-uniforms .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .react-app-uniforms .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .react-app-uniforms .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .react-app-uniforms .offcanvas-xl.showing, .react-app-uniforms .offcanvas-xl.show:not(.hiding) {
    transform: none;
  }
  .react-app-uniforms .offcanvas-xl.showing, .react-app-uniforms .offcanvas-xl.hiding, .react-app-uniforms .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .react-app-uniforms .offcanvas-xl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .react-app-uniforms .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .react-app-uniforms .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
@media (max-width: 1399.98px) {
  .react-app-uniforms .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .react-app-uniforms .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .react-app-uniforms .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .react-app-uniforms .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .react-app-uniforms .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .react-app-uniforms .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .react-app-uniforms .offcanvas-xxl.showing, .react-app-uniforms .offcanvas-xxl.show:not(.hiding) {
    transform: none;
  }
  .react-app-uniforms .offcanvas-xxl.showing, .react-app-uniforms .offcanvas-xxl.hiding, .react-app-uniforms .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .react-app-uniforms .offcanvas-xxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .react-app-uniforms .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .react-app-uniforms .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
.react-app-uniforms .offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--bs-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--bs-offcanvas-transition);
}
@media (prefers-reduced-motion: reduce) {
  .react-app-uniforms .offcanvas {
    transition: none;
  }
}
.react-app-uniforms .offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--bs-offcanvas-width);
  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(-100%);
}
.react-app-uniforms .offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--bs-offcanvas-width);
  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(100%);
}
.react-app-uniforms .offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(-100%);
}
.react-app-uniforms .offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(100%);
}
.react-app-uniforms .offcanvas.showing, .react-app-uniforms .offcanvas.show:not(.hiding) {
  transform: none;
}
.react-app-uniforms .offcanvas.showing, .react-app-uniforms .offcanvas.hiding, .react-app-uniforms .offcanvas.show {
  visibility: visible;
}
.react-app-uniforms .offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}
.react-app-uniforms .offcanvas-backdrop.fade {
  opacity: 0;
}
.react-app-uniforms .offcanvas-backdrop.show {
  opacity: 0.5;
}
.react-app-uniforms .offcanvas-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
}
.react-app-uniforms .offcanvas-header .btn-close {
  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--bs-offcanvas-padding-y));
  margin-right: calc(-0.5 * var(--bs-offcanvas-padding-x));
  margin-bottom: calc(-0.5 * var(--bs-offcanvas-padding-y));
}
.react-app-uniforms .offcanvas-title {
  margin-bottom: 0;
  line-height: var(--bs-offcanvas-title-line-height);
}
.react-app-uniforms .offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto;
}
.react-app-uniforms .placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}
.react-app-uniforms .placeholder.btn::before {
  display: inline-block;
  content: "";
}
.react-app-uniforms .placeholder-xs {
  min-height: 0.6em;
}
.react-app-uniforms .placeholder-sm {
  min-height: 0.8em;
}
.react-app-uniforms .placeholder-lg {
  min-height: 1.2em;
}
.react-app-uniforms .placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}
@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.react-app-uniforms .placeholder-wave {
  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}
@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%;
  }
}
.react-app-uniforms .clearfix::after {
  display: block;
  clear: both;
  content: "";
}
.react-app-uniforms .text-bg-primary {
  color: #000 !important;
  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;
}
.react-app-uniforms .text-bg-secondary {
  color: #000 !important;
  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;
}
.react-app-uniforms .text-bg-success {
  color: #fff !important;
  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;
}
.react-app-uniforms .text-bg-info {
  color: #000 !important;
  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;
}
.react-app-uniforms .text-bg-warning {
  color: #000 !important;
  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;
}
.react-app-uniforms .text-bg-danger {
  color: #fff !important;
  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;
}
.react-app-uniforms .text-bg-light {
  color: #000 !important;
  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;
}
.react-app-uniforms .text-bg-dark {
  color: #fff !important;
  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;
}
.react-app-uniforms .link-primary {
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.react-app-uniforms .link-primary:hover, .react-app-uniforms .link-primary:focus {
  color: RGBA(61, 169, 186, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(61, 169, 186, var(--bs-link-underline-opacity, 1)) !important;
}
.react-app-uniforms .link-secondary {
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.react-app-uniforms .link-secondary:hover, .react-app-uniforms .link-secondary:focus {
  color: RGBA(241, 246, 247, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(241, 246, 247, var(--bs-link-underline-opacity, 1)) !important;
}
.react-app-uniforms .link-success {
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.react-app-uniforms .link-success:hover, .react-app-uniforms .link-success:focus {
  color: RGBA(20, 108, 67, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(20, 108, 67, var(--bs-link-underline-opacity, 1)) !important;
}
.react-app-uniforms .link-info {
  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.react-app-uniforms .link-info:hover, .react-app-uniforms .link-info:focus {
  color: RGBA(255, 255, 255, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 255, 255, var(--bs-link-underline-opacity, 1)) !important;
}
.react-app-uniforms .link-warning {
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.react-app-uniforms .link-warning:hover, .react-app-uniforms .link-warning:focus {
  color: RGBA(255, 205, 57, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 205, 57, var(--bs-link-underline-opacity, 1)) !important;
}
.react-app-uniforms .link-danger {
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.react-app-uniforms .link-danger:hover, .react-app-uniforms .link-danger:focus {
  color: RGBA(176, 42, 55, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(176, 42, 55, var(--bs-link-underline-opacity, 1)) !important;
}
.react-app-uniforms .link-light {
  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.react-app-uniforms .link-light:hover, .react-app-uniforms .link-light:focus {
  color: RGBA(249, 250, 251, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(249, 250, 251, var(--bs-link-underline-opacity, 1)) !important;
}
.react-app-uniforms .link-dark {
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.react-app-uniforms .link-dark:hover, .react-app-uniforms .link-dark:focus {
  color: RGBA(26, 30, 33, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(26, 30, 33, var(--bs-link-underline-opacity, 1)) !important;
}
.react-app-uniforms .link-body-emphasis {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.react-app-uniforms .link-body-emphasis:hover, .react-app-uniforms .link-body-emphasis:focus {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
}
.react-app-uniforms .focus-ring:focus {
  outline: 0;
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);
}
.react-app-uniforms .icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}
.react-app-uniforms .icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  .react-app-uniforms .icon-link > .bi {
    transition: none;
  }
}
.react-app-uniforms .icon-link-hover:hover > .bi, .react-app-uniforms .icon-link-hover:focus-visible > .bi {
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));
}
.react-app-uniforms .ratio {
  position: relative;
  width: 100%;
}
.react-app-uniforms .ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}
.react-app-uniforms .ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.react-app-uniforms .ratio-1x1 {
  --bs-aspect-ratio: 100%;
}
.react-app-uniforms .ratio-4x3 {
  --bs-aspect-ratio: 75%;
}
.react-app-uniforms .ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}
.react-app-uniforms .ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}
.react-app-uniforms .fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}
.react-app-uniforms .fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}
.react-app-uniforms .sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}
.react-app-uniforms .sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}
@media (min-width: 576px) {
  .react-app-uniforms .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .react-app-uniforms .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .react-app-uniforms .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .react-app-uniforms .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .react-app-uniforms .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .react-app-uniforms .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .react-app-uniforms .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .react-app-uniforms .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .react-app-uniforms .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .react-app-uniforms .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.react-app-uniforms .hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}
.react-app-uniforms .vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}
.react-app-uniforms .visually-hidden,
.react-app-uniforms .visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.react-app-uniforms .visually-hidden:not(caption),
.react-app-uniforms .visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}
.react-app-uniforms .stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}
.react-app-uniforms .text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.react-app-uniforms .vr {
  display: inline-block;
  align-self: stretch;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}
.react-app-uniforms .align-baseline {
  vertical-align: baseline !important;
}
.react-app-uniforms .align-top {
  vertical-align: top !important;
}
.react-app-uniforms .align-middle {
  vertical-align: middle !important;
}
.react-app-uniforms .align-bottom {
  vertical-align: bottom !important;
}
.react-app-uniforms .align-text-bottom {
  vertical-align: text-bottom !important;
}
.react-app-uniforms .align-text-top {
  vertical-align: text-top !important;
}
.react-app-uniforms .float-start {
  float: left !important;
}
.react-app-uniforms .float-end {
  float: right !important;
}
.react-app-uniforms .float-none {
  float: none !important;
}
.react-app-uniforms .object-fit-contain {
  object-fit: contain !important;
}
.react-app-uniforms .object-fit-cover {
  object-fit: cover !important;
}
.react-app-uniforms .object-fit-fill {
  object-fit: fill !important;
}
.react-app-uniforms .object-fit-scale {
  object-fit: scale-down !important;
}
.react-app-uniforms .object-fit-none {
  object-fit: none !important;
}
.react-app-uniforms .opacity-0 {
  opacity: 0 !important;
}
.react-app-uniforms .opacity-25 {
  opacity: 0.25 !important;
}
.react-app-uniforms .opacity-50 {
  opacity: 0.5 !important;
}
.react-app-uniforms .opacity-75 {
  opacity: 0.75 !important;
}
.react-app-uniforms .opacity-100 {
  opacity: 1 !important;
}
.react-app-uniforms .overflow-auto {
  overflow: auto !important;
}
.react-app-uniforms .overflow-hidden {
  overflow: hidden !important;
}
.react-app-uniforms .overflow-visible {
  overflow: visible !important;
}
.react-app-uniforms .overflow-scroll {
  overflow: scroll !important;
}
.react-app-uniforms .overflow-x-auto {
  overflow-x: auto !important;
}
.react-app-uniforms .overflow-x-hidden {
  overflow-x: hidden !important;
}
.react-app-uniforms .overflow-x-visible {
  overflow-x: visible !important;
}
.react-app-uniforms .overflow-x-scroll {
  overflow-x: scroll !important;
}
.react-app-uniforms .overflow-y-auto {
  overflow-y: auto !important;
}
.react-app-uniforms .overflow-y-hidden {
  overflow-y: hidden !important;
}
.react-app-uniforms .overflow-y-visible {
  overflow-y: visible !important;
}
.react-app-uniforms .overflow-y-scroll {
  overflow-y: scroll !important;
}
.react-app-uniforms .d-inline {
  display: inline !important;
}
.react-app-uniforms .d-inline-block {
  display: inline-block !important;
}
.react-app-uniforms .d-block {
  display: block !important;
}
.react-app-uniforms .d-grid {
  display: grid !important;
}
.react-app-uniforms .d-inline-grid {
  display: inline-grid !important;
}
.react-app-uniforms .d-table {
  display: table !important;
}
.react-app-uniforms .d-table-row {
  display: table-row !important;
}
.react-app-uniforms .d-table-cell {
  display: table-cell !important;
}
.react-app-uniforms .d-flex {
  display: flex !important;
}
.react-app-uniforms .d-inline-flex {
  display: inline-flex !important;
}
.react-app-uniforms .d-none {
  display: none !important;
}
.react-app-uniforms .shadow {
  box-shadow: var(--bs-box-shadow) !important;
}
.react-app-uniforms .shadow-sm {
  box-shadow: var(--bs-box-shadow-sm) !important;
}
.react-app-uniforms .shadow-lg {
  box-shadow: var(--bs-box-shadow-lg) !important;
}
.react-app-uniforms .shadow-none {
  box-shadow: none !important;
}
.react-app-uniforms .focus-ring-primary {
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));
}
.react-app-uniforms .focus-ring-secondary {
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));
}
.react-app-uniforms .focus-ring-success {
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));
}
.react-app-uniforms .focus-ring-info {
  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));
}
.react-app-uniforms .focus-ring-warning {
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));
}
.react-app-uniforms .focus-ring-danger {
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));
}
.react-app-uniforms .focus-ring-light {
  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));
}
.react-app-uniforms .focus-ring-dark {
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));
}
.react-app-uniforms .position-static {
  position: static !important;
}
.react-app-uniforms .position-relative {
  position: relative !important;
}
.react-app-uniforms .position-absolute {
  position: absolute !important;
}
.react-app-uniforms .position-fixed {
  position: fixed !important;
}
.react-app-uniforms .position-sticky {
  position: sticky !important;
}
.react-app-uniforms .top-0 {
  top: 0 !important;
}
.react-app-uniforms .top-50 {
  top: 50% !important;
}
.react-app-uniforms .top-100 {
  top: 100% !important;
}
.react-app-uniforms .bottom-0 {
  bottom: 0 !important;
}
.react-app-uniforms .bottom-50 {
  bottom: 50% !important;
}
.react-app-uniforms .bottom-100 {
  bottom: 100% !important;
}
.react-app-uniforms .start-0 {
  left: 0 !important;
}
.react-app-uniforms .start-50 {
  left: 50% !important;
}
.react-app-uniforms .start-100 {
  left: 100% !important;
}
.react-app-uniforms .end-0 {
  right: 0 !important;
}
.react-app-uniforms .end-50 {
  right: 50% !important;
}
.react-app-uniforms .end-100 {
  right: 100% !important;
}
.react-app-uniforms .translate-middle {
  transform: translate(-50%, -50%) !important;
}
.react-app-uniforms .translate-middle-x {
  transform: translateX(-50%) !important;
}
.react-app-uniforms .translate-middle-y {
  transform: translateY(-50%) !important;
}
.react-app-uniforms .border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}
.react-app-uniforms .border-0 {
  border: 0 !important;
}
.react-app-uniforms .border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}
.react-app-uniforms .border-top-0 {
  border-top: 0 !important;
}
.react-app-uniforms .border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}
.react-app-uniforms .border-end-0 {
  border-right: 0 !important;
}
.react-app-uniforms .border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}
.react-app-uniforms .border-bottom-0 {
  border-bottom: 0 !important;
}
.react-app-uniforms .border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}
.react-app-uniforms .border-start-0 {
  border-left: 0 !important;
}
.react-app-uniforms .border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}
.react-app-uniforms .border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}
.react-app-uniforms .border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}
.react-app-uniforms .border-info {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}
.react-app-uniforms .border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}
.react-app-uniforms .border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}
.react-app-uniforms .border-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}
.react-app-uniforms .border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}
.react-app-uniforms .border-black {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;
}
.react-app-uniforms .border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}
.react-app-uniforms .border-primary-subtle {
  border-color: var(--bs-primary-border-subtle) !important;
}
.react-app-uniforms .border-secondary-subtle {
  border-color: var(--bs-secondary-border-subtle) !important;
}
.react-app-uniforms .border-success-subtle {
  border-color: var(--bs-success-border-subtle) !important;
}
.react-app-uniforms .border-info-subtle {
  border-color: var(--bs-info-border-subtle) !important;
}
.react-app-uniforms .border-warning-subtle {
  border-color: var(--bs-warning-border-subtle) !important;
}
.react-app-uniforms .border-danger-subtle {
  border-color: var(--bs-danger-border-subtle) !important;
}
.react-app-uniforms .border-light-subtle {
  border-color: var(--bs-light-border-subtle) !important;
}
.react-app-uniforms .border-dark-subtle {
  border-color: var(--bs-dark-border-subtle) !important;
}
.react-app-uniforms .border-1 {
  border-width: 1px !important;
}
.react-app-uniforms .border-2 {
  border-width: 2px !important;
}
.react-app-uniforms .border-3 {
  border-width: 3px !important;
}
.react-app-uniforms .border-4 {
  border-width: 4px !important;
}
.react-app-uniforms .border-5 {
  border-width: 5px !important;
}
.react-app-uniforms .border-opacity-10 {
  --bs-border-opacity: 0.1;
}
.react-app-uniforms .border-opacity-25 {
  --bs-border-opacity: 0.25;
}
.react-app-uniforms .border-opacity-50 {
  --bs-border-opacity: 0.5;
}
.react-app-uniforms .border-opacity-75 {
  --bs-border-opacity: 0.75;
}
.react-app-uniforms .border-opacity-100 {
  --bs-border-opacity: 1;
}
.react-app-uniforms .w-25 {
  width: 25% !important;
}
.react-app-uniforms .w-50 {
  width: 50% !important;
}
.react-app-uniforms .w-75 {
  width: 75% !important;
}
.react-app-uniforms .w-100 {
  width: 100% !important;
}
.react-app-uniforms .w-auto {
  width: auto !important;
}
.react-app-uniforms .mw-100 {
  max-width: 100% !important;
}
.react-app-uniforms .vw-100 {
  width: 100vw !important;
}
.react-app-uniforms .min-vw-100 {
  min-width: 100vw !important;
}
.react-app-uniforms .h-25 {
  height: 25% !important;
}
.react-app-uniforms .h-50 {
  height: 50% !important;
}
.react-app-uniforms .h-75 {
  height: 75% !important;
}
.react-app-uniforms .h-100 {
  height: 100% !important;
}
.react-app-uniforms .h-auto {
  height: auto !important;
}
.react-app-uniforms .mh-100 {
  max-height: 100% !important;
}
.react-app-uniforms .vh-100 {
  height: 100vh !important;
}
.react-app-uniforms .min-vh-100 {
  min-height: 100vh !important;
}
.react-app-uniforms .flex-fill {
  flex: 1 1 auto !important;
}
.react-app-uniforms .flex-row {
  flex-direction: row !important;
}
.react-app-uniforms .flex-column {
  flex-direction: column !important;
}
.react-app-uniforms .flex-row-reverse {
  flex-direction: row-reverse !important;
}
.react-app-uniforms .flex-column-reverse {
  flex-direction: column-reverse !important;
}
.react-app-uniforms .flex-grow-0 {
  flex-grow: 0 !important;
}
.react-app-uniforms .flex-grow-1 {
  flex-grow: 1 !important;
}
.react-app-uniforms .flex-shrink-0 {
  flex-shrink: 0 !important;
}
.react-app-uniforms .flex-shrink-1 {
  flex-shrink: 1 !important;
}
.react-app-uniforms .flex-wrap {
  flex-wrap: wrap !important;
}
.react-app-uniforms .flex-nowrap {
  flex-wrap: nowrap !important;
}
.react-app-uniforms .flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}
.react-app-uniforms .justify-content-start {
  justify-content: flex-start !important;
}
.react-app-uniforms .justify-content-end {
  justify-content: flex-end !important;
}
.react-app-uniforms .justify-content-center {
  justify-content: center !important;
}
.react-app-uniforms .justify-content-between {
  justify-content: space-between !important;
}
.react-app-uniforms .justify-content-around {
  justify-content: space-around !important;
}
.react-app-uniforms .justify-content-evenly {
  justify-content: space-evenly !important;
}
.react-app-uniforms .align-items-start {
  align-items: flex-start !important;
}
.react-app-uniforms .align-items-end {
  align-items: flex-end !important;
}
.react-app-uniforms .align-items-center {
  align-items: center !important;
}
.react-app-uniforms .align-items-baseline {
  align-items: baseline !important;
}
.react-app-uniforms .align-items-stretch {
  align-items: stretch !important;
}
.react-app-uniforms .align-content-start {
  align-content: flex-start !important;
}
.react-app-uniforms .align-content-end {
  align-content: flex-end !important;
}
.react-app-uniforms .align-content-center {
  align-content: center !important;
}
.react-app-uniforms .align-content-between {
  align-content: space-between !important;
}
.react-app-uniforms .align-content-around {
  align-content: space-around !important;
}
.react-app-uniforms .align-content-stretch {
  align-content: stretch !important;
}
.react-app-uniforms .align-self-auto {
  align-self: auto !important;
}
.react-app-uniforms .align-self-start {
  align-self: flex-start !important;
}
.react-app-uniforms .align-self-end {
  align-self: flex-end !important;
}
.react-app-uniforms .align-self-center {
  align-self: center !important;
}
.react-app-uniforms .align-self-baseline {
  align-self: baseline !important;
}
.react-app-uniforms .align-self-stretch {
  align-self: stretch !important;
}
.react-app-uniforms .order-first {
  order: -1 !important;
}
.react-app-uniforms .order-0 {
  order: 0 !important;
}
.react-app-uniforms .order-1 {
  order: 1 !important;
}
.react-app-uniforms .order-2 {
  order: 2 !important;
}
.react-app-uniforms .order-3 {
  order: 3 !important;
}
.react-app-uniforms .order-4 {
  order: 4 !important;
}
.react-app-uniforms .order-5 {
  order: 5 !important;
}
.react-app-uniforms .order-last {
  order: 6 !important;
}
.react-app-uniforms .m-0 {
  margin: 0 !important;
}
.react-app-uniforms .m-1 {
  margin: 0.25rem !important;
}
.react-app-uniforms .m-2 {
  margin: 0.5rem !important;
}
.react-app-uniforms .m-3 {
  margin: 1rem !important;
}
.react-app-uniforms .m-4 {
  margin: 1.5rem !important;
}
.react-app-uniforms .m-5 {
  margin: 3rem !important;
}
.react-app-uniforms .m-auto {
  margin: auto !important;
}
.react-app-uniforms .mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}
.react-app-uniforms .mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}
.react-app-uniforms .mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}
.react-app-uniforms .mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}
.react-app-uniforms .mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}
.react-app-uniforms .mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}
.react-app-uniforms .mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}
.react-app-uniforms .my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
.react-app-uniforms .my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}
.react-app-uniforms .my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}
.react-app-uniforms .my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}
.react-app-uniforms .my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}
.react-app-uniforms .my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}
.react-app-uniforms .my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}
.react-app-uniforms .mt-0 {
  margin-top: 0 !important;
}
.react-app-uniforms .mt-1 {
  margin-top: 0.25rem !important;
}
.react-app-uniforms .mt-2 {
  margin-top: 0.5rem !important;
}
.react-app-uniforms .mt-3 {
  margin-top: 1rem !important;
}
.react-app-uniforms .mt-4 {
  margin-top: 1.5rem !important;
}
.react-app-uniforms .mt-5 {
  margin-top: 3rem !important;
}
.react-app-uniforms .mt-auto {
  margin-top: auto !important;
}
.react-app-uniforms .me-0 {
  margin-right: 0 !important;
}
.react-app-uniforms .me-1 {
  margin-right: 0.25rem !important;
}
.react-app-uniforms .me-2 {
  margin-right: 0.5rem !important;
}
.react-app-uniforms .me-3 {
  margin-right: 1rem !important;
}
.react-app-uniforms .me-4 {
  margin-right: 1.5rem !important;
}
.react-app-uniforms .me-5 {
  margin-right: 3rem !important;
}
.react-app-uniforms .me-auto {
  margin-right: auto !important;
}
.react-app-uniforms .mb-0 {
  margin-bottom: 0 !important;
}
.react-app-uniforms .mb-1 {
  margin-bottom: 0.25rem !important;
}
.react-app-uniforms .mb-2 {
  margin-bottom: 0.5rem !important;
}
.react-app-uniforms .mb-3 {
  margin-bottom: 1rem !important;
}
.react-app-uniforms .mb-4 {
  margin-bottom: 1.5rem !important;
}
.react-app-uniforms .mb-5 {
  margin-bottom: 3rem !important;
}
.react-app-uniforms .mb-auto {
  margin-bottom: auto !important;
}
.react-app-uniforms .ms-0 {
  margin-left: 0 !important;
}
.react-app-uniforms .ms-1 {
  margin-left: 0.25rem !important;
}
.react-app-uniforms .ms-2 {
  margin-left: 0.5rem !important;
}
.react-app-uniforms .ms-3 {
  margin-left: 1rem !important;
}
.react-app-uniforms .ms-4 {
  margin-left: 1.5rem !important;
}
.react-app-uniforms .ms-5 {
  margin-left: 3rem !important;
}
.react-app-uniforms .ms-auto {
  margin-left: auto !important;
}
.react-app-uniforms .p-0 {
  padding: 0 !important;
}
.react-app-uniforms .p-1 {
  padding: 0.25rem !important;
}
.react-app-uniforms .p-2 {
  padding: 0.5rem !important;
}
.react-app-uniforms .p-3 {
  padding: 1rem !important;
}
.react-app-uniforms .p-4 {
  padding: 1.5rem !important;
}
.react-app-uniforms .p-5 {
  padding: 3rem !important;
}
.react-app-uniforms .px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}
.react-app-uniforms .px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}
.react-app-uniforms .px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}
.react-app-uniforms .px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}
.react-app-uniforms .px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}
.react-app-uniforms .px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}
.react-app-uniforms .py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.react-app-uniforms .py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}
.react-app-uniforms .py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
.react-app-uniforms .py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}
.react-app-uniforms .py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}
.react-app-uniforms .py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}
.react-app-uniforms .pt-0 {
  padding-top: 0 !important;
}
.react-app-uniforms .pt-1 {
  padding-top: 0.25rem !important;
}
.react-app-uniforms .pt-2 {
  padding-top: 0.5rem !important;
}
.react-app-uniforms .pt-3 {
  padding-top: 1rem !important;
}
.react-app-uniforms .pt-4 {
  padding-top: 1.5rem !important;
}
.react-app-uniforms .pt-5 {
  padding-top: 3rem !important;
}
.react-app-uniforms .pe-0 {
  padding-right: 0 !important;
}
.react-app-uniforms .pe-1 {
  padding-right: 0.25rem !important;
}
.react-app-uniforms .pe-2 {
  padding-right: 0.5rem !important;
}
.react-app-uniforms .pe-3 {
  padding-right: 1rem !important;
}
.react-app-uniforms .pe-4 {
  padding-right: 1.5rem !important;
}
.react-app-uniforms .pe-5 {
  padding-right: 3rem !important;
}
.react-app-uniforms .pb-0 {
  padding-bottom: 0 !important;
}
.react-app-uniforms .pb-1 {
  padding-bottom: 0.25rem !important;
}
.react-app-uniforms .pb-2 {
  padding-bottom: 0.5rem !important;
}
.react-app-uniforms .pb-3 {
  padding-bottom: 1rem !important;
}
.react-app-uniforms .pb-4 {
  padding-bottom: 1.5rem !important;
}
.react-app-uniforms .pb-5 {
  padding-bottom: 3rem !important;
}
.react-app-uniforms .ps-0 {
  padding-left: 0 !important;
}
.react-app-uniforms .ps-1 {
  padding-left: 0.25rem !important;
}
.react-app-uniforms .ps-2 {
  padding-left: 0.5rem !important;
}
.react-app-uniforms .ps-3 {
  padding-left: 1rem !important;
}
.react-app-uniforms .ps-4 {
  padding-left: 1.5rem !important;
}
.react-app-uniforms .ps-5 {
  padding-left: 3rem !important;
}
.react-app-uniforms .gap-0 {
  gap: 0 !important;
}
.react-app-uniforms .gap-1 {
  gap: 0.25rem !important;
}
.react-app-uniforms .gap-2 {
  gap: 0.5rem !important;
}
.react-app-uniforms .gap-3 {
  gap: 1rem !important;
}
.react-app-uniforms .gap-4 {
  gap: 1.5rem !important;
}
.react-app-uniforms .gap-5 {
  gap: 3rem !important;
}
.react-app-uniforms .row-gap-0 {
  row-gap: 0 !important;
}
.react-app-uniforms .row-gap-1 {
  row-gap: 0.25rem !important;
}
.react-app-uniforms .row-gap-2 {
  row-gap: 0.5rem !important;
}
.react-app-uniforms .row-gap-3 {
  row-gap: 1rem !important;
}
.react-app-uniforms .row-gap-4 {
  row-gap: 1.5rem !important;
}
.react-app-uniforms .row-gap-5 {
  row-gap: 3rem !important;
}
.react-app-uniforms .column-gap-0 {
  column-gap: 0 !important;
}
.react-app-uniforms .column-gap-1 {
  column-gap: 0.25rem !important;
}
.react-app-uniforms .column-gap-2 {
  column-gap: 0.5rem !important;
}
.react-app-uniforms .column-gap-3 {
  column-gap: 1rem !important;
}
.react-app-uniforms .column-gap-4 {
  column-gap: 1.5rem !important;
}
.react-app-uniforms .column-gap-5 {
  column-gap: 3rem !important;
}
.react-app-uniforms .font-monospace {
  font-family: var(--bs-font-monospace) !important;
}
.react-app-uniforms .fs-1 {
  font-size: calc(1.375rem + 1.5vw) !important;
}
.react-app-uniforms .fs-2 {
  font-size: calc(1.325rem + 0.9vw) !important;
}
.react-app-uniforms .fs-3 {
  font-size: calc(1.3rem + 0.6vw) !important;
}
.react-app-uniforms .fs-4 {
  font-size: calc(1.275rem + 0.3vw) !important;
}
.react-app-uniforms .fs-5 {
  font-size: 1.25rem !important;
}
.react-app-uniforms .fs-6 {
  font-size: 1rem !important;
}
.react-app-uniforms .fst-italic {
  font-style: italic !important;
}
.react-app-uniforms .fst-normal {
  font-style: normal !important;
}
.react-app-uniforms .fw-lighter {
  font-weight: lighter !important;
}
.react-app-uniforms .fw-light {
  font-weight: 300 !important;
}
.react-app-uniforms .fw-normal {
  font-weight: 400 !important;
}
.react-app-uniforms .fw-medium {
  font-weight: 500 !important;
}
.react-app-uniforms .fw-semibold {
  font-weight: 600 !important;
}
.react-app-uniforms .fw-bold {
  font-weight: 700 !important;
}
.react-app-uniforms .fw-bolder {
  font-weight: bolder !important;
}
.react-app-uniforms .lh-1 {
  line-height: 1 !important;
}
.react-app-uniforms .lh-sm {
  line-height: 1.25 !important;
}
.react-app-uniforms .lh-base {
  line-height: 1.5 !important;
}
.react-app-uniforms .lh-lg {
  line-height: 2 !important;
}
.react-app-uniforms .text-start {
  text-align: left !important;
}
.react-app-uniforms .text-end {
  text-align: right !important;
}
.react-app-uniforms .text-center {
  text-align: center !important;
}
.react-app-uniforms .text-decoration-none {
  text-decoration: none !important;
}
.react-app-uniforms .text-decoration-underline {
  text-decoration: underline !important;
}
.react-app-uniforms .text-decoration-line-through {
  text-decoration: line-through !important;
}
.react-app-uniforms .text-lowercase {
  text-transform: lowercase !important;
}
.react-app-uniforms .text-uppercase {
  text-transform: uppercase !important;
}
.react-app-uniforms .text-capitalize {
  text-transform: capitalize !important;
}
.react-app-uniforms .text-wrap {
  white-space: normal !important;
}
.react-app-uniforms .text-nowrap {
  white-space: nowrap !important;
}
.react-app-uniforms .text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}
.react-app-uniforms .text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}
.react-app-uniforms .text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}
.react-app-uniforms .text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}
.react-app-uniforms .text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}
.react-app-uniforms .text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}
.react-app-uniforms .text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}
.react-app-uniforms .text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}
.react-app-uniforms .text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}
.react-app-uniforms .text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}
.react-app-uniforms .text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}
.react-app-uniforms .text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}
.react-app-uniforms .text-muted {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}
.react-app-uniforms .text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}
.react-app-uniforms .text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}
.react-app-uniforms .text-body-secondary {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}
.react-app-uniforms .text-body-tertiary {
  --bs-text-opacity: 1;
  color: var(--bs-tertiary-color) !important;
}
.react-app-uniforms .text-body-emphasis {
  --bs-text-opacity: 1;
  color: var(--bs-emphasis-color) !important;
}
.react-app-uniforms .text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}
.react-app-uniforms .text-opacity-25 {
  --bs-text-opacity: 0.25;
}
.react-app-uniforms .text-opacity-50 {
  --bs-text-opacity: 0.5;
}
.react-app-uniforms .text-opacity-75 {
  --bs-text-opacity: 0.75;
}
.react-app-uniforms .text-opacity-100 {
  --bs-text-opacity: 1;
}
.react-app-uniforms .text-primary-emphasis {
  color: var(--bs-primary-text-emphasis) !important;
}
.react-app-uniforms .text-secondary-emphasis {
  color: var(--bs-secondary-text-emphasis) !important;
}
.react-app-uniforms .text-success-emphasis {
  color: var(--bs-success-text-emphasis) !important;
}
.react-app-uniforms .text-info-emphasis {
  color: var(--bs-info-text-emphasis) !important;
}
.react-app-uniforms .text-warning-emphasis {
  color: var(--bs-warning-text-emphasis) !important;
}
.react-app-uniforms .text-danger-emphasis {
  color: var(--bs-danger-text-emphasis) !important;
}
.react-app-uniforms .text-light-emphasis {
  color: var(--bs-light-text-emphasis) !important;
}
.react-app-uniforms .text-dark-emphasis {
  color: var(--bs-dark-text-emphasis) !important;
}
.react-app-uniforms .link-opacity-10 {
  --bs-link-opacity: 0.1;
}
.react-app-uniforms .link-opacity-10-hover:hover {
  --bs-link-opacity: 0.1;
}
.react-app-uniforms .link-opacity-25 {
  --bs-link-opacity: 0.25;
}
.react-app-uniforms .link-opacity-25-hover:hover {
  --bs-link-opacity: 0.25;
}
.react-app-uniforms .link-opacity-50 {
  --bs-link-opacity: 0.5;
}
.react-app-uniforms .link-opacity-50-hover:hover {
  --bs-link-opacity: 0.5;
}
.react-app-uniforms .link-opacity-75 {
  --bs-link-opacity: 0.75;
}
.react-app-uniforms .link-opacity-75-hover:hover {
  --bs-link-opacity: 0.75;
}
.react-app-uniforms .link-opacity-100 {
  --bs-link-opacity: 1;
}
.react-app-uniforms .link-opacity-100-hover:hover {
  --bs-link-opacity: 1;
}
.react-app-uniforms .link-offset-1 {
  text-underline-offset: 0.125em !important;
}
.react-app-uniforms .link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}
.react-app-uniforms .link-offset-2 {
  text-underline-offset: 0.25em !important;
}
.react-app-uniforms .link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}
.react-app-uniforms .link-offset-3 {
  text-underline-offset: 0.375em !important;
}
.react-app-uniforms .link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}
.react-app-uniforms .link-underline-primary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
}
.react-app-uniforms .link-underline-secondary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
}
.react-app-uniforms .link-underline-success {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
}
.react-app-uniforms .link-underline-info {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;
}
.react-app-uniforms .link-underline-warning {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
}
.react-app-uniforms .link-underline-danger {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
}
.react-app-uniforms .link-underline-light {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;
}
.react-app-uniforms .link-underline-dark {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
}
.react-app-uniforms .link-underline {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.react-app-uniforms .link-underline-opacity-0 {
  --bs-link-underline-opacity: 0;
}
.react-app-uniforms .link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity: 0;
}
.react-app-uniforms .link-underline-opacity-10 {
  --bs-link-underline-opacity: 0.1;
}
.react-app-uniforms .link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity: 0.1;
}
.react-app-uniforms .link-underline-opacity-25 {
  --bs-link-underline-opacity: 0.25;
}
.react-app-uniforms .link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity: 0.25;
}
.react-app-uniforms .link-underline-opacity-50 {
  --bs-link-underline-opacity: 0.5;
}
.react-app-uniforms .link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity: 0.5;
}
.react-app-uniforms .link-underline-opacity-75 {
  --bs-link-underline-opacity: 0.75;
}
.react-app-uniforms .link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity: 0.75;
}
.react-app-uniforms .link-underline-opacity-100 {
  --bs-link-underline-opacity: 1;
}
.react-app-uniforms .link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity: 1;
}
.react-app-uniforms .bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}
.react-app-uniforms .bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}
.react-app-uniforms .bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}
.react-app-uniforms .bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}
.react-app-uniforms .bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}
.react-app-uniforms .bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}
.react-app-uniforms .bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}
.react-app-uniforms .bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}
.react-app-uniforms .bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}
.react-app-uniforms .bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}
.react-app-uniforms .bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}
.react-app-uniforms .bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}
.react-app-uniforms .bg-body-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;
}
.react-app-uniforms .bg-body-tertiary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;
}
.react-app-uniforms .bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}
.react-app-uniforms .bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}
.react-app-uniforms .bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}
.react-app-uniforms .bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}
.react-app-uniforms .bg-opacity-100 {
  --bs-bg-opacity: 1;
}
.react-app-uniforms .bg-primary-subtle {
  background-color: var(--bs-primary-bg-subtle) !important;
}
.react-app-uniforms .bg-secondary-subtle {
  background-color: var(--bs-secondary-bg-subtle) !important;
}
.react-app-uniforms .bg-success-subtle {
  background-color: var(--bs-success-bg-subtle) !important;
}
.react-app-uniforms .bg-info-subtle {
  background-color: var(--bs-info-bg-subtle) !important;
}
.react-app-uniforms .bg-warning-subtle {
  background-color: var(--bs-warning-bg-subtle) !important;
}
.react-app-uniforms .bg-danger-subtle {
  background-color: var(--bs-danger-bg-subtle) !important;
}
.react-app-uniforms .bg-light-subtle {
  background-color: var(--bs-light-bg-subtle) !important;
}
.react-app-uniforms .bg-dark-subtle {
  background-color: var(--bs-dark-bg-subtle) !important;
}
.react-app-uniforms .bg-gradient {
  background-image: var(--bs-gradient) !important;
}
.react-app-uniforms .user-select-all {
  user-select: all !important;
}
.react-app-uniforms .user-select-auto {
  user-select: auto !important;
}
.react-app-uniforms .user-select-none {
  user-select: none !important;
}
.react-app-uniforms .pe-none {
  pointer-events: none !important;
}
.react-app-uniforms .pe-auto {
  pointer-events: auto !important;
}
.react-app-uniforms .rounded {
  border-radius: var(--bs-border-radius) !important;
}
.react-app-uniforms .rounded-0 {
  border-radius: 0 !important;
}
.react-app-uniforms .rounded-1 {
  border-radius: var(--bs-border-radius-sm) !important;
}
.react-app-uniforms .rounded-2 {
  border-radius: var(--bs-border-radius) !important;
}
.react-app-uniforms .rounded-3 {
  border-radius: var(--bs-border-radius-lg) !important;
}
.react-app-uniforms .rounded-4 {
  border-radius: var(--bs-border-radius-xl) !important;
}
.react-app-uniforms .rounded-5 {
  border-radius: var(--bs-border-radius-xxl) !important;
}
.react-app-uniforms .rounded-circle {
  border-radius: 50% !important;
}
.react-app-uniforms .rounded-pill {
  border-radius: var(--bs-border-radius-pill) !important;
}
.react-app-uniforms .rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}
.react-app-uniforms .rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
.react-app-uniforms .rounded-top-1 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}
.react-app-uniforms .rounded-top-2 {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}
.react-app-uniforms .rounded-top-3 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}
.react-app-uniforms .rounded-top-4 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}
.react-app-uniforms .rounded-top-5 {
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}
.react-app-uniforms .rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}
.react-app-uniforms .rounded-top-pill {
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
}
.react-app-uniforms .rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}
.react-app-uniforms .rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
.react-app-uniforms .rounded-end-1 {
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
}
.react-app-uniforms .rounded-end-2 {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}
.react-app-uniforms .rounded-end-3 {
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
}
.react-app-uniforms .rounded-end-4 {
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
}
.react-app-uniforms .rounded-end-5 {
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
}
.react-app-uniforms .rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}
.react-app-uniforms .rounded-end-pill {
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
}
.react-app-uniforms .rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}
.react-app-uniforms .rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}
.react-app-uniforms .rounded-bottom-1 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}
.react-app-uniforms .rounded-bottom-2 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}
.react-app-uniforms .rounded-bottom-3 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}
.react-app-uniforms .rounded-bottom-4 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}
.react-app-uniforms .rounded-bottom-5 {
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}
.react-app-uniforms .rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}
.react-app-uniforms .rounded-bottom-pill {
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
}
.react-app-uniforms .rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}
.react-app-uniforms .rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}
.react-app-uniforms .rounded-start-1 {
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
}
.react-app-uniforms .rounded-start-2 {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}
.react-app-uniforms .rounded-start-3 {
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
}
.react-app-uniforms .rounded-start-4 {
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
}
.react-app-uniforms .rounded-start-5 {
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
}
.react-app-uniforms .rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}
.react-app-uniforms .rounded-start-pill {
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
}
.react-app-uniforms .visible {
  visibility: visible !important;
}
.react-app-uniforms .invisible {
  visibility: hidden !important;
}
.react-app-uniforms .z-n1 {
  z-index: -1 !important;
}
.react-app-uniforms .z-0 {
  z-index: 0 !important;
}
.react-app-uniforms .z-1 {
  z-index: 1 !important;
}
.react-app-uniforms .z-2 {
  z-index: 2 !important;
}
.react-app-uniforms .z-3 {
  z-index: 3 !important;
}
@media (min-width: 576px) {
  .react-app-uniforms .float-sm-start {
    float: left !important;
  }
  .react-app-uniforms .float-sm-end {
    float: right !important;
  }
  .react-app-uniforms .float-sm-none {
    float: none !important;
  }
  .react-app-uniforms .object-fit-sm-contain {
    object-fit: contain !important;
  }
  .react-app-uniforms .object-fit-sm-cover {
    object-fit: cover !important;
  }
  .react-app-uniforms .object-fit-sm-fill {
    object-fit: fill !important;
  }
  .react-app-uniforms .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  .react-app-uniforms .object-fit-sm-none {
    object-fit: none !important;
  }
  .react-app-uniforms .d-sm-inline {
    display: inline !important;
  }
  .react-app-uniforms .d-sm-inline-block {
    display: inline-block !important;
  }
  .react-app-uniforms .d-sm-block {
    display: block !important;
  }
  .react-app-uniforms .d-sm-grid {
    display: grid !important;
  }
  .react-app-uniforms .d-sm-inline-grid {
    display: inline-grid !important;
  }
  .react-app-uniforms .d-sm-table {
    display: table !important;
  }
  .react-app-uniforms .d-sm-table-row {
    display: table-row !important;
  }
  .react-app-uniforms .d-sm-table-cell {
    display: table-cell !important;
  }
  .react-app-uniforms .d-sm-flex {
    display: flex !important;
  }
  .react-app-uniforms .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .react-app-uniforms .d-sm-none {
    display: none !important;
  }
  .react-app-uniforms .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .react-app-uniforms .flex-sm-row {
    flex-direction: row !important;
  }
  .react-app-uniforms .flex-sm-column {
    flex-direction: column !important;
  }
  .react-app-uniforms .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .react-app-uniforms .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .react-app-uniforms .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .react-app-uniforms .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .react-app-uniforms .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .react-app-uniforms .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .react-app-uniforms .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .react-app-uniforms .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .react-app-uniforms .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .react-app-uniforms .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .react-app-uniforms .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .react-app-uniforms .justify-content-sm-center {
    justify-content: center !important;
  }
  .react-app-uniforms .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .react-app-uniforms .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .react-app-uniforms .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .react-app-uniforms .align-items-sm-start {
    align-items: flex-start !important;
  }
  .react-app-uniforms .align-items-sm-end {
    align-items: flex-end !important;
  }
  .react-app-uniforms .align-items-sm-center {
    align-items: center !important;
  }
  .react-app-uniforms .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .react-app-uniforms .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .react-app-uniforms .align-content-sm-start {
    align-content: flex-start !important;
  }
  .react-app-uniforms .align-content-sm-end {
    align-content: flex-end !important;
  }
  .react-app-uniforms .align-content-sm-center {
    align-content: center !important;
  }
  .react-app-uniforms .align-content-sm-between {
    align-content: space-between !important;
  }
  .react-app-uniforms .align-content-sm-around {
    align-content: space-around !important;
  }
  .react-app-uniforms .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .react-app-uniforms .align-self-sm-auto {
    align-self: auto !important;
  }
  .react-app-uniforms .align-self-sm-start {
    align-self: flex-start !important;
  }
  .react-app-uniforms .align-self-sm-end {
    align-self: flex-end !important;
  }
  .react-app-uniforms .align-self-sm-center {
    align-self: center !important;
  }
  .react-app-uniforms .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .react-app-uniforms .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .react-app-uniforms .order-sm-first {
    order: -1 !important;
  }
  .react-app-uniforms .order-sm-0 {
    order: 0 !important;
  }
  .react-app-uniforms .order-sm-1 {
    order: 1 !important;
  }
  .react-app-uniforms .order-sm-2 {
    order: 2 !important;
  }
  .react-app-uniforms .order-sm-3 {
    order: 3 !important;
  }
  .react-app-uniforms .order-sm-4 {
    order: 4 !important;
  }
  .react-app-uniforms .order-sm-5 {
    order: 5 !important;
  }
  .react-app-uniforms .order-sm-last {
    order: 6 !important;
  }
  .react-app-uniforms .m-sm-0 {
    margin: 0 !important;
  }
  .react-app-uniforms .m-sm-1 {
    margin: 0.25rem !important;
  }
  .react-app-uniforms .m-sm-2 {
    margin: 0.5rem !important;
  }
  .react-app-uniforms .m-sm-3 {
    margin: 1rem !important;
  }
  .react-app-uniforms .m-sm-4 {
    margin: 1.5rem !important;
  }
  .react-app-uniforms .m-sm-5 {
    margin: 3rem !important;
  }
  .react-app-uniforms .m-sm-auto {
    margin: auto !important;
  }
  .react-app-uniforms .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .react-app-uniforms .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .react-app-uniforms .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .react-app-uniforms .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .react-app-uniforms .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .react-app-uniforms .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .react-app-uniforms .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .react-app-uniforms .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .react-app-uniforms .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .react-app-uniforms .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .react-app-uniforms .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .react-app-uniforms .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .react-app-uniforms .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .react-app-uniforms .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .react-app-uniforms .mt-sm-0 {
    margin-top: 0 !important;
  }
  .react-app-uniforms .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .react-app-uniforms .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .react-app-uniforms .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .react-app-uniforms .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .react-app-uniforms .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .react-app-uniforms .mt-sm-auto {
    margin-top: auto !important;
  }
  .react-app-uniforms .me-sm-0 {
    margin-right: 0 !important;
  }
  .react-app-uniforms .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  .react-app-uniforms .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  .react-app-uniforms .me-sm-3 {
    margin-right: 1rem !important;
  }
  .react-app-uniforms .me-sm-4 {
    margin-right: 1.5rem !important;
  }
  .react-app-uniforms .me-sm-5 {
    margin-right: 3rem !important;
  }
  .react-app-uniforms .me-sm-auto {
    margin-right: auto !important;
  }
  .react-app-uniforms .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .react-app-uniforms .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .react-app-uniforms .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .react-app-uniforms .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .react-app-uniforms .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .react-app-uniforms .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .react-app-uniforms .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .react-app-uniforms .ms-sm-0 {
    margin-left: 0 !important;
  }
  .react-app-uniforms .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  .react-app-uniforms .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  .react-app-uniforms .ms-sm-3 {
    margin-left: 1rem !important;
  }
  .react-app-uniforms .ms-sm-4 {
    margin-left: 1.5rem !important;
  }
  .react-app-uniforms .ms-sm-5 {
    margin-left: 3rem !important;
  }
  .react-app-uniforms .ms-sm-auto {
    margin-left: auto !important;
  }
  .react-app-uniforms .p-sm-0 {
    padding: 0 !important;
  }
  .react-app-uniforms .p-sm-1 {
    padding: 0.25rem !important;
  }
  .react-app-uniforms .p-sm-2 {
    padding: 0.5rem !important;
  }
  .react-app-uniforms .p-sm-3 {
    padding: 1rem !important;
  }
  .react-app-uniforms .p-sm-4 {
    padding: 1.5rem !important;
  }
  .react-app-uniforms .p-sm-5 {
    padding: 3rem !important;
  }
  .react-app-uniforms .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .react-app-uniforms .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .react-app-uniforms .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .react-app-uniforms .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .react-app-uniforms .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .react-app-uniforms .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .react-app-uniforms .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .react-app-uniforms .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .react-app-uniforms .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .react-app-uniforms .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .react-app-uniforms .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .react-app-uniforms .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .react-app-uniforms .pt-sm-0 {
    padding-top: 0 !important;
  }
  .react-app-uniforms .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .react-app-uniforms .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .react-app-uniforms .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .react-app-uniforms .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .react-app-uniforms .pt-sm-5 {
    padding-top: 3rem !important;
  }
  .react-app-uniforms .pe-sm-0 {
    padding-right: 0 !important;
  }
  .react-app-uniforms .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  .react-app-uniforms .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  .react-app-uniforms .pe-sm-3 {
    padding-right: 1rem !important;
  }
  .react-app-uniforms .pe-sm-4 {
    padding-right: 1.5rem !important;
  }
  .react-app-uniforms .pe-sm-5 {
    padding-right: 3rem !important;
  }
  .react-app-uniforms .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .react-app-uniforms .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .react-app-uniforms .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .react-app-uniforms .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .react-app-uniforms .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .react-app-uniforms .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  .react-app-uniforms .ps-sm-0 {
    padding-left: 0 !important;
  }
  .react-app-uniforms .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  .react-app-uniforms .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  .react-app-uniforms .ps-sm-3 {
    padding-left: 1rem !important;
  }
  .react-app-uniforms .ps-sm-4 {
    padding-left: 1.5rem !important;
  }
  .react-app-uniforms .ps-sm-5 {
    padding-left: 3rem !important;
  }
  .react-app-uniforms .gap-sm-0 {
    gap: 0 !important;
  }
  .react-app-uniforms .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .react-app-uniforms .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .react-app-uniforms .gap-sm-3 {
    gap: 1rem !important;
  }
  .react-app-uniforms .gap-sm-4 {
    gap: 1.5rem !important;
  }
  .react-app-uniforms .gap-sm-5 {
    gap: 3rem !important;
  }
  .react-app-uniforms .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  .react-app-uniforms .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }
  .react-app-uniforms .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }
  .react-app-uniforms .row-gap-sm-3 {
    row-gap: 1rem !important;
  }
  .react-app-uniforms .row-gap-sm-4 {
    row-gap: 1.5rem !important;
  }
  .react-app-uniforms .row-gap-sm-5 {
    row-gap: 3rem !important;
  }
  .react-app-uniforms .column-gap-sm-0 {
    column-gap: 0 !important;
  }
  .react-app-uniforms .column-gap-sm-1 {
    column-gap: 0.25rem !important;
  }
  .react-app-uniforms .column-gap-sm-2 {
    column-gap: 0.5rem !important;
  }
  .react-app-uniforms .column-gap-sm-3 {
    column-gap: 1rem !important;
  }
  .react-app-uniforms .column-gap-sm-4 {
    column-gap: 1.5rem !important;
  }
  .react-app-uniforms .column-gap-sm-5 {
    column-gap: 3rem !important;
  }
  .react-app-uniforms .text-sm-start {
    text-align: left !important;
  }
  .react-app-uniforms .text-sm-end {
    text-align: right !important;
  }
  .react-app-uniforms .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .react-app-uniforms .float-md-start {
    float: left !important;
  }
  .react-app-uniforms .float-md-end {
    float: right !important;
  }
  .react-app-uniforms .float-md-none {
    float: none !important;
  }
  .react-app-uniforms .object-fit-md-contain {
    object-fit: contain !important;
  }
  .react-app-uniforms .object-fit-md-cover {
    object-fit: cover !important;
  }
  .react-app-uniforms .object-fit-md-fill {
    object-fit: fill !important;
  }
  .react-app-uniforms .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  .react-app-uniforms .object-fit-md-none {
    object-fit: none !important;
  }
  .react-app-uniforms .d-md-inline {
    display: inline !important;
  }
  .react-app-uniforms .d-md-inline-block {
    display: inline-block !important;
  }
  .react-app-uniforms .d-md-block {
    display: block !important;
  }
  .react-app-uniforms .d-md-grid {
    display: grid !important;
  }
  .react-app-uniforms .d-md-inline-grid {
    display: inline-grid !important;
  }
  .react-app-uniforms .d-md-table {
    display: table !important;
  }
  .react-app-uniforms .d-md-table-row {
    display: table-row !important;
  }
  .react-app-uniforms .d-md-table-cell {
    display: table-cell !important;
  }
  .react-app-uniforms .d-md-flex {
    display: flex !important;
  }
  .react-app-uniforms .d-md-inline-flex {
    display: inline-flex !important;
  }
  .react-app-uniforms .d-md-none {
    display: none !important;
  }
  .react-app-uniforms .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .react-app-uniforms .flex-md-row {
    flex-direction: row !important;
  }
  .react-app-uniforms .flex-md-column {
    flex-direction: column !important;
  }
  .react-app-uniforms .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .react-app-uniforms .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .react-app-uniforms .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .react-app-uniforms .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .react-app-uniforms .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .react-app-uniforms .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .react-app-uniforms .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .react-app-uniforms .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .react-app-uniforms .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .react-app-uniforms .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .react-app-uniforms .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .react-app-uniforms .justify-content-md-center {
    justify-content: center !important;
  }
  .react-app-uniforms .justify-content-md-between {
    justify-content: space-between !important;
  }
  .react-app-uniforms .justify-content-md-around {
    justify-content: space-around !important;
  }
  .react-app-uniforms .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .react-app-uniforms .align-items-md-start {
    align-items: flex-start !important;
  }
  .react-app-uniforms .align-items-md-end {
    align-items: flex-end !important;
  }
  .react-app-uniforms .align-items-md-center {
    align-items: center !important;
  }
  .react-app-uniforms .align-items-md-baseline {
    align-items: baseline !important;
  }
  .react-app-uniforms .align-items-md-stretch {
    align-items: stretch !important;
  }
  .react-app-uniforms .align-content-md-start {
    align-content: flex-start !important;
  }
  .react-app-uniforms .align-content-md-end {
    align-content: flex-end !important;
  }
  .react-app-uniforms .align-content-md-center {
    align-content: center !important;
  }
  .react-app-uniforms .align-content-md-between {
    align-content: space-between !important;
  }
  .react-app-uniforms .align-content-md-around {
    align-content: space-around !important;
  }
  .react-app-uniforms .align-content-md-stretch {
    align-content: stretch !important;
  }
  .react-app-uniforms .align-self-md-auto {
    align-self: auto !important;
  }
  .react-app-uniforms .align-self-md-start {
    align-self: flex-start !important;
  }
  .react-app-uniforms .align-self-md-end {
    align-self: flex-end !important;
  }
  .react-app-uniforms .align-self-md-center {
    align-self: center !important;
  }
  .react-app-uniforms .align-self-md-baseline {
    align-self: baseline !important;
  }
  .react-app-uniforms .align-self-md-stretch {
    align-self: stretch !important;
  }
  .react-app-uniforms .order-md-first {
    order: -1 !important;
  }
  .react-app-uniforms .order-md-0 {
    order: 0 !important;
  }
  .react-app-uniforms .order-md-1 {
    order: 1 !important;
  }
  .react-app-uniforms .order-md-2 {
    order: 2 !important;
  }
  .react-app-uniforms .order-md-3 {
    order: 3 !important;
  }
  .react-app-uniforms .order-md-4 {
    order: 4 !important;
  }
  .react-app-uniforms .order-md-5 {
    order: 5 !important;
  }
  .react-app-uniforms .order-md-last {
    order: 6 !important;
  }
  .react-app-uniforms .m-md-0 {
    margin: 0 !important;
  }
  .react-app-uniforms .m-md-1 {
    margin: 0.25rem !important;
  }
  .react-app-uniforms .m-md-2 {
    margin: 0.5rem !important;
  }
  .react-app-uniforms .m-md-3 {
    margin: 1rem !important;
  }
  .react-app-uniforms .m-md-4 {
    margin: 1.5rem !important;
  }
  .react-app-uniforms .m-md-5 {
    margin: 3rem !important;
  }
  .react-app-uniforms .m-md-auto {
    margin: auto !important;
  }
  .react-app-uniforms .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .react-app-uniforms .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .react-app-uniforms .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .react-app-uniforms .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .react-app-uniforms .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .react-app-uniforms .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .react-app-uniforms .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .react-app-uniforms .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .react-app-uniforms .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .react-app-uniforms .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .react-app-uniforms .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .react-app-uniforms .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .react-app-uniforms .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .react-app-uniforms .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .react-app-uniforms .mt-md-0 {
    margin-top: 0 !important;
  }
  .react-app-uniforms .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .react-app-uniforms .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .react-app-uniforms .mt-md-3 {
    margin-top: 1rem !important;
  }
  .react-app-uniforms .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .react-app-uniforms .mt-md-5 {
    margin-top: 3rem !important;
  }
  .react-app-uniforms .mt-md-auto {
    margin-top: auto !important;
  }
  .react-app-uniforms .me-md-0 {
    margin-right: 0 !important;
  }
  .react-app-uniforms .me-md-1 {
    margin-right: 0.25rem !important;
  }
  .react-app-uniforms .me-md-2 {
    margin-right: 0.5rem !important;
  }
  .react-app-uniforms .me-md-3 {
    margin-right: 1rem !important;
  }
  .react-app-uniforms .me-md-4 {
    margin-right: 1.5rem !important;
  }
  .react-app-uniforms .me-md-5 {
    margin-right: 3rem !important;
  }
  .react-app-uniforms .me-md-auto {
    margin-right: auto !important;
  }
  .react-app-uniforms .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .react-app-uniforms .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .react-app-uniforms .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .react-app-uniforms .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .react-app-uniforms .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .react-app-uniforms .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .react-app-uniforms .mb-md-auto {
    margin-bottom: auto !important;
  }
  .react-app-uniforms .ms-md-0 {
    margin-left: 0 !important;
  }
  .react-app-uniforms .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  .react-app-uniforms .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  .react-app-uniforms .ms-md-3 {
    margin-left: 1rem !important;
  }
  .react-app-uniforms .ms-md-4 {
    margin-left: 1.5rem !important;
  }
  .react-app-uniforms .ms-md-5 {
    margin-left: 3rem !important;
  }
  .react-app-uniforms .ms-md-auto {
    margin-left: auto !important;
  }
  .react-app-uniforms .p-md-0 {
    padding: 0 !important;
  }
  .react-app-uniforms .p-md-1 {
    padding: 0.25rem !important;
  }
  .react-app-uniforms .p-md-2 {
    padding: 0.5rem !important;
  }
  .react-app-uniforms .p-md-3 {
    padding: 1rem !important;
  }
  .react-app-uniforms .p-md-4 {
    padding: 1.5rem !important;
  }
  .react-app-uniforms .p-md-5 {
    padding: 3rem !important;
  }
  .react-app-uniforms .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .react-app-uniforms .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .react-app-uniforms .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .react-app-uniforms .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .react-app-uniforms .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .react-app-uniforms .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .react-app-uniforms .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .react-app-uniforms .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .react-app-uniforms .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .react-app-uniforms .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .react-app-uniforms .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .react-app-uniforms .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .react-app-uniforms .pt-md-0 {
    padding-top: 0 !important;
  }
  .react-app-uniforms .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .react-app-uniforms .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .react-app-uniforms .pt-md-3 {
    padding-top: 1rem !important;
  }
  .react-app-uniforms .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .react-app-uniforms .pt-md-5 {
    padding-top: 3rem !important;
  }
  .react-app-uniforms .pe-md-0 {
    padding-right: 0 !important;
  }
  .react-app-uniforms .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  .react-app-uniforms .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  .react-app-uniforms .pe-md-3 {
    padding-right: 1rem !important;
  }
  .react-app-uniforms .pe-md-4 {
    padding-right: 1.5rem !important;
  }
  .react-app-uniforms .pe-md-5 {
    padding-right: 3rem !important;
  }
  .react-app-uniforms .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .react-app-uniforms .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .react-app-uniforms .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .react-app-uniforms .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .react-app-uniforms .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .react-app-uniforms .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  .react-app-uniforms .ps-md-0 {
    padding-left: 0 !important;
  }
  .react-app-uniforms .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  .react-app-uniforms .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  .react-app-uniforms .ps-md-3 {
    padding-left: 1rem !important;
  }
  .react-app-uniforms .ps-md-4 {
    padding-left: 1.5rem !important;
  }
  .react-app-uniforms .ps-md-5 {
    padding-left: 3rem !important;
  }
  .react-app-uniforms .gap-md-0 {
    gap: 0 !important;
  }
  .react-app-uniforms .gap-md-1 {
    gap: 0.25rem !important;
  }
  .react-app-uniforms .gap-md-2 {
    gap: 0.5rem !important;
  }
  .react-app-uniforms .gap-md-3 {
    gap: 1rem !important;
  }
  .react-app-uniforms .gap-md-4 {
    gap: 1.5rem !important;
  }
  .react-app-uniforms .gap-md-5 {
    gap: 3rem !important;
  }
  .react-app-uniforms .row-gap-md-0 {
    row-gap: 0 !important;
  }
  .react-app-uniforms .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }
  .react-app-uniforms .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }
  .react-app-uniforms .row-gap-md-3 {
    row-gap: 1rem !important;
  }
  .react-app-uniforms .row-gap-md-4 {
    row-gap: 1.5rem !important;
  }
  .react-app-uniforms .row-gap-md-5 {
    row-gap: 3rem !important;
  }
  .react-app-uniforms .column-gap-md-0 {
    column-gap: 0 !important;
  }
  .react-app-uniforms .column-gap-md-1 {
    column-gap: 0.25rem !important;
  }
  .react-app-uniforms .column-gap-md-2 {
    column-gap: 0.5rem !important;
  }
  .react-app-uniforms .column-gap-md-3 {
    column-gap: 1rem !important;
  }
  .react-app-uniforms .column-gap-md-4 {
    column-gap: 1.5rem !important;
  }
  .react-app-uniforms .column-gap-md-5 {
    column-gap: 3rem !important;
  }
  .react-app-uniforms .text-md-start {
    text-align: left !important;
  }
  .react-app-uniforms .text-md-end {
    text-align: right !important;
  }
  .react-app-uniforms .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .react-app-uniforms .float-lg-start {
    float: left !important;
  }
  .react-app-uniforms .float-lg-end {
    float: right !important;
  }
  .react-app-uniforms .float-lg-none {
    float: none !important;
  }
  .react-app-uniforms .object-fit-lg-contain {
    object-fit: contain !important;
  }
  .react-app-uniforms .object-fit-lg-cover {
    object-fit: cover !important;
  }
  .react-app-uniforms .object-fit-lg-fill {
    object-fit: fill !important;
  }
  .react-app-uniforms .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  .react-app-uniforms .object-fit-lg-none {
    object-fit: none !important;
  }
  .react-app-uniforms .d-lg-inline {
    display: inline !important;
  }
  .react-app-uniforms .d-lg-inline-block {
    display: inline-block !important;
  }
  .react-app-uniforms .d-lg-block {
    display: block !important;
  }
  .react-app-uniforms .d-lg-grid {
    display: grid !important;
  }
  .react-app-uniforms .d-lg-inline-grid {
    display: inline-grid !important;
  }
  .react-app-uniforms .d-lg-table {
    display: table !important;
  }
  .react-app-uniforms .d-lg-table-row {
    display: table-row !important;
  }
  .react-app-uniforms .d-lg-table-cell {
    display: table-cell !important;
  }
  .react-app-uniforms .d-lg-flex {
    display: flex !important;
  }
  .react-app-uniforms .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .react-app-uniforms .d-lg-none {
    display: none !important;
  }
  .react-app-uniforms .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .react-app-uniforms .flex-lg-row {
    flex-direction: row !important;
  }
  .react-app-uniforms .flex-lg-column {
    flex-direction: column !important;
  }
  .react-app-uniforms .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .react-app-uniforms .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .react-app-uniforms .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .react-app-uniforms .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .react-app-uniforms .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .react-app-uniforms .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .react-app-uniforms .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .react-app-uniforms .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .react-app-uniforms .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .react-app-uniforms .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .react-app-uniforms .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .react-app-uniforms .justify-content-lg-center {
    justify-content: center !important;
  }
  .react-app-uniforms .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .react-app-uniforms .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .react-app-uniforms .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .react-app-uniforms .align-items-lg-start {
    align-items: flex-start !important;
  }
  .react-app-uniforms .align-items-lg-end {
    align-items: flex-end !important;
  }
  .react-app-uniforms .align-items-lg-center {
    align-items: center !important;
  }
  .react-app-uniforms .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .react-app-uniforms .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .react-app-uniforms .align-content-lg-start {
    align-content: flex-start !important;
  }
  .react-app-uniforms .align-content-lg-end {
    align-content: flex-end !important;
  }
  .react-app-uniforms .align-content-lg-center {
    align-content: center !important;
  }
  .react-app-uniforms .align-content-lg-between {
    align-content: space-between !important;
  }
  .react-app-uniforms .align-content-lg-around {
    align-content: space-around !important;
  }
  .react-app-uniforms .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .react-app-uniforms .align-self-lg-auto {
    align-self: auto !important;
  }
  .react-app-uniforms .align-self-lg-start {
    align-self: flex-start !important;
  }
  .react-app-uniforms .align-self-lg-end {
    align-self: flex-end !important;
  }
  .react-app-uniforms .align-self-lg-center {
    align-self: center !important;
  }
  .react-app-uniforms .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .react-app-uniforms .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .react-app-uniforms .order-lg-first {
    order: -1 !important;
  }
  .react-app-uniforms .order-lg-0 {
    order: 0 !important;
  }
  .react-app-uniforms .order-lg-1 {
    order: 1 !important;
  }
  .react-app-uniforms .order-lg-2 {
    order: 2 !important;
  }
  .react-app-uniforms .order-lg-3 {
    order: 3 !important;
  }
  .react-app-uniforms .order-lg-4 {
    order: 4 !important;
  }
  .react-app-uniforms .order-lg-5 {
    order: 5 !important;
  }
  .react-app-uniforms .order-lg-last {
    order: 6 !important;
  }
  .react-app-uniforms .m-lg-0 {
    margin: 0 !important;
  }
  .react-app-uniforms .m-lg-1 {
    margin: 0.25rem !important;
  }
  .react-app-uniforms .m-lg-2 {
    margin: 0.5rem !important;
  }
  .react-app-uniforms .m-lg-3 {
    margin: 1rem !important;
  }
  .react-app-uniforms .m-lg-4 {
    margin: 1.5rem !important;
  }
  .react-app-uniforms .m-lg-5 {
    margin: 3rem !important;
  }
  .react-app-uniforms .m-lg-auto {
    margin: auto !important;
  }
  .react-app-uniforms .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .react-app-uniforms .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .react-app-uniforms .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .react-app-uniforms .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .react-app-uniforms .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .react-app-uniforms .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .react-app-uniforms .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .react-app-uniforms .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .react-app-uniforms .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .react-app-uniforms .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .react-app-uniforms .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .react-app-uniforms .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .react-app-uniforms .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .react-app-uniforms .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .react-app-uniforms .mt-lg-0 {
    margin-top: 0 !important;
  }
  .react-app-uniforms .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .react-app-uniforms .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .react-app-uniforms .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .react-app-uniforms .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .react-app-uniforms .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .react-app-uniforms .mt-lg-auto {
    margin-top: auto !important;
  }
  .react-app-uniforms .me-lg-0 {
    margin-right: 0 !important;
  }
  .react-app-uniforms .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  .react-app-uniforms .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  .react-app-uniforms .me-lg-3 {
    margin-right: 1rem !important;
  }
  .react-app-uniforms .me-lg-4 {
    margin-right: 1.5rem !important;
  }
  .react-app-uniforms .me-lg-5 {
    margin-right: 3rem !important;
  }
  .react-app-uniforms .me-lg-auto {
    margin-right: auto !important;
  }
  .react-app-uniforms .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .react-app-uniforms .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .react-app-uniforms .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .react-app-uniforms .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .react-app-uniforms .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .react-app-uniforms .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .react-app-uniforms .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .react-app-uniforms .ms-lg-0 {
    margin-left: 0 !important;
  }
  .react-app-uniforms .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  .react-app-uniforms .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  .react-app-uniforms .ms-lg-3 {
    margin-left: 1rem !important;
  }
  .react-app-uniforms .ms-lg-4 {
    margin-left: 1.5rem !important;
  }
  .react-app-uniforms .ms-lg-5 {
    margin-left: 3rem !important;
  }
  .react-app-uniforms .ms-lg-auto {
    margin-left: auto !important;
  }
  .react-app-uniforms .p-lg-0 {
    padding: 0 !important;
  }
  .react-app-uniforms .p-lg-1 {
    padding: 0.25rem !important;
  }
  .react-app-uniforms .p-lg-2 {
    padding: 0.5rem !important;
  }
  .react-app-uniforms .p-lg-3 {
    padding: 1rem !important;
  }
  .react-app-uniforms .p-lg-4 {
    padding: 1.5rem !important;
  }
  .react-app-uniforms .p-lg-5 {
    padding: 3rem !important;
  }
  .react-app-uniforms .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .react-app-uniforms .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .react-app-uniforms .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .react-app-uniforms .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .react-app-uniforms .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .react-app-uniforms .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .react-app-uniforms .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .react-app-uniforms .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .react-app-uniforms .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .react-app-uniforms .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .react-app-uniforms .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .react-app-uniforms .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .react-app-uniforms .pt-lg-0 {
    padding-top: 0 !important;
  }
  .react-app-uniforms .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .react-app-uniforms .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .react-app-uniforms .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .react-app-uniforms .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .react-app-uniforms .pt-lg-5 {
    padding-top: 3rem !important;
  }
  .react-app-uniforms .pe-lg-0 {
    padding-right: 0 !important;
  }
  .react-app-uniforms .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  .react-app-uniforms .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  .react-app-uniforms .pe-lg-3 {
    padding-right: 1rem !important;
  }
  .react-app-uniforms .pe-lg-4 {
    padding-right: 1.5rem !important;
  }
  .react-app-uniforms .pe-lg-5 {
    padding-right: 3rem !important;
  }
  .react-app-uniforms .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .react-app-uniforms .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .react-app-uniforms .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .react-app-uniforms .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .react-app-uniforms .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .react-app-uniforms .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  .react-app-uniforms .ps-lg-0 {
    padding-left: 0 !important;
  }
  .react-app-uniforms .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  .react-app-uniforms .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  .react-app-uniforms .ps-lg-3 {
    padding-left: 1rem !important;
  }
  .react-app-uniforms .ps-lg-4 {
    padding-left: 1.5rem !important;
  }
  .react-app-uniforms .ps-lg-5 {
    padding-left: 3rem !important;
  }
  .react-app-uniforms .gap-lg-0 {
    gap: 0 !important;
  }
  .react-app-uniforms .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .react-app-uniforms .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .react-app-uniforms .gap-lg-3 {
    gap: 1rem !important;
  }
  .react-app-uniforms .gap-lg-4 {
    gap: 1.5rem !important;
  }
  .react-app-uniforms .gap-lg-5 {
    gap: 3rem !important;
  }
  .react-app-uniforms .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  .react-app-uniforms .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }
  .react-app-uniforms .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }
  .react-app-uniforms .row-gap-lg-3 {
    row-gap: 1rem !important;
  }
  .react-app-uniforms .row-gap-lg-4 {
    row-gap: 1.5rem !important;
  }
  .react-app-uniforms .row-gap-lg-5 {
    row-gap: 3rem !important;
  }
  .react-app-uniforms .column-gap-lg-0 {
    column-gap: 0 !important;
  }
  .react-app-uniforms .column-gap-lg-1 {
    column-gap: 0.25rem !important;
  }
  .react-app-uniforms .column-gap-lg-2 {
    column-gap: 0.5rem !important;
  }
  .react-app-uniforms .column-gap-lg-3 {
    column-gap: 1rem !important;
  }
  .react-app-uniforms .column-gap-lg-4 {
    column-gap: 1.5rem !important;
  }
  .react-app-uniforms .column-gap-lg-5 {
    column-gap: 3rem !important;
  }
  .react-app-uniforms .text-lg-start {
    text-align: left !important;
  }
  .react-app-uniforms .text-lg-end {
    text-align: right !important;
  }
  .react-app-uniforms .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .react-app-uniforms .float-xl-start {
    float: left !important;
  }
  .react-app-uniforms .float-xl-end {
    float: right !important;
  }
  .react-app-uniforms .float-xl-none {
    float: none !important;
  }
  .react-app-uniforms .object-fit-xl-contain {
    object-fit: contain !important;
  }
  .react-app-uniforms .object-fit-xl-cover {
    object-fit: cover !important;
  }
  .react-app-uniforms .object-fit-xl-fill {
    object-fit: fill !important;
  }
  .react-app-uniforms .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  .react-app-uniforms .object-fit-xl-none {
    object-fit: none !important;
  }
  .react-app-uniforms .d-xl-inline {
    display: inline !important;
  }
  .react-app-uniforms .d-xl-inline-block {
    display: inline-block !important;
  }
  .react-app-uniforms .d-xl-block {
    display: block !important;
  }
  .react-app-uniforms .d-xl-grid {
    display: grid !important;
  }
  .react-app-uniforms .d-xl-inline-grid {
    display: inline-grid !important;
  }
  .react-app-uniforms .d-xl-table {
    display: table !important;
  }
  .react-app-uniforms .d-xl-table-row {
    display: table-row !important;
  }
  .react-app-uniforms .d-xl-table-cell {
    display: table-cell !important;
  }
  .react-app-uniforms .d-xl-flex {
    display: flex !important;
  }
  .react-app-uniforms .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .react-app-uniforms .d-xl-none {
    display: none !important;
  }
  .react-app-uniforms .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .react-app-uniforms .flex-xl-row {
    flex-direction: row !important;
  }
  .react-app-uniforms .flex-xl-column {
    flex-direction: column !important;
  }
  .react-app-uniforms .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .react-app-uniforms .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .react-app-uniforms .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .react-app-uniforms .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .react-app-uniforms .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .react-app-uniforms .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .react-app-uniforms .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .react-app-uniforms .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .react-app-uniforms .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .react-app-uniforms .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .react-app-uniforms .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .react-app-uniforms .justify-content-xl-center {
    justify-content: center !important;
  }
  .react-app-uniforms .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .react-app-uniforms .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .react-app-uniforms .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .react-app-uniforms .align-items-xl-start {
    align-items: flex-start !important;
  }
  .react-app-uniforms .align-items-xl-end {
    align-items: flex-end !important;
  }
  .react-app-uniforms .align-items-xl-center {
    align-items: center !important;
  }
  .react-app-uniforms .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .react-app-uniforms .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .react-app-uniforms .align-content-xl-start {
    align-content: flex-start !important;
  }
  .react-app-uniforms .align-content-xl-end {
    align-content: flex-end !important;
  }
  .react-app-uniforms .align-content-xl-center {
    align-content: center !important;
  }
  .react-app-uniforms .align-content-xl-between {
    align-content: space-between !important;
  }
  .react-app-uniforms .align-content-xl-around {
    align-content: space-around !important;
  }
  .react-app-uniforms .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .react-app-uniforms .align-self-xl-auto {
    align-self: auto !important;
  }
  .react-app-uniforms .align-self-xl-start {
    align-self: flex-start !important;
  }
  .react-app-uniforms .align-self-xl-end {
    align-self: flex-end !important;
  }
  .react-app-uniforms .align-self-xl-center {
    align-self: center !important;
  }
  .react-app-uniforms .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .react-app-uniforms .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .react-app-uniforms .order-xl-first {
    order: -1 !important;
  }
  .react-app-uniforms .order-xl-0 {
    order: 0 !important;
  }
  .react-app-uniforms .order-xl-1 {
    order: 1 !important;
  }
  .react-app-uniforms .order-xl-2 {
    order: 2 !important;
  }
  .react-app-uniforms .order-xl-3 {
    order: 3 !important;
  }
  .react-app-uniforms .order-xl-4 {
    order: 4 !important;
  }
  .react-app-uniforms .order-xl-5 {
    order: 5 !important;
  }
  .react-app-uniforms .order-xl-last {
    order: 6 !important;
  }
  .react-app-uniforms .m-xl-0 {
    margin: 0 !important;
  }
  .react-app-uniforms .m-xl-1 {
    margin: 0.25rem !important;
  }
  .react-app-uniforms .m-xl-2 {
    margin: 0.5rem !important;
  }
  .react-app-uniforms .m-xl-3 {
    margin: 1rem !important;
  }
  .react-app-uniforms .m-xl-4 {
    margin: 1.5rem !important;
  }
  .react-app-uniforms .m-xl-5 {
    margin: 3rem !important;
  }
  .react-app-uniforms .m-xl-auto {
    margin: auto !important;
  }
  .react-app-uniforms .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .react-app-uniforms .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .react-app-uniforms .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .react-app-uniforms .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .react-app-uniforms .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .react-app-uniforms .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .react-app-uniforms .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .react-app-uniforms .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .react-app-uniforms .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .react-app-uniforms .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .react-app-uniforms .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .react-app-uniforms .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .react-app-uniforms .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .react-app-uniforms .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .react-app-uniforms .mt-xl-0 {
    margin-top: 0 !important;
  }
  .react-app-uniforms .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .react-app-uniforms .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .react-app-uniforms .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .react-app-uniforms .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .react-app-uniforms .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .react-app-uniforms .mt-xl-auto {
    margin-top: auto !important;
  }
  .react-app-uniforms .me-xl-0 {
    margin-right: 0 !important;
  }
  .react-app-uniforms .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  .react-app-uniforms .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  .react-app-uniforms .me-xl-3 {
    margin-right: 1rem !important;
  }
  .react-app-uniforms .me-xl-4 {
    margin-right: 1.5rem !important;
  }
  .react-app-uniforms .me-xl-5 {
    margin-right: 3rem !important;
  }
  .react-app-uniforms .me-xl-auto {
    margin-right: auto !important;
  }
  .react-app-uniforms .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .react-app-uniforms .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .react-app-uniforms .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .react-app-uniforms .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .react-app-uniforms .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .react-app-uniforms .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .react-app-uniforms .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .react-app-uniforms .ms-xl-0 {
    margin-left: 0 !important;
  }
  .react-app-uniforms .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  .react-app-uniforms .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  .react-app-uniforms .ms-xl-3 {
    margin-left: 1rem !important;
  }
  .react-app-uniforms .ms-xl-4 {
    margin-left: 1.5rem !important;
  }
  .react-app-uniforms .ms-xl-5 {
    margin-left: 3rem !important;
  }
  .react-app-uniforms .ms-xl-auto {
    margin-left: auto !important;
  }
  .react-app-uniforms .p-xl-0 {
    padding: 0 !important;
  }
  .react-app-uniforms .p-xl-1 {
    padding: 0.25rem !important;
  }
  .react-app-uniforms .p-xl-2 {
    padding: 0.5rem !important;
  }
  .react-app-uniforms .p-xl-3 {
    padding: 1rem !important;
  }
  .react-app-uniforms .p-xl-4 {
    padding: 1.5rem !important;
  }
  .react-app-uniforms .p-xl-5 {
    padding: 3rem !important;
  }
  .react-app-uniforms .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .react-app-uniforms .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .react-app-uniforms .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .react-app-uniforms .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .react-app-uniforms .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .react-app-uniforms .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .react-app-uniforms .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .react-app-uniforms .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .react-app-uniforms .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .react-app-uniforms .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .react-app-uniforms .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .react-app-uniforms .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .react-app-uniforms .pt-xl-0 {
    padding-top: 0 !important;
  }
  .react-app-uniforms .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .react-app-uniforms .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .react-app-uniforms .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .react-app-uniforms .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .react-app-uniforms .pt-xl-5 {
    padding-top: 3rem !important;
  }
  .react-app-uniforms .pe-xl-0 {
    padding-right: 0 !important;
  }
  .react-app-uniforms .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  .react-app-uniforms .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  .react-app-uniforms .pe-xl-3 {
    padding-right: 1rem !important;
  }
  .react-app-uniforms .pe-xl-4 {
    padding-right: 1.5rem !important;
  }
  .react-app-uniforms .pe-xl-5 {
    padding-right: 3rem !important;
  }
  .react-app-uniforms .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .react-app-uniforms .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .react-app-uniforms .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .react-app-uniforms .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .react-app-uniforms .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .react-app-uniforms .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  .react-app-uniforms .ps-xl-0 {
    padding-left: 0 !important;
  }
  .react-app-uniforms .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  .react-app-uniforms .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  .react-app-uniforms .ps-xl-3 {
    padding-left: 1rem !important;
  }
  .react-app-uniforms .ps-xl-4 {
    padding-left: 1.5rem !important;
  }
  .react-app-uniforms .ps-xl-5 {
    padding-left: 3rem !important;
  }
  .react-app-uniforms .gap-xl-0 {
    gap: 0 !important;
  }
  .react-app-uniforms .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .react-app-uniforms .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .react-app-uniforms .gap-xl-3 {
    gap: 1rem !important;
  }
  .react-app-uniforms .gap-xl-4 {
    gap: 1.5rem !important;
  }
  .react-app-uniforms .gap-xl-5 {
    gap: 3rem !important;
  }
  .react-app-uniforms .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  .react-app-uniforms .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }
  .react-app-uniforms .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }
  .react-app-uniforms .row-gap-xl-3 {
    row-gap: 1rem !important;
  }
  .react-app-uniforms .row-gap-xl-4 {
    row-gap: 1.5rem !important;
  }
  .react-app-uniforms .row-gap-xl-5 {
    row-gap: 3rem !important;
  }
  .react-app-uniforms .column-gap-xl-0 {
    column-gap: 0 !important;
  }
  .react-app-uniforms .column-gap-xl-1 {
    column-gap: 0.25rem !important;
  }
  .react-app-uniforms .column-gap-xl-2 {
    column-gap: 0.5rem !important;
  }
  .react-app-uniforms .column-gap-xl-3 {
    column-gap: 1rem !important;
  }
  .react-app-uniforms .column-gap-xl-4 {
    column-gap: 1.5rem !important;
  }
  .react-app-uniforms .column-gap-xl-5 {
    column-gap: 3rem !important;
  }
  .react-app-uniforms .text-xl-start {
    text-align: left !important;
  }
  .react-app-uniforms .text-xl-end {
    text-align: right !important;
  }
  .react-app-uniforms .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  .react-app-uniforms .float-xxl-start {
    float: left !important;
  }
  .react-app-uniforms .float-xxl-end {
    float: right !important;
  }
  .react-app-uniforms .float-xxl-none {
    float: none !important;
  }
  .react-app-uniforms .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  .react-app-uniforms .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  .react-app-uniforms .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  .react-app-uniforms .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  .react-app-uniforms .object-fit-xxl-none {
    object-fit: none !important;
  }
  .react-app-uniforms .d-xxl-inline {
    display: inline !important;
  }
  .react-app-uniforms .d-xxl-inline-block {
    display: inline-block !important;
  }
  .react-app-uniforms .d-xxl-block {
    display: block !important;
  }
  .react-app-uniforms .d-xxl-grid {
    display: grid !important;
  }
  .react-app-uniforms .d-xxl-inline-grid {
    display: inline-grid !important;
  }
  .react-app-uniforms .d-xxl-table {
    display: table !important;
  }
  .react-app-uniforms .d-xxl-table-row {
    display: table-row !important;
  }
  .react-app-uniforms .d-xxl-table-cell {
    display: table-cell !important;
  }
  .react-app-uniforms .d-xxl-flex {
    display: flex !important;
  }
  .react-app-uniforms .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .react-app-uniforms .d-xxl-none {
    display: none !important;
  }
  .react-app-uniforms .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .react-app-uniforms .flex-xxl-row {
    flex-direction: row !important;
  }
  .react-app-uniforms .flex-xxl-column {
    flex-direction: column !important;
  }
  .react-app-uniforms .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .react-app-uniforms .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .react-app-uniforms .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .react-app-uniforms .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .react-app-uniforms .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .react-app-uniforms .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .react-app-uniforms .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .react-app-uniforms .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .react-app-uniforms .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .react-app-uniforms .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .react-app-uniforms .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .react-app-uniforms .justify-content-xxl-center {
    justify-content: center !important;
  }
  .react-app-uniforms .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .react-app-uniforms .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .react-app-uniforms .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .react-app-uniforms .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .react-app-uniforms .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .react-app-uniforms .align-items-xxl-center {
    align-items: center !important;
  }
  .react-app-uniforms .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .react-app-uniforms .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .react-app-uniforms .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .react-app-uniforms .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .react-app-uniforms .align-content-xxl-center {
    align-content: center !important;
  }
  .react-app-uniforms .align-content-xxl-between {
    align-content: space-between !important;
  }
  .react-app-uniforms .align-content-xxl-around {
    align-content: space-around !important;
  }
  .react-app-uniforms .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .react-app-uniforms .align-self-xxl-auto {
    align-self: auto !important;
  }
  .react-app-uniforms .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .react-app-uniforms .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .react-app-uniforms .align-self-xxl-center {
    align-self: center !important;
  }
  .react-app-uniforms .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .react-app-uniforms .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .react-app-uniforms .order-xxl-first {
    order: -1 !important;
  }
  .react-app-uniforms .order-xxl-0 {
    order: 0 !important;
  }
  .react-app-uniforms .order-xxl-1 {
    order: 1 !important;
  }
  .react-app-uniforms .order-xxl-2 {
    order: 2 !important;
  }
  .react-app-uniforms .order-xxl-3 {
    order: 3 !important;
  }
  .react-app-uniforms .order-xxl-4 {
    order: 4 !important;
  }
  .react-app-uniforms .order-xxl-5 {
    order: 5 !important;
  }
  .react-app-uniforms .order-xxl-last {
    order: 6 !important;
  }
  .react-app-uniforms .m-xxl-0 {
    margin: 0 !important;
  }
  .react-app-uniforms .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .react-app-uniforms .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .react-app-uniforms .m-xxl-3 {
    margin: 1rem !important;
  }
  .react-app-uniforms .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .react-app-uniforms .m-xxl-5 {
    margin: 3rem !important;
  }
  .react-app-uniforms .m-xxl-auto {
    margin: auto !important;
  }
  .react-app-uniforms .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .react-app-uniforms .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .react-app-uniforms .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .react-app-uniforms .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .react-app-uniforms .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .react-app-uniforms .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .react-app-uniforms .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .react-app-uniforms .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .react-app-uniforms .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .react-app-uniforms .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .react-app-uniforms .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .react-app-uniforms .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .react-app-uniforms .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .react-app-uniforms .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .react-app-uniforms .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .react-app-uniforms .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .react-app-uniforms .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .react-app-uniforms .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .react-app-uniforms .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .react-app-uniforms .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .react-app-uniforms .mt-xxl-auto {
    margin-top: auto !important;
  }
  .react-app-uniforms .me-xxl-0 {
    margin-right: 0 !important;
  }
  .react-app-uniforms .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  .react-app-uniforms .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  .react-app-uniforms .me-xxl-3 {
    margin-right: 1rem !important;
  }
  .react-app-uniforms .me-xxl-4 {
    margin-right: 1.5rem !important;
  }
  .react-app-uniforms .me-xxl-5 {
    margin-right: 3rem !important;
  }
  .react-app-uniforms .me-xxl-auto {
    margin-right: auto !important;
  }
  .react-app-uniforms .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .react-app-uniforms .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .react-app-uniforms .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .react-app-uniforms .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .react-app-uniforms .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .react-app-uniforms .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .react-app-uniforms .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .react-app-uniforms .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .react-app-uniforms .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  .react-app-uniforms .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  .react-app-uniforms .ms-xxl-3 {
    margin-left: 1rem !important;
  }
  .react-app-uniforms .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }
  .react-app-uniforms .ms-xxl-5 {
    margin-left: 3rem !important;
  }
  .react-app-uniforms .ms-xxl-auto {
    margin-left: auto !important;
  }
  .react-app-uniforms .p-xxl-0 {
    padding: 0 !important;
  }
  .react-app-uniforms .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .react-app-uniforms .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .react-app-uniforms .p-xxl-3 {
    padding: 1rem !important;
  }
  .react-app-uniforms .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .react-app-uniforms .p-xxl-5 {
    padding: 3rem !important;
  }
  .react-app-uniforms .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .react-app-uniforms .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .react-app-uniforms .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .react-app-uniforms .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .react-app-uniforms .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .react-app-uniforms .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .react-app-uniforms .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .react-app-uniforms .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .react-app-uniforms .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .react-app-uniforms .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .react-app-uniforms .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .react-app-uniforms .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .react-app-uniforms .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .react-app-uniforms .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .react-app-uniforms .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .react-app-uniforms .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .react-app-uniforms .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .react-app-uniforms .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  .react-app-uniforms .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .react-app-uniforms .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  .react-app-uniforms .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  .react-app-uniforms .pe-xxl-3 {
    padding-right: 1rem !important;
  }
  .react-app-uniforms .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }
  .react-app-uniforms .pe-xxl-5 {
    padding-right: 3rem !important;
  }
  .react-app-uniforms .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .react-app-uniforms .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .react-app-uniforms .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .react-app-uniforms .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .react-app-uniforms .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .react-app-uniforms .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  .react-app-uniforms .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .react-app-uniforms .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  .react-app-uniforms .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  .react-app-uniforms .ps-xxl-3 {
    padding-left: 1rem !important;
  }
  .react-app-uniforms .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }
  .react-app-uniforms .ps-xxl-5 {
    padding-left: 3rem !important;
  }
  .react-app-uniforms .gap-xxl-0 {
    gap: 0 !important;
  }
  .react-app-uniforms .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .react-app-uniforms .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .react-app-uniforms .gap-xxl-3 {
    gap: 1rem !important;
  }
  .react-app-uniforms .gap-xxl-4 {
    gap: 1.5rem !important;
  }
  .react-app-uniforms .gap-xxl-5 {
    gap: 3rem !important;
  }
  .react-app-uniforms .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  .react-app-uniforms .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }
  .react-app-uniforms .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }
  .react-app-uniforms .row-gap-xxl-3 {
    row-gap: 1rem !important;
  }
  .react-app-uniforms .row-gap-xxl-4 {
    row-gap: 1.5rem !important;
  }
  .react-app-uniforms .row-gap-xxl-5 {
    row-gap: 3rem !important;
  }
  .react-app-uniforms .column-gap-xxl-0 {
    column-gap: 0 !important;
  }
  .react-app-uniforms .column-gap-xxl-1 {
    column-gap: 0.25rem !important;
  }
  .react-app-uniforms .column-gap-xxl-2 {
    column-gap: 0.5rem !important;
  }
  .react-app-uniforms .column-gap-xxl-3 {
    column-gap: 1rem !important;
  }
  .react-app-uniforms .column-gap-xxl-4 {
    column-gap: 1.5rem !important;
  }
  .react-app-uniforms .column-gap-xxl-5 {
    column-gap: 3rem !important;
  }
  .react-app-uniforms .text-xxl-start {
    text-align: left !important;
  }
  .react-app-uniforms .text-xxl-end {
    text-align: right !important;
  }
  .react-app-uniforms .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .react-app-uniforms .fs-1 {
    font-size: 2.5rem !important;
  }
  .react-app-uniforms .fs-2 {
    font-size: 2rem !important;
  }
  .react-app-uniforms .fs-3 {
    font-size: 1.75rem !important;
  }
  .react-app-uniforms .fs-4 {
    font-size: 1.5rem !important;
  }
}
@media print {
  .react-app-uniforms .d-print-inline {
    display: inline !important;
  }
  .react-app-uniforms .d-print-inline-block {
    display: inline-block !important;
  }
  .react-app-uniforms .d-print-block {
    display: block !important;
  }
  .react-app-uniforms .d-print-grid {
    display: grid !important;
  }
  .react-app-uniforms .d-print-inline-grid {
    display: inline-grid !important;
  }
  .react-app-uniforms .d-print-table {
    display: table !important;
  }
  .react-app-uniforms .d-print-table-row {
    display: table-row !important;
  }
  .react-app-uniforms .d-print-table-cell {
    display: table-cell !important;
  }
  .react-app-uniforms .d-print-flex {
    display: flex !important;
  }
  .react-app-uniforms .d-print-inline-flex {
    display: inline-flex !important;
  }
  .react-app-uniforms .d-print-none {
    display: none !important;
  }
}
.react-app-uniforms * {
  font-family: "Titillium Web", sans-serif;
}
.react-app-uniforms *::selection {
  background: #0C93A9;
  color: #ffffff;
}
.react-app-uniforms .btn {
  font-weight: 500;
  font-size: 16px;
  padding-left: 40px;
  padding-right: 40px;
  border-radius: 0;
}
.react-app-uniforms .btn-primary,
.react-app-uniforms .btn-primary:hover,
.react-app-uniforms .btn-primary:active,
.react-app-uniforms .btn-primary:focus {
  color: #fff !important;
}
.react-app-uniforms .btn-secondary,
.react-app-uniforms .btn-secondary:hover,
.react-app-uniforms .btn-secondary:active,
.react-app-uniforms .btn-secondary:focus,
.react-app-uniforms .btn-outline-primary:hover,
.react-app-uniforms .btn-outline-primary:active,
.react-app-uniforms .btn-outline-primary:focus {
  color: #0C93A9 !important;
}
.react-app-uniforms .btn-outline-primary,
.react-app-uniforms btn-outline-primary:hover,
.react-app-uniforms .btn-outline-primary:active {
  background: #FFF !important;
  border: 1px solid #0C93A9;
}
.react-app-uniforms .btn-primary.btn:disabled {
  border-color: #d7d7d7 !important;
  background-color: #d7d7d7 !important;
}
.react-app-uniforms .btn:hover {
  box-shadow: none;
}
.react-app-uniforms .bg-grey {
  background-color: #6B7888;
}
.react-app-uniforms .icon-button {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  color: #FFF;
  background-color: rgba(255, 255, 255, 0.4);
  border-width: 0;
  font-size: 1.1rem;
  justify-content: center;
  align-items: center;
}
.react-app-uniforms .bg-white {
  background-color: #FFF !important;
  border-color: #FFF !important;
}
.react-app-uniforms .text-primary {
  color: #0C93A9 !important;
}
.react-app-uniforms .bg-red {
  background-color: #DB504A;
}
.react-app-uniforms .text-red {
  color: #DB504A;
}
.react-app-uniforms .text-black {
  color: #000000;
}
.react-app-uniforms .btn-icon-secondary {
  background-color: #EEF4F5;
  color: #0C93A9;
  border: none;
  border-radius: 50%;
  width: 50px;
  height: 50px;
}
.react-app-uniforms h1, .react-app-uniforms .h1 {
  color: #000000;
  font-weight: 700;
  font-size: 26px;
  margin-top: 50px;
  margin-bottom: 20px;
}
.react-app-uniforms h2, .react-app-uniforms .h2 {
  font-weight: 700;
  font-size: 20px;
  margin: 16px 0;
  color: #000000;
}
.react-app-uniforms body {
  color: #6B7888;
  font-size: 16px;
  background: #FFF;
  min-height: 100vh;
}
.react-app-uniforms .form-check-label,
.react-app-uniforms .form-label,
.react-app-uniforms .label,
.react-app-uniforms label,
.react-app-uniforms .form-control,
.react-app-uniforms .css-qbdosj-Input,
.react-app-uniforms .label-select {
  font-size: 16px;
  font-weight: 400;
  color: #6B7888 !important;
  line-height: 24px;
}
.react-app-uniforms .text-white {
  color: #FFF !important;
}
.react-app-uniforms a {
  font-weight: 800;
}
.react-app-uniforms a:hover {
  color: #0C93A9;
}
.react-app-uniforms .link-to-confirm {
  font-weight: 800;
  padding-left: 60px;
  color: #0C93A9;
  text-decoration: underline;
  cursor: pointer;
}
.react-app-uniforms .text-right {
  text-align: right;
}
.react-app-uniforms .text-regular {
  color: #6B7888;
  font-size: 14px;
  font-weight: 400;
}
.react-app-uniforms .text-muted {
  font-size: 12px;
  color: #6B7888 !important;
  line-height: 20px;
  font-style: italic;
}
.react-app-uniforms .fs-20 {
  font-size: 20px;
}
.react-app-uniforms .fs-14 {
  font-size: 14px;
}
.react-app-uniforms .switch .note {
  font-style: italic;
  font-size: 12px;
}
.react-app-uniforms .switch .note:first-child {
  margin-left: 65px;
}
.react-app-uniforms .switch .form-check-input {
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  appearance: none;
  background-color: #FFF;
  background-repeat: no-repeat;
  background-size: contain;
  border: 1px solid #dee2e6;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
  width: 2em;
  margin-left: -2.5em;
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}
.react-app-uniforms .switch .form-check-input:checked {
  background-color: #0C93A9;
  border-color: #0C93A9;
}
.react-app-uniforms .radio-button input {
  cursor: pointer;
  margin-top: 7px;
}
.react-app-uniforms .radio-button .note {
  font-style: italic;
  font-size: 12px;
  margin-left: 26px;
}
.react-app-uniforms .form-control {
  border-radius: 0;
  background: #FFF;
  border: 1px solid #dee2e6;
}
.react-app-uniforms input::placeholder {
  color: #C8C8C8 !important;
}
.react-app-uniforms .css-hzoui-control:hover {
  border-color: #0C93A9 !important;
}
.react-app-uniforms .radio-button .form-check-input {
  background-color: #FFF;
  border: 1px solid #dee2e6;
}
.react-app-uniforms .radio-button .form-check-input:checked {
  background-color: #2f4A75;
  border-color: #2f4A75;
}
.react-app-uniforms .form-upload {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  appearance: none;
  background-clip: padding-box;
  border: 1px solid #dee2e6;
  border-radius: 0;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  background-color: #FFF;
}
.react-app-uniforms .form-upload::-webkit-file-upload-button {
  background-color: #f8f9fa;
  border-right-width: 1px;
}
.react-app-uniforms .form-upload:hover::-webkit-file-upload-button {
  background-color: #dee2e6 !important;
}
.react-app-uniforms .modal-header {
  background-color: #0C93A9;
  padding-left: 20px;
}
.react-app-uniforms .modal-header h2, .react-app-uniforms .modal-header .h2 {
  color: #FFF !important;
}
.react-app-uniforms .modal-container {
  background-color: #FFF;
}
.react-app-uniforms .pointer-status {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
.react-app-uniforms .react-datepicker__day--selected,
.react-app-uniforms .react-datepicker__day--in-selecting-range,
.react-app-uniforms .react-datepicker__day--in-range,
.react-app-uniforms .react-datepicker__month-text--selected,
.react-app-uniforms .react-datepicker__month-text--in-selecting-range,
.react-app-uniforms .react-datepicker__month-text--in-range,
.react-app-uniforms .react-datepicker__quarter-text--selected,
.react-app-uniforms .react-datepicker__quarter-text--in-selecting-range,
.react-app-uniforms .react-datepicker__quarter-text--in-range,
.react-app-uniforms .react-datepicker__year-text--selected,
.react-app-uniforms .react-datepicker__year-text--in-selecting-range,
.react-app-uniforms .react-datepicker__year-text--in-range {
  background-color: #0C93A9 !important;
}
.react-app-uniforms .react-datepicker__day--keyboard-selected,
.react-app-uniforms .react-datepicker__month-text--keyboard-selected,
.react-app-uniforms .react-datepicker__quarter-text--keyboard-selected,
.react-app-uniforms .react-datepicker__year-text--keyboard-selected {
  background-color: #EEF4F5 !important;
  color: #0C93A9 !important;
}
.react-app-uniforms .react-datepicker-popper,
.react-app-uniforms #react-select-3-listbox {
  z-index: 200 !important;
}
.react-app-uniforms .css-b62m3t-container:first-child {
  position: relative;
}
.react-app-uniforms .tab-container {
  margin-bottom: 100px;
}
.react-app-uniforms .tab-container .tab-container-detail {
  background-color: #F5F5F5;
}
.react-app-uniforms .tab-container .nav-link {
  color: #d7d7d7;
  font-weight: 600;
  font-size: 17px;
  display: flex;
  flex-direction: row;
  gap: 15px;
  align-items: center;
}
.react-app-uniforms .tab-container .nav-link .index-counter {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid #d7d7d7;
  color: #d7d7d7;
  transition: 0.2s;
  display: flex;
  justify-content: center;
  align-items: center;
}
.react-app-uniforms .tab-container .nav-link .step-description {
  font-size: 10px;
}
.react-app-uniforms .tab-container .nav-link .bar {
  height: 25px;
  width: 3px;
  margin-left: 18.5px;
  background-color: #d7d7d7;
}
.react-app-uniforms .tab-container .nav-link.active {
  color: #0C93A9 !important;
  background-color: transparent !important;
}
.react-app-uniforms .tab-container .nav-link.active:hover {
  color: #FFFFFF;
}
.react-app-uniforms .tab-container .nav-link.active .index-counter {
  border: 2px solid #0C93A9;
  background-color: #0C93A9;
  color: #FFF;
}
.react-app-uniforms .tab-container .nav-link.active .bar {
  background-color: #0C93A9;
}
.react-app-uniforms .tab-container .nav-link:hover {
  color: #d7d7d7;
}
.react-app-uniforms .tab-container .nav-link.disabled {
  color: #d7d7d7;
}
.react-app-uniforms .tab-container .nav-link.isValid .index-counter {
  border: 2px solid #21BC6C;
  background-color: #21BC6C;
  color: #FFF;
}
.react-app-uniforms .tab-container .nav-link.isValid .bar {
  background-color: #21BC6C;
}
@media (max-width: 992px) {
  .react-app-uniforms .container-nav-item {
    display: flex;
    flex-direction: row !important;
    align-items: center;
    justify-content: space-between;
  }
  .react-app-uniforms .container-nav-item .nav-item {
    display: none;
  }
  .react-app-uniforms .container-nav-item .nav-item .bar {
    display: none;
  }
  .react-app-uniforms .container-nav-item .nav-item.is_active {
    display: block !important;
  }
  .react-app-uniforms .container-nav-item .nav-item.prev_next_active_key {
    display: block;
  }
  .react-app-uniforms .container-nav-item .nav-item.prev_next_active_key .step-description {
    display: none;
  }
  .react-app-uniforms .container-nav-item .nav-item.prev_next_active_key .step-title {
    display: none;
  }
  .react-app-uniforms .container-nav-item .nav-item.prev_next_active_key .gap-3 {
    gap: 0 !important;
  }
}
.react-app-uniforms .switch .form-check-input,
.react-app-uniforms .switch .form-check-label {
  cursor: pointer;
}
.react-app-uniforms .switch .form-check-input {
  transform: scale(1.35);
  transform-origin: top left;
}
.react-app-uniforms .switch .form-check-label {
  margin-left: 25px;
}
.react-app-uniforms .fc .fc-highlight {
  background: #0C93A9;
}
.react-app-uniforms .fc-day.disabled-cell {
  pointer-events: none;
  background-color: red;
  color: #bbb;
}
.react-app-uniforms .fc:hover {
  cursor: pointer;
}
.react-app-uniforms .wrapper {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-auto-rows: minmax(auto, auto);
}
.react-app-uniforms .cursor-pointer {
  cursor: pointer;
}
.react-app-uniforms .fc .fc-bg-event {
  background-color: #DB504A;
  pointer-events: none;
}
@media (max-width: 767px) {
  .react-app-uniforms {
    /* Stili da applicare per dispositivi con larghezza massima di 767px */
  }
  .react-app-uniforms .wrapper {
    grid-template-columns: repeat(1, 1fr);
  }
}
.react-app-uniforms .dropdown-container {
  box-shadow: 5px 5px 13px 5px rgba(0, 0, 0, 0.2);
  background-color: #FFF;
}
.react-app-uniforms .dropdown-container .dropdown-item:hover {
  background-color: rgba(0, 0, 0, 0.075);
}
.react-app-uniforms .table {
  border: 0;
}
.react-app-uniforms .table th {
  font-size: 10px;
  font-weight: 700;
}
.react-app-uniforms .table tr {
  border-boottom: 1px solid #dee2e6 !important;
}
.react-app-uniforms .table tr td {
  font-size: 14px;
  background-color: rgba(255, 202, 58, 0.05);
}
.react-app-uniforms .table tr td:last-child {
  border-right: 2px solid rgb(255, 202, 58);
}
.react-app-uniforms .table tr td:nth-child(2) {
  font-weight: 600;
}
.react-app-uniforms .table tr:hover {
  cursor: pointer;
}
.react-app-uniforms .table tr.sent td {
  background-color: rgba(185, 213, 133, 0.05);
}
.react-app-uniforms .table tr.sent td:last-child {
  border-right: 2px solid rgb(185, 213, 133);
}
.react-app-uniforms .table > :not(caption) > * > * {
  border-bottom-width: 1px;
  border-bottom-color: #dee2e6;
}
.react-app-uniforms .toast-container {
  position: fixed;
  box-shadow: 0px 0px 19px 0px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  overflow: hidden;
  z-index: 10000;
}
.react-app-uniforms .toast-container .toast {
  background-color: #FFF;
  border: none;
  padding: 10px;
}
.react-app-uniforms .toast-container .toast .toast-header {
  background-color: transparent;
}
.react-app-uniforms .toast-container .toast .pointer {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 10px;
}
.react-app-uniforms .toast-container .toast .pointer.danger {
  background-color: #dc3545;
}
.react-app-uniforms .toast-container .toast .pointer.success {
  background-color: #198754;
}
.react-app-uniforms .container-loading {
  position: fixed;
  top: 0;
  left: 0;
  align-items: center;
  justify-content: center;
  display: flex;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  z-index: 9999;
  padding-top: 100px;
}
.react-app-uniforms .container-loading .spinner {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: 9px solid;
  border-color: #EEF4F5;
  border-right-color: #0C93A9;
  animation: spinner-d3wgkg 1s infinite linear;
}
.react-app-uniforms .fixed {
  position: fixed;
  top: 0;
  left: 0;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.5);
}
@keyframes spinner-d3wgkg {
  to {
    transform: rotate(1turn);
  }
}
.react-app-uniforms hr {
  border: solid #CCC 0.5px;
}
.react-app-uniforms .show > .btn-info.dropdown-toggle:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.react-app-uniforms .z-index-100 {
  z-index: 101;
}
.react-app-uniforms .pdf-viewer-container {
  height: 50vh;
}
.react-app-uniforms .modal-container .form-control {
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.02) inset;
  border: 1px solid #dee2e6;
}
.react-app-uniforms .form-control:disabled {
  min-height: 42.5px;
}
.react-app-uniforms .accordion-button {
  font-weight: 600;
}
.react-app-uniforms .accordion-item {
  border: none !important;
  box-shadow: 0px 0px 9px 1px rgba(0, 0, 0, 0.1);
}
.react-app-uniforms .accordion-item .accordion-button {
  border-radius: 20px !important;
}
.react-app-uniforms .accordion-button:not(.collapsed) {
  box-shadow: none !important;
}
.react-app-uniforms .accordion-body {
  padding-top: 0;
}
.react-app-uniforms .accordion-body hr {
  margin-top: 0;
}
.react-app-uniforms .box-shadow-9 {
  box-shadow: 0px 0px 9px 1px rgba(0, 0, 0, 0.1);
}
.react-app-uniforms .br-20 {
  border-radius: 20px !important;
}
.react-app-uniforms .br-10 {
  border-radius: 10px !important;
}
.react-app-uniforms .css-13cymwt-control {
  border-radius: 10px;
}
.react-app-uniforms .skeleton {
  background: #eee;
  background: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);
  border-radius: 5px;
  background-size: 200% 100%;
  animation: 1.5s shine linear infinite;
}
@keyframes shine {
  to {
    background-position-x: -200%;
  }
}`, "",{"version":3,"sources":["webpack://./js/src/App.scss","webpack://./js/src/assets/style/custom.scss","webpack://./node_modules/bootstrap/scss/mixins/_banner.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./js/src/assets/style/style.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/mixins/_color-mode.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/_containers.scss","webpack://./node_modules/bootstrap/scss/mixins/_container.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./node_modules/bootstrap/scss/forms/_labels.scss","webpack://./node_modules/bootstrap/scss/forms/_form-text.scss","webpack://./node_modules/bootstrap/scss/forms/_form-control.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/forms/_form-select.scss","webpack://./node_modules/bootstrap/scss/forms/_form-check.scss","webpack://./node_modules/bootstrap/scss/forms/_form-range.scss","webpack://./node_modules/bootstrap/scss/forms/_floating-labels.scss","webpack://./node_modules/bootstrap/scss/forms/_input-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_accordion.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/mixins/_backdrop.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/_offcanvas.scss","webpack://./node_modules/bootstrap/scss/_placeholders.scss","webpack://./node_modules/bootstrap/scss/helpers/_color-bg.scss","webpack://./node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./node_modules/bootstrap/scss/helpers/_focus-ring.scss","webpack://./node_modules/bootstrap/scss/helpers/_icon-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./node_modules/bootstrap/scss/helpers/_position.scss","webpack://./node_modules/bootstrap/scss/helpers/_stacks.scss","webpack://./node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/helpers/_vr.scss","webpack://./node_modules/bootstrap/scss/utilities/_api.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;ECAA,yDAAA;ECCE;;;;IAAA;EC8hBF;;;;;;;GAAA;ECxeA,qBAAA;EAaA,mBAAA;EAYA,qBAAA;EAaA,mBAAA;EChBA,qBAAA;EAwBA,mBAAA;EAmCA,qBAAA;EAwBA,mBAAA;EC1BA;;;;;;;KAAA;EClFQ,qBAAA;EAwCA,mBAAA;ECqYR,kEAAA;EAiLA;;;;GAAA;EA4BA,cAAA;ARnoBA;ACpCA;EACE,WAAA;ADsCF;ACnCA;EACE,cAVQ;AD+CV;ASjDA;;EASI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,eAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAIA,8BAAA;EAAA,iCAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,6BAAA;EAAA,yBAAA;EAIA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,+BAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,0BAAA;EAAA,+BAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAIA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,8BAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,6BAAA;EACA,uBAAA;EAMA,qNAAA;EACA,yGAAA;EACA,yFAAA;EAOA,gDAAA;EC2OI,yBALI;EDpOR,0BAAA;EACA,0BAAA;EAKA,wBAAA;EACA,+BAAA;EACA,kBAAA;EACA,+BAAA;EAEA,yBAAA;EACA,gCAAA;EAEA,4CAAA;EACA,oCAAA;EACA,0BAAA;EACA,oCAAA;EAEA,0CAAA;EACA,mCAAA;EACA,yBAAA;EACA,mCAAA;EAGA,2BAAA;EAEA,wBAAA;EACA,iCAAA;EACA,+BAAA;EAEA,8BAAA;EACA,uCAAA;EAMA,wBAAA;EACA,6BAAA;EACA,0BAAA;EAGA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,mDAAA;EAEA,4BAAA;EACA,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mDAAA;EACA,8BAAA;EAGA,kDAAA;EACA,2DAAA;EACA,oDAAA;EACA,2DAAA;EAIA,8BAAA;EACA,6BAAA;EACA,+CAAA;EAIA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;AT0CF;AW1JI;EFsHA,kBAAA;EAGA,wBAAA;EACA,kCAAA;EACA,qBAAA;EACA,4BAAA;EAEA,yBAAA;EACA,sCAAA;EAEA,+CAAA;EACA,uCAAA;EACA,0BAAA;EACA,iCAAA;EAEA,6CAAA;EACA,sCAAA;EACA,yBAAA;EACA,gCAAA;EAGE,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,8BAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,+BAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,4BAAA;EAAA,+BAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAIA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,2BAAA;EAEA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,wCAAA;EAEA,wBAAA;EACA,6BAAA;EACA,0BAAA;EAEA,0BAAA;EACA,wDAAA;EAEA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;ATyCJ;AGjNA;;;EAGE,sBAAA;AHmNF;AGpMI;EANJ;IAOM,uBAAA;EHuMJ;AACF;AG1LA;EACE,SAAA;EACA,uCAAA;EO6OI,mCALI;EPtOR,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,qCAAA;EACA,mCAAA;EACA,8BAAA;EACA,6CAAA;AH4LF;AGnLA;EACE,cAAA;EACA,cSmnB4B;ETlnB5B,SAAA;EACA,wCAAA;EACA,aSynB4B;AZpc9B;AG3KA;EACE,aAAA;EACA,qBSwjB4B;ETrjB5B,gBSwjB4B;ETvjB5B,gBSwjB4B;ETvjB5B,8BAAA;AH2KF;AGxKA;EOuMQ,iCAAA;AV5BR;AUhII;EP3CJ;IO8MQ,iBAAA;EV/BN;AACF;AG3KA;EOkMQ,iCAAA;AVpBR;AUxII;EPtCJ;IOyMQ,eAAA;EVvBN;AACF;AG9KA;EO6LQ,+BAAA;AVZR;AUhJI;EPjCJ;IOoMQ,kBAAA;EVfN;AACF;AGjLA;EOwLQ,iCAAA;AVJR;AUxJI;EP5BJ;IO+LQ,iBAAA;EVPN;AACF;AGpLA;EO+KM,kBALI;AVaV;AGlLA;EO0KM,eALI;AVgBV;AG1KA;EACE,aAAA;EACA,mBSwV0B;AZ5K5B;AGlKA;EACE,iCAAA;EACA,YAAA;EACA,8BAAA;AHoKF;AG9JA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AHgKF;AG1JA;;EAEE,kBAAA;AH4JF;AGzJA;;;EAGE,aAAA;EACA,mBAAA;AH2JF;AGxJA;;;;EAIE,gBAAA;AH0JF;AGvJA;EACE,gBS6b4B;AZpS9B;AGpJA;EACE,qBAAA;EACA,cAAA;AHsJF;AGhJA;EACE,gBAAA;AHkJF;AG1IA;;EAEE,mBSsa4B;AZ1R9B;AGpIA;EO6EM,kBALI;AV+DV;AGhIA;EACE,iBSqf4B;ETpf5B,gCAAA;EACA,wCAAA;AHkIF;AGzHA;;EAEE,kBAAA;EOwDI,iBALI;EPjDR,cAAA;EACA,wBAAA;AH2HF;AGxHA;EAAM,eAAA;AH2HN;AG1HA;EAAM,WAAA;AH6HN;AGxHA;EACE,gEAAA;EACA,0BSgNwC;AZtF1C;AGxHE;EACE,mDAAA;AH0HJ;AG/GE;EAEE,cAAA;EACA,qBAAA;AHgHJ;AGzGA;;;;EAIE,qCSgV4B;EFlUxB,cALI;AVmGV;AGpGA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EOEI,kBALI;AV0GV;AGlGE;EOHI,kBALI;EPUN,cAAA;EACA,kBAAA;AHoGJ;AGhGA;EOVM,kBALI;EPiBR,2BAAA;EACA,qBAAA;AHkGF;AG/FE;EACE,cAAA;AHiGJ;AG7FA;EACE,2BAAA;EOtBI,kBALI;EP6BR,wBSu5CkC;ETt5ClC,sCSu5CkC;EC5rDhC,sBAAA;AbqYJ;AG7FE;EACE,UAAA;EO7BE,cALI;AVkIV;AGrFA;EACE,gBAAA;AHuFF;AGjFA;;EAEE,sBAAA;AHmFF;AG3EA;EACE,oBAAA;EACA,yBAAA;AH6EF;AG1EA;EACE,mBS4X4B;ET3X5B,sBS2X4B;ET1X5B,gCS4Z4B;ET3Z5B,gBAAA;AH4EF;AGrEA;EAEE,mBAAA;EACA,gCAAA;AHsEF;AGnEA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;AHqEF;AG7DA;EACE,qBAAA;AH+DF;AGzDA;EAEE,gBAAA;AH0DF;AGlDA;EACE,UAAA;AHoDF;AG/CA;;;;;EAKE,SAAA;EACA,oBAAA;EO5HI,kBALI;EPmIR,oBAAA;AHiDF;AG7CA;;EAEE,oBAAA;AH+CF;AG1CA;EACE,eAAA;AH4CF;AGzCA;EAGE,iBAAA;AHyCF;AGtCE;EACE,UAAA;AHwCJ;AGjCA;EACE,wBAAA;AHmCF;AG3BA;;;;EAIE,0BAAA;AH6BF;AG1BI;;;;EACE,eAAA;AH+BN;AGxBA;EACE,UAAA;EACA,kBAAA;AH0BF;AGrBA;EACE,gBAAA;AHuBF;AGbA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;AHeF;AGPA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBSmN4B;EFpatB,iCAAA;EPoNN,oBAAA;AHQF;AUxXI;EPyWJ;IOtMQ,iBAAA;EVyNN;AACF;AGXE;EACE,WAAA;AHaJ;AGNA;;;;;;;EAOE,UAAA;AHQF;AGLA;EACE,YAAA;AHOF;AGEA;EACE,6BAAA;EACA,oBAAA;AHAF;AGmBA;EACE,wBAAA;AHjBF;AGsBA;EACE,UAAA;AHpBF;AG2BA;EACE,aAAA;EACA,0BAAA;AHzBF;AG8BA;EACE,qBAAA;AH5BF;AGiCA;EACE,SAAA;AH/BF;AGsCA;EACE,kBAAA;EACA,eAAA;AHpCF;AG4CA;EACE,wBAAA;AH1CF;AGkDA;EACE,wBAAA;AHhDF;AcrhBA;EJmQM,kBALI;EI5PR,gBFwoB4B;AZjH9B;AclhBE;EJgQM,iCAAA;EI5PJ,gBFynBkB;EExnBlB,gBFwmB0B;AZtF9B;AUnbI;EIpGF;IJuQM,eAAA;EVoRN;AACF;Ac5hBE;EJgQM,iCAAA;EI5PJ,gBFynBkB;EExnBlB,gBFwmB0B;AZ5E9B;AU7bI;EIpGF;IJuQM,iBAAA;EV8RN;AACF;ActiBE;EJgQM,iCAAA;EI5PJ,gBFynBkB;EExnBlB,gBFwmB0B;AZlE9B;AUvcI;EIpGF;IJuQM,eAAA;EVwSN;AACF;AchjBE;EJgQM,iCAAA;EI5PJ,gBFynBkB;EExnBlB,gBFwmB0B;AZxD9B;AUjdI;EIpGF;IJuQM,iBAAA;EVkTN;AACF;Ac1jBE;EJgQM,iCAAA;EI5PJ,gBFynBkB;EExnBlB,gBFwmB0B;AZ9C9B;AU3dI;EIpGF;IJuQM,eAAA;EV4TN;AACF;AcpkBE;EJgQM,iCAAA;EI5PJ,gBFynBkB;EExnBlB,gBFwmB0B;AZpC9B;AUreI;EIpGF;IJuQM,iBAAA;EVsUN;AACF;ActjBA;ECvDE,eAAA;EACA,gBAAA;AfgnBF;AcrjBA;EC5DE,eAAA;EACA,gBAAA;AfonBF;ActjBA;EACE,qBAAA;AdwjBF;ActjBE;EACE,oBFsoB0B;AZ9E9B;Ac9iBA;EJ8MM,kBALI;EIvMR,yBAAA;AdgjBF;Ac5iBA;EACE,mBFiUO;EF1HH,kBALI;AV6WV;Ac5iBE;EACE,gBAAA;Ad8iBJ;Ac1iBA;EACE,iBAAA;EACA,mBFuTO;EF1HH,kBALI;EItLR,cFtFS;AZkoBX;Ac1iBE;EACE,aAAA;Ad4iBJ;AgB5oBA;ECIE,eAAA;EAGA,YAAA;AjByoBF;AgB1oBA;EACE,gBJ6jDkC;EI5jDlC,mCJ6jDkC;EI5jDlC,2DAAA;EHGE,sCAAA;EIRF,eAAA;EAGA,YAAA;AjBipBF;AgBnoBA;EAEE,qBAAA;AhBooBF;AgBjoBA;EACE,qBAAA;EACA,cAAA;AhBmoBF;AgBhoBA;ENyPM,kBALI;EMlPR,gCJgjDkC;AZ96BpC;AkBpqBE;;;;;;;ECHA,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,6CAAA;EACA,4CAAA;EACA,kBAAA;EACA,iBAAA;AnBgrBF;AoB1nBI;EF5CE;IACE,gBNkee;EZuMrB;AACF;AoB/nBI;EF5CE;IACE,gBNkee;EZ4MrB;AACF;AoBpoBI;EF5CE;IACE,gBNkee;EZiNrB;AACF;AoBzoBI;EF5CE;IACE,iBNkee;EZsNrB;AACF;AoB9oBI;EF5CE;IACE,iBNkee;EZ2NrB;AACF;AqB9sBA;EAEI,qBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;ArBotBJ;AqB/sBE;ECNA,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EAEA,yCAAA;EACA,6CAAA;EACA,4CAAA;AtButBF;AqBrtBI;ECOF,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;AtBitBF;AsBlqBM;EACE,YAAA;AtBoqBR;AsBjqBM;EApCJ,cAAA;EACA,WAAA;AtBwsBF;AsB1rBE;EACE,cAAA;EACA,WAAA;AtB4rBJ;AsB9rBE;EACE,cAAA;EACA,UAAA;AtBgsBJ;AsBlsBE;EACE,cAAA;EACA,mBAAA;AtBosBJ;AsBtsBE;EACE,cAAA;EACA,UAAA;AtBwsBJ;AsB1sBE;EACE,cAAA;EACA,UAAA;AtB4sBJ;AsB9sBE;EACE,cAAA;EACA,mBAAA;AtBgtBJ;AsBjrBM;EAhDJ,cAAA;EACA,WAAA;AtBouBF;AsB/qBU;EAhEN,cAAA;EACA,kBAAA;AtBkvBJ;AsBnrBU;EAhEN,cAAA;EACA,mBAAA;AtBsvBJ;AsBvrBU;EAhEN,cAAA;EACA,UAAA;AtB0vBJ;AsB3rBU;EAhEN,cAAA;EACA,mBAAA;AtB8vBJ;AsB/rBU;EAhEN,cAAA;EACA,mBAAA;AtBkwBJ;AsBnsBU;EAhEN,cAAA;EACA,UAAA;AtBswBJ;AsBvsBU;EAhEN,cAAA;EACA,mBAAA;AtB0wBJ;AsB3sBU;EAhEN,cAAA;EACA,mBAAA;AtB8wBJ;AsB/sBU;EAhEN,cAAA;EACA,UAAA;AtBkxBJ;AsBntBU;EAhEN,cAAA;EACA,mBAAA;AtBsxBJ;AsBvtBU;EAhEN,cAAA;EACA,mBAAA;AtB0xBJ;AsB3tBU;EAhEN,cAAA;EACA,WAAA;AtB8xBJ;AsBvtBY;EAxDV,wBAAA;AtBkxBF;AsB1tBY;EAxDV,yBAAA;AtBqxBF;AsB7tBY;EAxDV,gBAAA;AtBwxBF;AsBhuBY;EAxDV,yBAAA;AtB2xBF;AsBnuBY;EAxDV,yBAAA;AtB8xBF;AsBtuBY;EAxDV,gBAAA;AtBiyBF;AsBzuBY;EAxDV,yBAAA;AtBoyBF;AsB5uBY;EAxDV,yBAAA;AtBuyBF;AsB/uBY;EAxDV,gBAAA;AtB0yBF;AsBlvBY;EAxDV,yBAAA;AtB6yBF;AsBrvBY;EAxDV,yBAAA;AtBgzBF;AsB7uBQ;;EAEE,gBAAA;AtB+uBV;AsB5uBQ;;EAEE,gBAAA;AtB8uBV;AsBrvBQ;;EAEE,sBAAA;AtBuvBV;AsBpvBQ;;EAEE,sBAAA;AtBsvBV;AsB7vBQ;;EAEE,qBAAA;AtB+vBV;AsB5vBQ;;EAEE,qBAAA;AtB8vBV;AsBrwBQ;;EAEE,mBAAA;AtBuwBV;AsBpwBQ;;EAEE,mBAAA;AtBswBV;AsB7wBQ;;EAEE,qBAAA;AtB+wBV;AsB5wBQ;;EAEE,qBAAA;AtB8wBV;AsBrxBQ;;EAEE,mBAAA;AtBuxBV;AsBpxBQ;;EAEE,mBAAA;AtBsxBV;AoBh1BI;EEUE;IACE,YAAA;EtBy0BN;EsBt0BI;IApCJ,cAAA;IACA,WAAA;EtB62BA;EsB/1BA;IACE,cAAA;IACA,WAAA;EtBi2BF;EsBn2BA;IACE,cAAA;IACA,UAAA;EtBq2BF;EsBv2BA;IACE,cAAA;IACA,mBAAA;EtBy2BF;EsB32BA;IACE,cAAA;IACA,UAAA;EtB62BF;EsB/2BA;IACE,cAAA;IACA,UAAA;EtBi3BF;EsBn3BA;IACE,cAAA;IACA,mBAAA;EtBq3BF;EsBt1BI;IAhDJ,cAAA;IACA,WAAA;EtBy4BA;EsBp1BQ;IAhEN,cAAA;IACA,kBAAA;EtBu5BF;EsBx1BQ;IAhEN,cAAA;IACA,mBAAA;EtB25BF;EsB51BQ;IAhEN,cAAA;IACA,UAAA;EtB+5BF;EsBh2BQ;IAhEN,cAAA;IACA,mBAAA;EtBm6BF;EsBp2BQ;IAhEN,cAAA;IACA,mBAAA;EtBu6BF;EsBx2BQ;IAhEN,cAAA;IACA,UAAA;EtB26BF;EsB52BQ;IAhEN,cAAA;IACA,mBAAA;EtB+6BF;EsBh3BQ;IAhEN,cAAA;IACA,mBAAA;EtBm7BF;EsBp3BQ;IAhEN,cAAA;IACA,UAAA;EtBu7BF;EsBx3BQ;IAhEN,cAAA;IACA,mBAAA;EtB27BF;EsB53BQ;IAhEN,cAAA;IACA,mBAAA;EtB+7BF;EsBh4BQ;IAhEN,cAAA;IACA,WAAA;EtBm8BF;EsB53BU;IAxDV,cAAA;EtBu7BA;EsB/3BU;IAxDV,wBAAA;EtB07BA;EsBl4BU;IAxDV,yBAAA;EtB67BA;EsBr4BU;IAxDV,gBAAA;EtBg8BA;EsBx4BU;IAxDV,yBAAA;EtBm8BA;EsB34BU;IAxDV,yBAAA;EtBs8BA;EsB94BU;IAxDV,gBAAA;EtBy8BA;EsBj5BU;IAxDV,yBAAA;EtB48BA;EsBp5BU;IAxDV,yBAAA;EtB+8BA;EsBv5BU;IAxDV,gBAAA;EtBk9BA;EsB15BU;IAxDV,yBAAA;EtBq9BA;EsB75BU;IAxDV,yBAAA;EtBw9BA;EsBr5BM;;IAEE,gBAAA;EtBu5BR;EsBp5BM;;IAEE,gBAAA;EtBs5BR;EsB75BM;;IAEE,sBAAA;EtB+5BR;EsB55BM;;IAEE,sBAAA;EtB85BR;EsBr6BM;;IAEE,qBAAA;EtBu6BR;EsBp6BM;;IAEE,qBAAA;EtBs6BR;EsB76BM;;IAEE,mBAAA;EtB+6BR;EsB56BM;;IAEE,mBAAA;EtB86BR;EsBr7BM;;IAEE,qBAAA;EtBu7BR;EsBp7BM;;IAEE,qBAAA;EtBs7BR;EsB77BM;;IAEE,mBAAA;EtB+7BR;EsB57BM;;IAEE,mBAAA;EtB87BR;AACF;AoBz/BI;EEUE;IACE,YAAA;EtBk/BN;EsB/+BI;IApCJ,cAAA;IACA,WAAA;EtBshCA;EsBxgCA;IACE,cAAA;IACA,WAAA;EtB0gCF;EsB5gCA;IACE,cAAA;IACA,UAAA;EtB8gCF;EsBhhCA;IACE,cAAA;IACA,mBAAA;EtBkhCF;EsBphCA;IACE,cAAA;IACA,UAAA;EtBshCF;EsBxhCA;IACE,cAAA;IACA,UAAA;EtB0hCF;EsB5hCA;IACE,cAAA;IACA,mBAAA;EtB8hCF;EsB//BI;IAhDJ,cAAA;IACA,WAAA;EtBkjCA;EsB7/BQ;IAhEN,cAAA;IACA,kBAAA;EtBgkCF;EsBjgCQ;IAhEN,cAAA;IACA,mBAAA;EtBokCF;EsBrgCQ;IAhEN,cAAA;IACA,UAAA;EtBwkCF;EsBzgCQ;IAhEN,cAAA;IACA,mBAAA;EtB4kCF;EsB7gCQ;IAhEN,cAAA;IACA,mBAAA;EtBglCF;EsBjhCQ;IAhEN,cAAA;IACA,UAAA;EtBolCF;EsBrhCQ;IAhEN,cAAA;IACA,mBAAA;EtBwlCF;EsBzhCQ;IAhEN,cAAA;IACA,mBAAA;EtB4lCF;EsB7hCQ;IAhEN,cAAA;IACA,UAAA;EtBgmCF;EsBjiCQ;IAhEN,cAAA;IACA,mBAAA;EtBomCF;EsBriCQ;IAhEN,cAAA;IACA,mBAAA;EtBwmCF;EsBziCQ;IAhEN,cAAA;IACA,WAAA;EtB4mCF;EsBriCU;IAxDV,cAAA;EtBgmCA;EsBxiCU;IAxDV,wBAAA;EtBmmCA;EsB3iCU;IAxDV,yBAAA;EtBsmCA;EsB9iCU;IAxDV,gBAAA;EtBymCA;EsBjjCU;IAxDV,yBAAA;EtB4mCA;EsBpjCU;IAxDV,yBAAA;EtB+mCA;EsBvjCU;IAxDV,gBAAA;EtBknCA;EsB1jCU;IAxDV,yBAAA;EtBqnCA;EsB7jCU;IAxDV,yBAAA;EtBwnCA;EsBhkCU;IAxDV,gBAAA;EtB2nCA;EsBnkCU;IAxDV,yBAAA;EtB8nCA;EsBtkCU;IAxDV,yBAAA;EtBioCA;EsB9jCM;;IAEE,gBAAA;EtBgkCR;EsB7jCM;;IAEE,gBAAA;EtB+jCR;EsBtkCM;;IAEE,sBAAA;EtBwkCR;EsBrkCM;;IAEE,sBAAA;EtBukCR;EsB9kCM;;IAEE,qBAAA;EtBglCR;EsB7kCM;;IAEE,qBAAA;EtB+kCR;EsBtlCM;;IAEE,mBAAA;EtBwlCR;EsBrlCM;;IAEE,mBAAA;EtBulCR;EsB9lCM;;IAEE,qBAAA;EtBgmCR;EsB7lCM;;IAEE,qBAAA;EtB+lCR;EsBtmCM;;IAEE,mBAAA;EtBwmCR;EsBrmCM;;IAEE,mBAAA;EtBumCR;AACF;AoBlqCI;EEUE;IACE,YAAA;EtB2pCN;EsBxpCI;IApCJ,cAAA;IACA,WAAA;EtB+rCA;EsBjrCA;IACE,cAAA;IACA,WAAA;EtBmrCF;EsBrrCA;IACE,cAAA;IACA,UAAA;EtBurCF;EsBzrCA;IACE,cAAA;IACA,mBAAA;EtB2rCF;EsB7rCA;IACE,cAAA;IACA,UAAA;EtB+rCF;EsBjsCA;IACE,cAAA;IACA,UAAA;EtBmsCF;EsBrsCA;IACE,cAAA;IACA,mBAAA;EtBusCF;EsBxqCI;IAhDJ,cAAA;IACA,WAAA;EtB2tCA;EsBtqCQ;IAhEN,cAAA;IACA,kBAAA;EtByuCF;EsB1qCQ;IAhEN,cAAA;IACA,mBAAA;EtB6uCF;EsB9qCQ;IAhEN,cAAA;IACA,UAAA;EtBivCF;EsBlrCQ;IAhEN,cAAA;IACA,mBAAA;EtBqvCF;EsBtrCQ;IAhEN,cAAA;IACA,mBAAA;EtByvCF;EsB1rCQ;IAhEN,cAAA;IACA,UAAA;EtB6vCF;EsB9rCQ;IAhEN,cAAA;IACA,mBAAA;EtBiwCF;EsBlsCQ;IAhEN,cAAA;IACA,mBAAA;EtBqwCF;EsBtsCQ;IAhEN,cAAA;IACA,UAAA;EtBywCF;EsB1sCQ;IAhEN,cAAA;IACA,mBAAA;EtB6wCF;EsB9sCQ;IAhEN,cAAA;IACA,mBAAA;EtBixCF;EsBltCQ;IAhEN,cAAA;IACA,WAAA;EtBqxCF;EsB9sCU;IAxDV,cAAA;EtBywCA;EsBjtCU;IAxDV,wBAAA;EtB4wCA;EsBptCU;IAxDV,yBAAA;EtB+wCA;EsBvtCU;IAxDV,gBAAA;EtBkxCA;EsB1tCU;IAxDV,yBAAA;EtBqxCA;EsB7tCU;IAxDV,yBAAA;EtBwxCA;EsBhuCU;IAxDV,gBAAA;EtB2xCA;EsBnuCU;IAxDV,yBAAA;EtB8xCA;EsBtuCU;IAxDV,yBAAA;EtBiyCA;EsBzuCU;IAxDV,gBAAA;EtBoyCA;EsB5uCU;IAxDV,yBAAA;EtBuyCA;EsB/uCU;IAxDV,yBAAA;EtB0yCA;EsBvuCM;;IAEE,gBAAA;EtByuCR;EsBtuCM;;IAEE,gBAAA;EtBwuCR;EsB/uCM;;IAEE,sBAAA;EtBivCR;EsB9uCM;;IAEE,sBAAA;EtBgvCR;EsBvvCM;;IAEE,qBAAA;EtByvCR;EsBtvCM;;IAEE,qBAAA;EtBwvCR;EsB/vCM;;IAEE,mBAAA;EtBiwCR;EsB9vCM;;IAEE,mBAAA;EtBgwCR;EsBvwCM;;IAEE,qBAAA;EtBywCR;EsBtwCM;;IAEE,qBAAA;EtBwwCR;EsB/wCM;;IAEE,mBAAA;EtBixCR;EsB9wCM;;IAEE,mBAAA;EtBgxCR;AACF;AoB30CI;EEUE;IACE,YAAA;EtBo0CN;EsBj0CI;IApCJ,cAAA;IACA,WAAA;EtBw2CA;EsB11CA;IACE,cAAA;IACA,WAAA;EtB41CF;EsB91CA;IACE,cAAA;IACA,UAAA;EtBg2CF;EsBl2CA;IACE,cAAA;IACA,mBAAA;EtBo2CF;EsBt2CA;IACE,cAAA;IACA,UAAA;EtBw2CF;EsB12CA;IACE,cAAA;IACA,UAAA;EtB42CF;EsB92CA;IACE,cAAA;IACA,mBAAA;EtBg3CF;EsBj1CI;IAhDJ,cAAA;IACA,WAAA;EtBo4CA;EsB/0CQ;IAhEN,cAAA;IACA,kBAAA;EtBk5CF;EsBn1CQ;IAhEN,cAAA;IACA,mBAAA;EtBs5CF;EsBv1CQ;IAhEN,cAAA;IACA,UAAA;EtB05CF;EsB31CQ;IAhEN,cAAA;IACA,mBAAA;EtB85CF;EsB/1CQ;IAhEN,cAAA;IACA,mBAAA;EtBk6CF;EsBn2CQ;IAhEN,cAAA;IACA,UAAA;EtBs6CF;EsBv2CQ;IAhEN,cAAA;IACA,mBAAA;EtB06CF;EsB32CQ;IAhEN,cAAA;IACA,mBAAA;EtB86CF;EsB/2CQ;IAhEN,cAAA;IACA,UAAA;EtBk7CF;EsBn3CQ;IAhEN,cAAA;IACA,mBAAA;EtBs7CF;EsBv3CQ;IAhEN,cAAA;IACA,mBAAA;EtB07CF;EsB33CQ;IAhEN,cAAA;IACA,WAAA;EtB87CF;EsBv3CU;IAxDV,cAAA;EtBk7CA;EsB13CU;IAxDV,wBAAA;EtBq7CA;EsB73CU;IAxDV,yBAAA;EtBw7CA;EsBh4CU;IAxDV,gBAAA;EtB27CA;EsBn4CU;IAxDV,yBAAA;EtB87CA;EsBt4CU;IAxDV,yBAAA;EtBi8CA;EsBz4CU;IAxDV,gBAAA;EtBo8CA;EsB54CU;IAxDV,yBAAA;EtBu8CA;EsB/4CU;IAxDV,yBAAA;EtB08CA;EsBl5CU;IAxDV,gBAAA;EtB68CA;EsBr5CU;IAxDV,yBAAA;EtBg9CA;EsBx5CU;IAxDV,yBAAA;EtBm9CA;EsBh5CM;;IAEE,gBAAA;EtBk5CR;EsB/4CM;;IAEE,gBAAA;EtBi5CR;EsBx5CM;;IAEE,sBAAA;EtB05CR;EsBv5CM;;IAEE,sBAAA;EtBy5CR;EsBh6CM;;IAEE,qBAAA;EtBk6CR;EsB/5CM;;IAEE,qBAAA;EtBi6CR;EsBx6CM;;IAEE,mBAAA;EtB06CR;EsBv6CM;;IAEE,mBAAA;EtBy6CR;EsBh7CM;;IAEE,qBAAA;EtBk7CR;EsB/6CM;;IAEE,qBAAA;EtBi7CR;EsBx7CM;;IAEE,mBAAA;EtB07CR;EsBv7CM;;IAEE,mBAAA;EtBy7CR;AACF;AoBp/CI;EEUE;IACE,YAAA;EtB6+CN;EsB1+CI;IApCJ,cAAA;IACA,WAAA;EtBihDA;EsBngDA;IACE,cAAA;IACA,WAAA;EtBqgDF;EsBvgDA;IACE,cAAA;IACA,UAAA;EtBygDF;EsB3gDA;IACE,cAAA;IACA,mBAAA;EtB6gDF;EsB/gDA;IACE,cAAA;IACA,UAAA;EtBihDF;EsBnhDA;IACE,cAAA;IACA,UAAA;EtBqhDF;EsBvhDA;IACE,cAAA;IACA,mBAAA;EtByhDF;EsB1/CI;IAhDJ,cAAA;IACA,WAAA;EtB6iDA;EsBx/CQ;IAhEN,cAAA;IACA,kBAAA;EtB2jDF;EsB5/CQ;IAhEN,cAAA;IACA,mBAAA;EtB+jDF;EsBhgDQ;IAhEN,cAAA;IACA,UAAA;EtBmkDF;EsBpgDQ;IAhEN,cAAA;IACA,mBAAA;EtBukDF;EsBxgDQ;IAhEN,cAAA;IACA,mBAAA;EtB2kDF;EsB5gDQ;IAhEN,cAAA;IACA,UAAA;EtB+kDF;EsBhhDQ;IAhEN,cAAA;IACA,mBAAA;EtBmlDF;EsBphDQ;IAhEN,cAAA;IACA,mBAAA;EtBulDF;EsBxhDQ;IAhEN,cAAA;IACA,UAAA;EtB2lDF;EsB5hDQ;IAhEN,cAAA;IACA,mBAAA;EtB+lDF;EsBhiDQ;IAhEN,cAAA;IACA,mBAAA;EtBmmDF;EsBpiDQ;IAhEN,cAAA;IACA,WAAA;EtBumDF;EsBhiDU;IAxDV,cAAA;EtB2lDA;EsBniDU;IAxDV,wBAAA;EtB8lDA;EsBtiDU;IAxDV,yBAAA;EtBimDA;EsBziDU;IAxDV,gBAAA;EtBomDA;EsB5iDU;IAxDV,yBAAA;EtBumDA;EsB/iDU;IAxDV,yBAAA;EtB0mDA;EsBljDU;IAxDV,gBAAA;EtB6mDA;EsBrjDU;IAxDV,yBAAA;EtBgnDA;EsBxjDU;IAxDV,yBAAA;EtBmnDA;EsB3jDU;IAxDV,gBAAA;EtBsnDA;EsB9jDU;IAxDV,yBAAA;EtBynDA;EsBjkDU;IAxDV,yBAAA;EtB4nDA;EsBzjDM;;IAEE,gBAAA;EtB2jDR;EsBxjDM;;IAEE,gBAAA;EtB0jDR;EsBjkDM;;IAEE,sBAAA;EtBmkDR;EsBhkDM;;IAEE,sBAAA;EtBkkDR;EsBzkDM;;IAEE,qBAAA;EtB2kDR;EsBxkDM;;IAEE,qBAAA;EtB0kDR;EsBjlDM;;IAEE,mBAAA;EtBmlDR;EsBhlDM;;IAEE,mBAAA;EtBklDR;EsBzlDM;;IAEE,qBAAA;EtB2lDR;EsBxlDM;;IAEE,qBAAA;EtB0lDR;EsBjmDM;;IAEE,mBAAA;EtBmmDR;EsBhmDM;;IAEE,mBAAA;EtBkmDR;AACF;AuBxtDA;EAEE,8BAAA;EACA,2BAAA;EACA,+BAAA;EACA,4BAAA;EAEA,0CAAA;EACA,gCAAA;EACA,+CAAA;EACA,iCAAA;EACA,kDAAA;EACA,+DAAA;EACA,iDAAA;EACA,6DAAA;EACA,gDAAA;EACA,8DAAA;EAEA,WAAA;EACA,mBXkYO;EWjYP,mBXusB4B;EWtsB5B,0CAAA;AvButDF;AuBhtDE;EACE,sBAAA;EAEA,qFAAA;EACA,oCAAA;EACA,2CX+sB0B;EW9sB1B,2GAAA;AvBitDJ;AuB9sDE;EACE,uBAAA;AvBgtDJ;AuB7sDE;EACE,sBAAA;AvB+sDJ;AuB3sDA;EACE,+DAAA;AvB6sDF;AuBtsDA;EACE,iBAAA;AvBwsDF;AuB9rDE;EACE,wBAAA;AvBgsDJ;AuBjrDE;EACE,sCAAA;AvBmrDJ;AuBhrDI;EACE,sCAAA;AvBkrDN;AuB3qDE;EACE,sBAAA;AvB6qDJ;AuB1qDE;EACE,mBAAA;AvB4qDJ;AuBlqDE;EACE,oDAAA;EACA,8CAAA;AvBoqDJ;AuB9pDE;EACE,oDAAA;EACA,8CAAA;AvBgqDJ;AuBxpDA;EACE,oDAAA;EACA,8CAAA;AvB0pDF;AuBlpDE;EACE,mDAAA;EACA,6CAAA;AvBopDJ;AwBhyDE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AxB2xDJ;AwB7yDE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AxBwyDJ;AwB1zDE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AxBqzDJ;AwBv0DE;EAOE,sBAAA;EACA,oBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AxBk0DJ;AwBp1DE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AxB+0DJ;AwBj2DE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AxB41DJ;AwB92DE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AxBy2DJ;AwB33DE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AxBs3DJ;AuBruDI;EACE,gBAAA;EACA,iCAAA;AvBuuDN;AoBl0DI;EGyFA;IACE,gBAAA;IACA,iCAAA;EvB4uDJ;AACF;AoBx0DI;EGyFA;IACE,gBAAA;IACA,iCAAA;EvBkvDJ;AACF;AoB90DI;EGyFA;IACE,gBAAA;IACA,iCAAA;EvBwvDJ;AACF;AoBp1DI;EGyFA;IACE,gBAAA;IACA,iCAAA;EvB8vDJ;AACF;AoB11DI;EGyFA;IACE,gBAAA;IACA,iCAAA;EvBowDJ;AACF;AyBx6DA;EACE,qBbu2BsC;AZmkCxC;AyBj6DA;EACE,oDAAA;EACA,uDAAA;EACA,gBAAA;Ef8QI,kBALI;EerQR,gBb+lB4B;AZk0C9B;AyB75DA;EACE,kDAAA;EACA,qDAAA;EfoQI,kBALI;AViqDV;AyB55DA;EACE,mDAAA;EACA,sDAAA;Ef8PI,mBALI;AVsqDV;A0B57DA;EACE,mBd+1BsC;EFrkBlC,kBALI;EgBjRR,gCd+1BsC;AZ6lCxC;A2Bj8DA;EACE,cAAA;EACA,WAAA;EACA,yBAAA;EjBwRI,eALI;EiBhRR,gBfkmB4B;EejmB5B,gBfymB4B;EexmB5B,2Bf43BsC;Ee33BtC,gBAAA;EACA,mCfq3BsC;Eep3BtC,4BAAA;EACA,2DAAA;EdGE,sCAAA;EeHE,wEDMJ;A3B87DF;A4Bh8DM;EDhBN;ICiBQ,gBAAA;E5Bm8DN;AACF;A2Bj8DE;EACE,gBAAA;A3Bm8DJ;A2Bj8DI;EACE,eAAA;A3Bm8DN;A2B97DE;EACE,2Bfs2BoC;Eer2BpC,mCfg2BoC;Ee/1BpC,qBf82BoC;Ee72BpC,UAAA;EAKE,kDfkhBkB;AZ06CxB;A2Bx7DE;EAME,eAAA;EAMA,aAAA;EAKA,SAAA;A3B46DJ;A2Bv6DE;EACE,cAAA;EACA,UAAA;A3By6DJ;A2Br6DE;EACE,gCf40BoC;Ee10BpC,UAAA;A3Bs6DJ;A2B95DE;EAEE,wCf8yBoC;Ee3yBpC,UAAA;A3B65DJ;A2Bz5DE;EACE,yBAAA;EACA,0BAAA;EACA,0BforB0B;EenrB1B,2BfsyBoC;EiBp4BtC,uCjBqiCgC;Eer8B9B,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,+CfgsB0B;Ee/rB1B,gBAAA;ECzFE,qID0FF;A3B25DJ;A4Bj/DM;ED0EJ;ICzEM,gBAAA;E5Bo/DN;AACF;A2B75DE;EACE,wCf47B8B;AZm+BlC;A2Bt5DA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBfwf4B;Eevf5B,2Bf2xBsC;Ee1xBtC,6BAAA;EACA,yBAAA;EACA,sCAAA;A3Bw5DF;A2Bt5DE;EACE,UAAA;A3Bw5DJ;A2Br5DE;EAEE,gBAAA;EACA,eAAA;A3Bs5DJ;A2B34DA;EACE,mEf4wBsC;Ee3wBtC,uBAAA;EjByII,mBALI;EGvQN,yCAAA;AbkhEJ;A2B34DE;EACE,uBAAA;EACA,wBAAA;EACA,yBfooB0B;AZywC9B;A2Bz4DA;EACE,iEfgwBsC;Ee/vBtC,oBAAA;EjB4HI,kBALI;EGvQN,yCAAA;Ab6hEJ;A2Bz4DE;EACE,oBAAA;EACA,qBAAA;EACA,uBf2nB0B;AZgxC9B;A2Bn4DE;EACE,oEf6uBoC;AZwpCxC;A2Bl4DE;EACE,mEf0uBoC;AZ0pCxC;A2Bj4DE;EACE,iEfuuBoC;AZ4pCxC;A2B93DA;EACE,WfquBsC;EepuBtC,gEf8tBsC;Ee7tBtC,iBfilB4B;AZ+yC9B;A2B93DE;EACE,eAAA;A3Bg4DJ;A2B73DE;EACE,oBAAA;EdvLA,sCAAA;AbujEJ;A2B53DE;EACE,oBAAA;Ed5LA,sCAAA;Ab2jEJ;A2B33DE;EAAoB,+Df8sBkB;AZgrCxC;A2B73DE;EAAoB,6Df8sBkB;AZkrCxC;A8B/kEA;EACE,gEAAA;EAEA,cAAA;EACA,WAAA;EACA,0CAAA;EpBqRI,eALI;EoB7QR,gBlB+lB4B;EkB9lB5B,gBlBsmB4B;EkBrmB5B,2BlBy3BsC;EkBx3BtC,gBAAA;EACA,mClBk3BsC;EkBj3BtC,mFAAA;EACA,4BAAA;EACA,yClB+9BkC;EkB99BlC,0BlB+9BkC;EkB99BlC,2DAAA;EjBHE,sCAAA;EeHE,wEESJ;A9B8kEF;A4BnlEM;EEfN;IFgBQ,gBAAA;E5BslEN;AACF;A8BjlEE;EACE,qBlBs3BoC;EkBr3BpC,UAAA;EAKE,kDlBi+B4B;AZ8mClC;A8B3kEE;EAEE,sBlB6uB0B;EkB5uB1B,sBAAA;A9B4kEJ;A8BzkEE;EAEE,wClBu1BoC;AZmvCxC;A8BrkEE;EACE,kBAAA;EACA,uCAAA;A9BukEJ;A8BnkEA;EACE,oBlBsuB4B;EkBruB5B,uBlBquB4B;EkBpuB5B,oBlBquB4B;EFlgBxB,mBALI;EGvQN,yCAAA;AbgnEJ;A8BlkEA;EACE,mBlBkuB4B;EkBjuB5B,sBlBiuB4B;EkBhuB5B,kBlBiuB4B;EFtgBxB,kBALI;EGvQN,yCAAA;AbunEJ;A8B/jEI;EACE,gEAAA;A9BikEN;A+BzoEA;EACE,cAAA;EACA,kBnBq6BwC;EmBp6BxC,mBnBq6BwC;EmBp6BxC,uBnBq6BwC;AZsuC1C;A+BzoEE;EACE,WAAA;EACA,mBAAA;A/B2oEJ;A+BvoEA;EACE,oBnB25BwC;EmB15BxC,eAAA;EACA,iBAAA;A/ByoEF;A+BvoEE;EACE,YAAA;EACA,oBAAA;EACA,cAAA;A/ByoEJ;A+BroEA;EACE,qCAAA;EAEA,cAAA;EACA,UnB04BwC;EmBz4BxC,WnBy4BwC;EmBx4BxC,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,+CAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,2DnB24BwC;EmB14BxC,yBAAA;A/BsoEF;A+BnoEE;ElB3BE,qBAAA;AbiqEJ;A+BloEE;EAEE,kBnBm4BsC;AZgwC1C;A+BhoEE;EACE,uBnB03BsC;AZwwC1C;A+B/nEE;EACE,qBnBs1BoC;EmBr1BpC,UAAA;EACA,kDnB8foB;AZmoDxB;A+B9nEE;EACE,yB9BhEM;E8BiEN,qB9BjEM;ADisEV;A+B9nEI;EAII,iEAAA;A/B6nER;A+BznEI;EAII,iEAAA;A/BwnER;A+BnnEE;EACE,yB9BrFM;E8BsFN,qB9BtFM;E8B2FJ,iEAAA;A/BinEN;A+B7mEE;EACE,oBAAA;EACA,YAAA;EACA,YnBk2BuC;AZ6wC3C;A+BxmEI;EACE,eAAA;EACA,YnBy1BqC;AZixC3C;A+B5lEA;EACE,mBnBo1BgC;AZ0wClC;A+B5lEE;EACE,4DAAA;EAEA,UnB80B8B;EmB70B9B,mBAAA;EACA,0CAAA;EACA,gCAAA;ElBjHA,kBAAA;EeHE,iDGsHF;A/B6lEJ;A4B/sEM;EG0GJ;IHzGM,gBAAA;E5BktEN;AACF;A+BhmEI;EACE,4DAAA;A/BkmEN;A+B/lEI;EACE,iCnB60B4B;EmBx0B1B,4DAAA;A/B6lER;A+BxlEE;EACE,oBnBwzB8B;EmBvzB9B,eAAA;A/B0lEJ;A+BxlEI;EACE,oBAAA;EACA,cAAA;A/B0lEN;A+BrlEA;EACE,qBAAA;EACA,kBnBsyBgC;AZizClC;A+BplEA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;A/BslEF;A+BllEI;EACE,oBAAA;EACA,YAAA;EACA,anBspBwB;AZ87C9B;A+B7kEI;EACE,4DAAA;A/B+kEN;AgClwEA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,6BAAA;AhCowEF;AgClwEE;EACE,UAAA;AhCowEJ;AgChwEI;EAA0B,kEpB8gCa;AZqvC3C;AgClwEI;EAA0B,kEpB6gCa;AZwvC3C;AgClwEE;EACE,SAAA;AhCowEJ;AgCjwEE;EACE,WpB+/BuC;EoB9/BvC,YpB8/BuC;EoB7/BvC,oBAAA;EACA,gBAAA;EH1BF,yB5BFQ;E+B8BN,SpB6/BuC;EC1gCvC,mBAAA;EeHE,4GImBF;AhCkwEJ;A4BjxEM;EIMJ;IJLM,gBAAA;E5BoxEN;AACF;AgCrwEI;EHjCF,yBjB8hCyC;AZ2wC3C;AgCnwEE;EACE,WpBw+B8B;EoBv+B9B,cpBw+B8B;EoBv+B9B,kBAAA;EACA,epBu+B8B;EoBt+B9B,wCpBu+B8B;EoBt+B9B,yBAAA;EnB7BA,mBAAA;AbmyEJ;AgCjwEE;EACE,WpBo+BuC;EoBn+BvC,YpBm+BuC;EoBl+BvC,gBAAA;EHpDF,yB5BFQ;E+BwDN,SpBm+BuC;EC1gCvC,mBAAA;EeHE,4GI6CF;AhCkwEJ;A4B3yEM;EIiCJ;IJhCM,gBAAA;E5B8yEN;AACF;AgCrwEI;EH3DF,yBjB8hCyC;AZqyC3C;AgCnwEE;EACE,WpB88B8B;EoB78B9B,cpB88B8B;EoB78B9B,kBAAA;EACA,epB68B8B;EoB58B9B,wCpB68B8B;EoB58B9B,yBAAA;EnBvDA,mBAAA;Ab6zEJ;AgCjwEE;EACE,oBAAA;AhCmwEJ;AgCjwEI;EACE,2CpBg9BqC;AZmzC3C;AgChwEI;EACE,2CpB48BqC;AZszC3C;AiCz1EA;EACE,kBAAA;AjC21EF;AiCz1EE;;;EAGE,uDrBwiCoC;EqBviCpC,2DrBuiCoC;EqBtiCpC,iBrBuiCoC;AZozCxC;AiCx1EE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gDAAA;EACA,qBAAA;ELRE,gEKSF;AjC01EJ;A4B/1EM;EKTJ;ILUM,gBAAA;E5Bk2EN;AACF;AiC51EE;;EAEE,qBAAA;AjC81EJ;AiC51EI;;EACE,kBAAA;AjC+1EN;AiC51EI;;;EAEE,qBrB4gCkC;EqB3gClC,wBrB4gCkC;AZm1CxC;AiC51EI;;EACE,qBrBugCkC;EqBtgClC,wBrBugCkC;AZw1CxC;AiC31EE;EACE,qBrBigCoC;EqBhgCpC,wBrBigCoC;AZ41CxC;AiCt1EI;;;;EACE,2CAAA;EACA,8DrB2/BkC;AZg2CxC;AiCz1EM;;;;EACE,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,arBm/BgC;EqBl/BhC,WAAA;EACA,mCrBg0BgC;ECh3BpC,sCAAA;Ab+4EJ;AiCx1EI;EACE,2CAAA;EACA,8DrB0+BkC;AZg3CxC;AiCr1EI;EACE,sCAAA;AjCu1EN;AiCn1EE;;EAEE,crB1EO;AZ+5EX;AiCn1EI;;EACE,wCrB0yBkC;AZ4iDxC;AkC76EA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;AlC+6EF;AkC76EE;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;AlC+6EJ;AkC36EE;;;EAGE,UAAA;AlC66EJ;AkCv6EE;EACE,kBAAA;EACA,UAAA;AlCy6EJ;AkCv6EI;EACE,UAAA;AlCy6EN;AkC95EA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;ExB8OI,eALI;EwBvOR,gBtByjB4B;EsBxjB5B,gBtBgkB4B;EsB/jB5B,2BtBm1BsC;EsBl1BtC,kBAAA;EACA,mBAAA;EACA,uCtB06BsC;EsBz6BtC,2DAAA;ErBtCE,sCAAA;Abu8EJ;AkCv5EA;;;;EAIE,oBAAA;ExBwNI,kBALI;EGvQN,yCAAA;Ab+8EJ;AkCt5EA;;;;EAIE,uBAAA;ExB+MI,mBALI;EGvQN,yCAAA;Abu9EJ;AkCr5EA;;EAEE,mBAAA;AlCu5EF;AkC14EI;;;;ErBjEA,0BAAA;EACA,6BAAA;Abi9EJ;AkCx4EI;;;;ErB1EA,0BAAA;EACA,6BAAA;Abw9EJ;AkCl4EE;EACE,8CAAA;ErB1EA,yBAAA;EACA,4BAAA;Ab+8EJ;AkCl4EE;;ErB9EE,yBAAA;EACA,4BAAA;Abo9EJ;AmC5+EE;EACE,aAAA;EACA,WAAA;EACA,mBvBu0BoC;EFrkBlC,kBALI;EyB1PN,iCvBkjCqB;AZ27CzB;AmC1+EE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EzBqPE,mBALI;EyB7ON,WvBqiCqB;EuBpiCrB,mCvBoiCqB;EC/jCrB,sCAAA;AbugFJ;AmCv+EI;;;EAEE,cAAA;AnC0+EN;AmCzhFI;EAqDE,+CvBuhCmB;EuBphCjB,oCvB81BgC;EuB71BhC,yDAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;AnCq+ER;AmCl+EM;EACE,+CvB4gCiB;EuB3gCjB,2DvB2gCiB;AZy9CzB;AmCriFI;EA0EI,oCvB40BgC;EuB30BhC,kFAAA;AnC89ER;AmCziFI;EAkFE,+CvB0/BmB;AZg+CzB;AmCv9EQ;EAEE,iEAAA;EACA,uBvB05B8B;EuBz5B9B,+DAAA;EACA,2EAAA;AnCw9EV;AmCp9EM;EACE,+CvB6+BiB;EuB5+BjB,2DvB4+BiB;AZ0+CzB;AmCtjFI;EAwGI,yCAAA;AnCi9ER;AmCzjFI;EA+GE,+CvB69BmB;AZg/CzB;AmC38EM;EACE,4CvB09BiB;AZm/CzB;AmC18EM;EACE,2DvBs9BiB;AZs/CzB;AmCz8EM;EACE,iCvBk9BiB;AZy/CzB;AmCt8EI;EACE,kBAAA;AnCw8EN;AmCxkFI;;;;;EA0IM,UAAA;AnCq8EV;AmC3jFE;EACE,aAAA;EACA,WAAA;EACA,mBvBu0BoC;EFrkBlC,kBALI;EyB1PN,mCvBkjCqB;AZ0gDzB;AmCzjFE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EzBqPE,mBALI;EyB7ON,WvBqiCqB;EuBpiCrB,kCvBoiCqB;EC/jCrB,sCAAA;AbslFJ;AmCtjFI;;;EAEE,cAAA;AnCyjFN;AmCxmFI;EAqDE,iDvBuhCmB;EuBphCjB,oCvB81BgC;EuB71BhC,0DAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;AnCojFR;AmCjjFM;EACE,iDvB4gCiB;EuB3gCjB,0DvB2gCiB;AZwiDzB;AmCpnFI;EA0EI,oCvB40BgC;EuB30BhC,kFAAA;AnC6iFR;AmCxnFI;EAkFE,iDvB0/BmB;AZ+iDzB;AmCtiFQ;EAEE,kEAAA;EACA,uBvB05B8B;EuBz5B9B,+DAAA;EACA,2EAAA;AnCuiFV;AmCniFM;EACE,iDvB6+BiB;EuB5+BjB,0DvB4+BiB;AZyjDzB;AmCroFI;EAwGI,yCAAA;AnCgiFR;AmCxoFI;EA+GE,iDvB69BmB;AZ+jDzB;AmC1hFM;EACE,8CvB09BiB;AZkkDzB;AmCzhFM;EACE,0DvBs9BiB;AZqkDzB;AmCxhFM;EACE,mCvBk9BiB;AZwkDzB;AmCrhFI;EACE,kBAAA;AnCuhFN;AmCvpFI;;;;;EA4IM,UAAA;AnCkhFV;AoChqFA;EAEE,2BAAA;EACA,4BAAA;EACA,sBAAA;E1BuRI,wBALI;E0BhRR,yBAAA;EACA,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,6CAAA;EACA,kCAAA;EACA,+CAAA;EACA,wCAAA;EACA,4FAAA;EACA,+BAAA;EACA,iFAAA;EAGA,qBAAA;EACA,wDAAA;EACA,sCAAA;E1BsQI,kCALI;E0B/PR,sCAAA;EACA,sCAAA;EACA,0BAAA;EACA,kBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,mEAAA;EvBjBE,0CAAA;EgBfF,kCOkCqB;ERtBjB,qIQwBJ;ApC6pFF;A4BjrFM;EQhBN;IRiBQ,gBAAA;E5BorFN;AACF;AoChqFE;EACE,gCAAA;EAEA,wCAAA;EACA,8CAAA;ApCiqFJ;AoC9pFE;EAEE,0BAAA;EACA,kCAAA;EACA,wCAAA;ApC+pFJ;AoC5pFE;EACE,gCAAA;EPrDF,wCOsDuB;EACrB,8CAAA;EACA,UAAA;EAKE,0CAAA;ApC0pFN;AoCtpFE;EACE,8CAAA;EACA,UAAA;EAKE,0CAAA;ApCopFN;AoChpFE;EAKE,iCAAA;EACA,yCAAA;EAGA,+CAAA;ApC4oFJ;AoCzoFI;EAKI,0CAAA;ApCuoFR;AoCloFE;EAGE,mCAAA;EACA,oBAAA;EACA,2CAAA;EAEA,iDAAA;EACA,uCAAA;ApCioFJ;AoCrnFE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;ArC8tFF;AoCroFE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;ArC8uFF;AoCrpFE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;ArC8vFF;AoCrqFE;ECtGA,oBAAA;EACA,iBAAA;EACA,2BAAA;EACA,0BAAA;EACA,wBAAA;EACA,kCAAA;EACA,wCAAA;EACA,2BAAA;EACA,yBAAA;EACA,mCAAA;EACA,4DAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;ArC8wFF;AoCrrFE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;ArC8xFF;AoCrsFE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;ArC8yFF;AoCrtFE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;ArC8zFF;AoCruFE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;ArC80FF;AoC3tFE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;ArCq0FF;AoC3uFE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;ArCq1FF;AoC3vFE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;ArCq2FF;AoC3wFE;ECvGA,oBAAA;EACA,2BAAA;EACA,0BAAA;EACA,uBAAA;EACA,iCAAA;EACA,wCAAA;EACA,2BAAA;EACA,wBAAA;EACA,kCAAA;EACA,4DAAA;EACA,6BAAA;EACA,iCAAA;EACA,oCAAA;EACA,mBAAA;ArCq3FF;AoC3xFE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;ArCq4FF;AoC3yFE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;ArCq5FF;AoC3zFE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;ArCq6FF;AoC30FE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;ArCq7FF;AoC/0FA;EACE,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,kCAAA;EACA,gDAAA;EACA,wCAAA;EACA,iDAAA;EACA,yCAAA;EACA,gCAAA;EACA,2CAAA;EACA,+BAAA;EACA,uCAAA;EAEA,0BxBuRwC;AZyjF1C;AoCt0FE;EACE,0BAAA;ApCw0FJ;AoCr0FE;EACE,gCAAA;ApCu0FJ;AoC5zFA;ECxIE,0BAAA;EACA,wBAAA;E3B8NI,2BALI;E2BvNR,kDAAA;ArCu8FF;AoC9zFA;EC5IE,2BAAA;EACA,0BAAA;E3B8NI,4BALI;E2BvNR,kDAAA;ArC68FF;AsChhGA;EVgBM,gCUfJ;AtCkhGF;A4B//FM;EUpBN;IVqBQ,gBAAA;E5BkgGN;AACF;AsCrhGE;EACE,UAAA;AtCuhGJ;AsCjhGE;EACE,aAAA;AtCmhGJ;AsC/gGA;EACE,SAAA;EACA,gBAAA;EVDI,6BUEJ;AtCihGF;A4B/gGM;EULN;IVMQ,gBAAA;E5BkhGN;AACF;AsCphGE;EACE,QAAA;EACA,YAAA;EVNE,4BUOF;AtCshGJ;A4BzhGM;EUAJ;IVCM,gBAAA;E5B4hGN;AACF;AuCjjGA;;;;;;EAME,kBAAA;AvCmjGF;AuChjGA;EACE,mBAAA;AvCkjGF;AwC1hGI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;EArCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;AxCkkGF;AwCxgGI;EACE,cAAA;AxC0gGN;AuCxjGA;EAEE,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;E7BuQI,6BALI;E6BhQR,yCAAA;EACA,mCAAA;EACA,8DAAA;EACA,oDAAA;EACA,kDAAA;EACA,yFAAA;EACA,4DAAA;EACA,sCAAA;EACA,8CAAA;EACA,8CAAA;EACA,oDAAA;EACA,kDAAA;EACA,qCAAA;EACA,qCAAA;EACA,2DAAA;EACA,kCAAA;EACA,qCAAA;EACA,mCAAA;EACA,oCAAA;EACA,sCAAA;EAGA,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,uCAAA;EACA,kEAAA;EACA,SAAA;E7B0OI,uCALI;E6BnOR,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;E1BzCE,+CAAA;AbimGJ;AuCpjGE;EACE,SAAA;EACA,OAAA;EACA,qCAAA;AvCsjGJ;AuC9hGI;EACE,oBAAA;AvCgiGN;AuC9hGM;EACE,WAAA;EACA,OAAA;AvCgiGR;AuC5hGI;EACE,kBAAA;AvC8hGN;AuC5hGM;EACE,QAAA;EACA,UAAA;AvC8hGR;AoBxkGI;EmB4BA;IACE,oBAAA;EvC+iGJ;EuC7iGI;IACE,WAAA;IACA,OAAA;EvC+iGN;EuC3iGE;IACE,kBAAA;EvC6iGJ;EuC3iGI;IACE,QAAA;IACA,UAAA;EvC6iGN;AACF;AoBxlGI;EmB4BA;IACE,oBAAA;EvC+jGJ;EuC7jGI;IACE,WAAA;IACA,OAAA;EvC+jGN;EuC3jGE;IACE,kBAAA;EvC6jGJ;EuC3jGI;IACE,QAAA;IACA,UAAA;EvC6jGN;AACF;AoBxmGI;EmB4BA;IACE,oBAAA;EvC+kGJ;EuC7kGI;IACE,WAAA;IACA,OAAA;EvC+kGN;EuC3kGE;IACE,kBAAA;EvC6kGJ;EuC3kGI;IACE,QAAA;IACA,UAAA;EvC6kGN;AACF;AoBxnGI;EmB4BA;IACE,oBAAA;EvC+lGJ;EuC7lGI;IACE,WAAA;IACA,OAAA;EvC+lGN;EuC3lGE;IACE,kBAAA;EvC6lGJ;EuC3lGI;IACE,QAAA;IACA,UAAA;EvC6lGN;AACF;AoBxoGI;EmB4BA;IACE,oBAAA;EvC+mGJ;EuC7mGI;IACE,WAAA;IACA,OAAA;EvC+mGN;EuC3mGE;IACE,kBAAA;EvC6mGJ;EuC3mGI;IACE,QAAA;IACA,UAAA;EvC6mGN;AACF;AuCpmGE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;AvCsmGJ;AwC1rGI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;EA9BJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;AxC2tGF;AwCxqGI;EACE,cAAA;AxC0qGN;AuC1mGE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sCAAA;AvC4mGJ;AwC9sGI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;EAvBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;AxCwuGF;AwC5rGI;EACE,cAAA;AxC8rGN;AuCpnGI;EACE,iBAAA;AvCsnGN;AuChnGE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uCAAA;AvCknGJ;AwCruGI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;AxCuuGN;AwC5tGM;EACE,aAAA;AxC8tGR;AwC3tGM;EACE,qBAAA;EACA,qB5B0gBsB;E4BzgBtB,uB5BwgBsB;E4BvgBtB,WAAA;EAnCN,mCAAA;EACA,yBAAA;EACA,sCAAA;AxCiwGF;AwC3tGI;EACE,cAAA;AxC6tGN;AuCloGI;EACE,iBAAA;AvCooGN;AuC7nGA;EACE,SAAA;EACA,6CAAA;EACA,gBAAA;EACA,mDAAA;EACA,UAAA;AvC+nGF;AuCznGA;EACE,cAAA;EACA,WAAA;EACA,4EAAA;EACA,WAAA;EACA,gB3Byb4B;E2Bxb5B,oCAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;E1BtKE,uDAAA;AbkyGJ;AuCznGE;EAEE,0CAAA;EV1LF,kDU4LuB;AvCynGzB;AuCtnGE;EAEE,2CAAA;EACA,qBAAA;EVlMF,mDUmMuB;AvCunGzB;AuCpnGE;EAEE,6CAAA;EACA,oBAAA;EACA,6BAAA;AvCqnGJ;AuC/mGA;EACE,cAAA;AvCinGF;AuC7mGA;EACE,cAAA;EACA,gFAAA;EACA,gBAAA;E7BmEI,mBALI;E6B5DR,sCAAA;EACA,mBAAA;AvC+mGF;AuC3mGA;EACE,cAAA;EACA,4EAAA;EACA,oCAAA;AvC6mGF;AuCzmGA;EAEE,4BAAA;EACA,yBAAA;EACA,8DAAA;EACA,0BAAA;EACA,iCAAA;EACA,oCAAA;EACA,4DAAA;EACA,sDAAA;EACA,qCAAA;EACA,qCAAA;EACA,0CAAA;EACA,mCAAA;AvC0mGF;AyCh2GA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;AzCk2GF;AyCh2GE;;EACE,kBAAA;EACA,cAAA;AzCm2GJ;AyC91GE;;;;;;;;;;;;EAME,UAAA;AzCs2GJ;AyCj2GA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;AzCm2GF;AyCj2GE;EACE,WAAA;AzCm2GJ;AyC/1GA;E5BhBI,sCAAA;Abk3GJ;AyC91GE;;EAEE,8CAAA;AzCg2GJ;AyC51GE;;;E5BVE,0BAAA;EACA,6BAAA;Ab22GJ;AyCx1GE;;;E5BNE,yBAAA;EACA,4BAAA;Abm2GJ;AyC30GA;EACE,wBAAA;EACA,uBAAA;AzC60GF;AyC30GE;EAGE,cAAA;AzC20GJ;AyCx0GE;EACE,eAAA;AzC00GJ;AyCt0GA;EACE,uBAAA;EACA,sBAAA;AzCw0GF;AyCr0GA;EACE,sBAAA;EACA,qBAAA;AzCu0GF;AyCnzGA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;AzCqzGF;AyCnzGE;;EAEE,WAAA;AzCqzGJ;AyClzGE;;EAEE,6CAAA;AzCozGJ;AyChzGE;;E5B1FE,6BAAA;EACA,4BAAA;Ab84GJ;AyChzGE;;E5B7GE,yBAAA;EACA,0BAAA;Abi6GJ;A0Cz7GA;EAEE,6BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,uDAAA;EAGA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;A1Cu7GF;A0Cp7GA;EACE,cAAA;EACA,kEAAA;EhCsQI,uCALI;EgC/PR,2CAAA;EACA,+BAAA;EACA,qBAAA;EACA,gBAAA;EACA,SAAA;EdfI,uGcgBJ;A1Cs7GF;A4Bl8GM;EcGN;IdFQ,gBAAA;E5Bq8GN;AACF;A0Cz7GE;EAEE,qCAAA;A1C07GJ;A0Ct7GE;EACE,UAAA;EACA,kD9BkhBoB;AZs6FxB;A0Cp7GE;EAEE,wCAAA;EACA,oBAAA;EACA,eAAA;A1Cq7GJ;A0C76GA;EAEE,kDAAA;EACA,kDAAA;EACA,oDAAA;EACA,2GAAA;EACA,yDAAA;EACA,+CAAA;EACA,uGAAA;EAGA,oFAAA;A1C46GF;A0C16GE;EACE,yDAAA;EACA,yDAAA;E7B7CA,wDAAA;EACA,yDAAA;Ab09GJ;A0C36GI;EAGE,kBAAA;EACA,wDAAA;A1C26GN;A0Cv6GE;;EAEE,2CAAA;EACA,mDAAA;EACA,yDAAA;A1Cy6GJ;A0Ct6GE;EAEE,sDAAA;E7BjEA,yBAAA;EACA,0BAAA;Aby+GJ;A0C95GA;EAEE,qDAAA;EACA,sCAAA;EACA,sCAAA;A1C+5GF;A0C55GE;E7B5FE,gDAAA;Ab2/GJ;A0C35GE;;EAEE,4CAAA;EbjHF,oDakHuB;A1C65GzB;A0Cp5GA;EAEE,4BAAA;EACA,yCAAA;EACA,8DAAA;EAGA,gCAAA;A1Cm5GF;A0Cj5GE;EACE,gBAAA;EACA,eAAA;EACA,qEAAA;A1Cm5GJ;A0Cj5GI;EAEE,iCAAA;A1Ck5GN;A0C94GE;;EAEE,gB9B0d0B;E8Bzd1B,gDAAA;EACA,iCAAA;A1Cg5GJ;A0Ct4GE;;EAEE,cAAA;EACA,kBAAA;A1Cw4GJ;A0Cn4GE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;A1Cq4GJ;A0C/3GE;;EACE,WAAA;A1Ck4GJ;A0Cx3GE;EACE,aAAA;A1C03GJ;A0Cx3GE;EACE,cAAA;A1C03GJ;A2CvjHA;EAEE,wBAAA;EACA,6BAAA;EACA,2DAAA;EACA,gEAAA;EACA,mEAAA;EACA,+DAAA;EACA,sCAAA;EACA,kCAAA;EACA,oCAAA;EACA,8DAAA;EACA,oEAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,qEAAA;EACA,0EAAA;EACA,0DAAA;EACA,wCAAA;EACA,4DAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,8DAAA;A3CsjHF;A2ChjHE;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;A3CwjHJ;A2CpiHA;EACE,6CAAA;EACA,gDAAA;EACA,+CAAA;EjC4NI,2CALI;EiCrNR,mCAAA;EACA,qBAAA;EACA,mBAAA;A3CsiHF;A2CpiHE;EAEE,yCAAA;A3CqiHJ;A2C3hHA;EAEE,0BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,2CAAA;EACA,uDAAA;EACA,6DAAA;EAGA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;A3CyhHF;A2CthHI;EAEE,oCAAA;A3CuhHN;A2CnhHE;EACE,gBAAA;A3CqhHJ;A2C5gHA;EACE,mB/B8gCkC;E+B7gClC,sB/B6gCkC;E+B5gClC,6BAAA;A3C8gHF;A2C5gHE;;;EAGE,oCAAA;A3C8gHJ;A2CjgHA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;A3CigHF;A2C7/GA;EACE,8EAAA;EjCyII,6CALI;EiClIR,cAAA;EACA,6BAAA;EACA,6BAAA;EACA,0EAAA;E9BxIE,qDAAA;EeHE,+Ce6IJ;A3C+/GF;A4BxoHM;EeiIN;IfhIQ,gBAAA;E5B2oHN;AACF;A2ClgHE;EACE,qBAAA;A3CogHJ;A2CjgHE;EACE,qBAAA;EACA,UAAA;EACA,sDAAA;A3CmgHJ;A2C7/GA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;A3C+/GF;A2C5/GA;EACE,yCAAA;EACA,gBAAA;A3C8/GF;AoBxnHI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;E3Co/GN;E2Cl/GM;IACE,mBAAA;E3Co/GR;E2Cl/GQ;IACE,kBAAA;E3Co/GV;E2Cj/GQ;IACE,kDAAA;IACA,iDAAA;E3Cm/GV;E2C/+GM;IACE,iBAAA;E3Ci/GR;E2C9+GM;IACE,wBAAA;IACA,gBAAA;E3Cg/GR;E2C7+GM;IACE,aAAA;E3C++GR;E2C5+GM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;E3C4+GR;E2Cz+GQ;IACE,aAAA;E3C2+GV;E2Cx+GQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;E3C0+GV;AACF;AoBvqHI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;E3CmiHN;E2CjiHM;IACE,mBAAA;E3CmiHR;E2CjiHQ;IACE,kBAAA;E3CmiHV;E2ChiHQ;IACE,kDAAA;IACA,iDAAA;E3CkiHV;E2C9hHM;IACE,iBAAA;E3CgiHR;E2C7hHM;IACE,wBAAA;IACA,gBAAA;E3C+hHR;E2C5hHM;IACE,aAAA;E3C8hHR;E2C3hHM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;E3C2hHR;E2CxhHQ;IACE,aAAA;E3C0hHV;E2CvhHQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;E3CyhHV;AACF;AoBttHI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;E3CklHN;E2ChlHM;IACE,mBAAA;E3CklHR;E2ChlHQ;IACE,kBAAA;E3CklHV;E2C/kHQ;IACE,kDAAA;IACA,iDAAA;E3CilHV;E2C7kHM;IACE,iBAAA;E3C+kHR;E2C5kHM;IACE,wBAAA;IACA,gBAAA;E3C8kHR;E2C3kHM;IACE,aAAA;E3C6kHR;E2C1kHM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;E3C0kHR;E2CvkHQ;IACE,aAAA;E3CykHV;E2CtkHQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;E3CwkHV;AACF;AoBrwHI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;E3CioHN;E2C/nHM;IACE,mBAAA;E3CioHR;E2C/nHQ;IACE,kBAAA;E3CioHV;E2C9nHQ;IACE,kDAAA;IACA,iDAAA;E3CgoHV;E2C5nHM;IACE,iBAAA;E3C8nHR;E2C3nHM;IACE,wBAAA;IACA,gBAAA;E3C6nHR;E2C1nHM;IACE,aAAA;E3C4nHR;E2CznHM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;E3CynHR;E2CtnHQ;IACE,aAAA;E3CwnHV;E2CrnHQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;E3CunHV;AACF;AoBpzHI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;E3CgrHN;E2C9qHM;IACE,mBAAA;E3CgrHR;E2C9qHQ;IACE,kBAAA;E3CgrHV;E2C7qHQ;IACE,kDAAA;IACA,iDAAA;E3C+qHV;E2C3qHM;IACE,iBAAA;E3C6qHR;E2C1qHM;IACE,wBAAA;IACA,gBAAA;E3C4qHR;E2CzqHM;IACE,aAAA;E3C2qHR;E2CxqHM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;E3CwqHR;E2CrqHQ;IACE,aAAA;E3CuqHV;E2CpqHQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;E3CsqHV;AACF;A2C7tHI;EAEI,iBAAA;EACA,2BAAA;A3C8tHR;A2C5tHQ;EACE,mBAAA;A3C8tHV;A2C5tHU;EACE,kBAAA;A3C8tHZ;A2C3tHU;EACE,kDAAA;EACA,iDAAA;A3C6tHZ;A2CztHQ;EACE,iBAAA;A3C2tHV;A2CxtHQ;EACE,wBAAA;EACA,gBAAA;A3C0tHV;A2CvtHQ;EACE,aAAA;A3CytHV;A2CttHQ;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;Ef9NJ,gBegOI;A3CstHV;A2CntHU;EACE,aAAA;A3CqtHZ;A2CltHU;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;A3CotHZ;A2CnsHA;;EAGE,4CAAA;EACA,kDAAA;EACA,qDAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EACA,0DAAA;EACA,qEAAA;A3CosHF;A2C9rHI;EACE,qEAAA;A3CgsHN;A4Cz9HA;EAEE,wBAAA;EACA,wBAAA;EACA,gCAAA;EACA,uBAAA;EACA,0BAAA;EACA,8CAAA;EACA,0DAAA;EACA,gDAAA;EACA,sBAAA;EACA,uFAAA;EACA,+BAAA;EACA,6BAAA;EACA,sDAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,mCAAA;EACA,+BAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,2BAAA;EACA,qBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qEAAA;E/BjBE,2CAAA;Ab0+HJ;A4Cr9HE;EACE,eAAA;EACA,cAAA;A5Cu9HJ;A4Cp9HE;EACE,mBAAA;EACA,sBAAA;A5Cs9HJ;A4Cp9HI;EACE,mBAAA;E/BtBF,0DAAA;EACA,2DAAA;Ab6+HJ;A4Cp9HI;EACE,sBAAA;E/BbF,8DAAA;EACA,6DAAA;Abo+HJ;A4Cj9HE;;EAEE,aAAA;A5Cm9HJ;A4C/8HA;EAGE,cAAA;EACA,wDAAA;EACA,2BAAA;A5C+8HF;A4C58HA;EACE,4CAAA;EACA,iCAAA;A5C88HF;A4C38HA;EACE,sDAAA;EACA,gBAAA;EACA,oCAAA;A5C68HF;A4C18HA;EACE,gBAAA;A5C48HF;A4Cp8HE;EACE,oCAAA;A5Cs8HJ;A4C97HA;EACE,kEAAA;EACA,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,4EAAA;A5Cg8HF;A4C97HE;E/B7FE,wFAAA;Ab8hIJ;A4C57HA;EACE,kEAAA;EACA,+BAAA;EACA,uCAAA;EACA,yEAAA;A5C87HF;A4C57HE;E/BxGE,wFAAA;AbuiIJ;A4Cr7HA;EACE,uDAAA;EACA,sDAAA;EACA,sDAAA;EACA,gBAAA;A5Cu7HF;A4Cr7HE;EACE,mCAAA;EACA,sCAAA;A5Cu7HJ;A4Cn7HA;EACE,uDAAA;EACA,sDAAA;A5Cq7HF;A4Cj7HA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,2CAAA;E/B1IE,iDAAA;Ab8jIJ;A4Ch7HA;;;EAGE,WAAA;A5Ck7HF;A4C/6HA;;E/B3II,0DAAA;EACA,2DAAA;Ab8jIJ;A4C/6HA;;E/BlII,8DAAA;EACA,6DAAA;AbqjIJ;A4Cv6HE;EACE,0CAAA;A5Cy6HJ;AoBpiII;EwBuHJ;IAQI,aAAA;IACA,mBAAA;E5Cy6HF;E4Ct6HE;IAEE,YAAA;IACA,gBAAA;E5Cu6HJ;E4Cr6HI;IACE,cAAA;IACA,cAAA;E5Cu6HN;E4Cl6HM;I/B3KJ,0BAAA;IACA,6BAAA;EbglIF;E4Cn6HQ;;IAGE,0BAAA;E5Co6HV;E4Cl6HQ;;IAGE,6BAAA;E5Cm6HV;E4C/5HM;I/B5KJ,yBAAA;IACA,4BAAA;Eb8kIF;E4Ch6HQ;;IAGE,yBAAA;E5Ci6HV;E4C/5HQ;;IAGE,4BAAA;E5Cg6HV;AACF;A6CroIA;EAEE,0CAAA;EACA,oCAAA;EACA,8KAAA;EACA,mDAAA;EACA,mDAAA;EACA,qDAAA;EACA,4FAAA;EACA,qCAAA;EACA,kCAAA;EACA,8CAAA;EACA,6CAAA;EACA,iEAAA;EACA,sCAAA;EACA,kDAAA;EACA,8DAAA;EACA,wEAAA;EACA,8CAAA;EACA,2EAAA;EACA,sCAAA;EACA,mCAAA;EACA,4DAAA;EACA,qDAAA;A7CsoIF;A6CloIA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4EAAA;EnC2PI,eALI;EmCpPR,oCAAA;EACA,gBAAA;EACA,4CAAA;EACA,SAAA;EhCtBE,gBAAA;EgCwBF,qBAAA;EjB3BI,0CiB4BJ;A7CooIF;A4B5pIM;EiBWN;IjBVQ,gBAAA;E5B+pIN;AACF;A6CvoIE;EACE,uCAAA;EACA,+CAAA;EACA,kGAAA;A7CyoIJ;A6CvoII;EACE,qDAAA;EACA,iDAAA;A7CyoIN;A6CpoIE;EACE,cAAA;EACA,yCAAA;EACA,0CAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,4BAAA;EACA,mDAAA;EjBlDE,mDiBmDF;A7CsoIJ;A4BrrIM;EiBsCJ;IjBrCM,gBAAA;E5BwrIN;AACF;A6CxoIE;EACE,UAAA;A7C0oIJ;A6CvoIE;EACE,UAAA;EACA,wDAAA;EACA,UAAA;EACA,oDAAA;A7CyoIJ;A6CroIA;EACE,gBAAA;A7CuoIF;A6CpoIA;EACE,gCAAA;EACA,wCAAA;EACA,+EAAA;A7CsoIF;A6CpoIE;EhC/DE,yDAAA;EACA,0DAAA;AbssIJ;A6CroII;EhClEA,+DAAA;EACA,gEAAA;Ab0sIJ;A6CpoIE;EACE,aAAA;A7CsoIJ;A6CloIE;EhC9DE,6DAAA;EACA,4DAAA;AbmsIJ;A6CloIM;EhClEF,mEAAA;EACA,kEAAA;AbusIJ;A6CjoII;EhCvEA,6DAAA;EACA,4DAAA;Ab2sIJ;A6C/nIA;EACE,8EAAA;A7CioIF;A6CxnIE;EACE,eAAA;A7C0nIJ;A6CvnIE;EACE,eAAA;EACA,cAAA;EhCpHA,gBAAA;Ab8uIJ;A6CvnII;EAAgB,aAAA;A7C0nIpB;A6CznII;EAAe,gBAAA;A7C4nInB;A6CznIM;EhC3HF,gBAAA;AbuvIJ;A6ClnII;EACE,iEAAA;EACA,wEAAA;A7ConIN;A8C9wIA;EAEE,4BAAA;EACA,4BAAA;EACA,mCAAA;EAEA,oBAAA;EACA,+BAAA;EACA,wDAAA;EACA,sCAAA;EACA,4DAAA;EAGA,aAAA;EACA,eAAA;EACA,sEAAA;EACA,iDAAA;EpC+QI,yCALI;EoCxQR,gBAAA;EACA,yCAAA;EjCAE,iDAAA;Ab6wIJ;A8CvwIE;EACE,iDAAA;A9CywIJ;A8CvwII;EACE,WAAA;EACA,kDAAA;EACA,yCAAA;EACA,uFAAA;A9CywIN;A8CrwIE;EACE,6CAAA;A9CuwIJ;A+C5yIA;EAEE,kCAAA;EACA,mCAAA;ErC4RI,+BALI;EqCrRR,2CAAA;EACA,qCAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,uDAAA;EACA,+CAAA;EACA,0DAAA;EACA,uDAAA;EACA,gDAAA;EACA,wEAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EACA,yDAAA;EACA,mDAAA;EACA,6DAAA;EAGA,aAAA;EhCpBA,eAAA;EACA,gBAAA;Afg0IF;A+CzyIA;EACE,kBAAA;EACA,cAAA;EACA,sEAAA;ErCgQI,yCALI;EqCzPR,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;EnBpBI,qImBqBJ;A/C2yIF;A4B5zIM;EmBQN;InBPQ,gBAAA;E5B+zIN;AACF;A+C9yIE;EACE,UAAA;EACA,uCAAA;EAEA,+CAAA;EACA,qDAAA;A/C+yIJ;A+C5yIE;EACE,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,UnC2uCgC;EmC1uChC,iDAAA;A/C8yIJ;A+C3yIE;EAEE,UAAA;EACA,wCAAA;ElBtDF,gDkBuDuB;EACrB,sDAAA;A/C4yIJ;A+CzyIE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;EACA,wDAAA;A/C0yIJ;A+CryIE;EACE,8CnC8sCgC;AZylGpC;A+ClyIM;ElC9BF,0DAAA;EACA,6DAAA;Abm0IJ;A+ChyIM;ElClDF,2DAAA;EACA,8DAAA;Abq1IJ;A+CnxIA;EClGE,iCAAA;EACA,kCAAA;EtC0RI,kCALI;EsCnRR,yDAAA;AhDw3IF;A+CrxIA;ECtGE,iCAAA;EACA,kCAAA;EtC0RI,mCALI;EsCnRR,yDAAA;AhD83IF;AiDh4IA;EAEE,4BAAA;EACA,4BAAA;EvCuRI,4BALI;EuChRR,2BAAA;EACA,sBAAA;EACA,iDAAA;EAGA,qBAAA;EACA,4DAAA;EvC+QI,oCALI;EuCxQR,wCAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EpCJE,4CAAA;Abo4IJ;AiD33IE;EACE,aAAA;AjD63IJ;AiDx3IA;EACE,kBAAA;EACA,SAAA;AjD03IF;AkD15IA;EAEE,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,8BAAA;EACA,yBAAA;EACA,oCAAA;EACA,4EAAA;EACA,iDAAA;EACA,8BAAA;EAGA,kBAAA;EACA,4DAAA;EACA,4CAAA;EACA,4BAAA;EACA,oCAAA;EACA,8BAAA;ErCHE,4CAAA;Ab65IJ;AkDr5IA;EAEE,cAAA;AlDs5IF;AkDl5IA;EACE,gBtC6kB4B;EsC5kB5B,iCAAA;AlDo5IF;AkD54IA;EACE,mBtCo+C8B;AZ06FhC;AkD34IE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,qBAAA;AlD64IJ;AkDr4IE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;AlDu4IJ;AkD34IE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;AlD64IJ;AkDj5IE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;AlDm5IJ;AkDv5IE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;AlDy5IJ;AkD75IE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;AlD+5IJ;AkDn6IE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;AlDq6IJ;AkDz6IE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;AlD26IJ;AkD/6IE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;AlDi7IJ;AmD7+IE;EACE;IAAK,2BvCuhD2B;EZy9FlC;AACF;AmD5+IA;;EAGE,0BAAA;EzCkRI,gCALI;EyC3QR,wCAAA;EACA,oDAAA;EACA,oDAAA;EACA,6BAAA;EACA,6BAAA;EACA,6CAAA;EAGA,aAAA;EACA,iCAAA;EACA,gBAAA;EzCsQI,uCALI;EyC/PR,uCAAA;EtCRE,+CAAA;Abo/IJ;AmDv+IA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;EvBxBI,6CuByBJ;AnDy+IF;A4B9/IM;EuBYN;IvBXQ,gBAAA;E5BigJN;AACF;AmD3+IA;EtBAE,qMAAA;EsBEA,oEAAA;AnD6+IF;AmD1+IA;EACE,iBAAA;AnD4+IF;AmDz+IA;EACE,WAAA;AnD2+IF;AmDv+IE;EACE,kDAAA;AnDy+IJ;AmDt+IM;EAJJ;IAKM,eAAA;EnDy+IN;AACF;AoDriJA;EAEE,2CAAA;EACA,qCAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,oCAAA;EACA,sCAAA;EACA,uDAAA;EACA,4DAAA;EACA,sDAAA;EACA,yDAAA;EACA,wDAAA;EACA,yDAAA;EACA,8CAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EAGA,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;EvCXE,iDAAA;Ab8iJJ;AoD/hJA;EACE,qBAAA;EACA,sBAAA;ApDiiJF;AoD/hJE;EAEE,oCAAA;EACA,0BAAA;ApDgiJJ;AoDvhJA;EACE,WAAA;EACA,wCAAA;EACA,mBAAA;ApDyhJF;AoDthJE;EAEE,UAAA;EACA,8CAAA;EACA,qBAAA;EACA,sDAAA;ApDuhJJ;AoDphJE;EACE,+CAAA;EACA,uDAAA;ApDshJJ;AoD9gJA;EACE,kBAAA;EACA,cAAA;EACA,gFAAA;EACA,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;ApDghJF;AoD9gJE;EvCvDE,+BAAA;EACA,gCAAA;AbwkJJ;AoD9gJE;EvC7CE,mCAAA;EACA,kCAAA;Ab8jJJ;AoD9gJE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;ApD+gJJ;AoD3gJE;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;ApD6gJJ;AoDzgJE;EACE,mBAAA;ApD2gJJ;AoDzgJI;EACE,wDAAA;EACA,mDAAA;ApD2gJN;AoD9/II;EACE,mBAAA;ApDggJN;AoD7/IQ;EvCvDJ,6DAAA;EAZA,0BAAA;AbokJJ;AoD5/IQ;EvCxEJ,2DAAA;EAYA,4BAAA;Ab4jJJ;AoD3/IQ;EACE,aAAA;ApD6/IV;AoD1/IQ;EACE,mDAAA;EACA,oBAAA;ApD4/IV;AoD1/IU;EACE,yDAAA;EACA,oDAAA;ApD4/IZ;AoBllJI;EgC8DA;IACE,mBAAA;EpDuhJJ;EoDphJM;IvCvDJ,6DAAA;IAZA,0BAAA;Eb2lJF;EoDnhJM;IvCxEJ,2DAAA;IAYA,4BAAA;EbmlJF;EoDlhJM;IACE,aAAA;EpDohJR;EoDjhJM;IACE,mDAAA;IACA,oBAAA;EpDmhJR;EoDjhJQ;IACE,yDAAA;IACA,oDAAA;EpDmhJV;AACF;AoB1mJI;EgC8DA;IACE,mBAAA;EpD+iJJ;EoD5iJM;IvCvDJ,6DAAA;IAZA,0BAAA;EbmnJF;EoD3iJM;IvCxEJ,2DAAA;IAYA,4BAAA;Eb2mJF;EoD1iJM;IACE,aAAA;EpD4iJR;EoDziJM;IACE,mDAAA;IACA,oBAAA;EpD2iJR;EoDziJQ;IACE,yDAAA;IACA,oDAAA;EpD2iJV;AACF;AoBloJI;EgC8DA;IACE,mBAAA;EpDukJJ;EoDpkJM;IvCvDJ,6DAAA;IAZA,0BAAA;Eb2oJF;EoDnkJM;IvCxEJ,2DAAA;IAYA,4BAAA;EbmoJF;EoDlkJM;IACE,aAAA;EpDokJR;EoDjkJM;IACE,mDAAA;IACA,oBAAA;EpDmkJR;EoDjkJQ;IACE,yDAAA;IACA,oDAAA;EpDmkJV;AACF;AoB1pJI;EgC8DA;IACE,mBAAA;EpD+lJJ;EoD5lJM;IvCvDJ,6DAAA;IAZA,0BAAA;EbmqJF;EoD3lJM;IvCxEJ,2DAAA;IAYA,4BAAA;Eb2pJF;EoD1lJM;IACE,aAAA;EpD4lJR;EoDzlJM;IACE,mDAAA;IACA,oBAAA;EpD2lJR;EoDzlJQ;IACE,yDAAA;IACA,oDAAA;EpD2lJV;AACF;AoBlrJI;EgC8DA;IACE,mBAAA;EpDunJJ;EoDpnJM;IvCvDJ,6DAAA;IAZA,0BAAA;Eb2rJF;EoDnnJM;IvCxEJ,2DAAA;IAYA,4BAAA;EbmrJF;EoDlnJM;IACE,aAAA;EpDonJR;EoDjnJM;IACE,mDAAA;IACA,oBAAA;EpDmnJR;EoDjnJQ;IACE,yDAAA;IACA,oDAAA;EpDmnJV;AACF;AoDtmJA;EvChJI,gBAAA;AbyvJJ;AoDtmJE;EACE,mDAAA;ApDwmJJ;AoDtmJI;EACE,sBAAA;ApDwmJN;AoD3lJE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;ApD6lJJ;AoDvmJE;EACE,wDAAA;EACA,iDAAA;EACA,+DAAA;EACA,4DAAA;EACA,kEAAA;EACA,6DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;EACA,sEAAA;ApDymJJ;AoDnnJE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;ApDqnJJ;AoD/nJE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;ApDioJJ;AoD3oJE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;ApD6oJJ;AoDvpJE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,4DAAA;EACA,+DAAA;EACA,6DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;ApDypJJ;AoDnqJE;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;ApDqqJJ;AoD/qJE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;ApDirJJ;AqD72JA;EAEE,0BAAA;EACA,2DAAA;EACA,2BAAA;EACA,kCAAA;EACA,mEAAA;EACA,+BAAA;EACA,qCAAA;EACA,uEAAA;EAGA,uBAAA;EACA,UzCmpD2B;EyClpD3B,WzCkpD2B;EyCjpD3B,sBAAA;EACA,gCAAA;EACA,wEAAA;EACA,SAAA;ExCJE,uBAAA;EwCMF,oCAAA;ArD42JF;AqDz2JE;EACE,gCAAA;EACA,qBAAA;EACA,0CAAA;ArD22JJ;AqDx2JE;EACE,UAAA;EACA,4CAAA;EACA,0CAAA;ArD02JJ;AqDv2JE;EAEE,oBAAA;EACA,iBAAA;EACA,6CAAA;ArDw2JJ;AqDh2JA;EAHE,wCAAA;ArDs2JF;AqD71JI;EATF,wCAAA;ArDy2JF;AsD15JA;EAEE,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,0BAAA;EACA,2BAAA;E5CyRI,8BALI;E4ClRR,kBAAA;EACA,gDAAA;EACA,+CAAA;EACA,2DAAA;EACA,iDAAA;EACA,2CAAA;EACA,kDAAA;EACA,uDAAA;EACA,kEAAA;EAGA,gCAAA;EACA,eAAA;E5C2QI,oCALI;E4CpQR,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,sCAAA;EzCRE,4CAAA;Abk6JJ;AsDv5JE;EACE,UAAA;AtDy5JJ;AsDt5JE;EACE,aAAA;AtDw5JJ;AsDp5JA;EACE,uBAAA;EAEA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AtDq5JF;AsDn5JE;EACE,sCAAA;AtDq5JJ;AsDj5JA;EACE,aAAA;EACA,mBAAA;EACA,4DAAA;EACA,mCAAA;EACA,2CAAA;EACA,4BAAA;EACA,qFAAA;EzChCE,0FAAA;EACA,2FAAA;Abo7JJ;AsDl5JE;EACE,oDAAA;EACA,sCAAA;AtDo5JJ;AsDh5JA;EACE,kCAAA;EACA,qBAAA;AtDk5JF;AuDh9JA;EAEE,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gCAAA;EACA,2DAAA;EACA,+CAAA;EACA,oDAAA;EACA,8CAAA;EACA,2FAAA;EACA,iCAAA;EACA,iCAAA;EACA,oCAAA;EACA,sDAAA;EACA,sDAAA;EACA,iCAAA;EACA,6BAAA;EACA,sBAAA;EACA,sDAAA;EACA,sDAAA;EAGA,eAAA;EACA,MAAA;EACA,OAAA;EACA,+BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;AvD68JF;AuDt8JA;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EAEA,oBAAA;AvDu8JF;AuDp8JE;E3B5CI,mC2B6CF;EACA,8B3Cg8CgC;AZsgHpC;A4Bh/JM;E2BwCJ;I3BvCM,gBAAA;E5Bm/JN;AACF;AuDz8JE;EACE,e3C87CgC;AZ6gHpC;AuDv8JE;EACE,sB3C27CgC;AZ8gHpC;AuDr8JA;EACE,+CAAA;AvDu8JF;AuDr8JE;EACE,gBAAA;EACA,gBAAA;AvDu8JJ;AuDp8JE;EACE,gBAAA;AvDs8JJ;AuDl8JA;EACE,aAAA;EACA,mBAAA;EACA,mDAAA;AvDo8JF;AuDh8JA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;E1CrFE,4CAAA;E0CyFF,UAAA;AvD+7JF;AuD37JA;EAEE,0BAAA;EACA,sBAAA;EACA,0BAAA;EClHA,eAAA;EACA,MAAA;EACA,OAAA;EACA,kCDkH0B;ECjH1B,YAAA;EACA,aAAA;EACA,uCD+G4D;AvDg8J9D;AwD5iKE;EAAS,UAAA;AxD+iKX;AwD9iKE;EAAS,mCD2GiF;AvDs8J5F;AuDj8JA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,8BAAA;EACA,uCAAA;EACA,4FAAA;E1CtGE,2DAAA;EACA,4DAAA;Ab0iKJ;AuDl8JE;EACE,kGAAA;EACA,sJAAA;AvDo8JJ;AuD/7JA;EACE,gBAAA;EACA,8CAAA;AvDi8JF;AuD57JA;EACE,kBAAA;EAGA,cAAA;EACA,gCAAA;AvD47JF;AuDx7JA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,yEAAA;EACA,2CAAA;EACA,yFAAA;E1C1HE,+DAAA;EACA,8DAAA;AbqjKJ;AuDt7JE;EACE,8CAAA;AvDw7JJ;AoBpiKI;EmCkHF;IACE,0BAAA;IACA,2CAAA;EvDq7JF;EuDj7JA;IACE,gCAAA;IACA,kBAAA;IACA,iBAAA;EvDm7JF;EuDh7JA;IACE,uBAAA;EvDk7JF;AACF;AoBljKI;EmCoIF;;IAEE,uBAAA;EvDi7JF;AACF;AoBxjKI;EmC2IF;IACE,wBAAA;EvDg7JF;AACF;AuDv6JI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AvDy6JN;AuDv6JM;EACE,YAAA;EACA,SAAA;E1C1MJ,gBAAA;AbonKJ;AuDt6JM;;E1C9MF,gBAAA;AbwnKJ;AuDr6JM;EACE,gBAAA;AvDu6JR;AoBlkKI;EmCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EvD47JJ;EuD17JI;IACE,YAAA;IACA,SAAA;I1C1MJ,gBAAA;EbuoKF;EuDz7JI;;I1C9MF,gBAAA;Eb2oKF;EuDx7JI;IACE,gBAAA;EvD07JN;AACF;AoBtlKI;EmCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EvDg9JJ;EuD98JI;IACE,YAAA;IACA,SAAA;I1C1MJ,gBAAA;Eb2pKF;EuD78JI;;I1C9MF,gBAAA;Eb+pKF;EuD58JI;IACE,gBAAA;EvD88JN;AACF;AoB1mKI;EmCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EvDo+JJ;EuDl+JI;IACE,YAAA;IACA,SAAA;I1C1MJ,gBAAA;Eb+qKF;EuDj+JI;;I1C9MF,gBAAA;EbmrKF;EuDh+JI;IACE,gBAAA;EvDk+JN;AACF;AoB9nKI;EmCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EvDw/JJ;EuDt/JI;IACE,YAAA;IACA,SAAA;I1C1MJ,gBAAA;EbmsKF;EuDr/JI;;I1C9MF,gBAAA;EbusKF;EuDp/JI;IACE,gBAAA;EvDs/JN;AACF;AoBlpKI;EmCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EvD4gKJ;EuD1gKI;IACE,YAAA;IACA,SAAA;I1C1MJ,gBAAA;EbutKF;EuDzgKI;;I1C9MF,gBAAA;Eb2tKF;EuDxgKI;IACE,gBAAA;EvD0gKN;AACF;AIjvKA;EAEE,yBAAA;EACA,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,qBAAA;EMwRI,gCALI;ENjRR,qCAAA;EACA,yCAAA;EACA,mDAAA;EACA,yBAAA;EACA,gCAAA;EACA,iCAAA;EAGA,iCAAA;EACA,cAAA;EACA,gCAAA;EqDlBA,sC7C+lB4B;E6C7lB5B,kBAAA;EACA,gB7CwmB4B;E6CvmB5B,gB7C+mB4B;E6C9mB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;E/CgRI,sCALI;ENhQR,qBAAA;EACA,UAAA;AJyvKF;AIvvKE;EAAS,kCAAA;AJ0vKX;AIxvKE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AJ0vKJ;AIxvKI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AJ0vKN;AIrvKA;EACE,iDAAA;AJuvKF;AIrvKE;EACE,SAAA;EACA,wFAAA;EACA,sCAAA;AJuvKJ;AIlvKA;EACE,+CAAA;EACA,qCAAA;EACA,qCAAA;AJovKF;AIlvKE;EACE,WAAA;EACA,kIAAA;EACA,wCAAA;AJovKJ;AI9uKA;EACE,8CAAA;AJgvKF;AI9uKE;EACE,YAAA;EACA,wFAAA;EACA,yCAAA;AJgvKJ;AI3uKA;EACE,gDAAA;EACA,qCAAA;EACA,qCAAA;AJ6uKF;AI3uKE;EACE,UAAA;EACA,kIAAA;EACA,uCAAA;AJ6uKJ;AIvtKA;EACE,sCAAA;EACA,gEAAA;EACA,8BAAA;EACA,kBAAA;EACA,sCAAA;ESjGE,8CAAA;Ab2zKJ;AK90KA;EAEE,yBAAA;EACA,6BAAA;EK4RI,gCALI;ELrRR,kCAAA;EACA,iDAAA;EACA,6DAAA;EACA,sDAAA;EACA,2FAAA;EACA,6CAAA;EACA,mCAAA;EACA,qCAAA;EKmRI,mCALI;EL5QR,kCAAA;EACA,8CAAA;EACA,iCAAA;EACA,iCAAA;EACA,6CAAA;EACA,8BAAA;EACA,iCAAA;EACA,yDAAA;EAGA,iCAAA;EACA,cAAA;EACA,sCAAA;EoDzBA,sC7C+lB4B;E6C7lB5B,kBAAA;EACA,gB7CwmB4B;E6CvmB5B,gB7C+mB4B;E6C9mB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;E/CgRI,sCALI;EL1PR,qBAAA;EACA,sCAAA;EACA,4BAAA;EACA,2EAAA;EQhBE,8CAAA;Abw2KJ;AKp1KE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;ALs1KJ;AKp1KI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;ALq1KN;AK/0KE;EACE,oFAAA;ALi1KJ;AK/0KI;EAEE,wFAAA;ALg1KN;AK70KI;EACE,SAAA;EACA,gDAAA;AL+0KN;AK50KI;EACE,sCAAA;EACA,sCAAA;AL80KN;AKv0KE;EACE,kFAAA;EACA,qCAAA;EACA,qCAAA;ALy0KJ;AKv0KI;EAEE,kIAAA;ALw0KN;AKr0KI;EACE,OAAA;EACA,kDAAA;ALu0KN;AKp0KI;EACE,oCAAA;EACA,wCAAA;ALs0KN;AK9zKE;EACE,iFAAA;ALg0KJ;AK9zKI;EAEE,wFAAA;AL+zKN;AK5zKI;EACE,MAAA;EACA,mDAAA;AL8zKN;AK3zKI;EACE,mCAAA;EACA,yCAAA;AL6zKN;AKxzKE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,oCAAA;EACA,uDAAA;EACA,WAAA;EACA,+EAAA;AL0zKJ;AKpzKE;EACE,mFAAA;EACA,qCAAA;EACA,qCAAA;ALszKJ;AKpzKI;EAEE,kIAAA;ALqzKN;AKlzKI;EACE,QAAA;EACA,iDAAA;ALozKN;AKjzKI;EACE,qCAAA;EACA,uCAAA;ALmzKN;AK5xKA;EACE,8EAAA;EACA,gBAAA;EK2GI,6CALI;ELpGR,qCAAA;EACA,6CAAA;EACA,kFAAA;EQ5JE,6DAAA;EACA,8DAAA;Ab27KJ;AK7xKE;EACE,aAAA;AL+xKJ;AK3xKA;EACE,0EAAA;EACA,mCAAA;AL6xKF;AMl9KA;EACE,kBAAA;ANo9KF;AMj9KA;EACE,mBAAA;ANm9KF;AMh9KA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;ANk9KF;A0Dx+KE;EACE,cAAA;EACA,WAAA;EACA,WAAA;A1D0+KJ;AMn9KA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EsBlBI,sCtBmBJ;ANq9KF;A4Bp+KM;EtBQN;IsBPQ,gBAAA;E5Bu+KN;AACF;AMv9KA;;;EAGE,cAAA;ANy9KF;AMt9KA;;EAEE,2BAAA;ANw9KF;AMr9KA;;EAEE,4BAAA;ANu9KF;AM98KE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;ANg9KJ;AM78KE;;;EAGE,UAAA;EACA,UAAA;AN+8KJ;AM58KE;;EAEE,UAAA;EACA,UAAA;EsB5DE,2BtB6DF;AN88KJ;A4BvgLM;EtBqDJ;;IsBpDM,gBAAA;E5B2gLN;AACF;AM38KA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UMghDmC;EN/gDnC,UAAA;EACA,WM1FS;EN2FT,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YM2gDmC;EgBjmD/B,8BtBuFJ;AN48KF;A4B/hLM;EtBkEN;;IsBjEQ,gBAAA;E5BmiLN;AACF;AM/8KE;;;EAEE,WMpGO;ENqGP,qBAAA;EACA,UAAA;EACA,YMmgDiC;AZ+8HrC;AM/8KA;EACE,OAAA;ANi9KF;AM98KA;EACE,QAAA;ANg9KF;AM38KA;;EAEE,qBAAA;EACA,WMogDmC;ENngDnC,YMmgDmC;ENlgDnC,4BAAA;EACA,wBAAA;EACA,0BAAA;AN68KF;AMl8KA;EACE,0DAAA;ANo8KF;AMl8KA;EACE,0DAAA;ANo8KF;AM57KA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBM48CmC;EN38CnC,mBAAA;EACA,gBM08CmC;AZm/HrC;AM37KE;EACE,uBAAA;EACA,cAAA;EACA,WM08CiC;ENz8CjC,WM08CiC;ENz8CjC,UAAA;EACA,iBM08CiC;ENz8CjC,gBMy8CiC;ENx8CjC,mBAAA;EACA,eAAA;EACA,sBM1KO;EN2KP,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YMi8CiC;EgBzmD/B,6BtByKF;AN47KJ;A4BjmLM;EtBoJJ;IsBnJM,gBAAA;E5BomLN;AACF;AM97KE;EACE,UM87CiC;AZkgIrC;AMv7KA;EACE,kBAAA;EACA,UAAA;EACA,eMw7CmC;ENv7CnC,SAAA;EACA,oBMq7CmC;ENp7CnC,uBMo7CmC;ENn7CnC,WMrMS;ENsMT,kBAAA;ANy7KF;AMn7KE;;EAEE,gCMy7CiC;AZ4/HrC;AMl7KE;EACE,sBMxMO;AZ4nLX;AMj7KE;EACE,WM5MO;AZ+nLX;AM77KE;;;EAEE,gCMy7CiC;AZugIrC;AM77KE;EACE,sBMxMO;AZuoLX;AM57KE;EACE,WM5MO;AZ0oLX;A2DxpLA;;EAEE,qBAAA;EACA,8BAAA;EACA,gCAAA;EACA,gDAAA;EAEA,kBAAA;EACA,6FAAA;A3DypLF;A2DrpLA;EACE;IAAK,0CAAA;E3DwpLL;AACF;A2DrpLA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,iCAAA;EACA,mCAAA;EACA,2CAAA;EAGA,yDAAA;EACA,+BAAA;A3DopLF;A2DjpLA;EAEE,wBAAA;EACA,yBAAA;EACA,gCAAA;A3DkpLF;A2DzoLA;EACE;IACE,mBAAA;E3D2oLF;E2DzoLA;IACE,UAAA;IACA,eAAA;E3D2oLF;AACF;A2DvoLA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mCAAA;EACA,yCAAA;EAGA,8BAAA;EACA,UAAA;A3DsoLF;A2DnoLA;EACE,wBAAA;EACA,yBAAA;A3DqoLF;A2DjoLE;EACE;;IAEE,kCAAA;E3DmoLJ;AACF;A4DntLA;EAEE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;EACA,8BAAA;EACA,0CAAA;EACA,oCAAA;EACA,mDAAA;EACA,+DAAA;EACA,kDAAA;EACA,qDAAA;EACA,qCAAA;A5DotLF;AoBvpLI;EwC5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IhC5BA,0CgC8BA;E5DosLJ;AACF;A4B/tLM;EgCYJ;IhCXM,gBAAA;E5BkuLN;AACF;AoB5qLI;EwC5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E5D2sLN;E4DxsLI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E5D0sLN;E4DvsLI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E5DysLN;E4DtsLI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E5DwsLN;E4DrsLI;IAEE,eAAA;E5DssLN;E4DnsLI;IAGE,mBAAA;E5DmsLN;AACF;AoBhuLI;EwC/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E5DksLN;E4DhsLM;IACE,aAAA;E5DksLR;E4D/rLM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E5DgsLR;AACF;AoBpuLI;EwC5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IhC5BA,0CgC8BA;E5DixLJ;AACF;A4B5yLM;EgCYJ;IhCXM,gBAAA;E5B+yLN;AACF;AoBzvLI;EwC5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E5DwxLN;E4DrxLI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E5DuxLN;E4DpxLI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E5DsxLN;E4DnxLI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E5DqxLN;E4DlxLI;IAEE,eAAA;E5DmxLN;E4DhxLI;IAGE,mBAAA;E5DgxLN;AACF;AoB7yLI;EwC/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E5D+wLN;E4D7wLM;IACE,aAAA;E5D+wLR;E4D5wLM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E5D6wLR;AACF;AoBjzLI;EwC5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IhC5BA,0CgC8BA;E5D81LJ;AACF;A4Bz3LM;EgCYJ;IhCXM,gBAAA;E5B43LN;AACF;AoBt0LI;EwC5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E5Dq2LN;E4Dl2LI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E5Do2LN;E4Dj2LI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E5Dm2LN;E4Dh2LI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E5Dk2LN;E4D/1LI;IAEE,eAAA;E5Dg2LN;E4D71LI;IAGE,mBAAA;E5D61LN;AACF;AoB13LI;EwC/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E5D41LN;E4D11LM;IACE,aAAA;E5D41LR;E4Dz1LM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E5D01LR;AACF;AoB93LI;EwC5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IhC5BA,0CgC8BA;E5D26LJ;AACF;A4Bt8LM;EgCYJ;IhCXM,gBAAA;E5By8LN;AACF;AoBn5LI;EwC5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E5Dk7LN;E4D/6LI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E5Di7LN;E4D96LI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E5Dg7LN;E4D76LI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E5D+6LN;E4D56LI;IAEE,eAAA;E5D66LN;E4D16LI;IAGE,mBAAA;E5D06LN;AACF;AoBv8LI;EwC/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E5Dy6LN;E4Dv6LM;IACE,aAAA;E5Dy6LR;E4Dt6LM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E5Du6LR;AACF;AoB38LI;EwC5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IhC5BA,0CgC8BA;E5Dw/LJ;AACF;A4BnhMM;EgCYJ;IhCXM,gBAAA;E5BshMN;AACF;AoBh+LI;EwC5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E5D+/LN;E4D5/LI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E5D8/LN;E4D3/LI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E5D6/LN;E4D1/LI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E5D4/LN;E4Dz/LI;IAEE,eAAA;E5D0/LN;E4Dv/LI;IAGE,mBAAA;E5Du/LN;AACF;AoBphMI;EwC/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E5Ds/LN;E4Dp/LM;IACE,aAAA;E5Ds/LR;E4Dn/LM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E5Do/LR;AACF;A4DpkME;EAEI,eAAA;EACA,SAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,UAAA;EhC5BA,0CgC8BA;A5DokMN;A4B9lMM;EgCYJ;IhCXM,gBAAA;E5BimMN;AACF;A4DvkMM;EACE,MAAA;EACA,OAAA;EACA,gCAAA;EACA,qFAAA;EACA,4BAAA;A5DykMR;A4DtkMM;EACE,MAAA;EACA,QAAA;EACA,gCAAA;EACA,oFAAA;EACA,2BAAA;A5DwkMR;A4DrkMM;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,sFAAA;EACA,4BAAA;A5DukMR;A4DpkMM;EACE,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,mFAAA;EACA,2BAAA;A5DskMR;A4DnkMM;EAEE,eAAA;A5DokMR;A4DjkMM;EAGE,mBAAA;A5DikMR;A4DtiMA;EJpHE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a5C0mCkC;E4CzmClC,YAAA;EACA,aAAA;EACA,sB5CUS;AZmpMX;AwD1pME;EAAS,UAAA;AxD6pMX;AwD5pME;EAAS,Y5Ci+CyB;AZ8rJpC;A4DjjMA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oEAAA;A5DmjMF;A4DjjME;EACE,4FAAA;EACA,sDAAA;EACA,wDAAA;EACA,yDAAA;A5DmjMJ;A4D/iMA;EACE,gBAAA;EACA,kDAAA;A5DijMF;A4D9iMA;EACE,YAAA;EACA,oEAAA;EACA,gBAAA;A5DgjMF;A6DhsMA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,YjDgzCkC;AZk5JpC;A6DhsME;EACE,qBAAA;EACA,WAAA;A7DksMJ;A6D7rMA;EACE,iBAAA;A7D+rMF;A6D5rMA;EACE,iBAAA;A7D8rMF;A6D3rMA;EACE,iBAAA;A7D6rMF;A6DxrME;EACE,mDAAA;A7D0rMJ;A6DtrMA;EACE;IACE,YjDmxCgC;EZq6JlC;AACF;A6DrrMA;EACE,+EAAA;EACA,oBAAA;EACA,8CAAA;A7DurMF;A6DprMA;EACE;IACE,uBAAA;E7DsrMF;AACF;A0DruME;EACE,cAAA;EACA,WAAA;EACA,WAAA;A1DuuMJ;A8D1uME;EACE,sBAAA;EACA,iFAAA;A9D4uMJ;A8D9uME;EACE,sBAAA;EACA,mFAAA;A9DgvMJ;A8DlvME;EACE,sBAAA;EACA,iFAAA;A9DovMJ;A8DtvME;EACE,sBAAA;EACA,8EAAA;A9DwvMJ;A8D1vME;EACE,sBAAA;EACA,iFAAA;A9D4vMJ;A8D9vME;EACE,sBAAA;EACA,gFAAA;A9DgwMJ;A8DlwME;EACE,sBAAA;EACA,+EAAA;A9DowMJ;A8DtwME;EACE,sBAAA;EACA,8EAAA;A9DwwMJ;A+D1wME;EACE,wEAAA;EACA,kGAAA;A/D4wMJ;A+DzwMM;EAGE,+DAAA;EACA,yFAAA;A/DywMR;A+DlxME;EACE,0EAAA;EACA,oGAAA;A/DoxMJ;A+DjxMM;EAGE,gEAAA;EACA,0FAAA;A/DixMR;A+D1xME;EACE,wEAAA;EACA,kGAAA;A/D4xMJ;A+DzxMM;EAGE,8DAAA;EACA,wFAAA;A/DyxMR;A+DlyME;EACE,qEAAA;EACA,+FAAA;A/DoyMJ;A+DjyMM;EAGE,gEAAA;EACA,0FAAA;A/DiyMR;A+D1yME;EACE,wEAAA;EACA,kGAAA;A/D4yMJ;A+DzyMM;EAGE,+DAAA;EACA,yFAAA;A/DyyMR;A+DlzME;EACE,uEAAA;EACA,iGAAA;A/DozMJ;A+DjzMM;EAGE,8DAAA;EACA,wFAAA;A/DizMR;A+D1zME;EACE,sEAAA;EACA,gGAAA;A/D4zMJ;A+DzzMM;EAGE,gEAAA;EACA,0FAAA;A/DyzMR;A+Dl0ME;EACE,qEAAA;EACA,+FAAA;A/Do0MJ;A+Dj0MM;EAGE,6DAAA;EACA,uFAAA;A/Di0MR;A+D1zMA;EACE,+EAAA;EACA,yGAAA;A/D4zMF;A+DzzMI;EAEE,kFAAA;EACA,4GAAA;A/D0zMN;AgEp1MA;EACE,UAAA;EAEA,kJAAA;AhEq1MF;AiEx1MA;EACE,oBAAA;EACA,arD6c4B;EqD5c5B,mBAAA;EACA,kFAAA;EACA,6BrD2c4B;EqD1c5B,2BAAA;AjE01MF;AiEx1ME;EACE,cAAA;EACA,UrDuc0B;EqDtc1B,WrDsc0B;EqDrc1B,kBAAA;ErCIE,sCqCHF;AjE01MJ;A4Bn1MM;EqCZJ;IrCaM,gBAAA;E5Bs1MN;AACF;AiEx1MI;EACE,mEAAA;AjE01MN;AkE72MA;EACE,kBAAA;EACA,WAAA;AlE+2MF;AkE72ME;EACE,cAAA;EACA,mCAAA;EACA,WAAA;AlE+2MJ;AkE52ME;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AlE82MJ;AkEz2ME;EACE,uBAAA;AlE22MJ;AkE52ME;EACE,sBAAA;AlE82MJ;AkE/2ME;EACE,yBAAA;AlEi3MJ;AkEl3ME;EACE,iCAAA;AlEo3MJ;AmEz4MA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,avDumCkC;AZoyKpC;AmEx4MA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,avD+lCkC;AZ2yKpC;AmEl4MI;EACE,gBAAA;EACA,MAAA;EACA,avDmlC8B;AZizKpC;AmEj4MI;EACE,gBAAA;EACA,SAAA;EACA,avD6kC8B;AZszKpC;AoBp2MI;E+CxCA;IACE,gBAAA;IACA,MAAA;IACA,avDmlC8B;EZ4zKlC;EmE54ME;IACE,gBAAA;IACA,SAAA;IACA,avD6kC8B;EZi0KlC;AACF;AoBh3MI;E+CxCA;IACE,gBAAA;IACA,MAAA;IACA,avDmlC8B;EZw0KlC;EmEx5ME;IACE,gBAAA;IACA,SAAA;IACA,avD6kC8B;EZ60KlC;AACF;AoB53MI;E+CxCA;IACE,gBAAA;IACA,MAAA;IACA,avDmlC8B;EZo1KlC;EmEp6ME;IACE,gBAAA;IACA,SAAA;IACA,avD6kC8B;EZy1KlC;AACF;AoBx4MI;E+CxCA;IACE,gBAAA;IACA,MAAA;IACA,avDmlC8B;EZg2KlC;EmEh7ME;IACE,gBAAA;IACA,SAAA;IACA,avD6kC8B;EZq2KlC;AACF;AoBp5MI;E+CxCA;IACE,gBAAA;IACA,MAAA;IACA,avDmlC8B;EZ42KlC;EmE57ME;IACE,gBAAA;IACA,SAAA;IACA,avD6kC8B;EZi3KlC;AACF;AoE99MA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;ApEg+MF;AoE79MA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;ApE+9MF;AqEv+MA;;ECIE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;AtEu+MF;AsEp+ME;;EACE,6BAAA;AtEu+MJ;AuEr/ME;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,U3DgcsC;E2D/btC,WAAA;AvEu/MJ;AwE//MA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;AzEkgNF;A0ExgNA;EACE,qBAAA;EACA,mBAAA;EACA,6B9DisB4B;E8DhsB5B,eAAA;EACA,8BAAA;EACA,a9D2rB4B;AZ+0L9B;AO98MQ;EAOI,mCAAA;AP08MZ;AOj9MQ;EAOI,8BAAA;AP68MZ;AOp9MQ;EAOI,iCAAA;APg9MZ;AOv9MQ;EAOI,iCAAA;APm9MZ;AO19MQ;EAOI,sCAAA;APs9MZ;AO79MQ;EAOI,mCAAA;APy9MZ;AOh+MQ;EAOI,sBAAA;AP49MZ;AOn+MQ;EAOI,uBAAA;AP+9MZ;AOt+MQ;EAOI,sBAAA;APk+MZ;AOz+MQ;EAOI,8BAAA;APq+MZ;AO5+MQ;EAOI,4BAAA;APw+MZ;AO/+MQ;EAOI,2BAAA;AP2+MZ;AOl/MQ;EAOI,iCAAA;AP8+MZ;AOr/MQ;EAOI,2BAAA;APi/MZ;AOx/MQ;EAOI,qBAAA;APo/MZ;AO3/MQ;EAOI,wBAAA;APu/MZ;AO9/MQ;EAOI,uBAAA;AP0/MZ;AOjgNQ;EAOI,wBAAA;AP6/MZ;AOpgNQ;EAOI,qBAAA;APggNZ;AOvgNQ;EAOI,yBAAA;APmgNZ;AO1gNQ;EAOI,2BAAA;APsgNZ;AO7gNQ;EAOI,4BAAA;APygNZ;AOhhNQ;EAOI,2BAAA;AP4gNZ;AOnhNQ;EAOI,2BAAA;AP+gNZ;AOthNQ;EAOI,6BAAA;APkhNZ;AOzhNQ;EAOI,8BAAA;APqhNZ;AO5hNQ;EAOI,6BAAA;APwhNZ;AO/hNQ;EAOI,2BAAA;AP2hNZ;AOliNQ;EAOI,6BAAA;AP8hNZ;AOriNQ;EAOI,8BAAA;APiiNZ;AOxiNQ;EAOI,6BAAA;APoiNZ;AO3iNQ;EAOI,0BAAA;APuiNZ;AO9iNQ;EAOI,gCAAA;AP0iNZ;AOjjNQ;EAOI,yBAAA;AP6iNZ;AOpjNQ;EAOI,wBAAA;APgjNZ;AOvjNQ;EAOI,+BAAA;APmjNZ;AO1jNQ;EAOI,yBAAA;APsjNZ;AO7jNQ;EAOI,6BAAA;APyjNZ;AOhkNQ;EAOI,8BAAA;AP4jNZ;AOnkNQ;EAOI,wBAAA;AP+jNZ;AOtkNQ;EAOI,+BAAA;APkkNZ;AOzkNQ;EAOI,wBAAA;APqkNZ;AO5kNQ;EAOI,2CAAA;APwkNZ;AO/kNQ;EAOI,8CAAA;AP2kNZ;AOllNQ;EAOI,8CAAA;AP8kNZ;AOrlNQ;EAOI,2BAAA;APilNZ;AOlmNQ;EACE,gFAAA;APomNV;AOrmNQ;EACE,kFAAA;APumNV;AOxmNQ;EACE,gFAAA;AP0mNV;AO3mNQ;EACE,6EAAA;AP6mNV;AO9mNQ;EACE,gFAAA;APgnNV;AOjnNQ;EACE,+EAAA;APmnNV;AOpnNQ;EACE,8EAAA;APsnNV;AOvnNQ;EACE,6EAAA;APynNV;AOhnNQ;EAOI,2BAAA;AP4mNZ;AOnnNQ;EAOI,6BAAA;AP+mNZ;AOtnNQ;EAOI,6BAAA;APknNZ;AOznNQ;EAOI,0BAAA;APqnNZ;AO5nNQ;EAOI,2BAAA;APwnNZ;AO/nNQ;EAOI,iBAAA;AP2nNZ;AOloNQ;EAOI,mBAAA;AP8nNZ;AOroNQ;EAOI,oBAAA;APioNZ;AOxoNQ;EAOI,oBAAA;APooNZ;AO3oNQ;EAOI,sBAAA;APuoNZ;AO9oNQ;EAOI,uBAAA;AP0oNZ;AOjpNQ;EAOI,kBAAA;AP6oNZ;AOppNQ;EAOI,oBAAA;APgpNZ;AOvpNQ;EAOI,qBAAA;APmpNZ;AO1pNQ;EAOI,mBAAA;APspNZ;AO7pNQ;EAOI,qBAAA;APypNZ;AOhqNQ;EAOI,sBAAA;AP4pNZ;AOnqNQ;EAOI,2CAAA;AP+pNZ;AOtqNQ;EAOI,sCAAA;APkqNZ;AOzqNQ;EAOI,sCAAA;APqqNZ;AO5qNQ;EAOI,uFAAA;APwqNZ;AO/qNQ;EAOI,oBAAA;AP2qNZ;AOlrNQ;EAOI,2FAAA;AP8qNZ;AOrrNQ;EAOI,wBAAA;APirNZ;AOxrNQ;EAOI,6FAAA;APorNZ;AO3rNQ;EAOI,0BAAA;APurNZ;AO9rNQ;EAOI,8FAAA;AP0rNZ;AOjsNQ;EAOI,2BAAA;AP6rNZ;AOpsNQ;EAOI,4FAAA;APgsNZ;AOvsNQ;EAOI,yBAAA;APmsNZ;AO1sNQ;EAIQ,sBAAA;EAGJ,8EAAA;APusNZ;AO9sNQ;EAIQ,sBAAA;EAGJ,gFAAA;AP2sNZ;AOltNQ;EAIQ,sBAAA;EAGJ,8EAAA;AP+sNZ;AOttNQ;EAIQ,sBAAA;EAGJ,2EAAA;APmtNZ;AO1tNQ;EAIQ,sBAAA;EAGJ,8EAAA;APutNZ;AO9tNQ;EAIQ,sBAAA;EAGJ,6EAAA;AP2tNZ;AOluNQ;EAIQ,sBAAA;EAGJ,4EAAA;AP+tNZ;AOtuNQ;EAIQ,sBAAA;EAGJ,2EAAA;APmuNZ;AO1uNQ;EAIQ,sBAAA;EAGJ,4EAAA;APuuNZ;AO9uNQ;EAIQ,sBAAA;EAGJ,4EAAA;AP2uNZ;AOlvNQ;EAOI,wDAAA;AP8uNZ;AOrvNQ;EAOI,0DAAA;APivNZ;AOxvNQ;EAOI,wDAAA;APovNZ;AO3vNQ;EAOI,qDAAA;APuvNZ;AO9vNQ;EAOI,wDAAA;AP0vNZ;AOjwNQ;EAOI,uDAAA;AP6vNZ;AOpwNQ;EAOI,sDAAA;APgwNZ;AOvwNQ;EAOI,qDAAA;APmwNZ;AO1wNQ;EAOI,4BAAA;APswNZ;AO7wNQ;EAOI,4BAAA;APywNZ;AOhxNQ;EAOI,4BAAA;AP4wNZ;AOnxNQ;EAOI,4BAAA;AP+wNZ;AOtxNQ;EAOI,4BAAA;APkxNZ;AOnyNQ;EACE,wBAAA;APqyNV;AOtyNQ;EACE,yBAAA;APwyNV;AOzyNQ;EACE,wBAAA;AP2yNV;AO5yNQ;EACE,yBAAA;AP8yNV;AO/yNQ;EACE,sBAAA;APizNV;AOxyNQ;EAOI,qBAAA;APoyNZ;AO3yNQ;EAOI,qBAAA;APuyNZ;AO9yNQ;EAOI,qBAAA;AP0yNZ;AOjzNQ;EAOI,sBAAA;AP6yNZ;AOpzNQ;EAOI,sBAAA;APgzNZ;AOvzNQ;EAOI,0BAAA;APmzNZ;AO1zNQ;EAOI,uBAAA;APszNZ;AO7zNQ;EAOI,2BAAA;APyzNZ;AOh0NQ;EAOI,sBAAA;AP4zNZ;AOn0NQ;EAOI,sBAAA;AP+zNZ;AOt0NQ;EAOI,sBAAA;APk0NZ;AOz0NQ;EAOI,uBAAA;APq0NZ;AO50NQ;EAOI,uBAAA;APw0NZ;AO/0NQ;EAOI,2BAAA;AP20NZ;AOl1NQ;EAOI,wBAAA;AP80NZ;AOr1NQ;EAOI,4BAAA;APi1NZ;AOx1NQ;EAOI,yBAAA;APo1NZ;AO31NQ;EAOI,8BAAA;APu1NZ;AO91NQ;EAOI,iCAAA;AP01NZ;AOj2NQ;EAOI,sCAAA;AP61NZ;AOp2NQ;EAOI,yCAAA;APg2NZ;AOv2NQ;EAOI,uBAAA;APm2NZ;AO12NQ;EAOI,uBAAA;APs2NZ;AO72NQ;EAOI,yBAAA;APy2NZ;AOh3NQ;EAOI,yBAAA;AP42NZ;AOn3NQ;EAOI,0BAAA;AP+2NZ;AOt3NQ;EAOI,4BAAA;APk3NZ;AOz3NQ;EAOI,kCAAA;APq3NZ;AO53NQ;EAOI,sCAAA;APw3NZ;AO/3NQ;EAOI,oCAAA;AP23NZ;AOl4NQ;EAOI,kCAAA;AP83NZ;AOr4NQ;EAOI,yCAAA;APi4NZ;AOx4NQ;EAOI,wCAAA;APo4NZ;AO34NQ;EAOI,wCAAA;APu4NZ;AO94NQ;EAOI,kCAAA;AP04NZ;AOj5NQ;EAOI,gCAAA;AP64NZ;AOp5NQ;EAOI,8BAAA;APg5NZ;AOv5NQ;EAOI,gCAAA;APm5NZ;AO15NQ;EAOI,+BAAA;APs5NZ;AO75NQ;EAOI,oCAAA;APy5NZ;AOh6NQ;EAOI,kCAAA;AP45NZ;AOn6NQ;EAOI,gCAAA;AP+5NZ;AOt6NQ;EAOI,uCAAA;APk6NZ;AOz6NQ;EAOI,sCAAA;APq6NZ;AO56NQ;EAOI,iCAAA;APw6NZ;AO/6NQ;EAOI,2BAAA;AP26NZ;AOl7NQ;EAOI,iCAAA;AP86NZ;AOr7NQ;EAOI,+BAAA;APi7NZ;AOx7NQ;EAOI,6BAAA;APo7NZ;AO37NQ;EAOI,+BAAA;APu7NZ;AO97NQ;EAOI,8BAAA;AP07NZ;AOj8NQ;EAOI,oBAAA;AP67NZ;AOp8NQ;EAOI,mBAAA;APg8NZ;AOv8NQ;EAOI,mBAAA;APm8NZ;AO18NQ;EAOI,mBAAA;APs8NZ;AO78NQ;EAOI,mBAAA;APy8NZ;AOh9NQ;EAOI,mBAAA;AP48NZ;AOn9NQ;EAOI,mBAAA;AP+8NZ;AOt9NQ;EAOI,mBAAA;APk9NZ;AOz9NQ;EAOI,oBAAA;APq9NZ;AO59NQ;EAOI,0BAAA;APw9NZ;AO/9NQ;EAOI,yBAAA;AP29NZ;AOl+NQ;EAOI,uBAAA;AP89NZ;AOr+NQ;EAOI,yBAAA;APi+NZ;AOx+NQ;EAOI,uBAAA;APo+NZ;AO3+NQ;EAOI,uBAAA;APu+NZ;AO9+NQ;EAOI,0BAAA;EAAA,yBAAA;AP2+NZ;AOl/NQ;EAOI,gCAAA;EAAA,+BAAA;AP++NZ;AOt/NQ;EAOI,+BAAA;EAAA,8BAAA;APm/NZ;AO1/NQ;EAOI,6BAAA;EAAA,4BAAA;APu/NZ;AO9/NQ;EAOI,+BAAA;EAAA,8BAAA;AP2/NZ;AOlgOQ;EAOI,6BAAA;EAAA,4BAAA;AP+/NZ;AOtgOQ;EAOI,6BAAA;EAAA,4BAAA;APmgOZ;AO1gOQ;EAOI,wBAAA;EAAA,2BAAA;APugOZ;AO9gOQ;EAOI,8BAAA;EAAA,iCAAA;AP2gOZ;AOlhOQ;EAOI,6BAAA;EAAA,gCAAA;AP+gOZ;AOthOQ;EAOI,2BAAA;EAAA,8BAAA;APmhOZ;AO1hOQ;EAOI,6BAAA;EAAA,gCAAA;APuhOZ;AO9hOQ;EAOI,2BAAA;EAAA,8BAAA;AP2hOZ;AOliOQ;EAOI,2BAAA;EAAA,8BAAA;AP+hOZ;AOtiOQ;EAOI,wBAAA;APkiOZ;AOziOQ;EAOI,8BAAA;APqiOZ;AO5iOQ;EAOI,6BAAA;APwiOZ;AO/iOQ;EAOI,2BAAA;AP2iOZ;AOljOQ;EAOI,6BAAA;AP8iOZ;AOrjOQ;EAOI,2BAAA;APijOZ;AOxjOQ;EAOI,2BAAA;APojOZ;AO3jOQ;EAOI,0BAAA;APujOZ;AO9jOQ;EAOI,gCAAA;AP0jOZ;AOjkOQ;EAOI,+BAAA;AP6jOZ;AOpkOQ;EAOI,6BAAA;APgkOZ;AOvkOQ;EAOI,+BAAA;APmkOZ;AO1kOQ;EAOI,6BAAA;APskOZ;AO7kOQ;EAOI,6BAAA;APykOZ;AOhlOQ;EAOI,2BAAA;AP4kOZ;AOnlOQ;EAOI,iCAAA;AP+kOZ;AOtlOQ;EAOI,gCAAA;APklOZ;AOzlOQ;EAOI,8BAAA;APqlOZ;AO5lOQ;EAOI,gCAAA;APwlOZ;AO/lOQ;EAOI,8BAAA;AP2lOZ;AOlmOQ;EAOI,8BAAA;AP8lOZ;AOrmOQ;EAOI,yBAAA;APimOZ;AOxmOQ;EAOI,+BAAA;APomOZ;AO3mOQ;EAOI,8BAAA;APumOZ;AO9mOQ;EAOI,4BAAA;AP0mOZ;AOjnOQ;EAOI,8BAAA;AP6mOZ;AOpnOQ;EAOI,4BAAA;APgnOZ;AOvnOQ;EAOI,4BAAA;APmnOZ;AO1nOQ;EAOI,qBAAA;APsnOZ;AO7nOQ;EAOI,2BAAA;APynOZ;AOhoOQ;EAOI,0BAAA;AP4nOZ;AOnoOQ;EAOI,wBAAA;AP+nOZ;AOtoOQ;EAOI,0BAAA;APkoOZ;AOzoOQ;EAOI,wBAAA;APqoOZ;AO5oOQ;EAOI,2BAAA;EAAA,0BAAA;APyoOZ;AOhpOQ;EAOI,iCAAA;EAAA,gCAAA;AP6oOZ;AOppOQ;EAOI,gCAAA;EAAA,+BAAA;APipOZ;AOxpOQ;EAOI,8BAAA;EAAA,6BAAA;APqpOZ;AO5pOQ;EAOI,gCAAA;EAAA,+BAAA;APypOZ;AOhqOQ;EAOI,8BAAA;EAAA,6BAAA;AP6pOZ;AOpqOQ;EAOI,yBAAA;EAAA,4BAAA;APiqOZ;AOxqOQ;EAOI,+BAAA;EAAA,kCAAA;APqqOZ;AO5qOQ;EAOI,8BAAA;EAAA,iCAAA;APyqOZ;AOhrOQ;EAOI,4BAAA;EAAA,+BAAA;AP6qOZ;AOprOQ;EAOI,8BAAA;EAAA,iCAAA;APirOZ;AOxrOQ;EAOI,4BAAA;EAAA,+BAAA;APqrOZ;AO5rOQ;EAOI,yBAAA;APwrOZ;AO/rOQ;EAOI,+BAAA;AP2rOZ;AOlsOQ;EAOI,8BAAA;AP8rOZ;AOrsOQ;EAOI,4BAAA;APisOZ;AOxsOQ;EAOI,8BAAA;APosOZ;AO3sOQ;EAOI,4BAAA;APusOZ;AO9sOQ;EAOI,2BAAA;AP0sOZ;AOjtOQ;EAOI,iCAAA;AP6sOZ;AOptOQ;EAOI,gCAAA;APgtOZ;AOvtOQ;EAOI,8BAAA;APmtOZ;AO1tOQ;EAOI,gCAAA;APstOZ;AO7tOQ;EAOI,8BAAA;APytOZ;AOhuOQ;EAOI,4BAAA;AP4tOZ;AOnuOQ;EAOI,kCAAA;AP+tOZ;AOtuOQ;EAOI,iCAAA;APkuOZ;AOzuOQ;EAOI,+BAAA;APquOZ;AO5uOQ;EAOI,iCAAA;APwuOZ;AO/uOQ;EAOI,+BAAA;AP2uOZ;AOlvOQ;EAOI,0BAAA;AP8uOZ;AOrvOQ;EAOI,gCAAA;APivOZ;AOxvOQ;EAOI,+BAAA;APovOZ;AO3vOQ;EAOI,6BAAA;APuvOZ;AO9vOQ;EAOI,+BAAA;AP0vOZ;AOjwOQ;EAOI,6BAAA;AP6vOZ;AOpwOQ;EAOI,iBAAA;APgwOZ;AOvwOQ;EAOI,uBAAA;APmwOZ;AO1wOQ;EAOI,sBAAA;APswOZ;AO7wOQ;EAOI,oBAAA;APywOZ;AOhxOQ;EAOI,sBAAA;AP4wOZ;AOnxOQ;EAOI,oBAAA;AP+wOZ;AOtxOQ;EAOI,qBAAA;APkxOZ;AOzxOQ;EAOI,2BAAA;APqxOZ;AO5xOQ;EAOI,0BAAA;APwxOZ;AO/xOQ;EAOI,wBAAA;AP2xOZ;AOlyOQ;EAOI,0BAAA;AP8xOZ;AOryOQ;EAOI,wBAAA;APiyOZ;AOxyOQ;EAOI,wBAAA;APoyOZ;AO3yOQ;EAOI,8BAAA;APuyOZ;AO9yOQ;EAOI,6BAAA;AP0yOZ;AOjzOQ;EAOI,2BAAA;AP6yOZ;AOpzOQ;EAOI,6BAAA;APgzOZ;AOvzOQ;EAOI,2BAAA;APmzOZ;AO1zOQ;EAOI,gDAAA;APszOZ;AO7zOQ;EAOI,4CAAA;APyzOZ;AOh0OQ;EAOI,4CAAA;AP4zOZ;AOn0OQ;EAOI,0CAAA;AP+zOZ;AOt0OQ;EAOI,4CAAA;APk0OZ;AOz0OQ;EAOI,6BAAA;APq0OZ;AO50OQ;EAOI,0BAAA;APw0OZ;AO/0OQ;EAOI,6BAAA;AP20OZ;AOl1OQ;EAOI,6BAAA;AP80OZ;AOr1OQ;EAOI,+BAAA;APi1OZ;AOx1OQ;EAOI,2BAAA;APo1OZ;AO31OQ;EAOI,2BAAA;APu1OZ;AO91OQ;EAOI,2BAAA;AP01OZ;AOj2OQ;EAOI,2BAAA;AP61OZ;AOp2OQ;EAOI,2BAAA;APg2OZ;AOv2OQ;EAOI,8BAAA;APm2OZ;AO12OQ;EAOI,yBAAA;APs2OZ;AO72OQ;EAOI,4BAAA;APy2OZ;AOh3OQ;EAOI,2BAAA;AP42OZ;AOn3OQ;EAOI,yBAAA;AP+2OZ;AOt3OQ;EAOI,2BAAA;APk3OZ;AOz3OQ;EAOI,4BAAA;APq3OZ;AO53OQ;EAOI,6BAAA;APw3OZ;AO/3OQ;EAOI,gCAAA;AP23OZ;AOl4OQ;EAOI,qCAAA;AP83OZ;AOr4OQ;EAOI,wCAAA;APi4OZ;AOx4OQ;EAOI,oCAAA;APo4OZ;AO34OQ;EAOI,oCAAA;APu4OZ;AO94OQ;EAOI,qCAAA;AP04OZ;AOj5OQ;EAOI,8BAAA;AP64OZ;AOp5OQ;EAOI,8BAAA;APg5OZ;AOv5OQ;EAOI,gCAAA;EAAA,iCAAA;APo5OZ;AO35OQ;EAIQ,oBAAA;EAGJ,qEAAA;APw5OZ;AO/5OQ;EAIQ,oBAAA;EAGJ,uEAAA;AP45OZ;AOn6OQ;EAIQ,oBAAA;EAGJ,qEAAA;APg6OZ;AOv6OQ;EAIQ,oBAAA;EAGJ,kEAAA;APo6OZ;AO36OQ;EAIQ,oBAAA;EAGJ,qEAAA;APw6OZ;AO/6OQ;EAIQ,oBAAA;EAGJ,oEAAA;AP46OZ;AOn7OQ;EAIQ,oBAAA;EAGJ,mEAAA;APg7OZ;AOv7OQ;EAIQ,oBAAA;EAGJ,kEAAA;APo7OZ;AO37OQ;EAIQ,oBAAA;EAGJ,mEAAA;APw7OZ;AO/7OQ;EAIQ,oBAAA;EAGJ,mEAAA;AP47OZ;AOn8OQ;EAIQ,oBAAA;EAGJ,wEAAA;APg8OZ;AOv8OQ;EAIQ,oBAAA;EAGJ,2CAAA;APo8OZ;AO38OQ;EAIQ,oBAAA;EAGJ,oCAAA;APw8OZ;AO/8OQ;EAIQ,oBAAA;EAGJ,0CAAA;AP48OZ;AOn9OQ;EAIQ,oBAAA;EAGJ,2CAAA;APg9OZ;AOv9OQ;EAIQ,oBAAA;EAGJ,0CAAA;APo9OZ;AO39OQ;EAIQ,oBAAA;EAGJ,0CAAA;APw9OZ;AO/9OQ;EAIQ,oBAAA;EAGJ,yBAAA;AP49OZ;AO7+OQ;EACE,uBAAA;AP++OV;AOh/OQ;EACE,sBAAA;APk/OV;AOn/OQ;EACE,uBAAA;APq/OV;AOt/OQ;EACE,oBAAA;APw/OV;AO/+OQ;EAOI,iDAAA;AP2+OZ;AOl/OQ;EAOI,mDAAA;AP8+OZ;AOr/OQ;EAOI,iDAAA;APi/OZ;AOx/OQ;EAOI,8CAAA;APo/OZ;AO3/OQ;EAOI,iDAAA;APu/OZ;AO9/OQ;EAOI,gDAAA;AP0/OZ;AOjgPQ;EAOI,+CAAA;AP6/OZ;AOpgPQ;EAOI,8CAAA;APggPZ;AOjhPQ;EACE,sBAAA;APmhPV;AO/gPU;EACE,sBAAA;APihPZ;AOvhPQ;EACE,uBAAA;APyhPV;AOrhPU;EACE,uBAAA;APuhPZ;AO7hPQ;EACE,sBAAA;AP+hPV;AO3hPU;EACE,sBAAA;AP6hPZ;AOniPQ;EACE,uBAAA;APqiPV;AOjiPU;EACE,uBAAA;APmiPZ;AOziPQ;EACE,oBAAA;AP2iPV;AOviPU;EACE,oBAAA;APyiPZ;AOriPQ;EAOI,yCAAA;APiiPZ;AO5hPU;EAOI,yCAAA;APwhPd;AO3iPQ;EAOI,wCAAA;APuiPZ;AOliPU;EAOI,wCAAA;AP8hPd;AOjjPQ;EAOI,yCAAA;AP6iPZ;AOxiPU;EAOI,yCAAA;APoiPd;AOvjPQ;EAIQ,8BAAA;EAGJ,+FAAA;APojPZ;AO3jPQ;EAIQ,8BAAA;EAGJ,iGAAA;APwjPZ;AO/jPQ;EAIQ,8BAAA;EAGJ,+FAAA;AP4jPZ;AOnkPQ;EAIQ,8BAAA;EAGJ,4FAAA;APgkPZ;AOvkPQ;EAIQ,8BAAA;EAGJ,+FAAA;APokPZ;AO3kPQ;EAIQ,8BAAA;EAGJ,8FAAA;APwkPZ;AO/kPQ;EAIQ,8BAAA;EAGJ,6FAAA;AP4kPZ;AOnlPQ;EAIQ,8BAAA;EAGJ,4FAAA;APglPZ;AOvlPQ;EAIQ,8BAAA;EAGJ,qGAAA;APolPZ;AOrmPQ;EACE,8BAAA;APumPV;AOnmPU;EACE,8BAAA;APqmPZ;AO3mPQ;EACE,gCAAA;AP6mPV;AOzmPU;EACE,gCAAA;AP2mPZ;AOjnPQ;EACE,iCAAA;APmnPV;AO/mPU;EACE,iCAAA;APinPZ;AOvnPQ;EACE,gCAAA;APynPV;AOrnPU;EACE,gCAAA;APunPZ;AO7nPQ;EACE,iCAAA;AP+nPV;AO3nPU;EACE,iCAAA;AP6nPZ;AOnoPQ;EACE,8BAAA;APqoPV;AOjoPU;EACE,8BAAA;APmoPZ;AO/nPQ;EAIQ,kBAAA;EAGJ,8EAAA;AP4nPZ;AOnoPQ;EAIQ,kBAAA;EAGJ,gFAAA;APgoPZ;AOvoPQ;EAIQ,kBAAA;EAGJ,8EAAA;APooPZ;AO3oPQ;EAIQ,kBAAA;EAGJ,2EAAA;APwoPZ;AO/oPQ;EAIQ,kBAAA;EAGJ,8EAAA;AP4oPZ;AOnpPQ;EAIQ,kBAAA;EAGJ,6EAAA;APgpPZ;AOvpPQ;EAIQ,kBAAA;EAGJ,4EAAA;APopPZ;AO3pPQ;EAIQ,kBAAA;EAGJ,2EAAA;APwpPZ;AO/pPQ;EAIQ,kBAAA;EAGJ,4EAAA;AP4pPZ;AOnqPQ;EAIQ,kBAAA;EAGJ,4EAAA;APgqPZ;AOvqPQ;EAIQ,kBAAA;EAGJ,8EAAA;APoqPZ;AO3qPQ;EAIQ,kBAAA;EAGJ,wCAAA;APwqPZ;AO/qPQ;EAIQ,kBAAA;EAGJ,mFAAA;AP4qPZ;AOnrPQ;EAIQ,kBAAA;EAGJ,kFAAA;APgrPZ;AOjsPQ;EACE,oBAAA;APmsPV;AOpsPQ;EACE,qBAAA;APssPV;AOvsPQ;EACE,oBAAA;APysPV;AO1sPQ;EACE,qBAAA;AP4sPV;AO7sPQ;EACE,kBAAA;AP+sPV;AOtsPQ;EAOI,wDAAA;APksPZ;AOzsPQ;EAOI,0DAAA;APqsPZ;AO5sPQ;EAOI,wDAAA;APwsPZ;AO/sPQ;EAOI,qDAAA;AP2sPZ;AOltPQ;EAOI,wDAAA;AP8sPZ;AOrtPQ;EAOI,uDAAA;APitPZ;AOxtPQ;EAOI,sDAAA;APotPZ;AO3tPQ;EAOI,qDAAA;APutPZ;AO9tPQ;EAOI,+CAAA;AP0tPZ;AOjuPQ;EAOI,2BAAA;AP6tPZ;AOpuPQ;EAOI,4BAAA;APguPZ;AOvuPQ;EAOI,4BAAA;APmuPZ;AO1uPQ;EAOI,+BAAA;APsuPZ;AO7uPQ;EAOI,+BAAA;APyuPZ;AOhvPQ;EAOI,iDAAA;AP4uPZ;AOnvPQ;EAOI,2BAAA;AP+uPZ;AOtvPQ;EAOI,oDAAA;APkvPZ;AOzvPQ;EAOI,iDAAA;APqvPZ;AO5vPQ;EAOI,oDAAA;APwvPZ;AO/vPQ;EAOI,oDAAA;AP2vPZ;AOlwPQ;EAOI,qDAAA;AP8vPZ;AOrwPQ;EAOI,6BAAA;APiwPZ;AOxwPQ;EAOI,sDAAA;APowPZ;AO3wPQ;EAOI,0DAAA;EAAA,2DAAA;APwwPZ;AO/wPQ;EAOI,oCAAA;EAAA,qCAAA;AP4wPZ;AOnxPQ;EAOI,6DAAA;EAAA,8DAAA;APgxPZ;AOvxPQ;EAOI,0DAAA;EAAA,2DAAA;APoxPZ;AO3xPQ;EAOI,6DAAA;EAAA,8DAAA;APwxPZ;AO/xPQ;EAOI,6DAAA;EAAA,8DAAA;AP4xPZ;AOnyPQ;EAOI,8DAAA;EAAA,+DAAA;APgyPZ;AOvyPQ;EAOI,sCAAA;EAAA,uCAAA;APoyPZ;AO3yPQ;EAOI,+DAAA;EAAA,gEAAA;APwyPZ;AO/yPQ;EAOI,2DAAA;EAAA,8DAAA;AP4yPZ;AOnzPQ;EAOI,qCAAA;EAAA,wCAAA;APgzPZ;AOvzPQ;EAOI,8DAAA;EAAA,iEAAA;APozPZ;AO3zPQ;EAOI,2DAAA;EAAA,8DAAA;APwzPZ;AO/zPQ;EAOI,8DAAA;EAAA,iEAAA;AP4zPZ;AOn0PQ;EAOI,8DAAA;EAAA,iEAAA;APg0PZ;AOv0PQ;EAOI,+DAAA;EAAA,kEAAA;APo0PZ;AO30PQ;EAOI,uCAAA;EAAA,0CAAA;APw0PZ;AO/0PQ;EAOI,gEAAA;EAAA,mEAAA;AP40PZ;AOn1PQ;EAOI,8DAAA;EAAA,6DAAA;APg1PZ;AOv1PQ;EAOI,wCAAA;EAAA,uCAAA;APo1PZ;AO31PQ;EAOI,iEAAA;EAAA,gEAAA;APw1PZ;AO/1PQ;EAOI,8DAAA;EAAA,6DAAA;AP41PZ;AOn2PQ;EAOI,iEAAA;EAAA,gEAAA;APg2PZ;AOv2PQ;EAOI,iEAAA;EAAA,gEAAA;APo2PZ;AO32PQ;EAOI,kEAAA;EAAA,iEAAA;APw2PZ;AO/2PQ;EAOI,0CAAA;EAAA,yCAAA;AP42PZ;AOn3PQ;EAOI,mEAAA;EAAA,kEAAA;APg3PZ;AOv3PQ;EAOI,6DAAA;EAAA,0DAAA;APo3PZ;AO33PQ;EAOI,uCAAA;EAAA,oCAAA;APw3PZ;AO/3PQ;EAOI,gEAAA;EAAA,6DAAA;AP43PZ;AOn4PQ;EAOI,6DAAA;EAAA,0DAAA;APg4PZ;AOv4PQ;EAOI,gEAAA;EAAA,6DAAA;APo4PZ;AO34PQ;EAOI,gEAAA;EAAA,6DAAA;APw4PZ;AO/4PQ;EAOI,iEAAA;EAAA,8DAAA;AP44PZ;AOn5PQ;EAOI,yCAAA;EAAA,sCAAA;APg5PZ;AOv5PQ;EAOI,kEAAA;EAAA,+DAAA;APo5PZ;AO35PQ;EAOI,8BAAA;APu5PZ;AO95PQ;EAOI,6BAAA;AP05PZ;AOj6PQ;EAOI,sBAAA;AP65PZ;AOp6PQ;EAOI,qBAAA;APg6PZ;AOv6PQ;EAOI,qBAAA;APm6PZ;AO16PQ;EAOI,qBAAA;APs6PZ;AO76PQ;EAOI,qBAAA;APy6PZ;AoBn7PI;EbGI;IAOI,sBAAA;EP66PV;EOp7PM;IAOI,uBAAA;EPg7PV;EOv7PM;IAOI,sBAAA;EPm7PV;EO17PM;IAOI,8BAAA;EPs7PV;EO77PM;IAOI,4BAAA;EPy7PV;EOh8PM;IAOI,2BAAA;EP47PV;EOn8PM;IAOI,iCAAA;EP+7PV;EOt8PM;IAOI,2BAAA;EPk8PV;EOz8PM;IAOI,0BAAA;EPq8PV;EO58PM;IAOI,gCAAA;EPw8PV;EO/8PM;IAOI,yBAAA;EP28PV;EOl9PM;IAOI,wBAAA;EP88PV;EOr9PM;IAOI,+BAAA;EPi9PV;EOx9PM;IAOI,yBAAA;EPo9PV;EO39PM;IAOI,6BAAA;EPu9PV;EO99PM;IAOI,8BAAA;EP09PV;EOj+PM;IAOI,wBAAA;EP69PV;EOp+PM;IAOI,+BAAA;EPg+PV;EOv+PM;IAOI,wBAAA;EPm+PV;EO1+PM;IAOI,yBAAA;EPs+PV;EO7+PM;IAOI,8BAAA;EPy+PV;EOh/PM;IAOI,iCAAA;EP4+PV;EOn/PM;IAOI,sCAAA;EP++PV;EOt/PM;IAOI,yCAAA;EPk/PV;EOz/PM;IAOI,uBAAA;EPq/PV;EO5/PM;IAOI,uBAAA;EPw/PV;EO//PM;IAOI,yBAAA;EP2/PV;EOlgQM;IAOI,yBAAA;EP8/PV;EOrgQM;IAOI,0BAAA;EPigQV;EOxgQM;IAOI,4BAAA;EPogQV;EO3gQM;IAOI,kCAAA;EPugQV;EO9gQM;IAOI,sCAAA;EP0gQV;EOjhQM;IAOI,oCAAA;EP6gQV;EOphQM;IAOI,kCAAA;EPghQV;EOvhQM;IAOI,yCAAA;EPmhQV;EO1hQM;IAOI,wCAAA;EPshQV;EO7hQM;IAOI,wCAAA;EPyhQV;EOhiQM;IAOI,kCAAA;EP4hQV;EOniQM;IAOI,gCAAA;EP+hQV;EOtiQM;IAOI,8BAAA;EPkiQV;EOziQM;IAOI,gCAAA;EPqiQV;EO5iQM;IAOI,+BAAA;EPwiQV;EO/iQM;IAOI,oCAAA;EP2iQV;EOljQM;IAOI,kCAAA;EP8iQV;EOrjQM;IAOI,gCAAA;EPijQV;EOxjQM;IAOI,uCAAA;EPojQV;EO3jQM;IAOI,sCAAA;EPujQV;EO9jQM;IAOI,iCAAA;EP0jQV;EOjkQM;IAOI,2BAAA;EP6jQV;EOpkQM;IAOI,iCAAA;EPgkQV;EOvkQM;IAOI,+BAAA;EPmkQV;EO1kQM;IAOI,6BAAA;EPskQV;EO7kQM;IAOI,+BAAA;EPykQV;EOhlQM;IAOI,8BAAA;EP4kQV;EOnlQM;IAOI,oBAAA;EP+kQV;EOtlQM;IAOI,mBAAA;EPklQV;EOzlQM;IAOI,mBAAA;EPqlQV;EO5lQM;IAOI,mBAAA;EPwlQV;EO/lQM;IAOI,mBAAA;EP2lQV;EOlmQM;IAOI,mBAAA;EP8lQV;EOrmQM;IAOI,mBAAA;EPimQV;EOxmQM;IAOI,mBAAA;EPomQV;EO3mQM;IAOI,oBAAA;EPumQV;EO9mQM;IAOI,0BAAA;EP0mQV;EOjnQM;IAOI,yBAAA;EP6mQV;EOpnQM;IAOI,uBAAA;EPgnQV;EOvnQM;IAOI,yBAAA;EPmnQV;EO1nQM;IAOI,uBAAA;EPsnQV;EO7nQM;IAOI,uBAAA;EPynQV;EOhoQM;IAOI,0BAAA;IAAA,yBAAA;EP6nQV;EOpoQM;IAOI,gCAAA;IAAA,+BAAA;EPioQV;EOxoQM;IAOI,+BAAA;IAAA,8BAAA;EPqoQV;EO5oQM;IAOI,6BAAA;IAAA,4BAAA;EPyoQV;EOhpQM;IAOI,+BAAA;IAAA,8BAAA;EP6oQV;EOppQM;IAOI,6BAAA;IAAA,4BAAA;EPipQV;EOxpQM;IAOI,6BAAA;IAAA,4BAAA;EPqpQV;EO5pQM;IAOI,wBAAA;IAAA,2BAAA;EPypQV;EOhqQM;IAOI,8BAAA;IAAA,iCAAA;EP6pQV;EOpqQM;IAOI,6BAAA;IAAA,gCAAA;EPiqQV;EOxqQM;IAOI,2BAAA;IAAA,8BAAA;EPqqQV;EO5qQM;IAOI,6BAAA;IAAA,gCAAA;EPyqQV;EOhrQM;IAOI,2BAAA;IAAA,8BAAA;EP6qQV;EOprQM;IAOI,2BAAA;IAAA,8BAAA;EPirQV;EOxrQM;IAOI,wBAAA;EPorQV;EO3rQM;IAOI,8BAAA;EPurQV;EO9rQM;IAOI,6BAAA;EP0rQV;EOjsQM;IAOI,2BAAA;EP6rQV;EOpsQM;IAOI,6BAAA;EPgsQV;EOvsQM;IAOI,2BAAA;EPmsQV;EO1sQM;IAOI,2BAAA;EPssQV;EO7sQM;IAOI,0BAAA;EPysQV;EOhtQM;IAOI,gCAAA;EP4sQV;EOntQM;IAOI,+BAAA;EP+sQV;EOttQM;IAOI,6BAAA;EPktQV;EOztQM;IAOI,+BAAA;EPqtQV;EO5tQM;IAOI,6BAAA;EPwtQV;EO/tQM;IAOI,6BAAA;EP2tQV;EOluQM;IAOI,2BAAA;EP8tQV;EOruQM;IAOI,iCAAA;EPiuQV;EOxuQM;IAOI,gCAAA;EPouQV;EO3uQM;IAOI,8BAAA;EPuuQV;EO9uQM;IAOI,gCAAA;EP0uQV;EOjvQM;IAOI,8BAAA;EP6uQV;EOpvQM;IAOI,8BAAA;EPgvQV;EOvvQM;IAOI,yBAAA;EPmvQV;EO1vQM;IAOI,+BAAA;EPsvQV;EO7vQM;IAOI,8BAAA;EPyvQV;EOhwQM;IAOI,4BAAA;EP4vQV;EOnwQM;IAOI,8BAAA;EP+vQV;EOtwQM;IAOI,4BAAA;EPkwQV;EOzwQM;IAOI,4BAAA;EPqwQV;EO5wQM;IAOI,qBAAA;EPwwQV;EO/wQM;IAOI,2BAAA;EP2wQV;EOlxQM;IAOI,0BAAA;EP8wQV;EOrxQM;IAOI,wBAAA;EPixQV;EOxxQM;IAOI,0BAAA;EPoxQV;EO3xQM;IAOI,wBAAA;EPuxQV;EO9xQM;IAOI,2BAAA;IAAA,0BAAA;EP2xQV;EOlyQM;IAOI,iCAAA;IAAA,gCAAA;EP+xQV;EOtyQM;IAOI,gCAAA;IAAA,+BAAA;EPmyQV;EO1yQM;IAOI,8BAAA;IAAA,6BAAA;EPuyQV;EO9yQM;IAOI,gCAAA;IAAA,+BAAA;EP2yQV;EOlzQM;IAOI,8BAAA;IAAA,6BAAA;EP+yQV;EOtzQM;IAOI,yBAAA;IAAA,4BAAA;EPmzQV;EO1zQM;IAOI,+BAAA;IAAA,kCAAA;EPuzQV;EO9zQM;IAOI,8BAAA;IAAA,iCAAA;EP2zQV;EOl0QM;IAOI,4BAAA;IAAA,+BAAA;EP+zQV;EOt0QM;IAOI,8BAAA;IAAA,iCAAA;EPm0QV;EO10QM;IAOI,4BAAA;IAAA,+BAAA;EPu0QV;EO90QM;IAOI,yBAAA;EP00QV;EOj1QM;IAOI,+BAAA;EP60QV;EOp1QM;IAOI,8BAAA;EPg1QV;EOv1QM;IAOI,4BAAA;EPm1QV;EO11QM;IAOI,8BAAA;EPs1QV;EO71QM;IAOI,4BAAA;EPy1QV;EOh2QM;IAOI,2BAAA;EP41QV;EOn2QM;IAOI,iCAAA;EP+1QV;EOt2QM;IAOI,gCAAA;EPk2QV;EOz2QM;IAOI,8BAAA;EPq2QV;EO52QM;IAOI,gCAAA;EPw2QV;EO/2QM;IAOI,8BAAA;EP22QV;EOl3QM;IAOI,4BAAA;EP82QV;EOr3QM;IAOI,kCAAA;EPi3QV;EOx3QM;IAOI,iCAAA;EPo3QV;EO33QM;IAOI,+BAAA;EPu3QV;EO93QM;IAOI,iCAAA;EP03QV;EOj4QM;IAOI,+BAAA;EP63QV;EOp4QM;IAOI,0BAAA;EPg4QV;EOv4QM;IAOI,gCAAA;EPm4QV;EO14QM;IAOI,+BAAA;EPs4QV;EO74QM;IAOI,6BAAA;EPy4QV;EOh5QM;IAOI,+BAAA;EP44QV;EOn5QM;IAOI,6BAAA;EP+4QV;EOt5QM;IAOI,iBAAA;EPk5QV;EOz5QM;IAOI,uBAAA;EPq5QV;EO55QM;IAOI,sBAAA;EPw5QV;EO/5QM;IAOI,oBAAA;EP25QV;EOl6QM;IAOI,sBAAA;EP85QV;EOr6QM;IAOI,oBAAA;EPi6QV;EOx6QM;IAOI,qBAAA;EPo6QV;EO36QM;IAOI,2BAAA;EPu6QV;EO96QM;IAOI,0BAAA;EP06QV;EOj7QM;IAOI,wBAAA;EP66QV;EOp7QM;IAOI,0BAAA;EPg7QV;EOv7QM;IAOI,wBAAA;EPm7QV;EO17QM;IAOI,wBAAA;EPs7QV;EO77QM;IAOI,8BAAA;EPy7QV;EOh8QM;IAOI,6BAAA;EP47QV;EOn8QM;IAOI,2BAAA;EP+7QV;EOt8QM;IAOI,6BAAA;EPk8QV;EOz8QM;IAOI,2BAAA;EPq8QV;EO58QM;IAOI,2BAAA;EPw8QV;EO/8QM;IAOI,4BAAA;EP28QV;EOl9QM;IAOI,6BAAA;EP88QV;AACF;AoBz9QI;EbGI;IAOI,sBAAA;EPm9QV;EO19QM;IAOI,uBAAA;EPs9QV;EO79QM;IAOI,sBAAA;EPy9QV;EOh+QM;IAOI,8BAAA;EP49QV;EOn+QM;IAOI,4BAAA;EP+9QV;EOt+QM;IAOI,2BAAA;EPk+QV;EOz+QM;IAOI,iCAAA;EPq+QV;EO5+QM;IAOI,2BAAA;EPw+QV;EO/+QM;IAOI,0BAAA;EP2+QV;EOl/QM;IAOI,gCAAA;EP8+QV;EOr/QM;IAOI,yBAAA;EPi/QV;EOx/QM;IAOI,wBAAA;EPo/QV;EO3/QM;IAOI,+BAAA;EPu/QV;EO9/QM;IAOI,yBAAA;EP0/QV;EOjgRM;IAOI,6BAAA;EP6/QV;EOpgRM;IAOI,8BAAA;EPggRV;EOvgRM;IAOI,wBAAA;EPmgRV;EO1gRM;IAOI,+BAAA;EPsgRV;EO7gRM;IAOI,wBAAA;EPygRV;EOhhRM;IAOI,yBAAA;EP4gRV;EOnhRM;IAOI,8BAAA;EP+gRV;EOthRM;IAOI,iCAAA;EPkhRV;EOzhRM;IAOI,sCAAA;EPqhRV;EO5hRM;IAOI,yCAAA;EPwhRV;EO/hRM;IAOI,uBAAA;EP2hRV;EOliRM;IAOI,uBAAA;EP8hRV;EOriRM;IAOI,yBAAA;EPiiRV;EOxiRM;IAOI,yBAAA;EPoiRV;EO3iRM;IAOI,0BAAA;EPuiRV;EO9iRM;IAOI,4BAAA;EP0iRV;EOjjRM;IAOI,kCAAA;EP6iRV;EOpjRM;IAOI,sCAAA;EPgjRV;EOvjRM;IAOI,oCAAA;EPmjRV;EO1jRM;IAOI,kCAAA;EPsjRV;EO7jRM;IAOI,yCAAA;EPyjRV;EOhkRM;IAOI,wCAAA;EP4jRV;EOnkRM;IAOI,wCAAA;EP+jRV;EOtkRM;IAOI,kCAAA;EPkkRV;EOzkRM;IAOI,gCAAA;EPqkRV;EO5kRM;IAOI,8BAAA;EPwkRV;EO/kRM;IAOI,gCAAA;EP2kRV;EOllRM;IAOI,+BAAA;EP8kRV;EOrlRM;IAOI,oCAAA;EPilRV;EOxlRM;IAOI,kCAAA;EPolRV;EO3lRM;IAOI,gCAAA;EPulRV;EO9lRM;IAOI,uCAAA;EP0lRV;EOjmRM;IAOI,sCAAA;EP6lRV;EOpmRM;IAOI,iCAAA;EPgmRV;EOvmRM;IAOI,2BAAA;EPmmRV;EO1mRM;IAOI,iCAAA;EPsmRV;EO7mRM;IAOI,+BAAA;EPymRV;EOhnRM;IAOI,6BAAA;EP4mRV;EOnnRM;IAOI,+BAAA;EP+mRV;EOtnRM;IAOI,8BAAA;EPknRV;EOznRM;IAOI,oBAAA;EPqnRV;EO5nRM;IAOI,mBAAA;EPwnRV;EO/nRM;IAOI,mBAAA;EP2nRV;EOloRM;IAOI,mBAAA;EP8nRV;EOroRM;IAOI,mBAAA;EPioRV;EOxoRM;IAOI,mBAAA;EPooRV;EO3oRM;IAOI,mBAAA;EPuoRV;EO9oRM;IAOI,mBAAA;EP0oRV;EOjpRM;IAOI,oBAAA;EP6oRV;EOppRM;IAOI,0BAAA;EPgpRV;EOvpRM;IAOI,yBAAA;EPmpRV;EO1pRM;IAOI,uBAAA;EPspRV;EO7pRM;IAOI,yBAAA;EPypRV;EOhqRM;IAOI,uBAAA;EP4pRV;EOnqRM;IAOI,uBAAA;EP+pRV;EOtqRM;IAOI,0BAAA;IAAA,yBAAA;EPmqRV;EO1qRM;IAOI,gCAAA;IAAA,+BAAA;EPuqRV;EO9qRM;IAOI,+BAAA;IAAA,8BAAA;EP2qRV;EOlrRM;IAOI,6BAAA;IAAA,4BAAA;EP+qRV;EOtrRM;IAOI,+BAAA;IAAA,8BAAA;EPmrRV;EO1rRM;IAOI,6BAAA;IAAA,4BAAA;EPurRV;EO9rRM;IAOI,6BAAA;IAAA,4BAAA;EP2rRV;EOlsRM;IAOI,wBAAA;IAAA,2BAAA;EP+rRV;EOtsRM;IAOI,8BAAA;IAAA,iCAAA;EPmsRV;EO1sRM;IAOI,6BAAA;IAAA,gCAAA;EPusRV;EO9sRM;IAOI,2BAAA;IAAA,8BAAA;EP2sRV;EOltRM;IAOI,6BAAA;IAAA,gCAAA;EP+sRV;EOttRM;IAOI,2BAAA;IAAA,8BAAA;EPmtRV;EO1tRM;IAOI,2BAAA;IAAA,8BAAA;EPutRV;EO9tRM;IAOI,wBAAA;EP0tRV;EOjuRM;IAOI,8BAAA;EP6tRV;EOpuRM;IAOI,6BAAA;EPguRV;EOvuRM;IAOI,2BAAA;EPmuRV;EO1uRM;IAOI,6BAAA;EPsuRV;EO7uRM;IAOI,2BAAA;EPyuRV;EOhvRM;IAOI,2BAAA;EP4uRV;EOnvRM;IAOI,0BAAA;EP+uRV;EOtvRM;IAOI,gCAAA;EPkvRV;EOzvRM;IAOI,+BAAA;EPqvRV;EO5vRM;IAOI,6BAAA;EPwvRV;EO/vRM;IAOI,+BAAA;EP2vRV;EOlwRM;IAOI,6BAAA;EP8vRV;EOrwRM;IAOI,6BAAA;EPiwRV;EOxwRM;IAOI,2BAAA;EPowRV;EO3wRM;IAOI,iCAAA;EPuwRV;EO9wRM;IAOI,gCAAA;EP0wRV;EOjxRM;IAOI,8BAAA;EP6wRV;EOpxRM;IAOI,gCAAA;EPgxRV;EOvxRM;IAOI,8BAAA;EPmxRV;EO1xRM;IAOI,8BAAA;EPsxRV;EO7xRM;IAOI,yBAAA;EPyxRV;EOhyRM;IAOI,+BAAA;EP4xRV;EOnyRM;IAOI,8BAAA;EP+xRV;EOtyRM;IAOI,4BAAA;EPkyRV;EOzyRM;IAOI,8BAAA;EPqyRV;EO5yRM;IAOI,4BAAA;EPwyRV;EO/yRM;IAOI,4BAAA;EP2yRV;EOlzRM;IAOI,qBAAA;EP8yRV;EOrzRM;IAOI,2BAAA;EPizRV;EOxzRM;IAOI,0BAAA;EPozRV;EO3zRM;IAOI,wBAAA;EPuzRV;EO9zRM;IAOI,0BAAA;EP0zRV;EOj0RM;IAOI,wBAAA;EP6zRV;EOp0RM;IAOI,2BAAA;IAAA,0BAAA;EPi0RV;EOx0RM;IAOI,iCAAA;IAAA,gCAAA;EPq0RV;EO50RM;IAOI,gCAAA;IAAA,+BAAA;EPy0RV;EOh1RM;IAOI,8BAAA;IAAA,6BAAA;EP60RV;EOp1RM;IAOI,gCAAA;IAAA,+BAAA;EPi1RV;EOx1RM;IAOI,8BAAA;IAAA,6BAAA;EPq1RV;EO51RM;IAOI,yBAAA;IAAA,4BAAA;EPy1RV;EOh2RM;IAOI,+BAAA;IAAA,kCAAA;EP61RV;EOp2RM;IAOI,8BAAA;IAAA,iCAAA;EPi2RV;EOx2RM;IAOI,4BAAA;IAAA,+BAAA;EPq2RV;EO52RM;IAOI,8BAAA;IAAA,iCAAA;EPy2RV;EOh3RM;IAOI,4BAAA;IAAA,+BAAA;EP62RV;EOp3RM;IAOI,yBAAA;EPg3RV;EOv3RM;IAOI,+BAAA;EPm3RV;EO13RM;IAOI,8BAAA;EPs3RV;EO73RM;IAOI,4BAAA;EPy3RV;EOh4RM;IAOI,8BAAA;EP43RV;EOn4RM;IAOI,4BAAA;EP+3RV;EOt4RM;IAOI,2BAAA;EPk4RV;EOz4RM;IAOI,iCAAA;EPq4RV;EO54RM;IAOI,gCAAA;EPw4RV;EO/4RM;IAOI,8BAAA;EP24RV;EOl5RM;IAOI,gCAAA;EP84RV;EOr5RM;IAOI,8BAAA;EPi5RV;EOx5RM;IAOI,4BAAA;EPo5RV;EO35RM;IAOI,kCAAA;EPu5RV;EO95RM;IAOI,iCAAA;EP05RV;EOj6RM;IAOI,+BAAA;EP65RV;EOp6RM;IAOI,iCAAA;EPg6RV;EOv6RM;IAOI,+BAAA;EPm6RV;EO16RM;IAOI,0BAAA;EPs6RV;EO76RM;IAOI,gCAAA;EPy6RV;EOh7RM;IAOI,+BAAA;EP46RV;EOn7RM;IAOI,6BAAA;EP+6RV;EOt7RM;IAOI,+BAAA;EPk7RV;EOz7RM;IAOI,6BAAA;EPq7RV;EO57RM;IAOI,iBAAA;EPw7RV;EO/7RM;IAOI,uBAAA;EP27RV;EOl8RM;IAOI,sBAAA;EP87RV;EOr8RM;IAOI,oBAAA;EPi8RV;EOx8RM;IAOI,sBAAA;EPo8RV;EO38RM;IAOI,oBAAA;EPu8RV;EO98RM;IAOI,qBAAA;EP08RV;EOj9RM;IAOI,2BAAA;EP68RV;EOp9RM;IAOI,0BAAA;EPg9RV;EOv9RM;IAOI,wBAAA;EPm9RV;EO19RM;IAOI,0BAAA;EPs9RV;EO79RM;IAOI,wBAAA;EPy9RV;EOh+RM;IAOI,wBAAA;EP49RV;EOn+RM;IAOI,8BAAA;EP+9RV;EOt+RM;IAOI,6BAAA;EPk+RV;EOz+RM;IAOI,2BAAA;EPq+RV;EO5+RM;IAOI,6BAAA;EPw+RV;EO/+RM;IAOI,2BAAA;EP2+RV;EOl/RM;IAOI,2BAAA;EP8+RV;EOr/RM;IAOI,4BAAA;EPi/RV;EOx/RM;IAOI,6BAAA;EPo/RV;AACF;AoB//RI;EbGI;IAOI,sBAAA;EPy/RV;EOhgSM;IAOI,uBAAA;EP4/RV;EOngSM;IAOI,sBAAA;EP+/RV;EOtgSM;IAOI,8BAAA;EPkgSV;EOzgSM;IAOI,4BAAA;EPqgSV;EO5gSM;IAOI,2BAAA;EPwgSV;EO/gSM;IAOI,iCAAA;EP2gSV;EOlhSM;IAOI,2BAAA;EP8gSV;EOrhSM;IAOI,0BAAA;EPihSV;EOxhSM;IAOI,gCAAA;EPohSV;EO3hSM;IAOI,yBAAA;EPuhSV;EO9hSM;IAOI,wBAAA;EP0hSV;EOjiSM;IAOI,+BAAA;EP6hSV;EOpiSM;IAOI,yBAAA;EPgiSV;EOviSM;IAOI,6BAAA;EPmiSV;EO1iSM;IAOI,8BAAA;EPsiSV;EO7iSM;IAOI,wBAAA;EPyiSV;EOhjSM;IAOI,+BAAA;EP4iSV;EOnjSM;IAOI,wBAAA;EP+iSV;EOtjSM;IAOI,yBAAA;EPkjSV;EOzjSM;IAOI,8BAAA;EPqjSV;EO5jSM;IAOI,iCAAA;EPwjSV;EO/jSM;IAOI,sCAAA;EP2jSV;EOlkSM;IAOI,yCAAA;EP8jSV;EOrkSM;IAOI,uBAAA;EPikSV;EOxkSM;IAOI,uBAAA;EPokSV;EO3kSM;IAOI,yBAAA;EPukSV;EO9kSM;IAOI,yBAAA;EP0kSV;EOjlSM;IAOI,0BAAA;EP6kSV;EOplSM;IAOI,4BAAA;EPglSV;EOvlSM;IAOI,kCAAA;EPmlSV;EO1lSM;IAOI,sCAAA;EPslSV;EO7lSM;IAOI,oCAAA;EPylSV;EOhmSM;IAOI,kCAAA;EP4lSV;EOnmSM;IAOI,yCAAA;EP+lSV;EOtmSM;IAOI,wCAAA;EPkmSV;EOzmSM;IAOI,wCAAA;EPqmSV;EO5mSM;IAOI,kCAAA;EPwmSV;EO/mSM;IAOI,gCAAA;EP2mSV;EOlnSM;IAOI,8BAAA;EP8mSV;EOrnSM;IAOI,gCAAA;EPinSV;EOxnSM;IAOI,+BAAA;EPonSV;EO3nSM;IAOI,oCAAA;EPunSV;EO9nSM;IAOI,kCAAA;EP0nSV;EOjoSM;IAOI,gCAAA;EP6nSV;EOpoSM;IAOI,uCAAA;EPgoSV;EOvoSM;IAOI,sCAAA;EPmoSV;EO1oSM;IAOI,iCAAA;EPsoSV;EO7oSM;IAOI,2BAAA;EPyoSV;EOhpSM;IAOI,iCAAA;EP4oSV;EOnpSM;IAOI,+BAAA;EP+oSV;EOtpSM;IAOI,6BAAA;EPkpSV;EOzpSM;IAOI,+BAAA;EPqpSV;EO5pSM;IAOI,8BAAA;EPwpSV;EO/pSM;IAOI,oBAAA;EP2pSV;EOlqSM;IAOI,mBAAA;EP8pSV;EOrqSM;IAOI,mBAAA;EPiqSV;EOxqSM;IAOI,mBAAA;EPoqSV;EO3qSM;IAOI,mBAAA;EPuqSV;EO9qSM;IAOI,mBAAA;EP0qSV;EOjrSM;IAOI,mBAAA;EP6qSV;EOprSM;IAOI,mBAAA;EPgrSV;EOvrSM;IAOI,oBAAA;EPmrSV;EO1rSM;IAOI,0BAAA;EPsrSV;EO7rSM;IAOI,yBAAA;EPyrSV;EOhsSM;IAOI,uBAAA;EP4rSV;EOnsSM;IAOI,yBAAA;EP+rSV;EOtsSM;IAOI,uBAAA;EPksSV;EOzsSM;IAOI,uBAAA;EPqsSV;EO5sSM;IAOI,0BAAA;IAAA,yBAAA;EPysSV;EOhtSM;IAOI,gCAAA;IAAA,+BAAA;EP6sSV;EOptSM;IAOI,+BAAA;IAAA,8BAAA;EPitSV;EOxtSM;IAOI,6BAAA;IAAA,4BAAA;EPqtSV;EO5tSM;IAOI,+BAAA;IAAA,8BAAA;EPytSV;EOhuSM;IAOI,6BAAA;IAAA,4BAAA;EP6tSV;EOpuSM;IAOI,6BAAA;IAAA,4BAAA;EPiuSV;EOxuSM;IAOI,wBAAA;IAAA,2BAAA;EPquSV;EO5uSM;IAOI,8BAAA;IAAA,iCAAA;EPyuSV;EOhvSM;IAOI,6BAAA;IAAA,gCAAA;EP6uSV;EOpvSM;IAOI,2BAAA;IAAA,8BAAA;EPivSV;EOxvSM;IAOI,6BAAA;IAAA,gCAAA;EPqvSV;EO5vSM;IAOI,2BAAA;IAAA,8BAAA;EPyvSV;EOhwSM;IAOI,2BAAA;IAAA,8BAAA;EP6vSV;EOpwSM;IAOI,wBAAA;EPgwSV;EOvwSM;IAOI,8BAAA;EPmwSV;EO1wSM;IAOI,6BAAA;EPswSV;EO7wSM;IAOI,2BAAA;EPywSV;EOhxSM;IAOI,6BAAA;EP4wSV;EOnxSM;IAOI,2BAAA;EP+wSV;EOtxSM;IAOI,2BAAA;EPkxSV;EOzxSM;IAOI,0BAAA;EPqxSV;EO5xSM;IAOI,gCAAA;EPwxSV;EO/xSM;IAOI,+BAAA;EP2xSV;EOlySM;IAOI,6BAAA;EP8xSV;EOrySM;IAOI,+BAAA;EPiySV;EOxySM;IAOI,6BAAA;EPoySV;EO3ySM;IAOI,6BAAA;EPuySV;EO9ySM;IAOI,2BAAA;EP0ySV;EOjzSM;IAOI,iCAAA;EP6ySV;EOpzSM;IAOI,gCAAA;EPgzSV;EOvzSM;IAOI,8BAAA;EPmzSV;EO1zSM;IAOI,gCAAA;EPszSV;EO7zSM;IAOI,8BAAA;EPyzSV;EOh0SM;IAOI,8BAAA;EP4zSV;EOn0SM;IAOI,yBAAA;EP+zSV;EOt0SM;IAOI,+BAAA;EPk0SV;EOz0SM;IAOI,8BAAA;EPq0SV;EO50SM;IAOI,4BAAA;EPw0SV;EO/0SM;IAOI,8BAAA;EP20SV;EOl1SM;IAOI,4BAAA;EP80SV;EOr1SM;IAOI,4BAAA;EPi1SV;EOx1SM;IAOI,qBAAA;EPo1SV;EO31SM;IAOI,2BAAA;EPu1SV;EO91SM;IAOI,0BAAA;EP01SV;EOj2SM;IAOI,wBAAA;EP61SV;EOp2SM;IAOI,0BAAA;EPg2SV;EOv2SM;IAOI,wBAAA;EPm2SV;EO12SM;IAOI,2BAAA;IAAA,0BAAA;EPu2SV;EO92SM;IAOI,iCAAA;IAAA,gCAAA;EP22SV;EOl3SM;IAOI,gCAAA;IAAA,+BAAA;EP+2SV;EOt3SM;IAOI,8BAAA;IAAA,6BAAA;EPm3SV;EO13SM;IAOI,gCAAA;IAAA,+BAAA;EPu3SV;EO93SM;IAOI,8BAAA;IAAA,6BAAA;EP23SV;EOl4SM;IAOI,yBAAA;IAAA,4BAAA;EP+3SV;EOt4SM;IAOI,+BAAA;IAAA,kCAAA;EPm4SV;EO14SM;IAOI,8BAAA;IAAA,iCAAA;EPu4SV;EO94SM;IAOI,4BAAA;IAAA,+BAAA;EP24SV;EOl5SM;IAOI,8BAAA;IAAA,iCAAA;EP+4SV;EOt5SM;IAOI,4BAAA;IAAA,+BAAA;EPm5SV;EO15SM;IAOI,yBAAA;EPs5SV;EO75SM;IAOI,+BAAA;EPy5SV;EOh6SM;IAOI,8BAAA;EP45SV;EOn6SM;IAOI,4BAAA;EP+5SV;EOt6SM;IAOI,8BAAA;EPk6SV;EOz6SM;IAOI,4BAAA;EPq6SV;EO56SM;IAOI,2BAAA;EPw6SV;EO/6SM;IAOI,iCAAA;EP26SV;EOl7SM;IAOI,gCAAA;EP86SV;EOr7SM;IAOI,8BAAA;EPi7SV;EOx7SM;IAOI,gCAAA;EPo7SV;EO37SM;IAOI,8BAAA;EPu7SV;EO97SM;IAOI,4BAAA;EP07SV;EOj8SM;IAOI,kCAAA;EP67SV;EOp8SM;IAOI,iCAAA;EPg8SV;EOv8SM;IAOI,+BAAA;EPm8SV;EO18SM;IAOI,iCAAA;EPs8SV;EO78SM;IAOI,+BAAA;EPy8SV;EOh9SM;IAOI,0BAAA;EP48SV;EOn9SM;IAOI,gCAAA;EP+8SV;EOt9SM;IAOI,+BAAA;EPk9SV;EOz9SM;IAOI,6BAAA;EPq9SV;EO59SM;IAOI,+BAAA;EPw9SV;EO/9SM;IAOI,6BAAA;EP29SV;EOl+SM;IAOI,iBAAA;EP89SV;EOr+SM;IAOI,uBAAA;EPi+SV;EOx+SM;IAOI,sBAAA;EPo+SV;EO3+SM;IAOI,oBAAA;EPu+SV;EO9+SM;IAOI,sBAAA;EP0+SV;EOj/SM;IAOI,oBAAA;EP6+SV;EOp/SM;IAOI,qBAAA;EPg/SV;EOv/SM;IAOI,2BAAA;EPm/SV;EO1/SM;IAOI,0BAAA;EPs/SV;EO7/SM;IAOI,wBAAA;EPy/SV;EOhgTM;IAOI,0BAAA;EP4/SV;EOngTM;IAOI,wBAAA;EP+/SV;EOtgTM;IAOI,wBAAA;EPkgTV;EOzgTM;IAOI,8BAAA;EPqgTV;EO5gTM;IAOI,6BAAA;EPwgTV;EO/gTM;IAOI,2BAAA;EP2gTV;EOlhTM;IAOI,6BAAA;EP8gTV;EOrhTM;IAOI,2BAAA;EPihTV;EOxhTM;IAOI,2BAAA;EPohTV;EO3hTM;IAOI,4BAAA;EPuhTV;EO9hTM;IAOI,6BAAA;EP0hTV;AACF;AoBriTI;EbGI;IAOI,sBAAA;EP+hTV;EOtiTM;IAOI,uBAAA;EPkiTV;EOziTM;IAOI,sBAAA;EPqiTV;EO5iTM;IAOI,8BAAA;EPwiTV;EO/iTM;IAOI,4BAAA;EP2iTV;EOljTM;IAOI,2BAAA;EP8iTV;EOrjTM;IAOI,iCAAA;EPijTV;EOxjTM;IAOI,2BAAA;EPojTV;EO3jTM;IAOI,0BAAA;EPujTV;EO9jTM;IAOI,gCAAA;EP0jTV;EOjkTM;IAOI,yBAAA;EP6jTV;EOpkTM;IAOI,wBAAA;EPgkTV;EOvkTM;IAOI,+BAAA;EPmkTV;EO1kTM;IAOI,yBAAA;EPskTV;EO7kTM;IAOI,6BAAA;EPykTV;EOhlTM;IAOI,8BAAA;EP4kTV;EOnlTM;IAOI,wBAAA;EP+kTV;EOtlTM;IAOI,+BAAA;EPklTV;EOzlTM;IAOI,wBAAA;EPqlTV;EO5lTM;IAOI,yBAAA;EPwlTV;EO/lTM;IAOI,8BAAA;EP2lTV;EOlmTM;IAOI,iCAAA;EP8lTV;EOrmTM;IAOI,sCAAA;EPimTV;EOxmTM;IAOI,yCAAA;EPomTV;EO3mTM;IAOI,uBAAA;EPumTV;EO9mTM;IAOI,uBAAA;EP0mTV;EOjnTM;IAOI,yBAAA;EP6mTV;EOpnTM;IAOI,yBAAA;EPgnTV;EOvnTM;IAOI,0BAAA;EPmnTV;EO1nTM;IAOI,4BAAA;EPsnTV;EO7nTM;IAOI,kCAAA;EPynTV;EOhoTM;IAOI,sCAAA;EP4nTV;EOnoTM;IAOI,oCAAA;EP+nTV;EOtoTM;IAOI,kCAAA;EPkoTV;EOzoTM;IAOI,yCAAA;EPqoTV;EO5oTM;IAOI,wCAAA;EPwoTV;EO/oTM;IAOI,wCAAA;EP2oTV;EOlpTM;IAOI,kCAAA;EP8oTV;EOrpTM;IAOI,gCAAA;EPipTV;EOxpTM;IAOI,8BAAA;EPopTV;EO3pTM;IAOI,gCAAA;EPupTV;EO9pTM;IAOI,+BAAA;EP0pTV;EOjqTM;IAOI,oCAAA;EP6pTV;EOpqTM;IAOI,kCAAA;EPgqTV;EOvqTM;IAOI,gCAAA;EPmqTV;EO1qTM;IAOI,uCAAA;EPsqTV;EO7qTM;IAOI,sCAAA;EPyqTV;EOhrTM;IAOI,iCAAA;EP4qTV;EOnrTM;IAOI,2BAAA;EP+qTV;EOtrTM;IAOI,iCAAA;EPkrTV;EOzrTM;IAOI,+BAAA;EPqrTV;EO5rTM;IAOI,6BAAA;EPwrTV;EO/rTM;IAOI,+BAAA;EP2rTV;EOlsTM;IAOI,8BAAA;EP8rTV;EOrsTM;IAOI,oBAAA;EPisTV;EOxsTM;IAOI,mBAAA;EPosTV;EO3sTM;IAOI,mBAAA;EPusTV;EO9sTM;IAOI,mBAAA;EP0sTV;EOjtTM;IAOI,mBAAA;EP6sTV;EOptTM;IAOI,mBAAA;EPgtTV;EOvtTM;IAOI,mBAAA;EPmtTV;EO1tTM;IAOI,mBAAA;EPstTV;EO7tTM;IAOI,oBAAA;EPytTV;EOhuTM;IAOI,0BAAA;EP4tTV;EOnuTM;IAOI,yBAAA;EP+tTV;EOtuTM;IAOI,uBAAA;EPkuTV;EOzuTM;IAOI,yBAAA;EPquTV;EO5uTM;IAOI,uBAAA;EPwuTV;EO/uTM;IAOI,uBAAA;EP2uTV;EOlvTM;IAOI,0BAAA;IAAA,yBAAA;EP+uTV;EOtvTM;IAOI,gCAAA;IAAA,+BAAA;EPmvTV;EO1vTM;IAOI,+BAAA;IAAA,8BAAA;EPuvTV;EO9vTM;IAOI,6BAAA;IAAA,4BAAA;EP2vTV;EOlwTM;IAOI,+BAAA;IAAA,8BAAA;EP+vTV;EOtwTM;IAOI,6BAAA;IAAA,4BAAA;EPmwTV;EO1wTM;IAOI,6BAAA;IAAA,4BAAA;EPuwTV;EO9wTM;IAOI,wBAAA;IAAA,2BAAA;EP2wTV;EOlxTM;IAOI,8BAAA;IAAA,iCAAA;EP+wTV;EOtxTM;IAOI,6BAAA;IAAA,gCAAA;EPmxTV;EO1xTM;IAOI,2BAAA;IAAA,8BAAA;EPuxTV;EO9xTM;IAOI,6BAAA;IAAA,gCAAA;EP2xTV;EOlyTM;IAOI,2BAAA;IAAA,8BAAA;EP+xTV;EOtyTM;IAOI,2BAAA;IAAA,8BAAA;EPmyTV;EO1yTM;IAOI,wBAAA;EPsyTV;EO7yTM;IAOI,8BAAA;EPyyTV;EOhzTM;IAOI,6BAAA;EP4yTV;EOnzTM;IAOI,2BAAA;EP+yTV;EOtzTM;IAOI,6BAAA;EPkzTV;EOzzTM;IAOI,2BAAA;EPqzTV;EO5zTM;IAOI,2BAAA;EPwzTV;EO/zTM;IAOI,0BAAA;EP2zTV;EOl0TM;IAOI,gCAAA;EP8zTV;EOr0TM;IAOI,+BAAA;EPi0TV;EOx0TM;IAOI,6BAAA;EPo0TV;EO30TM;IAOI,+BAAA;EPu0TV;EO90TM;IAOI,6BAAA;EP00TV;EOj1TM;IAOI,6BAAA;EP60TV;EOp1TM;IAOI,2BAAA;EPg1TV;EOv1TM;IAOI,iCAAA;EPm1TV;EO11TM;IAOI,gCAAA;EPs1TV;EO71TM;IAOI,8BAAA;EPy1TV;EOh2TM;IAOI,gCAAA;EP41TV;EOn2TM;IAOI,8BAAA;EP+1TV;EOt2TM;IAOI,8BAAA;EPk2TV;EOz2TM;IAOI,yBAAA;EPq2TV;EO52TM;IAOI,+BAAA;EPw2TV;EO/2TM;IAOI,8BAAA;EP22TV;EOl3TM;IAOI,4BAAA;EP82TV;EOr3TM;IAOI,8BAAA;EPi3TV;EOx3TM;IAOI,4BAAA;EPo3TV;EO33TM;IAOI,4BAAA;EPu3TV;EO93TM;IAOI,qBAAA;EP03TV;EOj4TM;IAOI,2BAAA;EP63TV;EOp4TM;IAOI,0BAAA;EPg4TV;EOv4TM;IAOI,wBAAA;EPm4TV;EO14TM;IAOI,0BAAA;EPs4TV;EO74TM;IAOI,wBAAA;EPy4TV;EOh5TM;IAOI,2BAAA;IAAA,0BAAA;EP64TV;EOp5TM;IAOI,iCAAA;IAAA,gCAAA;EPi5TV;EOx5TM;IAOI,gCAAA;IAAA,+BAAA;EPq5TV;EO55TM;IAOI,8BAAA;IAAA,6BAAA;EPy5TV;EOh6TM;IAOI,gCAAA;IAAA,+BAAA;EP65TV;EOp6TM;IAOI,8BAAA;IAAA,6BAAA;EPi6TV;EOx6TM;IAOI,yBAAA;IAAA,4BAAA;EPq6TV;EO56TM;IAOI,+BAAA;IAAA,kCAAA;EPy6TV;EOh7TM;IAOI,8BAAA;IAAA,iCAAA;EP66TV;EOp7TM;IAOI,4BAAA;IAAA,+BAAA;EPi7TV;EOx7TM;IAOI,8BAAA;IAAA,iCAAA;EPq7TV;EO57TM;IAOI,4BAAA;IAAA,+BAAA;EPy7TV;EOh8TM;IAOI,yBAAA;EP47TV;EOn8TM;IAOI,+BAAA;EP+7TV;EOt8TM;IAOI,8BAAA;EPk8TV;EOz8TM;IAOI,4BAAA;EPq8TV;EO58TM;IAOI,8BAAA;EPw8TV;EO/8TM;IAOI,4BAAA;EP28TV;EOl9TM;IAOI,2BAAA;EP88TV;EOr9TM;IAOI,iCAAA;EPi9TV;EOx9TM;IAOI,gCAAA;EPo9TV;EO39TM;IAOI,8BAAA;EPu9TV;EO99TM;IAOI,gCAAA;EP09TV;EOj+TM;IAOI,8BAAA;EP69TV;EOp+TM;IAOI,4BAAA;EPg+TV;EOv+TM;IAOI,kCAAA;EPm+TV;EO1+TM;IAOI,iCAAA;EPs+TV;EO7+TM;IAOI,+BAAA;EPy+TV;EOh/TM;IAOI,iCAAA;EP4+TV;EOn/TM;IAOI,+BAAA;EP++TV;EOt/TM;IAOI,0BAAA;EPk/TV;EOz/TM;IAOI,gCAAA;EPq/TV;EO5/TM;IAOI,+BAAA;EPw/TV;EO//TM;IAOI,6BAAA;EP2/TV;EOlgUM;IAOI,+BAAA;EP8/TV;EOrgUM;IAOI,6BAAA;EPigUV;EOxgUM;IAOI,iBAAA;EPogUV;EO3gUM;IAOI,uBAAA;EPugUV;EO9gUM;IAOI,sBAAA;EP0gUV;EOjhUM;IAOI,oBAAA;EP6gUV;EOphUM;IAOI,sBAAA;EPghUV;EOvhUM;IAOI,oBAAA;EPmhUV;EO1hUM;IAOI,qBAAA;EPshUV;EO7hUM;IAOI,2BAAA;EPyhUV;EOhiUM;IAOI,0BAAA;EP4hUV;EOniUM;IAOI,wBAAA;EP+hUV;EOtiUM;IAOI,0BAAA;EPkiUV;EOziUM;IAOI,wBAAA;EPqiUV;EO5iUM;IAOI,wBAAA;EPwiUV;EO/iUM;IAOI,8BAAA;EP2iUV;EOljUM;IAOI,6BAAA;EP8iUV;EOrjUM;IAOI,2BAAA;EPijUV;EOxjUM;IAOI,6BAAA;EPojUV;EO3jUM;IAOI,2BAAA;EPujUV;EO9jUM;IAOI,2BAAA;EP0jUV;EOjkUM;IAOI,4BAAA;EP6jUV;EOpkUM;IAOI,6BAAA;EPgkUV;AACF;AoB3kUI;EbGI;IAOI,sBAAA;EPqkUV;EO5kUM;IAOI,uBAAA;EPwkUV;EO/kUM;IAOI,sBAAA;EP2kUV;EOllUM;IAOI,8BAAA;EP8kUV;EOrlUM;IAOI,4BAAA;EPilUV;EOxlUM;IAOI,2BAAA;EPolUV;EO3lUM;IAOI,iCAAA;EPulUV;EO9lUM;IAOI,2BAAA;EP0lUV;EOjmUM;IAOI,0BAAA;EP6lUV;EOpmUM;IAOI,gCAAA;EPgmUV;EOvmUM;IAOI,yBAAA;EPmmUV;EO1mUM;IAOI,wBAAA;EPsmUV;EO7mUM;IAOI,+BAAA;EPymUV;EOhnUM;IAOI,yBAAA;EP4mUV;EOnnUM;IAOI,6BAAA;EP+mUV;EOtnUM;IAOI,8BAAA;EPknUV;EOznUM;IAOI,wBAAA;EPqnUV;EO5nUM;IAOI,+BAAA;EPwnUV;EO/nUM;IAOI,wBAAA;EP2nUV;EOloUM;IAOI,yBAAA;EP8nUV;EOroUM;IAOI,8BAAA;EPioUV;EOxoUM;IAOI,iCAAA;EPooUV;EO3oUM;IAOI,sCAAA;EPuoUV;EO9oUM;IAOI,yCAAA;EP0oUV;EOjpUM;IAOI,uBAAA;EP6oUV;EOppUM;IAOI,uBAAA;EPgpUV;EOvpUM;IAOI,yBAAA;EPmpUV;EO1pUM;IAOI,yBAAA;EPspUV;EO7pUM;IAOI,0BAAA;EPypUV;EOhqUM;IAOI,4BAAA;EP4pUV;EOnqUM;IAOI,kCAAA;EP+pUV;EOtqUM;IAOI,sCAAA;EPkqUV;EOzqUM;IAOI,oCAAA;EPqqUV;EO5qUM;IAOI,kCAAA;EPwqUV;EO/qUM;IAOI,yCAAA;EP2qUV;EOlrUM;IAOI,wCAAA;EP8qUV;EOrrUM;IAOI,wCAAA;EPirUV;EOxrUM;IAOI,kCAAA;EPorUV;EO3rUM;IAOI,gCAAA;EPurUV;EO9rUM;IAOI,8BAAA;EP0rUV;EOjsUM;IAOI,gCAAA;EP6rUV;EOpsUM;IAOI,+BAAA;EPgsUV;EOvsUM;IAOI,oCAAA;EPmsUV;EO1sUM;IAOI,kCAAA;EPssUV;EO7sUM;IAOI,gCAAA;EPysUV;EOhtUM;IAOI,uCAAA;EP4sUV;EOntUM;IAOI,sCAAA;EP+sUV;EOttUM;IAOI,iCAAA;EPktUV;EOztUM;IAOI,2BAAA;EPqtUV;EO5tUM;IAOI,iCAAA;EPwtUV;EO/tUM;IAOI,+BAAA;EP2tUV;EOluUM;IAOI,6BAAA;EP8tUV;EOruUM;IAOI,+BAAA;EPiuUV;EOxuUM;IAOI,8BAAA;EPouUV;EO3uUM;IAOI,oBAAA;EPuuUV;EO9uUM;IAOI,mBAAA;EP0uUV;EOjvUM;IAOI,mBAAA;EP6uUV;EOpvUM;IAOI,mBAAA;EPgvUV;EOvvUM;IAOI,mBAAA;EPmvUV;EO1vUM;IAOI,mBAAA;EPsvUV;EO7vUM;IAOI,mBAAA;EPyvUV;EOhwUM;IAOI,mBAAA;EP4vUV;EOnwUM;IAOI,oBAAA;EP+vUV;EOtwUM;IAOI,0BAAA;EPkwUV;EOzwUM;IAOI,yBAAA;EPqwUV;EO5wUM;IAOI,uBAAA;EPwwUV;EO/wUM;IAOI,yBAAA;EP2wUV;EOlxUM;IAOI,uBAAA;EP8wUV;EOrxUM;IAOI,uBAAA;EPixUV;EOxxUM;IAOI,0BAAA;IAAA,yBAAA;EPqxUV;EO5xUM;IAOI,gCAAA;IAAA,+BAAA;EPyxUV;EOhyUM;IAOI,+BAAA;IAAA,8BAAA;EP6xUV;EOpyUM;IAOI,6BAAA;IAAA,4BAAA;EPiyUV;EOxyUM;IAOI,+BAAA;IAAA,8BAAA;EPqyUV;EO5yUM;IAOI,6BAAA;IAAA,4BAAA;EPyyUV;EOhzUM;IAOI,6BAAA;IAAA,4BAAA;EP6yUV;EOpzUM;IAOI,wBAAA;IAAA,2BAAA;EPizUV;EOxzUM;IAOI,8BAAA;IAAA,iCAAA;EPqzUV;EO5zUM;IAOI,6BAAA;IAAA,gCAAA;EPyzUV;EOh0UM;IAOI,2BAAA;IAAA,8BAAA;EP6zUV;EOp0UM;IAOI,6BAAA;IAAA,gCAAA;EPi0UV;EOx0UM;IAOI,2BAAA;IAAA,8BAAA;EPq0UV;EO50UM;IAOI,2BAAA;IAAA,8BAAA;EPy0UV;EOh1UM;IAOI,wBAAA;EP40UV;EOn1UM;IAOI,8BAAA;EP+0UV;EOt1UM;IAOI,6BAAA;EPk1UV;EOz1UM;IAOI,2BAAA;EPq1UV;EO51UM;IAOI,6BAAA;EPw1UV;EO/1UM;IAOI,2BAAA;EP21UV;EOl2UM;IAOI,2BAAA;EP81UV;EOr2UM;IAOI,0BAAA;EPi2UV;EOx2UM;IAOI,gCAAA;EPo2UV;EO32UM;IAOI,+BAAA;EPu2UV;EO92UM;IAOI,6BAAA;EP02UV;EOj3UM;IAOI,+BAAA;EP62UV;EOp3UM;IAOI,6BAAA;EPg3UV;EOv3UM;IAOI,6BAAA;EPm3UV;EO13UM;IAOI,2BAAA;EPs3UV;EO73UM;IAOI,iCAAA;EPy3UV;EOh4UM;IAOI,gCAAA;EP43UV;EOn4UM;IAOI,8BAAA;EP+3UV;EOt4UM;IAOI,gCAAA;EPk4UV;EOz4UM;IAOI,8BAAA;EPq4UV;EO54UM;IAOI,8BAAA;EPw4UV;EO/4UM;IAOI,yBAAA;EP24UV;EOl5UM;IAOI,+BAAA;EP84UV;EOr5UM;IAOI,8BAAA;EPi5UV;EOx5UM;IAOI,4BAAA;EPo5UV;EO35UM;IAOI,8BAAA;EPu5UV;EO95UM;IAOI,4BAAA;EP05UV;EOj6UM;IAOI,4BAAA;EP65UV;EOp6UM;IAOI,qBAAA;EPg6UV;EOv6UM;IAOI,2BAAA;EPm6UV;EO16UM;IAOI,0BAAA;EPs6UV;EO76UM;IAOI,wBAAA;EPy6UV;EOh7UM;IAOI,0BAAA;EP46UV;EOn7UM;IAOI,wBAAA;EP+6UV;EOt7UM;IAOI,2BAAA;IAAA,0BAAA;EPm7UV;EO17UM;IAOI,iCAAA;IAAA,gCAAA;EPu7UV;EO97UM;IAOI,gCAAA;IAAA,+BAAA;EP27UV;EOl8UM;IAOI,8BAAA;IAAA,6BAAA;EP+7UV;EOt8UM;IAOI,gCAAA;IAAA,+BAAA;EPm8UV;EO18UM;IAOI,8BAAA;IAAA,6BAAA;EPu8UV;EO98UM;IAOI,yBAAA;IAAA,4BAAA;EP28UV;EOl9UM;IAOI,+BAAA;IAAA,kCAAA;EP+8UV;EOt9UM;IAOI,8BAAA;IAAA,iCAAA;EPm9UV;EO19UM;IAOI,4BAAA;IAAA,+BAAA;EPu9UV;EO99UM;IAOI,8BAAA;IAAA,iCAAA;EP29UV;EOl+UM;IAOI,4BAAA;IAAA,+BAAA;EP+9UV;EOt+UM;IAOI,yBAAA;EPk+UV;EOz+UM;IAOI,+BAAA;EPq+UV;EO5+UM;IAOI,8BAAA;EPw+UV;EO/+UM;IAOI,4BAAA;EP2+UV;EOl/UM;IAOI,8BAAA;EP8+UV;EOr/UM;IAOI,4BAAA;EPi/UV;EOx/UM;IAOI,2BAAA;EPo/UV;EO3/UM;IAOI,iCAAA;EPu/UV;EO9/UM;IAOI,gCAAA;EP0/UV;EOjgVM;IAOI,8BAAA;EP6/UV;EOpgVM;IAOI,gCAAA;EPggVV;EOvgVM;IAOI,8BAAA;EPmgVV;EO1gVM;IAOI,4BAAA;EPsgVV;EO7gVM;IAOI,kCAAA;EPygVV;EOhhVM;IAOI,iCAAA;EP4gVV;EOnhVM;IAOI,+BAAA;EP+gVV;EOthVM;IAOI,iCAAA;EPkhVV;EOzhVM;IAOI,+BAAA;EPqhVV;EO5hVM;IAOI,0BAAA;EPwhVV;EO/hVM;IAOI,gCAAA;EP2hVV;EOliVM;IAOI,+BAAA;EP8hVV;EOriVM;IAOI,6BAAA;EPiiVV;EOxiVM;IAOI,+BAAA;EPoiVV;EO3iVM;IAOI,6BAAA;EPuiVV;EO9iVM;IAOI,iBAAA;EP0iVV;EOjjVM;IAOI,uBAAA;EP6iVV;EOpjVM;IAOI,sBAAA;EPgjVV;EOvjVM;IAOI,oBAAA;EPmjVV;EO1jVM;IAOI,sBAAA;EPsjVV;EO7jVM;IAOI,oBAAA;EPyjVV;EOhkVM;IAOI,qBAAA;EP4jVV;EOnkVM;IAOI,2BAAA;EP+jVV;EOtkVM;IAOI,0BAAA;EPkkVV;EOzkVM;IAOI,wBAAA;EPqkVV;EO5kVM;IAOI,0BAAA;EPwkVV;EO/kVM;IAOI,wBAAA;EP2kVV;EOllVM;IAOI,wBAAA;EP8kVV;EOrlVM;IAOI,8BAAA;EPilVV;EOxlVM;IAOI,6BAAA;EPolVV;EO3lVM;IAOI,2BAAA;EPulVV;EO9lVM;IAOI,6BAAA;EP0lVV;EOjmVM;IAOI,2BAAA;EP6lVV;EOpmVM;IAOI,2BAAA;EPgmVV;EOvmVM;IAOI,4BAAA;EPmmVV;EO1mVM;IAOI,6BAAA;EPsmVV;AACF;A2E7pVA;EpE+CQ;IAOI,4BAAA;EP2mVV;EOlnVM;IAOI,0BAAA;EP8mVV;EOrnVM;IAOI,6BAAA;EPinVV;EOxnVM;IAOI,4BAAA;EPonVV;AACF;A2ExpVA;EpE4BQ;IAOI,0BAAA;EPynVV;EOhoVM;IAOI,gCAAA;EP4nVV;EOnoVM;IAOI,yBAAA;EP+nVV;EOtoVM;IAOI,wBAAA;EPkoVV;EOzoVM;IAOI,+BAAA;EPqoVV;EO5oVM;IAOI,yBAAA;EPwoVV;EO/oVM;IAOI,6BAAA;EP2oVV;EOlpVM;IAOI,8BAAA;EP8oVV;EOrpVM;IAOI,wBAAA;EPipVV;EOxpVM;IAOI,+BAAA;EPopVV;EO3pVM;IAOI,wBAAA;EPupVV;AACF;AQjuVA;EACE,wCAAA;ARmuVF;AQhuVA;EACE,mBPHQ;EOIR,cAAA;ARkuVF;AQ7tVA;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AR+tVF;AQ5tVA;;;;EAIE,sBAAA;AR8tVF;AQ3tVA;;;;;;;EAOE,yBAAA;AR6tVF;AQ1tVA;;;EAGE,2BAAA;EACA,yBAAA;AR4tVF;AQztVA;EACE,gCAAA;EACA,oCAAA;AR2tVF;AQxtVA;EACE,gBAAA;AR0tVF;AQvtVA;EACE,yBAAA;ARytVF;AQttVA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,0CAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;ARwtVF;AQrtVA;EACE,iCAAA;EACA,6BAAA;ARutVF;AQptVA;EACE,yBAAA;ARstVF;AQntVA;EACE,yBAAA;ARqtVF;AQltVA;EACE,cAAA;ARotVF;AQjtVA;EACE,cAAA;ARmtVF;AQhtVA;EACE,yBPvFU;EOwFV,cPzFQ;EO0FR,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;ARktVF;AQ7sVA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AR+sVF;AQ5sVA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;AR8sVF;AQ3sVA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AR6sVF;AQ1sVA;;;;;;;EAOE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,iBAAA;AR4sVF;AQzsVA;EACE,sBAAA;AR2sVF;AQxsVA;EACE,gBAAA;AR0sVF;AQxsVE;EACE,cP7IM;ADu1VV;AQtsVA;EACE,gBAAA;EACA,kBAAA;EACA,cPpJQ;EOqJR,0BAAA;EACA,eAAA;ARwsVF;AQrsVA;EACE,iBAAA;ARusVF;AQpsVA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;ARssVF;AQnsVA;EACE,eAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;ARqsVF;AQlsVA;EACE,eAAA;ARosVF;AQjsVA;EACE,eAAA;ARmsVF;AQ/rVE;EACE,kBAAA;EACA,eAAA;ARisVJ;AQ/rVI;EACE,iBAAA;ARisVN;AQ7rVE;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,4BAAA;EACA,wBAAA;EACA,yBAAA;EACA,iCAAA;EACA,yBAAA;EACA,UAAA;EACA,mBAAA;EACA,gCAAA;EACA,kBAAA;EACA,iDAAA;AR+rVJ;AQ7rVI;EACE,yBP9MI;EO+MJ,qBP/MI;AD84VV;AQzrVE;EACE,eAAA;EACA,eAAA;AR2rVJ;AQxrVE;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;AR0rVJ;AQtrVA;EACE,gBAAA;EACA,gBAAA;EACA,yBAAA;ARwrVF;AQrrVA;EACE,yBAAA;ARurVF;AQlrVA;EACE,gCAAA;ARorVF;AQ/qVE;EACE,sBAAA;EACA,yBAAA;ARirVJ;AQ/qVI;EACE,yBAAA;EACA,qBAAA;ARirVN;AQ3qVA;EACE,cAAA;EACA,WAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;EACA,yBAAA;EACA,gBAAA;EACA,wEAAA;EACA,sBAAA;AR6qVF;AQ3qVE;EACE,yBAAA;EACA,uBAAA;AR6qVJ;AQzqVA;EACE,oCAAA;AR2qVF;AQpqVA;EACE,yBP5RQ;EO6RR,kBAAA;ARsqVF;AQpqVE;EACE,sBAAA;ARsqVJ;AQlqVA;EACE,sBAAA;ARoqVF;AQjqVA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ARmqVF;AQ/pVA;;;;;;;;;;;;EAYE,oCAAA;ARiqVF;AQ9pVA;;;;EAIE,oCAAA;EACA,yBAAA;ARgqVF;AQ7pVA;;EAEE,uBAAA;AR+pVF;AQ5pVA;EACE,kBAAA;AR8pVF;AQ1pVA;EACE,oBAAA;AR4pVF;AQ1pVE;EACE,yBPjVG;AD6+VP;AQzpVE;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AR2pVJ;AQzpVI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AR2pVN;AQxpVI;EACE,eAAA;AR0pVN;AQvpVI;EACE,YAAA;EACA,UAAA;EACA,mBAAA;EACA,yBAAA;ARypVN;AQtpVI;EACE,yBAAA;EACA,wCAAA;ARwpVN;AQtpVM;EACE,cAAA;ARwpVR;AQrpVM;EACE,yBAAA;EACA,yBPjYE;EOkYF,WAAA;ARupVR;AQppVM;EACE,yBPtYE;AD4hWV;AQlpVI;EACE,cAAA;ARopVN;AQjpVI;EACE,cAAA;ARmpVN;AQ/oVM;EACE,yBAAA;EACA,yBAAA;EACA,WAAA;ARipVR;AQ9oVM;EACE,yBAAA;ARgpVR;AQ1oVA;EACE;IACE,aAAA;IACA,8BAAA;IACA,mBAAA;IACA,8BAAA;ER4oVF;EQ1oVE;IACE,aAAA;ER4oVJ;EQ1oVI;IACE,aAAA;ER4oVN;EQzoVI;IACE,yBAAA;ER2oVN;EQxoVI;IACE,cAAA;ER0oVN;EQxoVM;IACE,aAAA;ER0oVR;EQvoVM;IACE,aAAA;ERyoVR;EQtoVM;IACE,iBAAA;ERwoVR;AACF;AQ7nVE;;EAEE,eAAA;AR+nVJ;AQ5nVE;EACE,sBAAA;EACA,0BAAA;AR8nVJ;AQ3nVE;EACE,iBAAA;AR6nVJ;AQvnVA;EACE,mBP5dQ;ADqlWV;AQrnVA;EACE,oBAAA;EACA,qBAAA;EACA,WAAA;ARunVF;AQpnVA;EACE,eAAA;ARsnVF;AQnnVA;EACE,aAAA;EACA,qCAAA;EACA,kCAAA;ARqnVF;AQlnVA;EACE,eAAA;ARonVF;AQjnVA;EACE,yBAAA;EACA,oBAAA;ARmnVF;AQhnVA;ER3fA;IQ6fE,sEAAA;ERknVA;EQjnVA;IACE,qCAAA;ERmnVF;AACF;AQ9mVA;EACE,+CAAA;EACA,sBAAA;ARgnVF;AQ9mVE;EACE,sCAAA;ARgnVJ;AQ3mVA;EACE,SAAA;AR6mVF;AQ3mVE;EACE,eAAA;EACA,gBAAA;AR6mVJ;AQ1mVE;EACE,4CAAA;AR4mVJ;AQ1mVI;EACE,eAAA;EACA,0CAAA;AR4mVN;AQ1mVM;EACE,yCAAA;AR4mVR;AQzmVM;EACE,gBAAA;AR2mVR;AQvmVI;EACE,eAAA;ARymVN;AQrmVM;EACE,2CAAA;ARumVR;AQrmVQ;EACE,0CAAA;ARumVV;AQjmVE;EACE,wBAAA;EACA,4BAAA;ARmmVJ;AQ7lVA;EACE,eAAA;EACA,+CAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AR+lVF;AQ7lVE;EACE,sBAAA;EAMA,YAAA;EACA,aAAA;AR0lVJ;AQ/lVI;EACE,6BAAA;ARimVN;AQ3lVI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AR6lVN;AQ3lVM;EACE,yBI5iBE;AZyoWV;AQ1lVM;EACE,yBI7iBE;AZyoWV;AQrlVA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,kBAAA;ARulVF;AQrlVE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,qBPhnBQ;EOinBR,2BPlnBM;EOmnBN,4CAAA;ARulVJ;AQnlVA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,mBAAA;EACA,0CAAA;ARqlVF;AQllVA;EACE;IACE,wBAAA;ERolVF;AACF;AQ/kVA;EACE,wBAAA;ARilVF;AQ9kVA;EACE,wBAAA;EACA,gBAAA;ARglVF;AQvkVA;EACE,YAAA;ARykVF;AQtkVA;EACE,YAAA;ARwkVF;AQrkVA;EACE,iDAAA;EACA,yBAAA;ARukVF;AQpkVA;EACE,kBAAA;ARskVF;AQnkVA;EACE,gBAAA;ARqkVF;AQhkVA;EACE,uBAAA;EACA,8CAAA;ARkkVF;AQ/jVA;EACE,8BAAA;ARikVF;AQ9jVA;EACE,2BAAA;ARgkVF;AQ7jVA;EACE,cAAA;AR+jVF;AQ5jVA;EACE,aAAA;AR8jVF;AQ3jVA;EACE,8CAAA;AR6jVF;AQ1jVA;EACE,8BAAA;AR4jVF;AQzjVA;EACE,8BAAA;AR2jVF;AQxjVA;EACE,mBAAA;AR0jVF;AQpjVA;EACE,gBAAA;EACA,yEAAA;EACA,kBAAA;EACA,0BAAA;EACA,qCAAA;ARsjVF;AQnjVA;EACE;IACE,4BAAA;ERqjVF;AACF","sourcesContent":[".react-app-uniforms{\n  // CustomBootstrap\n  @import 'assets/style/custom.scss';\n\n  // Global Style\n  @import 'assets/style/style.scss';\n}\n\n@import url('https://italia.github.io/design-web-toolkit/components/raw/spid/index.css');\n@import url('https://fonts.googleapis.com/css2?family=Titillium+Web:wght@300;400;600;700&display=swap');\n\n\n","/* The following block can be included in a custom.scss */\n\n$primary: #0C93A9;\n$secondary: #EEF4F5;\n$info: #FFF;\n$grey: #F5F5F5;\n\n.btn-primary{\n  color: #fff;\n}\n\n.btn-secondary{\n  color: $primary;\n}\n\n@import '~bootstrap/scss/bootstrap';\n\n\n","@mixin bsBanner($file) {\n  /*!\n   * Bootstrap #{$file} v5.3.2 (https://getbootstrap.com/)\n   * Copyright 2011-2023 The Bootstrap Authors\n   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n   */\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  color: var(--#{$prefix}highlight-color);\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  @include font-size($legend-font-size);\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n/* rtl:options: {\n  \"autoRename\": true,\n  \"stringMap\":[ {\n    \"name\"    : \"prev-next\",\n    \"search\"  : \"prev\",\n    \"replace\" : \"next\"\n  } ]\n} */\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg);\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg);\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n\n// Dark mode carousel\n\n@mixin carousel-dark() {\n  .carousel-control-prev-icon,\n  .carousel-control-next-icon {\n    filter: $carousel-dark-control-icon-filter;\n  }\n\n  .carousel-indicators [data-bs-target] {\n    background-color: $carousel-dark-indicator-active-bg;\n  }\n\n  .carousel-caption {\n    color: $carousel-dark-caption-color;\n  }\n}\n\n.carousel-dark {\n  @include carousel-dark();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    @if $color-mode-type == \"media-query\" {\n      .carousel {\n        @include carousel-dark();\n      }\n    } @else {\n      .carousel,\n      &.carousel {\n        @include carousel-dark();\n      }\n    }\n  }\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix: \"\", $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","* {\n  font-family: 'Titillium Web', sans-serif;\n}\n\n*::selection {\n  background: $primary;\n  color: #ffffff;\n}\n\n// Button\n\n.btn {\n  font-weight: 500;\n  font-size: 16px;\n  padding-left: 40px;\n  padding-right: 40px;\n  border-radius: 0;\n}\n\n.btn-primary,\n.btn-primary:hover,\n.btn-primary:active,\n.btn-primary:focus {\n  color: #fff !important;\n}\n\n.btn-secondary,\n.btn-secondary:hover,\n.btn-secondary:active,\n.btn-secondary:focus,\n.btn-outline-primary:hover,\n.btn-outline-primary:active,\n.btn-outline-primary:focus {\n  color: $primary !important;\n}\n\n.btn-outline-primary,\nbtn-outline-primary:hover,\n.btn-outline-primary:active {\n  background: #FFF !important;\n  border: 1px solid $primary;\n}\n\n.btn-primary.btn:disabled {\n  border-color: #d7d7d7 !important;\n  background-color: #d7d7d7 !important;\n}\n\n.btn:hover {\n  box-shadow: none;\n}\n\n.bg-grey {\n  background-color: #6B7888;\n}\n\n.icon-button {\n  width: 35px;\n  height: 35px;\n  border-radius: 50%;\n  color: #FFF;\n  background-color: rgba(255, 255, 255, .4);\n  border-width: 0;\n  font-size: 1.1rem;\n  justify-content: center;\n  align-items: center;\n}\n\n.bg-white {\n  background-color: #FFF !important;\n  border-color: #FFF !important;\n}\n\n.text-primary {\n  color: $primary !important;\n}\n\n.bg-red {\n  background-color: #DB504A;\n}\n\n.text-red {\n  color: #DB504A;\n}\n\n.text-black {\n  color: #000000;\n}\n\n.btn-icon-secondary {\n  background-color: $secondary;\n  color: $primary;\n  border: none;\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n}\n\n// Text\n\nh1 {\n  color: #000000;\n  font-weight: 700;\n  font-size: 26px;\n  margin-top: 50px;\n  margin-bottom: 20px;\n}\n\nh2 {\n  font-weight: 700;\n  font-size: 20px;\n  margin: 16px 0;\n  color: #000000;\n}\n\nbody {\n  color: #6B7888;\n  font-size: 16px;\n  background: #FFF;\n  min-height: 100vh;\n}\n\n.form-check-label,\n.form-label,\n.label,\nlabel,\n.form-control,\n.css-qbdosj-Input,\n.label-select {\n  font-size: 16px;\n  font-weight: 400;\n  color: #6B7888 !important;\n  line-height: 24px;\n}\n\n.text-white {\n  color: #FFF !important;\n}\n\na {\n  font-weight: 800;\n\n  &:hover {\n    color: $primary;\n  }\n}\n\n.link-to-confirm {\n  font-weight: 800;\n  padding-left: 60px;\n  color: $primary;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.text-right {\n  text-align: right;\n}\n\n.text-regular {\n  color: #6B7888;\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.text-muted {\n  font-size: 12px;\n  color: #6B7888 !important;\n  line-height: 20px;\n  font-style: italic;\n}\n\n.fs-20 {\n  font-size: 20px;\n}\n\n.fs-14 {\n  font-size: 14px;\n}\n\n.switch {\n  .note {\n    font-style: italic;\n    font-size: 12px;\n\n    &:first-child {\n      margin-left: 65px;\n    }\n  }\n\n  .form-check-input {\n    height: 1em;\n    margin-top: 0.25em;\n    vertical-align: top;\n    appearance: none;\n    background-color: #FFF;\n    background-repeat: no-repeat;\n    background-size: contain;\n    border: 1px solid #dee2e6;\n    -webkit-print-color-adjust: exact;\n    print-color-adjust: exact;\n    width: 2em;\n    margin-left: -2.5em;\n    background-position: left center;\n    border-radius: 2em;\n    transition: background-position 0.15s ease-in-out;\n\n    &:checked {\n      background-color: $primary;\n      border-color: $primary;\n    }\n  }\n}\n\n.radio-button {\n  input {\n    cursor: pointer;\n    margin-top: 7px;\n  }\n\n  .note {\n    font-style: italic;\n    font-size: 12px;\n    margin-left: 26px;\n  }\n}\n\n.form-control {\n  border-radius: 0;\n  background: #FFF;\n  border: 1px solid #dee2e6;\n}\n\ninput::placeholder {\n  color: #C8C8C8 !important;\n}\n\n\n// Form Select\n.css-hzoui-control:hover {\n  border-color: $primary !important;\n}\n\n// Form Radio\n.radio-button {\n  .form-check-input {\n    background-color: #FFF;\n    border: 1px solid #dee2e6;\n\n    &:checked {\n      background-color: #2f4A75;\n      border-color: #2f4A75;\n    }\n  }\n}\n\n// FormUpload\n.form-upload {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  appearance: none;\n  background-clip: padding-box;\n  border: 1px solid #dee2e6;\n  border-radius: 0;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  background-color: #FFF;\n\n  &::-webkit-file-upload-button {\n    background-color: #f8f9fa;\n    border-right-width: 1px;\n  }\n}\n\n.form-upload:hover::-webkit-file-upload-button {\n  background-color: #dee2e6 !important;\n}\n\n\n\n\n// Modal\n.modal-header {\n  background-color: $primary;\n  padding-left: 20px;\n\n  h2 {\n    color: #FFF !important;\n  }\n}\n\n.modal-container {\n  background-color: #FFF;\n}\n\n.pointer-status {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n}\n\n// DatePicker\n.react-datepicker__day--selected,\n.react-datepicker__day--in-selecting-range,\n.react-datepicker__day--in-range,\n.react-datepicker__month-text--selected,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--selected,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--selected,\n.react-datepicker__year-text--in-selecting-range,\n.react-datepicker__year-text--in-range {\n  background-color: $primary !important;\n}\n\n.react-datepicker__day--keyboard-selected,\n.react-datepicker__month-text--keyboard-selected,\n.react-datepicker__quarter-text--keyboard-selected,\n.react-datepicker__year-text--keyboard-selected {\n  background-color: $secondary !important;\n  color: $primary !important;\n}\n\n.react-datepicker-popper,\n#react-select-3-listbox {\n  z-index: 200 !important;\n}\n\n.css-b62m3t-container:first-child {\n  position: relative;\n}\n\n// Tab\n.tab-container {\n  margin-bottom: 100px;\n\n  .tab-container-detail {\n    background-color: $grey;\n  }\n\n  .nav-link {\n    color: #d7d7d7;\n    font-weight: 600;\n    font-size: 17px;\n    display: flex;\n    flex-direction: row;\n    gap: 15px;\n    align-items: center;\n\n    .index-counter {\n      width: 40px;\n      height: 40px;\n      border-radius: 50%;\n      border: 2px solid #d7d7d7;\n      color: #d7d7d7;\n      transition: .2s;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n\n    .step-description {\n      font-size: 10px;\n    }\n\n    .bar {\n      height: 25px;\n      width: 3px;\n      margin-left: 18.5px;\n      background-color: #d7d7d7;\n    }\n\n    &.active {\n      color: $primary !important;\n      background-color: transparent !important;\n\n      &:hover {\n        color: #FFFFFF;\n      }\n\n      .index-counter {\n        border: 2px solid $primary;\n        background-color: $primary;\n        color: #FFF\n      }\n\n      .bar {\n        background-color: $primary;\n      }\n    }\n\n    &:hover {\n      color: #d7d7d7;\n    }\n\n    &.disabled {\n      color: #d7d7d7;\n    }\n\n    &.isValid {\n      .index-counter {\n        border: 2px solid #21BC6C;\n        background-color: #21BC6C;\n        color: #FFF\n      }\n\n      .bar {\n        background-color: #21BC6C;\n      }\n    }\n  }\n}\n\n@media (max-width: 992px) {\n  .container-nav-item {\n    display: flex;\n    flex-direction: row !important;\n    align-items: center;\n    justify-content: space-between;\n\n    .nav-item {\n      display: none;\n\n      .bar {\n        display: none;\n      }\n\n      &.is_active {\n        display: block !important;\n      }\n\n      &.prev_next_active_key {\n        display: block;\n\n        .step-description {\n          display: none;\n        }\n\n        .step-title {\n          display: none;\n        }\n\n        .gap-3 {\n          gap: 0 !important;\n        }\n      }\n    }\n  }\n}\n\n\n// Switch\n\n.switch {\n\n  .form-check-input,\n  .form-check-label {\n    cursor: pointer;\n  }\n\n  .form-check-input {\n    transform: scale(1.35);\n    transform-origin: top left\n  }\n\n  .form-check-label {\n    margin-left: 25px;\n  }\n\n}\n\n// Calendar\n.fc .fc-highlight {\n  background: $primary;\n}\n\n/* Stile per disabilitare le celle precedenti alla data iniziale */\n.fc-day.disabled-cell {\n  pointer-events: none;\n  background-color: red;\n  color: #bbb;\n}\n\n.fc:hover {\n  cursor: pointer;\n}\n\n.wrapper {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-auto-rows: minmax(auto, auto);\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.fc .fc-bg-event {\n  background-color: #DB504A;\n  pointer-events: none\n}\n\n@media (max-width: 767px) {\n\n  /* Stili da applicare per dispositivi con larghezza massima di 767px */\n  .wrapper {\n    grid-template-columns: repeat(1, 1fr);\n  }\n\n}\n\n// Dropdown\n.dropdown-container {\n  box-shadow: 5px 5px 13px 5px rgba(0, 0, 0, 0.2);\n  background-color: #FFF;\n\n  .dropdown-item:hover {\n    background-color: rgba(0, 0, 0, 0.075);\n  }\n}\n\n// Table\n.table {\n  border: 0;\n\n  th {\n    font-size: 10px;\n    font-weight: 700;\n  }\n\n  tr {\n    border-boottom: 1px solid #dee2e6 !important;\n\n    td {\n      font-size: 14px;\n      background-color: rgba(255, 202, 58, .05);\n\n      &:last-child {\n        border-right: 2px solid rgba(255, 202, 58);\n      }\n\n      &:nth-child(2) {\n        font-weight: 600;\n      }\n    }\n\n    &:hover {\n      cursor: pointer;\n    }\n\n    &.sent {\n      td {\n        background-color: rgba(185, 213, 133, .05);\n\n        &:last-child {\n          border-right: 2px solid rgba(185, 213, 133);\n        }\n      }\n    }\n  }\n\n  &> :not(caption)>*>* {\n    border-bottom-width: 1px;\n    border-bottom-color: #dee2e6;\n  }\n}\n\n// Tost\n\n.toast-container {\n  position: fixed;\n  box-shadow: 0px 0px 19px 0px rgba(0, 0, 0, 0.1);\n  border-radius: 20px;\n  overflow: hidden;\n  z-index: 10000;\n\n  .toast {\n    background-color: #FFF;\n\n    .toast-header {\n      background-color: transparent;\n    }\n\n    border: none;\n    padding: 10px;\n\n    .pointer {\n      width: 10px;\n      height: 10px;\n      border-radius: 50%;\n      margin-right: 10px;\n\n      &.danger {\n        background-color: $danger;\n      }\n\n      &.success {\n        background-color: $success;\n      }\n    }\n  }\n}\n\n// Loading\n.container-loading {\n  position: fixed;\n  top: 0;\n  left: 0;\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  width: 100%;\n  height: 100%;\n  background: rgba(255, 255, 255, 0.8);\n  z-index: 9999;\n  padding-top: 100px;\n\n  .spinner {\n    width: 56px;\n    height: 56px;\n    border-radius: 50%;\n    border: 9px solid;\n    border-color: $secondary;\n    border-right-color: $primary;\n    animation: spinner-d3wgkg 1s infinite linear;\n  }\n}\n\n.fixed {\n  position: fixed;\n  top: 0;\n  left: 0;\n  align-items: center;\n  background-color: rgba(255, 255, 255, 0.5);\n}\n\n@keyframes spinner-d3wgkg {\n  to {\n    transform: rotate(1turn);\n  }\n}\n\n// Other\n\nhr {\n  border: solid #CCC 0.5px;\n}\n\n.show>.btn-info.dropdown-toggle:focus {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n/*\n.css-b62m3t-container {\n  z-index: 200;\n}\n*/\n\n.z-index-100 {\n  z-index: 101;\n}\n\n.pdf-viewer-container {\n  height: 50vh;\n}\n\n.modal-container .form-control {\n  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.02) inset;\n  border: 1px solid #dee2e6;\n}\n\n.form-control:disabled {\n  min-height: 42.5px;\n}\n\n.accordion-button {\n  font-weight: 600;\n}\n\n\n/* Accordion */\n.accordion-item {\n  border: none !important;\n  box-shadow: 0px 0px 9px 1px rgba(0, 0, 0, .1);\n}\n\n.accordion-item .accordion-button {\n  border-radius: 20px !important;\n}\n\n.accordion-button:not(.collapsed) {\n  box-shadow: none !important;\n}\n\n.accordion-body {\n  padding-top: 0;\n}\n\n.accordion-body hr {\n  margin-top: 0;\n}\n\n.box-shadow-9 {\n  box-shadow: 0px 0px 9px 1px rgba(0, 0, 0, .1);\n}\n\n.br-20 {\n  border-radius: 20px !important;\n}\n\n.br-10 {\n  border-radius: 10px !important;\n}\n\n.css-13cymwt-control {\n  border-radius: 10px;\n}\n\n\n// Loading\n\n.skeleton {\n  background: #eee;\n  background: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);\n  border-radius: 5px;\n  background-size: 200% 100%;\n  animation: 1.5s shine linear infinite;\n}\n\n@keyframes shine {\n  to {\n    background-position-x: -200%;\n  }\n}\n",":root,\n[data-bs-theme=\"light\"] {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-text {\n    --#{$prefix}#{$color}-text-emphasis: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-bg-subtle {\n    --#{$prefix}#{$color}-bg-subtle: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-border-subtle {\n    --#{$prefix}#{$color}-border-subtle: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-color: #{$mark-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.3.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    color-scheme: dark;\n\n    // scss-docs-start root-dark-mode-vars\n    --#{$prefix}body-color: #{$body-color-dark};\n    --#{$prefix}body-color-rgb: #{to-rgb($body-color-dark)};\n    --#{$prefix}body-bg: #{$body-bg-dark};\n    --#{$prefix}body-bg-rgb: #{to-rgb($body-bg-dark)};\n\n    --#{$prefix}emphasis-color: #{$body-emphasis-color-dark};\n    --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color-dark)};\n\n    --#{$prefix}secondary-color: #{$body-secondary-color-dark};\n    --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color-dark)};\n    --#{$prefix}secondary-bg: #{$body-secondary-bg-dark};\n    --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg-dark)};\n\n    --#{$prefix}tertiary-color: #{$body-tertiary-color-dark};\n    --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color-dark)};\n    --#{$prefix}tertiary-bg: #{$body-tertiary-bg-dark};\n    --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg-dark)};\n\n    @each $color, $value in $theme-colors-text-dark {\n      --#{$prefix}#{$color}-text-emphasis: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-bg-subtle-dark {\n      --#{$prefix}#{$color}-bg-subtle: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-border-subtle-dark {\n      --#{$prefix}#{$color}-border-subtle: #{$value};\n    }\n\n    --#{$prefix}heading-color: #{$headings-color-dark};\n\n    --#{$prefix}link-color: #{$link-color-dark};\n    --#{$prefix}link-hover-color: #{$link-hover-color-dark};\n    --#{$prefix}link-color-rgb: #{to-rgb($link-color-dark)};\n    --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color-dark)};\n\n    --#{$prefix}code-color: #{$code-color-dark};\n    --#{$prefix}highlight-color: #{$mark-color-dark};\n    --#{$prefix}highlight-bg: #{$mark-bg-dark};\n\n    --#{$prefix}border-color: #{$border-color-dark};\n    --#{$prefix}border-color-translucent: #{$border-color-translucent-dark};\n\n    --#{$prefix}form-valid-color: #{$form-valid-color-dark};\n    --#{$prefix}form-valid-border-color: #{$form-valid-border-color-dark};\n    --#{$prefix}form-invalid-color: #{$form-invalid-color-dark};\n    --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color-dark};\n    // scss-docs-end root-dark-mode-vars\n  }\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// scss-docs-start color-mode-mixin\n@mixin color-mode($mode: light, $root: false) {\n  @if $color-mode-type == \"media-query\" {\n    @if $root == true {\n      @media (prefers-color-scheme: $mode) {\n        :root {\n          @content;\n        }\n      }\n    } @else {\n      @media (prefers-color-scheme: $mode) {\n        @content;\n      }\n    }\n  } @else {\n    [data-bs-theme=\"#{$mode}\"] {\n      @content;\n    }\n  }\n}\n// scss-docs-end color-mode-mixin\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-text-variables\n$primary-text-emphasis:   shade-color($primary, 60%) !default;\n$secondary-text-emphasis: shade-color($secondary, 60%) !default;\n$success-text-emphasis:   shade-color($success, 60%) !default;\n$info-text-emphasis:      shade-color($info, 60%) !default;\n$warning-text-emphasis:   shade-color($warning, 60%) !default;\n$danger-text-emphasis:    shade-color($danger, 60%) !default;\n$light-text-emphasis:     $gray-700 !default;\n$dark-text-emphasis:      $gray-700 !default;\n// scss-docs-end theme-text-variables\n\n// scss-docs-start theme-bg-subtle-variables\n$primary-bg-subtle:       tint-color($primary, 80%) !default;\n$secondary-bg-subtle:     tint-color($secondary, 80%) !default;\n$success-bg-subtle:       tint-color($success, 80%) !default;\n$info-bg-subtle:          tint-color($info, 80%) !default;\n$warning-bg-subtle:       tint-color($warning, 80%) !default;\n$danger-bg-subtle:        tint-color($danger, 80%) !default;\n$light-bg-subtle:         mix($gray-100, $white) !default;\n$dark-bg-subtle:          $gray-400 !default;\n// scss-docs-end theme-bg-subtle-variables\n\n// scss-docs-start theme-border-subtle-variables\n$primary-border-subtle:   tint-color($primary, 60%) !default;\n$secondary-border-subtle: tint-color($secondary, 60%) !default;\n$success-border-subtle:   tint-color($success, 60%) !default;\n$info-border-subtle:      tint-color($info, 60%) !default;\n$warning-border-subtle:   tint-color($warning, 60%) !default;\n$danger-border-subtle:    tint-color($danger, 60%) !default;\n$light-border-subtle:     $gray-200 !default;\n$dark-border-subtle:      $gray-500 !default;\n// scss-docs-end theme-border-subtle-variables\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n$enable-dark-mode:            true !default;\n$color-mode-type:             data !default; // `data` or `media-query`\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                $gray-900 !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      rgba($body-color, .75) !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       rgba($body-color, .5) !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n$border-style:                solid !default;\n$border-color:                $gray-300 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.3.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 5.3.0\n// fusv-enable\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v5.2.0\n$hr-height:                   null !default; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-color:                  $body-color !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}emphasis-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba(var(--#{$prefix}emphasis-color-rgb), $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba(var(--#{$prefix}emphasis-color-rgb), $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba(var(--#{$prefix}emphasis-color-rgb), $table-hover-bg-factor) !default;\n\n$table-border-factor:         .2 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n$btn-link-focus-shadow-rgb:   to-rgb(mix(color-contrast($link-color), $link-color, 15%)) !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      var(--#{$prefix}box-shadow-inset) !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          var(--#{$prefix}box-shadow-inset) !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}secondary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     var(--#{$prefix}box-shadow-inset) !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-underline-gap:                 1rem !default;\n$nav-underline-border-width:        .125rem !default;\n$nav-underline-link-active-color:   var(--#{$prefix}emphasis-color) !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               var(--#{$prefix}box-shadow) !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(#{$pagination-border-width} * -1) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              var(--#{$prefix}primary-bg-subtle) !default;\n$accordion-button-active-color:           var(--#{$prefix}primary-text-emphasis) !default;\n\n$accordion-button-focus-border-color:     $input-focus-border-color !default;\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $body-color !default;\n$accordion-icon-active-color:             $primary-text-emphasis !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                var(--#{$prefix}box-shadow) !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       var(--#{$prefix}box-shadow-sm) !default;\n$modal-content-box-shadow-sm-up:    var(--#{$prefix}box-shadow) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// fusv-disable\n$alert-bg-scale:                -80% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-border-scale:            -70% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-color-scale:             40% !default; // Deprecated in v5.2.0, to be removed in v6\n// fusv-enable\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n// fusv-disable\n$list-group-item-bg-scale:          -80% !default; // Deprecated in v5.3.0\n$list-group-item-color-scale:       40% !default; // Deprecated in v5.3.0\n// fusv-enable\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default;\n$carousel-dark-caption-color:        $black !default;\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default;\n// scss-docs-end carousel-dark-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default;\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null !default;\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    @include font-size($font-size);\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: percentage(divide(1, $count));\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0%; // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is and invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefor we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  appearance: none;\n  background-color: $form-select-bg;\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-select {\n      --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator-dark)};\n    }\n  }\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  flex-shrink: 0;\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-switch .form-check-input:not(:checked):not(:focus) {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-dark)};\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  appearance: none;\n  background-color: transparent;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n\n      &::after {\n        position: absolute;\n        inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n        z-index: -1;\n        height: $form-floating-label-height;\n        content: \"\";\n        background-color: $input-bg;\n        @include border-radius($input-border-radius);\n      }\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n    }\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label,\n  > .form-control:disabled ~ label { // Required for `.form-control`s because of specificity\n    color: $form-floating-label-disabled-color;\n\n    &::after {\n      background-color: $input-disabled-bg;\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: calc(#{$input-border-width} * -1); // stylelint-disable-line function-disallowed-list\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: 0 0 0 #000; // Can't use `none` as keyword negates all values when used with multiple shadows\n  --#{$prefix}btn-focus-shadow-rgb: #{$btn-link-focus-shadow-rgb};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// scss-docs-start caret-mixins\n@mixin caret-down($width: $caret-width) {\n  border-top: $width solid;\n  border-right: $width solid transparent;\n  border-bottom: 0;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-up($width: $caret-width) {\n  border-top: 0;\n  border-right: $width solid transparent;\n  border-bottom: $width solid;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-end($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: 0;\n  border-bottom: $width solid transparent;\n  border-left: $width solid;\n}\n\n@mixin caret-start($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: $width solid;\n  border-bottom: $width solid transparent;\n}\n\n@mixin caret(\n  $direction: down,\n  $width: $caret-width,\n  $spacing: $caret-spacing,\n  $vertical-align: $caret-vertical-align\n) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $spacing;\n      vertical-align: $vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down($width);\n      } @else if $direction == up {\n        @include caret-up($width);\n      } @else if $direction == end {\n        @include caret-end($width);\n      }\n    }\n\n    @if $direction == start {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $spacing;\n        vertical-align: $vertical-align;\n        content: \"\";\n        @include caret-start($width);\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n// scss-docs-end caret-mixins\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn ~ .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Underline\n//\n\n.nav-underline {\n  // scss-docs-start nav-underline-css-vars\n  --#{$prefix}nav-underline-gap: #{$nav-underline-gap};\n  --#{$prefix}nav-underline-border-width: #{$nav-underline-border-width};\n  --#{$prefix}nav-underline-link-active-color: #{$nav-underline-link-active-color};\n  // scss-docs-end nav-underline-css-vars\n\n  gap: var(--#{$prefix}nav-underline-gap);\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n    border-bottom: var(--#{$prefix}nav-underline-border-width) solid transparent;\n\n    &:hover,\n    &:focus {\n      border-bottom-color: currentcolor;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    font-weight: $font-weight-bold;\n    color: var(--#{$prefix}nav-underline-link-active-color);\n    border-bottom-color: currentcolor;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=\"dark\"] {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .navbar-toggler-icon {\n      --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-border-color: #{$accordion-button-focus-border-color};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    border-color: var(--#{$prefix}accordion-btn-focus-border-color);\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  .accordion-collapse {\n    border-width: 0;\n  }\n\n  .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    .accordion-button {\n      &,\n      &.collapsed {\n        @include border-radius(0);\n      }\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .accordion-button::after {\n      --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon-dark)};\n      --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon-dark)};\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == calc(#{$pagination-border-width} * -1) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert\n@each $state in map-keys($theme-colors) {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}alert-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}alert-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}alert-link-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end alert-modifiers\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: $progress-height; }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  &:hover,\n  &:focus {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-action-hover-color);\n    text-decoration: none;\n    background-color: var(--#{$prefix}list-group-action-hover-bg);\n  }\n\n  &:active {\n    color: var(--#{$prefix}list-group-action-active-color);\n    background-color: var(--#{$prefix}list-group-action-active-bg);\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state in map-keys($theme-colors) {\n  .list-group-item-#{$state} {\n    --#{$prefix}list-group-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-hover-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-hover-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-active-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-active-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-active-color: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-active-bg: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-active-border-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end list-group-modifiers\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  --#{$prefix}btn-close-white-filter: #{$btn-close-white-filter};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n@mixin btn-close-white() {\n  filter: var(--#{$prefix}btn-close-white-filter);\n}\n\n.btn-close-white {\n  @include btn-close-white();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .btn-close {\n      @include btn-close-white();\n    }\n  }\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    margin: calc(-.5 * var(--#{$prefix}modal-header-padding-y)) calc(-.5 * var(--#{$prefix}modal-header-padding-x)) calc(-.5 * var(--#{$prefix}modal-header-padding-y)) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-right: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(-100%);\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-left: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none;\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    margin-top: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}offcanvas-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: RGBA(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: RGBA(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n",".focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--bs-focus-ring-x`, `--bs-focus-ring-y`, or `--bs-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n",".icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
